// kapigen version 0.0.7
// tslint:disable
import { createRequestClient } from "./requestClientInternal";

export {
  CanonicalError,
  CanonicalErrorCode,
  createRequestClient,
  getAntiForgeryToken,
} from "./requestClientInternal";

export namespace google {
  export namespace protobuf {
    export interface Any {
      typeUrl: string;
      value: any;
    }

    export interface BoolValue {
      value: boolean;
    }

    export interface DoubleValue {
      value: number;
    }

    export interface Duration {
      seconds: number;
      nanos: number;
    }

    export interface Empty {}

    export interface FieldMask {
      paths: string[];
    }

    export interface FloatValue {
      value: number;
    }

    export interface Int32Value {
      value: number;
    }

    export interface Int64Value {
      value: number;
    }

    export interface StringValue {
      value: string;
    }

    export interface Timestamp {
      seconds: number;
      nanos: number;
    }
  }

  export namespace rpc {
    export namespace ErrorResponse {
      // This message has the same semantics as `google.rpc.Status`. It uses HTTP
      // status code instead of gRPC status code. It has extra fields `status` and
      // `errors` for backward compatibility with [Google API Client
      // Libraries](https://developers.google.com/api-client-library).
      export interface Status {
        // The HTTP status code that corresponds to `google.rpc.Status.code`.
        code: number;
        // This corresponds to `google.rpc.Status.message`.
        message: string;
        // This is the enum version for `google.rpc.Status.code`.
        status: google.rpc.Code;
        // This corresponds to `google.rpc.Status.details`.
        details: google.protobuf.Any[];
      }
    }
    // The canonical error codes for Google APIs.
    // 
    // 
    // Sometimes multiple error codes may apply.  Services should return
    // the most specific error code that applies.  For example, prefer
    // `OUT_OF_RANGE` over `FAILED_PRECONDITION` if both codes apply.
    // Similarly prefer `NOT_FOUND` or `ALREADY_EXISTS` over `FAILED_PRECONDITION`.
    export enum Code {
      // Not an error; returned on success
      // 
      // HTTP Mapping: 200 OK
      OK = "ok", // = 0;
      // The operation was cancelled, typically by the caller.
      // 
      // HTTP Mapping: 499 Client Closed Request
      CANCELLED = "cancelled", // = 1;
      // Unknown error.  For example, this error may be returned when
      // a `Status` value received from another address space belongs to
      // an error space that is not known in this address space.  Also
      // errors raised by APIs that do not return enough error information
      // may be converted to this error.
      // 
      // HTTP Mapping: 500 Internal Server Error
      UNKNOWN = "unknown", // = 2;
      // The client specified an invalid argument.  Note that this differs
      // from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
      // that are problematic regardless of the state of the system
      // (e.g., a malformed file name).
      // 
      // HTTP Mapping: 400 Bad Request
      INVALID_ARGUMENT = "invalidArgument", // = 3;
      // The deadline expired before the operation could complete. For operations
      // that change the state of the system, this error may be returned
      // even if the operation has completed successfully.  For example, a
      // successful response from a server could have been delayed long
      // enough for the deadline to expire.
      // 
      // HTTP Mapping: 504 Gateway Timeout
      DEADLINE_EXCEEDED = "deadlineExceeded", // = 4;
      // Some requested entity (e.g., file or directory) was not found.
      // 
      // Note to server developers: if a request is denied for an entire class
      // of users, such as gradual feature rollout or undocumented allowlist,
      // `NOT_FOUND` may be used. If a request is denied for some users within
      // a class of users, such as user-based access control, `PERMISSION_DENIED`
      // must be used.
      // 
      // HTTP Mapping: 404 Not Found
      NOT_FOUND = "notFound", // = 5;
      // The entity that a client attempted to create (e.g., file or directory)
      // already exists.
      // 
      // HTTP Mapping: 409 Conflict
      ALREADY_EXISTS = "alreadyExists", // = 6;
      // The caller does not have permission to execute the specified
      // operation. `PERMISSION_DENIED` must not be used for rejections
      // caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
      // instead for those errors). `PERMISSION_DENIED` must not be
      // used if the caller can not be identified (use `UNAUTHENTICATED`
      // instead for those errors). This error code does not imply the
      // request is valid or the requested entity exists or satisfies
      // other pre-conditions.
      // 
      // HTTP Mapping: 403 Forbidden
      PERMISSION_DENIED = "permissionDenied", // = 7;
      // The request does not have valid authentication credentials for the
      // operation.
      // 
      // HTTP Mapping: 401 Unauthorized
      UNAUTHENTICATED = "unauthenticated", // = 16;
      // Some resource has been exhausted, perhaps a per-user quota, or
      // perhaps the entire file system is out of space.
      // 
      // HTTP Mapping: 429 Too Many Requests
      RESOURCE_EXHAUSTED = "resourceExhausted", // = 8;
      // The operation was rejected because the system is not in a state
      // required for the operation's execution.  For example, the directory
      // to be deleted is non-empty, an rmdir operation is applied to
      // a non-directory, etc.
      // 
      // Service implementors can use the following guidelines to decide
      // between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
      //  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
      //  (b) Use `ABORTED` if the client should retry at a higher level
      //      (e.g., when a client-specified test-and-set fails, indicating the
      //      client should restart a read-modify-write sequence).
      //  (c) Use `FAILED_PRECONDITION` if the client should not retry until
      //      the system state has been explicitly fixed.  E.g., if an "rmdir"
      //      fails because the directory is non-empty, `FAILED_PRECONDITION`
      //      should be returned since the client should not retry unless
      //      the files are deleted from the directory.
      // 
      // HTTP Mapping: 400 Bad Request
      FAILED_PRECONDITION = "failedPrecondition", // = 9;
      // The operation was aborted, typically due to a concurrency issue such as
      // a sequencer check failure or transaction abort.
      // 
      // See the guidelines above for deciding between `FAILED_PRECONDITION`,
      // `ABORTED`, and `UNAVAILABLE`.
      // 
      // HTTP Mapping: 409 Conflict
      ABORTED = "aborted", // = 10;
      // The operation was attempted past the valid range.  E.g., seeking or
      // reading past end-of-file.
      // 
      // Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
      // be fixed if the system state changes. For example, a 32-bit file
      // system will generate `INVALID_ARGUMENT` if asked to read at an
      // offset that is not in the range [0,2^32-1], but it will generate
      // `OUT_OF_RANGE` if asked to read from an offset past the current
      // file size.
      // 
      // There is a fair bit of overlap between `FAILED_PRECONDITION` and
      // `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
      // error) when it applies so that callers who are iterating through
      // a space can easily look for an `OUT_OF_RANGE` error to detect when
      // they are done.
      // 
      // HTTP Mapping: 400 Bad Request
      OUT_OF_RANGE = "outOfRange", // = 11;
      // The operation is not implemented or is not supported/enabled in this
      // service.
      // 
      // HTTP Mapping: 501 Not Implemented
      UNIMPLEMENTED = "unimplemented", // = 12;
      // Internal errors.  This means that some invariants expected by the
      // underlying system have been broken.  This error code is reserved
      // for serious errors.
      // 
      // HTTP Mapping: 500 Internal Server Error
      INTERNAL = "internal", // = 13;
      // The service is currently unavailable.  This is most likely a
      // transient condition, which can be corrected by retrying with
      // a backoff.
      // 
      // See the guidelines above for deciding between `FAILED_PRECONDITION`,
      // `ABORTED`, and `UNAVAILABLE`.
      // 
      // HTTP Mapping: 503 Service Unavailable
      UNAVAILABLE = "unavailable", // = 14;
      // Unrecoverable data loss or corruption.
      // 
      // HTTP Mapping: 500 Internal Server Error
      DATA_LOSS = "dataLoss", // = 15;
    }
  }
}

export namespace Kaggle {
  export namespace Sdk {
    export namespace Abuse {
      export enum PrivatedModerationStatus {
        UNSPECIFIED = "unspecified", // = 0;
        NO_ABUSE = "noAbuse", // = 1;
        PRIVATED = "privated", // = 2;
        PERMANENTLY_PRIVATED = "permanentlyPrivated", // = 3;
      }
    }

    export namespace ActiveEvents {
      export interface DeleteActiveEventRequest {
        eventId: string;
      }

      export interface FirebaseConfig {
        apiKey: string;
        authDomain: string;
        databaseUrl: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
        proxyDomain: string;
      }

      export interface GetActiveEventsFirebaseConfigRequest {}

      export interface GetActiveEventsFirebaseConfigResponse {
        config: Kaggle.Sdk.ActiveEvents.FirebaseConfig | null;
        // Custom auth token for the current user (or empty if logged out).
        authToken: string;
      }
    }

    export namespace Admin {
      export namespace CreateLogMessageRequest {
        // These intentionally match Microsoft.Extensions.Logging.LogLevel
        // and must match exactly or it won't parse correctly.
        export enum LogLevel {
          NONE = "none", // = 0;
          CRITICAL = "critical", // = 1;
          ERROR = "error", // = 2;
          WARNING = "warning", // = 3;
          INFORMATION = "information", // = 4;
          DEBUG = "debug", // = 5;
          TRACE = "trace", // = 6;
        }
      }

      export namespace Models {
        export interface AutoFormProps {
          id: /* Int32 */ number | null;
          typeName: string | null;
          typeNames: string[];
        }

        export interface SiteConfigDto {
          siteId: /*Int32*/ number;
        }
      }

      export interface ActivityLog {
        id: number;
        logDate: /* google.protobuf.Timestamp */ string | null;
        userAgent?: /* google.protobuf.StringValue */ string | null;
        ipAddress?: /* google.protobuf.StringValue */ string | null;
        country?: /* google.protobuf.StringValue */ string | null;
        region?: /* google.protobuf.StringValue */ string | null;
        city?: /* google.protobuf.StringValue */ string | null;
        organization?: /* google.protobuf.StringValue */ string | null;
      }

      export interface AddSiteConfigRequest {
        name: string;
        value: string;
      }

      export interface AdminUser {
        id: number;
        mostRecentLog: Kaggle.Sdk.Admin.ActivityLog | null;
        lastVerifiedPhoneNumber?: /* google.protobuf.StringValue */ string | null;
        hasPhoneReputations?: /* google.protobuf.BoolValue */ boolean | null;
        isLastPhoneNumberReputable?: /* google.protobuf.BoolValue */ boolean | null;
      }

      export interface AutoFormModel {
        properties: Kaggle.Sdk.Admin.AutoFormProperty[];
      }

      export interface AutoFormProperty {
        description?: /* google.protobuf.StringValue */ string | null;
        isNullable: boolean;
        isReadonly: boolean;
        name?: /* google.protobuf.StringValue */ string | null;
        sortOrder: number;
        type: Kaggle.Sdk.Admin.AutoFormPropertyType;
        value?: /* google.protobuf.StringValue */ string | null;
      }

      export interface BatchResetRateLimitStatusesRequest {
        // The rate limits to reset (currently no limit).
        requests: Kaggle.Sdk.Admin.ResetRateLimitStatusRequest[];
      }

      export interface BatchResetRateLimitStatusesResponse {
        resetCount: number;
      }

      export interface CreateDelegatedUserAccessTokenRequest {
        // The user id that the token should represent.
        destinationUserId: number;
        // Reason for delegated access (e.g. support ticket).
        // NOTE: This could be passed to Gin in the future.
        justification: string;
      }

      export interface CreateDelegatedUserAccessTokenResponse {
        // Opaque token that can be used to impersonate another user.
        token: string;
      }

      export interface CreateIdmecLinkRequest {
        // The UserName for the user we're looking up.
        userName: string;
      }

      export interface CreateIdmecLinkResponse {
        // A list of signed URIs, could be multiple if multiple users with the same username were deleted.
        accessLinks: string[];
      }

      export interface CreateInboxFileRequest {
        // Directory name used for tagging the uploaded file.
        virtualDirectory: string;
        // Token representing the uploaded file.
        blobFileToken: string;
      }
      // NOTE: This is sent to non-admins, so we're intentionally *NOT* sending back the
      // full InboxFile (with its URL for a direct download).
      export interface CreateInboxFileResponse {}

      export interface CreateIpBanRequest {
        // The exact IPv4 IP (e.g. "1.2.3.4") or a valid CIDR range
        // (e.g. "1.2.3.4/24").
        ipRange: string;
        // An optional comment explaining why the banned was performed.
        comment?: string;
      }

      export interface CreateLogMessageRequest {
        // The logger/source from where the log message will be generated from.
        source: string;
        // The severity level of the message to report.
        level: Kaggle.Sdk.Admin.CreateLogMessageRequest.LogLevel;
        // The message text to log.
        message: string;
      }

      export interface CreateLogMessageResponse {}

      export interface CreateOrganizationRequest {
        // The display name for the created organization
        displayName: string;
        // The slug for the created organization
        slug: string;
        // Cropped image representing the organization
        image: Kaggle.Sdk.Common.CroppedImageUpload | null;
      }

      export interface CreateOrganizationResponse {
        // ID for the created organization
        organizationId: number;
      }

      export interface DeleteInboxFileRequest {
        // Id of the file to delete.
        inboxFileId: number;
      }

      export interface DeleteIpBanRequest {
        // The id of the existing ban to delete.
        ipBanId: number;
      }

      export interface DeleteSiteConfigRequest {
        id: number;
      }

      export interface EmergencyBanner {
        bannerId: string;
        messageHtml: string;
        uriPathRegex: string;
      }

      export interface EmergencyBannersConfig {
        banners: Kaggle.Sdk.Admin.EmergencyBanner[];
      }

      export interface GetAdminUserRequest {
        userId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface GetAllSiteConfigsRequest {
        forceCacheRefresh: boolean;
      }

      export interface GetAutoFormModelRequest {
        typeName?: /* google.protobuf.StringValue */ string | null;
        id: number;
      }

      export interface GetDatabaseSizeRequest {}

      export interface GetDatabaseSizeResponse {
        databaseSize?: /* google.protobuf.DoubleValue */ number | null;
      }

      export interface GetLoggingConfigRequest {}

      export interface GetLoggingConfigResponse {
        loggingConfig: string;
      }

      export interface GetSampleRequestRequest {
        requestType: string;
      }

      export interface GetSampleRequestResponse {
        sampleRequest: string;
      }

      export interface GetSiteConfigsResponse {
        siteConfigs: Kaggle.Sdk.Admin.SiteConfig[];
      }

      export interface InboxFile {
        // Unique id for the uploaded file.
        id: number;
        // The optional virtual directory that contains this file.
        virtualDirectory: string;
        // The user-visible filename.
        fileName: string;
        // The size (in bytes) of the file.
        contentLength: number;
        // Timestamp of when the file was uploaded.
        uploadTime: /* google.protobuf.Timestamp */ string | null;
        // The (signed) download URL (direct from GCS)
        directDownloadUrl: string;
        // Ideally we would just need the user's ID and would be able to fetch info for the avatar info,
        // but that currently is ready in the frontend, so we instead send the info that the frontend needs:
        // int32 uploader_user_id = 7;
        uploaderInfo: Kaggle.Sdk.Admin.InboxFileUserInfo | null;
      }
      // The existing frontend depended on this information. Future updates should just use
      // the user id and fetch whatever is needed.
      export interface InboxFileUserInfo {
        id: number;
        displayName: string;
        userUrl: string;
        // Performance tier should likely be an enum, but making an integer for backwards compatibility
        tier: number;
        thumbnailUrl: string;
      }

      export interface IpBan {
        // The unique identifier for the ban.
        ipBanId: number;
        // The exact IPv4 IP (e.g. "1.2.3.4") or a valid CIDR range
        // (e.g. "1.2.3.4/24").
        ipRange: string;
        // The Kaggle (admin) username who banned the IP range.
        creatorUsername: string;
        // An optional comment explaining why the banned was performed.
        comment: string;
        // The absolute point in time when the IP ban was created.
        createTime: /* google.protobuf.Timestamp */ string | null;
      }

      export interface ListInboxFilesRequest {
        // Optional virtual directory/tag to limit scope of listing.
        virtualDirectory: string;
        // The maximum number of bans to return.
        pageSize: number;
        // The `next_page_token` value returned from a previous request, if any.
        pageToken: string;
      }

      export interface ListInboxFilesResponse {
        // The virtual directory that the files belong to.
        virtualDirectory: string;
        // The listing of files available for download.
        inboxFiles: Kaggle.Sdk.Admin.InboxFile[];
        // Token to retrieve the next page of results, or empty if there are no more
        // results in the list.
        nextPageToken: string;
      }

      export interface ListIpBansRequest {
        // The maximum number of bans to return.
        pageSize: number;
        // The `next_page_token` value returned from a previous request, if any.
        pageToken: string;
      }

      export interface ListIpBansResponse {
        // A list of all active IP bans.
        ipBans: Kaggle.Sdk.Admin.IpBan[];
        // Token to retrieve the next page of results, or empty if there are no more
        // results in the list.
        nextPageToken: string;
      }

      export interface ListRateLimitsRequest {}

      export interface ListRateLimitsResponse {
        rateLimits: Kaggle.Sdk.Admin.RateLimit[];
      }

      export interface ListRateLimitStatusesRequest {
        // Optional filter/pattern passed directly to Redis (for efficient key searching)
        redisKeyPattern: string;
        // Optional regex to use on the rate limit (Redis) key names.
        keyRegex: string;
        // Should the response only include rate limits that have been exceeded/tripped?
        onlyExceeded: boolean;
        // Optional fields to order by (e.g. "key, tokens_count desc").
        orderBy: string;
      }

      export interface ListRateLimitStatusesResponse {
        // Number of rate limits that matched the filters (but irrespective of "only_exceeded").
        filtersMatchCount: number;
        // Time that the request was processed. All expiration times should be after this date.
        // Not using Timestamp until JSON serialization issue is resolved:
        // google.protobuf.Timestamp server_time = 2;
        serverTimeString: string;
        // All rate limits that match the filters and "only_exceeded"
        // Optionally ordered by "order_by".
        rateLimitStatuses: Kaggle.Sdk.Admin.RateLimitStatus[];
      }

      export interface ListRequestTypesRequest {}

      export interface ListRequestTypesResponse {
        requestTypes: string[];
      }

      export interface RateLimit {
        // The name of the limit (e.g. "CompetitionApiRequest").
        name: string;
        // All of the scopes that apply for the rate limit.
        scopes: Kaggle.Sdk.Admin.RateLimitScope[];
      }

      export interface RateLimitFillRate {
        // Time period to fill completely (e.g. "minute", "hour")
        per: string;
        initialTokenCount: number;
      }

      export interface RateLimitScope {
        // The scope of the rate limit (e.g. "user", "all")
        scope: string;
        fillRates: Kaggle.Sdk.Admin.RateLimitFillRate[];
      }

      export interface RateLimitStatus {
        key: string;
        // Not using Timestamp until JSON serialization issue is resolved:
        // See https://kaggle.slack.com/archives/CEDHFMV6D/p1570810506045800?thread_ts=1570810037.045200&cid=CEDHFMV6D
        // google.protobuf.Timestamp update_time = 2;
        updateTimeString: string;
        // google.protobuf.Timestamp expiration_time = 3;
        expirationTimeString: string;
        tokensCount: number;
        blocksCount: number;
        initialTokensCount: number;
      }

      export interface ResetRateLimitStatusRequest {
        // The Redis key of the rate limit reset.
        key: string;
      }

      export interface ResetRateLimitStatusResponse {
        // Was the limit reset?
        reset: boolean;
      }

      export interface ResetSearchIndexesRequest {}

      export interface ResetSearchIndexRequest {
        name: string;
      }

      export interface SiteConfig {
        // Unset if this stems from a FlagDefault annotation and not a DB-backed SiteConfig row.
        id?: /* google.protobuf.Int32Value */ number | null;
        name: string;
        value?: /* google.protobuf.StringValue */ string | null;
      }

      export interface TestIpBansRequest {
        // The IP address(es) (separated by spaces or commas) to test to see if they're banned.
        ips: string;
      }

      export interface TestIpBansResponse {
        // Maps between the parsed IP(s) from the request to its existing IpBan if it
        // exists. If it doesn't exist, an empty IpBan (with id 0) will be returned.
        ipBans: { [key: string]: Kaggle.Sdk.Admin.IpBan | null };
      }

      export interface UpdateAutoFormModelRequest {
        typeName?: /* google.protobuf.StringValue */ string | null;
        id: number;
        model?: Kaggle.Sdk.Admin.AutoFormModel | null;
      }

      export interface UpdateLoggingConfigRequest {
        value: string;
      }

      export interface UpdateSiteConfigRequest {
        id: number;
        value: string;
      }

      export enum AutoFormPropertyType {
        BOOL = "bool", // = 0;
        CODE = "code", // = 1;
        DATE_TIME = "dateTime", // = 2;
        ENUM = "enum", // = 3;
        FLOAT = "float", // = 4;
        INT = "int", // = 5;
        STRING = "string", // = 6;
        TEXT = "text", // = 7;
      }
      // Services related exclusively to the "Genie" admin section.
      // File drop/pickup functionality.
      // Admin service used for banning IP addresses (i.e. for malicious users).
    }

    export namespace Blobs {
      export interface StartBlobUploadRequest {
        // The destination bucket where to upload the blob.
        // NOTE: Untrusted clients will be able to change this.
        bucket: Kaggle.Sdk.Blobs.ClientBlobBucket;
        // Name (e.g. file name) of the blob.
        name: string;
        // Content/MIME type (e.g. "text/plain").
        contentType?: string;
        // Size in bytes of the blob.
        contentLength: number;
        // Optional user-reported time when the blob was last updated/modified.
        lastUpdateTime: /* google.protobuf.Timestamp */ string | null;
      }

      export interface StartBlobUploadResponse {
        // Opaque string token used to reference the new blob/file.
        token: string;
        // URL to use to start the upload.
        createUrl: string;
      }
      // GCS bucket references to where a client/frontend can upload blobs.
      // These are mapped to the actual bucket via RegisterSingletonBucket.
      export enum ClientBlobBucket {
        UNSPECIFIED = "unspecified", // = 0;
        COMPETITION_DATA_FILES = "competitionDataFiles", // = 1;
        COMPETITION_SUBMISSIONS = "competitionSubmissions", // = 2;
        COMPETITION_SOLUTIONS = "competitionSolutions", // = 3;
        INBOX_FILES = "inboxFiles", // = 4;
        FORUM_MESSAGE_ATTACHMENT_FILES = "forumMessageAttachmentFiles", // = 5;
        TEAM_MODEL_FILES = "teamModelFiles", // = 6;
        USER_CONTENT = "userContent", // = 7;
        DATASET_VERSION_FILES_V2 = "datasetVersionFilesV2", // = 8;
        KERNEL_SESSION_FILES = "kernelSessionFiles", // = 9;
        LEARN_CERTIFICATES = "learnCertificates", // = 10;
        ORGANIZATIONS = "organizations", // = 11;
      }
      // Binary Large OBject (BLOB) service used for uploading files to Google Cloud Storage (GCS).
    }

    export namespace Chime {
      export interface SendSmsResponse {
        normalizedPhoneNumber?: /* google.protobuf.StringValue */ string | null;
        isSuccessful: boolean;
        apiTransactionId?: /* google.protobuf.StringValue */ string | null;
        errorMessage?: /* google.protobuf.StringValue */ string | null;
      }

      export interface TestSmsRequest {
        to?: /* google.protobuf.StringValue */ string | null;
        message?: /* google.protobuf.StringValue */ string | null;
      }
    }

    export namespace Cms {
      export interface CmsPage {
        isCreatingPage: boolean;
        isEditingPage: boolean;
        title?: /* google.protobuf.StringValue */ string | null;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        imageUrl?: /* google.protobuf.StringValue */ string | null;
        mimeType?: /* google.protobuf.StringValue */ string | null;
        pageContent?: /* google.protobuf.StringValue */ string | null;
        createTime: /* google.protobuf.Timestamp */ string | null;
        id: number;
        isPublished: boolean;
        url?: /* google.protobuf.StringValue */ string | null;
        userDisplayName?: /* google.protobuf.StringValue */ string | null;
        username?: /* google.protobuf.StringValue */ string | null;
        isDocPage: boolean;
        docPageOrder?: /* google.protobuf.Int32Value */ number | null;
        allowUnsanitizedHtml: boolean;
        isNewWorld: boolean;
      }

      export interface DocsPage {
        id: number;
        url?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        createTime: /* google.protobuf.Timestamp */ string | null;
        docPageOrder?: /* google.protobuf.Int32Value */ number | null;
        content?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListDocsRequest {
        wantContent: boolean;
      }

      export interface ListDocsResponse {
        docsPages: Kaggle.Sdk.Cms.DocsPage[];
      }

      export interface ListPagesRequest {
        filter?: Kaggle.Sdk.Cms.CmsFilterBy;
        group?: Kaggle.Sdk.Cms.CmsGroupBy;
        sort?: Kaggle.Sdk.Cms.CmsSortBy;
        search?: string;
      }

      export interface ListPagesResponse {
        pages: Kaggle.Sdk.Cms.CmsPage[];
      }

      export interface UpdateDocPageOrderRequest {
        pageId: number;
        orderNum: number;
      }

      export interface UpdatePageRequest {
        id: number;
        imageUrl?: /* google.protobuf.StringValue */ string | null;
        isPublished: boolean;
        mimeType?: /* google.protobuf.StringValue */ string | null;
        pageContent?: /* google.protobuf.StringValue */ string | null;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        isDocPage: boolean;
        docPageOrder?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface UpdatePageResponse {
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export enum CmsFilterBy {
        UNSPECIFIED = "unspecified", // = 0;
        ALL = "all", // = 1;
        PUBLISHED = "published", // = 2;
        UNPUBLISHED = "unpublished", // = 3;
      }

      export enum CmsGroupBy {
        UNSPECIFIED = "unspecified", // = 0;
        ALL = "all", // = 1;
        DOCUMENTATION_PAGES = "documentationPages", // = 2;
      }

      export enum CmsSortBy {
        UNSPECIFIED = "unspecified", // = 0;
        EARLIEST = "earliest", // = 1;
        LATEST = "latest", // = 2;
        DOC_PAGE_ORDER = "docPageOrder", // = 3;
      }
      // CMS = Content Management System
    }

    export namespace Common {
      export namespace Models {
        export namespace Legacy {
          export interface PageMessageDto {
            id: string | null;
            type: Kaggle.Sdk.Common.Models.Legacy.PageMessageType;
            message: string | null;
            dangerousHtmlMessage: string | null;
            isPersistent: boolean;
            faIcon: string | null;
          }

          export enum PageMessageType {
            ERROR = "error", // = 0;
            INFO = "info", // = 1;
            WARNING = "warning", // = 2;
            SUCCESS = "success", // = 3;
            SITE = "site", // = 4;
          }
        }

        export interface VoteButtonModel {
          totalVotes: /*Int32*/ number;
          medalVotes: /*Int32*/ number;
          hasAlreadyVotedUp: boolean;
          hasAlreadyVotedDown: boolean;
          canUpvote: boolean;
          canDownvote: boolean;
          voters: Kaggle.Sdk.Datasets.SimpleUserDto[];
          currentUserInfo: Kaggle.Sdk.Datasets.SimpleUserDto | null;
          showVoters: boolean;
          alwaysShowVoters: boolean;
          kernelId: /* Int32 */ number | null;
          datasetId: /* Int32 */ number | null;
          forumMessageId: /* Int32 */ number | null;
        }
      }

      export interface Category {
        id: number;
        name?: /* google.protobuf.StringValue */ string;
        fullPath?: /* google.protobuf.StringValue */ string;
        listingUrl?: /* google.protobuf.StringValue */ string;
        description?: /* google.protobuf.StringValue */ string;
        isInherited: boolean;
        datasetCount: number;
        competitionCount: number;
        scriptCount: number;
        totalCount: number;
        tagUrl?: /* google.protobuf.StringValue */ string;
      }

      export interface CroppedImageRectangle {
        // Title of the crop (e.g. "thumbnail").  
        title?: string;
        top: number;
        left: number;
        width: number;
        height: number;
      }
      // This is the result of our <ImageUploader /> React component.
      export interface CroppedImageUpload {
        // Token that represents the image blob.
        // It's optional since you can crop an existing image by URL and thus just update the rectangle(s).
        token?: /* google.protobuf.StringValue */ string | null;
        // Cropped rectangles (i.e. for selecting a smaller rectangle from the image in the token).  
        cropRectangles: Kaggle.Sdk.Common.CroppedImageRectangle[];
      }
      // Represents an HTTP redirect (e.g. 301 or 302) response.
      // Patterned after ASP.NET MVC's RedirectResult.
      export interface HttpRedirect {
        // Destination URL for the redirect.
        url: string;
        // Should it be an HTTP 301 (permanent) redirect or just temporary (HTTP 302)?.
        permanent: boolean;
      }

      export interface Image {
        src?: /* google.protobuf.StringValue */ string | null;
        alt?: /* google.protobuf.StringValue */ string | null;
      }

      export interface PageMessage {
        id?: /* google.protobuf.StringValue */ string | null;
        type: Kaggle.Sdk.Common.PageMessageType;
        message?: /* google.protobuf.StringValue */ string | null;
        dangerousHtmlMessage?: /* google.protobuf.StringValue */ string | null;
        isPersistent: boolean;
      }

      export interface VoteButton {
        totalVotes: number;
        medalVotes?: /* google.protobuf.Int32Value */ number | null;
        hasAlreadyVotedUp: boolean;
        hasAlreadyVotedDown: boolean;
        canUpvote: boolean;
        canDownvote: boolean;
        voters: Kaggle.Sdk.Users.User[];
        currentUserInfo: Kaggle.Sdk.Users.User | null;
        showVoters: boolean;
        alwaysShowVoters: boolean;
        kernelId?: /* google.protobuf.Int32Value */ number | null;
        datasetId?: /* google.protobuf.Int32Value */ number | null;
        forumMessageId?: /* google.protobuf.Int32Value */ number | null;
      }

      export enum PageMessageType {
        ERROR = "error", // = 0;
        INFO = "info", // = 1;
        WARNING = "warning", // = 2;
        SUCCESS = "success", // = 3;
        SITE = "site", // = 4;
      }
      // Type/direction of a vote.
      export enum VoteType {
        UNSPECIFIED = "unspecified", // = 0;
        // Casts an approval/positive vote.
        UPVOTE = "upvote", // = 1;
        // Removes a previous vote.
        DELETE_VOTE = "deleteVote", // = 2;
      }
    }

    export namespace Competitions {
      export namespace CreateSubmissionRequest {
        export interface FileSource {
          // Token for GCS upload of user's submission file in our temp (inbox) dir.
          gcsBlobToken: string;
        }

        export interface KernelSource {
          // AKA kernel_session_id AKA script_version_id
          kernelRunId: number;
          // Filename in the Output Files of the above Kernel Session
          fileName: string;
          // *
          // Do not verify that the output file is present.
          // For the CreateSubmissionHandler, if this is true then the
          // competition must be a synchronous rerun competition.
          skipOutputFileCheck: boolean;
        }
      }

      export namespace Foreign {
        // Subset of the full Category object with seemingly everything needed for now.
        // Also known as Tag.
        export interface Category {
          id: number;
          // The name of the category.
          name: string;
          // The category's full path.
          fullPath: string;
          // A description of the category.
          description: string;
          // The number of datasets tagged with this category.
          datasetCount: number;
          // The number of competitions tagged with this category.
          competitionCount: number;
          // The number of kernels tagged with this category.
          scriptCount: number;
          // The name of the category, as it appears in the URL.
          slug: string;
          // The display name of the category.
          displayName: string;
        }
        /// <summary>
        /// This is to support getting required CurrentDatabundleVersionIds for
        /// Competition reruns, potentially in bulk.  If our query layer were extended
        /// outside the Competitions project, this should live in Datasets space.
        /// Keeping this intentionally thin for now to limit the dependency.
        /// </summary>
        export interface Databundle {
          id: number;
          currentDatabundleVersionId: number;
        }
        // Subset of the full Organization object with everything needed for our new world where Organization pages
        // are turned down, and only shown with minimal details in Comps and Datasets pages.
        export interface Organization {
          id: number;
          name: string;
          thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        }
        // Subset of the full User object, currently only using fields required by
        // Competitions code, specifically around Team Members and Admin Emails.
        export interface User {
          // The user's ID.
          id: number;
          // The user's display name.
          displayName: string;
          email: string;
          imageThumbName: string;
          // The name of the user as shown in the URL of their profile page.
          userName: string;
          performanceTier: Kaggle.Sdk.Users.UserAchievementTier;
        }
      }

      export namespace InitiateBulkRerunRequest {
        export interface KernelRunSettings {
          // Currently unused.
          maxRamGb: number;
          // Currently unused.
          maxDiskGb: number;
          // Currently unused.
          maxCpuRuntimeHours: number;
          // Currently unused.
          maxGpuRuntimeHours: number;
          cpuWorkerPoolName?: /* google.protobuf.StringValue */ string | null;
          gpuWorkerPoolName?: /* google.protobuf.StringValue */ string | null;
        }

        export interface RerunSubmissionSelector {
          // If > 0, we won't select more Submissions than specified here.
          maxSubmissions: number;
          // If set and non-empty, we will only look for Submissions with the given Ids.
          submissionIds: number[];
          // If set, take unselected Submissions with highest Public Score up to
          // Competition.NumScoredSubmissions.
          autoSelect: boolean;
        }
      }

      export namespace Legacy {
        export namespace ColumnMapping {
          export enum Type {
            UNSPECIFIED = "unspecified", // = 0;
            SOLUTION = "solution", // = 1;
            SUBMISSION = "submission", // = 2;
          }
        }

        export namespace RescoreSubmissionsRequest {
          export interface SpecificSubmissions {
            submissionIds: number[];
            teamIds: number[];
          }
        }

        export interface AddHostUserRequest {
          competitionId: number;
          hostUserId: number;
        }

        export interface AddHostUserResponse {}
        // Similar to https://github.com/googleapis/googleapis/blob/master/google/longrunning/operations.proto
        // Has historically only been used by Competitions but could eventually be made into an official (non-Legacy) service.
        export interface BackgroundOperation {
          id: string;
          name: string;
          done: boolean;
          // This is an "any" type in the normal LongRunningOperation, but we only use it for this purpose.
          metadata: Kaggle.Sdk.Competitions.Legacy.SubmissionsRange | null;
          error?: /* google.protobuf.StringValue */ string | null;
          progress?: /* google.protobuf.StringValue */ string | null;
          // Convenience URL that allows manual polling of the latest status.
          statusUrl: string;
        }
        // Describes a single column in a dataframe.
        export interface ColumnDefinition {
          name: string;
          parsingDataType: string;
        }

        export interface ColumnMapping {
          type: Kaggle.Sdk.Competitions.Legacy.ColumnMapping.Type;
          warnings: string[];
          // Maps column keys to current selected column definition name.
          columnMappings: { [key: string]: Kaggle.Sdk.Competitions.Legacy.ColumnMappingValue | null };
          columnDefinitions: Kaggle.Sdk.Competitions.Legacy.ColumnDefinition[];
        }

        export interface ColumnMappingValue {
          name?: /* google.protobuf.StringValue */ string | null;
        }

        export interface CompetitionCardDto {
          competitionId: number;
          competitionName?: /* google.protobuf.StringValue */ string | null;
          competitionTitle?: /* google.protobuf.StringValue */ string | null;
          competitionDescription?: /* google.protobuf.StringValue */ string | null;
          competitionUrl?: /* google.protobuf.StringValue */ string | null;
          coverImageUrl?: /* google.protobuf.StringValue */ string | null;
          thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
          deadline: /* google.protobuf.Timestamp */ string | null;
          totalTeams: number;
          totalKernels: number;
          rewardQuantity?: /* google.protobuf.DoubleValue */ number | null;
          rewardTypeName?: /* google.protobuf.StringValue */ string | null;
          organizationName?: /* google.protobuf.StringValue */ string | null;
          organizationUrl?: /* google.protobuf.StringValue */ string | null;
          organizationAvatarUrl?: /* google.protobuf.StringValue */ string | null;
          hostSegment: Kaggle.Sdk.Competitions.HostSegment;
          hostSegmentTitle?: /* google.protobuf.StringValue */ string | null;
          isLimited: boolean;
          isPrivate: boolean;
          isInClass: boolean;
          userHasEntered: boolean;
          userRank?: /* google.protobuf.Int32Value */ number | null;
          medal: Kaggle.Sdk.Users.Medal;
          userTeamUsers: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardMemberDto[];
          categories: Kaggle.Sdk.Tags.TagList | null;
          mergerDeadline: /* google.protobuf.Timestamp */ string | null;
          newEntrantDeadline: /* google.protobuf.Timestamp */ string | null;
          enabledDate: /* google.protobuf.Timestamp */ string | null;
          maxDailySubmissions: number;
          maxTeamSize?: /* google.protobuf.Int32Value */ number | null;
          evaluationMetric?: /* google.protobuf.StringValue */ string | null;
          awardsPoints: boolean;
          isKernelsSubmissionsOnly: boolean;
          submissionsDisabled: boolean;
          rewardDisplay?: /* google.protobuf.StringValue */ string | null;
          isOngoingCompetition: boolean;
        }

        export interface CompetitionDto {
          competitionId: number;
          competitionType: Kaggle.Sdk.Competitions.CompetitionType;
          competitionTitle?: /* google.protobuf.StringValue */ string | null;
          briefDescription?: /* google.protobuf.StringValue */ string | null;
          competitionHeaderImageUrl?: /* google.protobuf.StringValue */ string | null;
          organizationId?: /* google.protobuf.Int32Value */ number | null;
          organizationName?: /* google.protobuf.StringValue */ string | null;
          organizationThumbnailUrl?: /* google.protobuf.StringValue */ string | null;
          hasAcceptedRules: boolean;
          dateEnabled: /* google.protobuf.Timestamp */ string | null;
          deadline: /* google.protobuf.Timestamp */ string | null;
          mergerDeadline: /* google.protobuf.Timestamp */ string | null;
          newEntrantDeadline: /* google.protobuf.Timestamp */ string | null;
          rewardQuantity?: /* google.protobuf.DoubleValue */ number | null;
          rewardTypeName?: /* google.protobuf.StringValue */ string | null;
          totalTeams: number;
          isInClass: boolean;
          hostSegment: Kaggle.Sdk.Competitions.HostSegment;
          canEdit: boolean;
          canEditMetadata: boolean;
          rules: Kaggle.Sdk.Competitions.Legacy.CompetitionPage | null;
          dataIntro: Kaggle.Sdk.Competitions.Legacy.CompetitionPage | null;
          competitionSlug?: /* google.protobuf.StringValue */ string | null;
          numPrizes: number;
          leaderboardPercentage: number;
          hasLimitedParticipation: boolean;
          discussion: Kaggle.Sdk.Discussions.TopicListDto | null;
          competitionThumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
          newTopic: Kaggle.Sdk.Discussions.NewTopicDto | null;
          numScoredSubmissions: number;
          maxDailySubmissions: number;
          maxDailySubmissionsResetDate: /* google.protobuf.Timestamp */ string | null;
          remainingDailySubmissions?: /* google.protobuf.Int32Value */ number | null;
          totalSolutionRows?: /* google.protobuf.Int32Value */ number | null;
          team: Kaggle.Sdk.Competitions.Legacy.CompetitionTeamDto | null;
          maxTeamSize?: /* google.protobuf.Int32Value */ number | null;
          topicTitle?: /* google.protobuf.StringValue */ string | null;
          totalCompetitors?: /* google.protobuf.Int32Value */ number | null;
          totalEntries: number;
          countsTowardsRanking: boolean;
          countsTowardsTiers: boolean;
          evaluationAlgorithm: Kaggle.Sdk.Competitions.EvaluationAlgorithm | null;
          allowPrivateLeaderboardDisplay: boolean;
          isCreatingCompetition: boolean;
          pages: Kaggle.Sdk.Competitions.Legacy.CompetitionPage[];
          databundleVersionId?: /* google.protobuf.Int32Value */ number | null;
          databundleVersions: Kaggle.Sdk.Datasets.CompetitionDatabundleVersion[];
          submissionsAreDisabled: boolean;
          hasLeaderboard: boolean;
          finalLeaderboardHasBeenVerified: boolean;
          witholdFinalLeaderboardUntilItHasBeenVerified: boolean;
          isPrivate: boolean;
          publicLeaderboardMessage?: /* google.protobuf.StringValue */ string | null;
          privateLeaderboardMessage?: /* google.protobuf.StringValue */ string | null;
          disablePrizeIndicator: boolean;
          hasKernels: boolean;
          hasSolutionFile: boolean;
          userRankMultiplier: number;
          needsPhoneVerification: boolean;
          scoringIsMax: boolean;
          rawDataUrl?: /* google.protobuf.StringValue */ string | null;
          canSubmitModel: boolean;
          mySubmissionsCount?: /* google.protobuf.Int32Value */ number | null;
          mostRecentSubmissionStatus: Kaggle.Sdk.Competitions.Legacy.SubmissionStatusDto | null;
          isCompetitionHost: boolean;
          allowTeamMergers: boolean;
          hostSegments: Kaggle.Sdk.Competitions.Legacy.HostSegmentItem[];
          hostSegmentTitle?: /* google.protobuf.StringValue */ string | null;
          canParticipate: boolean;
          isCompetitionPending: boolean;
          competitionHasLaunched: boolean;
          competitionHasEnded: boolean;
          shareToken?: /* google.protobuf.StringValue */ string | null;
          ownerTwitter?: /* google.protobuf.StringValue */ string | null;
          externalCompetitionThumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
          competitionUrl?: /* google.protobuf.StringValue */ string | null;
          mergerDeadlineHasPassed: boolean;
          categories: Kaggle.Sdk.Tags.TagList | null;
          competitionHostClaims: Kaggle.Sdk.Competitions.Legacy.CompetitionHostClaims | null;
          newEntrantDeadlineHasPassed: boolean;
          onlyAllowKernelSubmissions: boolean;
          requiresSameRowCountInSubmissionAndSolution: boolean;
          enableLazyLeaderboard: boolean;
          rulesRequired: boolean;
          usesSynchronousReruns: boolean;
          modelFileName?: /* google.protobuf.StringValue */ string | null;
          modelFileSizeBytes?: /* google.protobuf.Int64Value */ number | null;
          isOngoingCompetition: boolean;
        }

        export interface CompetitionGroupDto {
          grouping: Kaggle.Sdk.Competitions.CompetitionGrouping;
          totalCompetitions: number;
          competitions: Kaggle.Sdk.Competitions.Legacy.CompetitionCardDto[];
        }

        export interface CompetitionHostClaims {
          readSettings: boolean;
          writeSettings: boolean;
          writeDescriptions: boolean;
          writeDeadline: boolean;
          readSubmissions: boolean;
          writeSubmissions: boolean;
          invalidateSubmissions: boolean;
          rescoreSubmissions: boolean;
          readEvaluation: boolean;
          writeEvaluation: boolean;
          writeTeamVisibility: boolean;
          updateCategory: boolean;
          launchCompetition: boolean;
          writeBenchmarks: boolean;
          writeTeamMergers: boolean;
          isCompetitionHost: boolean;
        }

        export interface CompetitionLeaderboardMemberDto {
          profileUrl?: /* google.protobuf.StringValue */ string | null;
          thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
          tier: Kaggle.Sdk.Users.UserAchievementTier;
          displayName?: /* google.protobuf.StringValue */ string | null;
        }

        export interface CompetitionLeaderboardSubmissionDto {
          teamId: number;
          rank?: /* google.protobuf.Int32Value */ number | null;
          change?: /* google.protobuf.Int32Value */ number | null;
          medal: Kaggle.Sdk.Users.Medal;
          teamName?: /* google.protobuf.StringValue */ string | null;
          teamMembers: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardMemberDto[];
          score?: /* google.protobuf.StringValue */ string | null;
          entries: number;
          lastSubmission: /* google.protobuf.Timestamp */ string | null;
          sourceKernelName?: /* google.protobuf.StringValue */ string | null;
          sourceKernelUrl?: /* google.protobuf.StringValue */ string | null;
          submissionId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface CompetitionPage {
          // Using a wrapper type for ids since replacing the page doesn't requiring the
          // existing values.
          id?: /* google.protobuf.Int32Value */ number | null;
          postId?: /* google.protobuf.Int32Value */ number | null;
          content: string;
          mimeType: string;
          name: string;
          isPublished?: /* google.protobuf.BoolValue */ boolean | null;
        }

        export interface CompetitionTeamDto {
          id: number;
          name?: /* google.protobuf.StringValue */ string | null;
          canCreateMerger: boolean;
          members: Kaggle.Sdk.Competitions.Legacy.CompetitionTeamMemberDto[];
        }

        export interface CompetitionTeamInfoDto {
          id: number;
          rank?: /* google.protobuf.Int32Value */ number | null;
          name?: /* google.protobuf.StringValue */ string | null;
          entries: number;
          entriesSizeInBytes: number;
          publicScore?: /* google.protobuf.StringValue */ string | null;
          downloadTeamModelUrl?: /* google.protobuf.StringValue */ string | null;
          isBenchmark: boolean;
          privateScore?: /* google.protobuf.StringValue */ string | null;
        }

        export interface CompetitionTeamMemberDto {
          userId: number;
          displayName?: /* google.protobuf.StringValue */ string | null;
          userUrl?: /* google.protobuf.StringValue */ string | null;
          avatarUrl?: /* google.protobuf.StringValue */ string | null;
          tier: Kaggle.Sdk.Users.UserAchievementTier;
          isTeamLeader: boolean;
        }

        export interface EvaluationInfo {
          metrics: Kaggle.Sdk.Competitions.Legacy.EvaluationMetricMetadata[];
          metric: Kaggle.Sdk.Competitions.Legacy.EvaluationMetric | null;
          parameters: Kaggle.Sdk.Competitions.Legacy.EvaluationMetricParameter[];
          solutionColumnMapping: Kaggle.Sdk.Competitions.Legacy.ColumnMapping | null;
          submissionColumnMapping: Kaggle.Sdk.Competitions.Legacy.ColumnMapping | null;
          solutionInfo: Kaggle.Sdk.Competitions.Legacy.SolutionInfo | null;
          steps: Kaggle.Sdk.Competitions.Legacy.EvaluationStep[];
          isCompetitionEnabled: boolean;
          isCompetitionClosed: boolean;
        }

        export interface EvaluationMetric {
          id: number;
          name: string;
          abbreviation: string;
          description?: /* google.protobuf.StringValue */ string | null;
          isPublic: boolean;
          solutionColumns: Kaggle.Sdk.Competitions.Legacy.ColumnDefinition[];
          submissionColumns: Kaggle.Sdk.Competitions.Legacy.ColumnDefinition[];
          parameters: Kaggle.Sdk.Competitions.Legacy.EvaluationMetricParameter[];
        }

        export interface EvaluationMetricMetadata {
          id: number;
          name: string;
          isPublic: boolean;
          abbr: string;
        }
        // (Hyper)parameter used to configure an evaluation metric.
        export interface EvaluationMetricParameter {
          name: string;
          type: string;
          value: string;
        }

        export interface GetBackgroundOperationRequest {
          id: string;
        }

        export interface GetCompetitionHasSubmissionColumnMappingRequest {
          competitionId: number;
        }

        export interface GetCompetitionHasSubmissionColumnMappingResponse {
          hasSubmissionColumnMapping: boolean;
        }

        export interface GetEvaluationMetricRequest {
          competitionId: number;
          metricId: number;
        }

        export interface GetHostChecklistRequest {
          competitionId: number;
        }

        export interface GetHostClaimsRequest {
          competitionId: number;
        }
        // All things metrics related:
        export interface GetHostEvaluationInfoRequest {
          competitionId: number;
        }

        export interface GetMostRecentSubmissionStatusRequest {
          // Must be provided.
          competitionId: number;
          // All three are optional filters to restrict the Submission search.
          submissionId?: /* google.protobuf.Int32Value */ number | null;
          teamId?: /* google.protobuf.Int32Value */ number | null;
          greaterThanSubmissionId?: /* google.protobuf.Int32Value */ number | null;
          // Whether the skip the extra calculation of this field.
          ignoreRemainingDailySubmissions: boolean;
        }

        export interface GetSolutionColumnMappingRequest {
          competitionId: number;
        }

        export interface GetSolutionColumnMappingResponse {
          solutionColumnMapping: Kaggle.Sdk.Competitions.Legacy.ColumnMapping | null;
        }

        export interface GetSolutionInfoRequest {
          competitionId: number;
        }

        export interface GetSubmissionColumnMappingRequest {
          competitionId: number;
        }

        export interface GetSubmissionColumnMappingResponse {
          submissionColumnMapping: Kaggle.Sdk.Competitions.Legacy.ColumnMapping | null;
        }

        export interface HostChecklist {
          isCompetitionPending: boolean;
          children: Kaggle.Sdk.Competitions.Legacy.HostChecklistItem[];
        }

        export interface HostChecklistItem {
          ok: boolean;
          message: string;
          action?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
          tips: string[];
          useHistory: boolean;
        }

        export interface HostEvaluationInfo {
          evaluationInfo: Kaggle.Sdk.Competitions.Legacy.EvaluationInfo | null;
          topMetricIds: number[];
        }

        export interface HostSegmentItem {
          value: Kaggle.Sdk.Competitions.HostSegment;
          label?: /* google.protobuf.StringValue */ string | null;
        }

        export interface HostUserAvatar {
          user: Kaggle.Sdk.Users.UserAvatar | null;
          isAlreadyHost: boolean;
        }

        export interface InvalidateSubmissionsRequest {
          competitionId: number;
          submissionIdsToInvalidate: number[];
          teamIdsToInvalidate: number[];
        }

        export interface LaunchCompetitionRequest {
          competitionId: number;
          // Optional time in the future to launch the competition rather than launching
          // it immediately.
          futureTime: /* google.protobuf.Timestamp */ string | null;
        }

        export interface LaunchCompetitionResponse {
          // The time when the competition launched (or will launch).
          launchTime: /* google.protobuf.Timestamp */ string | null;
        }
        // Differs from ColumnMapping for historical reasons, but should eventually
        // merge that one and this one.
        export interface LegacyColumnMapping {
          mappedColumnNames: { [key: string]: string };
          samplingMethod?: string;
          samplingPercentage?: number;
        }

        export interface LegacyGetCompetitionRequest {
          competitionIdOrName?: /* google.protobuf.StringValue */ string | null;
        }

        export interface LegacyGetLeaderboardRequest {
          competitionId: number;
          leaderboardType: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardType;
          pageSize?: /* google.protobuf.Int32Value */ number | null;
          includeNearUser: boolean;
          includeAfterUser: boolean;
          includeBeforeUser: boolean;
        }

        export interface LegacyGetLeaderboardResponse {
          submissions: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardSubmissionDto[];
          beforeUser: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardSubmissionDto[];
          nearUser: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardSubmissionDto[];
          afterUser: Kaggle.Sdk.Competitions.Legacy.CompetitionLeaderboardSubmissionDto[];
          userRanking?: /* google.protobuf.Int32Value */ number | null;
          totalRankings: number;
        }

        export interface LegacyListCompetitionsRequest {
          tab: Kaggle.Sdk.Competitions.CompetitionListTab;
          category: Kaggle.Sdk.Competitions.HostSegment;
          sortBy: Kaggle.Sdk.Competitions.CompetitionSortBy;
          search?: /* google.protobuf.StringValue */ string | null;
          // 0 means anonymous. Null means infer CurrentUserId.
          userId?: /* google.protobuf.Int32Value */ number | null;
          isProfileListing: boolean;
          page: number;
        }

        export interface LegacyListCompetitionsResponse {
          sortByOptions: Kaggle.Sdk.Competitions.Legacy.ValueLabel[];
          tabOptions: Kaggle.Sdk.Competitions.Legacy.ValueLabel[];
          categoryOptions: Kaggle.Sdk.Competitions.Legacy.ValueLabel[];
          fullCompetitionGroups: Kaggle.Sdk.Competitions.Legacy.CompetitionGroupDto[];
          pagedCompetitionGroup: Kaggle.Sdk.Competitions.Legacy.CompetitionGroupDto | null;
          values: Kaggle.Sdk.Competitions.Legacy.ViewCompetitionListValuesDto | null;
        }

        export interface LegacyListTeamsRequest {
          competitionId: number;
          sortBy: Kaggle.Sdk.Competitions.Legacy.CompetitionTeamSortBy;
          filter?: /* google.protobuf.StringValue */ string | null;
          hideUnrankedTeams: boolean;
          page?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface LegacyListTeamsResponse {
          teamsList: Kaggle.Sdk.Competitions.Legacy.CompetitionTeamInfoDto[];
          hasMoreData: boolean;
          sortByOptions: Kaggle.Sdk.Competitions.Legacy.ValueLabel[];
          totalTeams: number;
          totalSubmissions: number;
        }
        // Specifically built for the ListSandboxSubmissions endpoint.
        export interface LegacySandboxSubmission {
          id: number;
          name: string;
          publicScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          privateScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          submissionStatus: Kaggle.Sdk.Competitions.SubmissionStatus;
          error?: /* google.protobuf.StringValue */ string | null;
          dateSubmitted: /* google.protobuf.Timestamp */ string | null;
          isBenchmark: boolean;
          downloadUrl: string;
        }
        // Contains raw Submission data, as well as extended data about scoring progress, such as position in pipeline and
        // estimated wait and score durations.
        export interface LegacySubmissionExtended {
          id: number;
          name: string;
          publicScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          privateScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          previousBestPublicScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          submissionStatus: Kaggle.Sdk.Competitions.SubmissionStatus;
          error?: /* google.protobuf.StringValue */ string | null;
          estimatedWaitDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          estimatedScoreDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          // May not be set correctly if not requested by the caller.
          remainingDailySubmissions?: /* google.protobuf.Int32Value */ number | null;
          totalSubmissionsInLine: number;
          elapsedWaitDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          elapsedScoreDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          dateSubmitted: /* google.protobuf.Timestamp */ string | null;
          competitionName: string;
          competitionSlug: string;
          userDisplayName: string;
          userName: string;
          priority: Kaggle.Sdk.Competitions.Legacy.LegacyWorkerPriority;
          isBenchmark: boolean;
          downloadUrl: string;
        }

        export interface LegacyTeamSubmission {
          id: number;
          name?: /* google.protobuf.StringValue */ string | null;
          contentLength?: /* google.protobuf.Int64Value */ number | null;
          details?: /* google.protobuf.StringValue */ string | null;
          teamName?: /* google.protobuf.StringValue */ string | null;
          date: /* google.protobuf.Timestamp */ string | null;
          privateScore?: /* google.protobuf.StringValue */ string | null;
          publicScore?: /* google.protobuf.StringValue */ string | null;
          isSelected: boolean;
          status: Kaggle.Sdk.Competitions.SubmissionStatus;
          errorDetails?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
          // This is used on the client, and not currently set by the service
          isChecked: boolean;
          versionName?: /* google.protobuf.StringValue */ string | null;
          version?: /* google.protobuf.Int32Value */ number | null;
          latestVersion?: /* google.protobuf.Int32Value */ number | null;
          isAfterDeadline: boolean;
          submittedBy?: /* google.protobuf.StringValue */ string | null;
          submittedByUrl?: /* google.protobuf.StringValue */ string | null;
          syncRerunState: Kaggle.Sdk.Competitions.CompetitionKernelRerunState | null;
        }

        export interface ListHostUsersRequest {
          competitionId: number;
        }

        export interface ListHostUsersResponse {
          hosts: Kaggle.Sdk.Users.UserAvatar[];
        }

        export interface ListMySubmissionsRequest {
          competitionId: number;
          sortBy: Kaggle.Sdk.Competitions.SubmissionSortBy;
          group: Kaggle.Sdk.Competitions.SubmissionGroup;
          page?: /* google.protobuf.Int32Value */ number | null;
          pageSize?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface ListMySubmissionsResponse {
          submissions: Kaggle.Sdk.Competitions.Legacy.LegacyTeamSubmission[];
        }

        export interface ListSandboxSubmissionsRequest {
          competitionId: number;
        }

        export interface ListSandboxSubmissionsResponse {
          sandboxSubmissions: Kaggle.Sdk.Competitions.Legacy.LegacySandboxSubmission[];
        }

        export interface ListTeamSubmissionsRequest {
          competitionId: number;
          teamId: number;
        }

        export interface ListTeamSubmissionsResponse {
          teamSubmissions: Kaggle.Sdk.Competitions.Legacy.LegacyTeamSubmission[];
        }

        export interface ObliterateEvaluationFromStepRequest {
          competitionId: number;
          // Used by frontend clients.
          stepId?: number;
          // Used internally for a specific step.
          evaluationStep?: Kaggle.Sdk.Competitions.Legacy.EvaluationStep;
        }
        // Used by the UI to let admins pick a specific range of submissions.
        export interface PagingParameters {
          // Number of submissions to skip/ignore from the start of the ordered list.
          skip?: number;
          // Number of submissions to actually pick from the ordered list.
          take?: number;
          // Minimum submission id to pick.
          minId?: number;
          // Maximum submission id to pick.
          maxId?: number;
        }

        export interface RemoveHostUserRequest {
          competitionId: number;
          hostUserId: number;
        }

        export interface RescoreSubmissionRequest {
          competitionId: number;
          submissionId: number;
        }

        export interface RescoreSubmissionsRequest {
          rescoreType: Kaggle.Sdk.Competitions.Legacy.BulkRescoreSubmissionsType;
          competitionId?: number;
          // Optional specific submissions by id or by team.
          specificSubmissionsToRescore: Kaggle.Sdk.Competitions.Legacy.RescoreSubmissionsRequest.SpecificSubmissions | null;
          pagingParameters: Kaggle.Sdk.Competitions.Legacy.PagingParameters | null;
          // Preview the rescore but don't actually do it.
          preview?: boolean;
        }

        export interface SearchHostUsersRequest {
          competitionId: number;
          query: string;
        }

        export interface SearchHostUsersResponse {
          users: Kaggle.Sdk.Competitions.Legacy.HostUserAvatar[];
        }

        export interface SetBenchmarkSubmissionNameRequest {
          competitionId: number;
          submissionId: number;
          name?: /* google.protobuf.StringValue */ string | null;
        }

        export interface SetEvaluationMetricParametersRequest {
          competitionId: number;
          nameValuePairs: { [key: string]: string };
        }

        export interface SetEvaluationMetricRequest {
          competitionId: number;
          metricId: number;
        }

        export interface SolutionInfo {
          hasRaw: boolean;
          hasDerived: boolean;
          rawFileName?: /* google.protobuf.StringValue */ string | null;
          rawDownloadUrl?: /* google.protobuf.StringValue */ string | null;
          derivedFileName?: /* google.protobuf.StringValue */ string | null;
          derivedDownloadUrl?: /* google.protobuf.StringValue */ string | null;
          uploadDate: /* google.protobuf.Timestamp */ string | null;
          usageColumnName?: /* google.protobuf.StringValue */ string | null;
          samplingPercentage: number;
          totalSolutionPrivateRows?: /* google.protobuf.Int32Value */ number | null;
          totalSolutionPublicRows?: /* google.protobuf.Int32Value */ number | null;
          totalSolutionRows?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface SubmissionsRange {
          count: number;
          minId: number;
          maxId: number;
        }

        export interface SubmissionStatusDto {
          id: number;
          name?: /* google.protobuf.StringValue */ string | null;
          privateScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          publicScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          previousBestPublicScoreFormatted?: /* google.protobuf.StringValue */ string | null;
          submissionStatus: Kaggle.Sdk.Competitions.SubmissionStatus;
          error?: /* google.protobuf.StringValue */ string | null;
          estimatedWaitDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          estimatedScoreDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          remainingDailySubmissions?: /* google.protobuf.Int32Value */ number | null;
          totalSubmissionsInLine: number;
          elapsedWaitDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          elapsedScoreDurationMilliseconds?: /* google.protobuf.Int32Value */ number | null;
          dateSubmitted: /* google.protobuf.Timestamp */ string | null;
          competitionName?: /* google.protobuf.StringValue */ string | null;
          competitionSlug?: /* google.protobuf.StringValue */ string | null;
          userDisplayName?: /* google.protobuf.StringValue */ string | null;
          userName?: /* google.protobuf.StringValue */ string | null;
          priority: Kaggle.Sdk.Competitions.Legacy.LegacyWorkerPriority;
          isBenchmark: boolean;
          downloadUrl?: /* google.protobuf.StringValue */ string | null;
        }

        export interface ToggleBenchmarkSubmissionRequest {
          competitionId: number;
          submissionId: number;
        }

        export interface UpdateCompetitionSettingsRequest {
          competitionId: number;
          title?: /* google.protobuf.StringValue */ string | null;
          slug: string;
          briefDescription?: /* google.protobuf.StringValue */ string | null;
          hostSegment: Kaggle.Sdk.Competitions.HostSegment;
          organizationId?: /* google.protobuf.Int32Value */ number | null;
          deadline: /* google.protobuf.Timestamp */ string | null;
          maxTeamSize?: /* google.protobuf.Int32Value */ number | null;
          allowTeamMergers: boolean;
          maxDailySubmissions: number;
          numScoredPrivateSubmissions: number;
          countsTowardsRanking: boolean;
          countsTowardsTiers: boolean;
        }

        export interface UpdateImagesRequest {
          competitionId: number;
          // These are two distinct images:
          header: Kaggle.Sdk.Common.CroppedImageUpload | null;
          thumbnail: Kaggle.Sdk.Common.CroppedImageUpload | null;
        }

        export interface UpdateImagesResponse {
          cardImageUrl?: /* google.protobuf.StringValue */ string | null;
          coverImageUrl?: /* google.protobuf.StringValue */ string | null;
          thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        }

        export interface UpdateOverviewRequest {
          competitionId: number;
          overviewPages: Kaggle.Sdk.Competitions.Legacy.CompetitionPage[];
        }

        export interface UpdateOverviewResponse {
          pages: Kaggle.Sdk.Competitions.Legacy.CompetitionPage[];
        }

        export interface UpdatePageRequest {
          competitionId: number;
          page: Kaggle.Sdk.Competitions.Legacy.CompetitionPage | null;
        }

        export interface UpdateSolutionColumnMappingRequest {
          competitionId: number;
          columnMapping: Kaggle.Sdk.Competitions.Legacy.LegacyColumnMapping | null;
        }

        export interface UpdateSubmissionColumnMappingRequest {
          competitionId: number;
          columnMapping: Kaggle.Sdk.Competitions.Legacy.LegacyColumnMapping | null;
        }

        export interface UpdateTeamVisibilityRequest {
          competitionId: number;
          hideTeam: boolean;
          teamIds: number[];
        }

        export interface ValueLabel {
          value?: /* google.protobuf.StringValue */ string | null;
          label?: /* google.protobuf.StringValue */ string | null;
        }

        export interface ViewCompetitionListValuesDto {
          page: number;
          tab: Kaggle.Sdk.Competitions.CompetitionListTab;
          sortBy: Kaggle.Sdk.Competitions.CompetitionSortBy;
          category: Kaggle.Sdk.Competitions.HostSegment;
          search?: /* google.protobuf.StringValue */ string | null;
        }

        export interface WaitBackgroundOperationRequest {
          id: string;
        }

        export enum BulkRescoreSubmissionsType {
          UNSPECIFIED = "unspecified", // = 0;
          ALL = "all", // = 1;
          COMPLETED = "completed", // = 2;
          COMPLETED_WITHOUT_DETAIL = "completedWithoutDetail", // = 3;
          AFTER_DEADLINE = "afterDeadline", // = 4;
          PENDING = "pending", // = 5;
          ERRORED = "errored", // = 6;
          SPECIFIC = "specific", // = 7;
          SITEWIDE_SPECIFIC = "sitewideSpecific", // = 8;
          SITEWIDE_PENDING = "sitewidePending", // = 9;
        }

        export enum CompetitionLeaderboardType {
          PUBLIC = "public", // = 0;
          PRIVATE = "private", // = 1;
          ACTIVE = "active", // = 2;
        }

        export enum CompetitionPageError {
          UNSPECIFIED = "unspecified", // = 0;
          // Page name has special meaning (e.g. "rules" or "data") and is reserved.
          RESERVED_NAME = "reservedName", // = 1;
          // Page name is already in use.
          DUPLICATE_NAME = "duplicateName", // = 2;
          CONCURRENT_EDIT = "concurrentEdit", // = 3;
        }

        export enum CompetitionTeamSortBy {
          RANK = "rank", // = 0;
          PUBLIC_SCORE_ASC = "publicScoreAsc", // = 1;
          PUBLIC_SCORE_DESC = "publicScoreDesc", // = 2;
          PRIVATE_SCORE_ASC = "privateScoreAsc", // = 3;
          PRIVATE_SCORE_DESC = "privateScoreDesc", // = 4;
        }

        export enum EvaluationStep {
          UNSPECIFIED = "unspecified", // = 0;
          METRIC = "metric", // = 1;
          PARAMETER = "parameter", // = 2;
          SOLUTION = "solution", // = 3;
          SOLUTION_MAPPING = "solutionMapping", // = 4;
          SUBMISSION = "submission", // = 5;
          SUBMISSION_MAPPING = "submissionMapping", // = 6;
        }

        export enum LegacyWorkerPriority {
          NORMAL = "normal", // = 0;
          BACKGROUND = "background", // = -1;
        }
        // Loosely based on https://github.com/googleapis/googleapis/blob/master/google/longrunning/operations.proto
        // Prefixed with "Background" to avoid conflict with that one.
        // Has historically only been used by Competitions but could eventually be made into an official (non-Legacy) service.
      }

      export namespace ListCompetitionsRequest {
        export namespace Selector {
          // Predefined query types.
          export enum ListOption {
            // Displays launched competitions.
            // (-- KAGGLE_INTERNAL: DateEnabled in the past --)
            DEFAULT = "default", // = 0;
            // Competitions that the current user has entered.
            // (-- KAGGLE_INTERNAL: Specifically, competitions where the user has a
            // team. --)
            USER_ENTERED = "userEntered", // = 1;
            // Competitions that the current user is a host for.
            // (-- KAGGLE_INTERNAL: host-via-admin ignored. --)
            USER_HOSTED = "userHosted", // = 2;
            // Unlaunched competitions.  Must be admin to use this.
            UNLAUNCHED = "unlaunched", // = 3;
            // Displays active competitions.
            // (-- KAGGLE_INTERNAL: date_enabled <= NOW < deadline. --)
            ACTIVE = "active", // = 4;
            // Displays completed competitions
            // (-- KAGGLE_INTERNAL: date_enabled != null && deadline < NOW. --)
            COMPLETED = "completed", // = 5;
            // Displays all competitions in the Current User's Your Work section.
            // (-- KAGGLE_INTERNAL: Complex query combining recent submissions,
            // rules acceptances, and Leaderboard presence. --)
            USER_YOUR_WORK = "userYourWork", // = 6;
            // Displays bookmarked competitions
            USER_BOOKMARKED = "userBookmarked", // = 7;
          }
          // Optional filters for competition prestige type.
          export enum PrestigeFilter {
            // Does not add a constraint for prestige type.
            UNSPECIFIED = "unspecified", // = 0;
            // Only returns competitions with monetary prizes.
            MONEY = "money", // = 1;
            // Only returns competitions which award medals.
            MEDALS = "medals", // = 2;
            // Only returns competitions which do not award money nor medals.
            OTHER = "other", // = 3;
          }
          // Predefined sort orders.
          export enum SortOption {
            // Currently equal to NEWEST.
            DEFAULT = "default", // = 0;
            // Shows the newest competitions first.
            // (-- KAGGLE_INTERNAL: Order by DateEnabled descending. --)
            NEWEST = "newest", // = 1;
            // Shows the oldest competitions first.
            // (-- KAGGLE_INTERNAL: Order by Deadline ascending. --)
            OLDEST = "oldest", // = 2;
            // Sorts by the competition's prize money.
            // (-- KAGGLE_INTERNAL: Orders by RewardQuantity descending. --)
            REWARD = "reward", // = 3;
            // Sorts by the number of teams.
            // (-- KAGGLE_INTERNAL: Order by Comp's (TeamCountOverride ?? TotalTeams)
            // descending. --)
            NUM_TEAMS = "numTeams", // = 4;
            // Shows the recently closed competitions first.
            // (-- KAGGLE_INTERNAL: Order by Deadline descending. --)
            RECENTLY_CLOSED = "recentlyClosed", // = 5;
          }
          // Optional filters for competition visibility.
          export enum VisibilityFilter {
            // Does not add a constraint for visibility.
            UNSPECIFIED = "unspecified", // = 0;
            // Only returns publicly visible competitions (anonymous users can see).
            PUBLIC = "public", // = 1;
            // Only returns publicly visible competitions whose Private Leaderboard
            // is also visible.
            PUBLIC_AND_PRIVATE_LEADERBOARD = "publicAndPrivateLeaderboard", // = 2;
          }
        }
        // Defines the query parameters.
        export interface Selector {
          // Returns competitions matching the provided ID's. If ID's are specified
          // here, the below fields are not used.
          competitionIds: number[];
          // Defines the type of competitions to be returned. Only has an effect if
          // competition_ids is unset.
          listOption: Kaggle.Sdk.Competitions.ListCompetitionsRequest.Selector.ListOption;
          // If specified, lists relative to the given user, otherwise lists relative to
          // calling user by default. Only allowed if list_option is USER_ENTERED or
          // USER_HOSTED. Results will still be restricted and scrubbed relative to the
          // calling user.
          listForUserId?: /* google.protobuf.Int32Value */ number | null;
          // Defines the category of competitions to be returned. This is temporarily
          // an int32, but will eventually be migrated to an enum. The category values
          // are:
          // UNSPECIFIED = 0
          // FEATURED = 1
          // RESEARCH = 2
          // RECRUITMENT = 3
          // GETTING_STARTED = 5
          // MASTERS = 6
          // PLAYGROUND = 8
          // IN_CLASS = 10
          // Only has an effect if competition_ids is unset.
          // (-- KAGGLE_INTERNAL
          // If set, only take Comps with the given HostSegment.  If unset, and
          // `list_option` is neither USER_ENTERED nor USER_HOSTED, we will ignore
          // InClass competitions from the query.
          // Using HostSegment directly is buggy (build-sdk fails), so just use the
          // id for now.
          // --)
          hostSegmentIdFilter: number;
          // If true, only return simulation competitions (Competition.EvaluationAlgorithm.IsEnvironment = 1)
          requireSimulations: boolean;
          // If provided, add a constraint for competitions with matching prestige.
          prestigeFilter: Kaggle.Sdk.Competitions.ListCompetitionsRequest.Selector.PrestigeFilter;
          // If provided, add a constraint for competitions' visibility status
          visibilityFilter: Kaggle.Sdk.Competitions.ListCompetitionsRequest.Selector.VisibilityFilter;
          // Foreign keys to Categories table. If provided, we only take Comps with
          // matching CompetitionCategory entries.
          tagIds: number[];
          // Defines the order in which results should be returned. Only has an
          // effect if competition_ids is unset.
          sortOption: Kaggle.Sdk.Competitions.ListCompetitionsRequest.Selector.SortOption;
          // String search term. Only has an effect if competition_ids is unset.
          // (-- KAGGLE_INTERNAL Hooks up to SearchService. --)
          searchQuery: string;
        }
      }

      export namespace ListSubmissionsRequest {
        export namespace Selector {
          export enum ListOption {
            // List all otherwise matching submissions.
            DEFAULT = "default", // = 0;
            // List only successful submissions.
            SUCCESSFUL = "successful", // = 1;
            // List only selected submissions.
            SELECTED = "selected", // = 2;
          }

          export enum SortOption {
            // Sort by date submitted, newest submissions first.
            DEFAULT = "default", // = 0;
            // Sort by the name in alphabetical order.
            NAME = "name", // = 1;
            // Sort by the private score, highest score first.
            PRIVATE_SCORE = "privateScore", // = 2;
            // Sort by the public score, highest score first.
            PUBLIC_SCORE = "publicScore", // = 3;
          }
        }

        export interface Selector {
          listOption: Kaggle.Sdk.Competitions.ListSubmissionsRequest.Selector.ListOption;
          sortOption: Kaggle.Sdk.Competitions.ListSubmissionsRequest.Selector.SortOption;
        }
      }

      export namespace SearchTeamsResponse {
        export interface FoundTeam {
          teamId: number;
          teamName: string;
        }
      }

      export namespace UpdateSubmissionSelectionResponse {
        // If we fail for known reasons, we throw CanonicalException with ErrorInfo using one of these values.
        // On success we return an empty message.
        export enum ErrorReason {
          UNSPECIFIED = "unspecified", // = 0;
          SELECTIONS_DISABLED = "selectionsDisabled", // = 1;
          NOT_TEAM_LEADER = "notTeamLeader", // = 2;
          TOO_MANY_SELECTED = "tooManySelected", // = 3;
          INVALID_SUBMISSION = "invalidSubmission", // = 4;
          ALREADY_HAS_VALUE = "alreadyHasValue", // = 5;
        }
      }

      export interface AcceptRulesRequest {
        competitionId: number;
      }

      export interface AcceptTeamMergeRequest {
        mergeRequestId: number;
      }

      export interface ArchiveCompetitionRequest {
        competitionId: number;
      }

      export interface BulkCreateEpisodeRequest {
        requests: Kaggle.Sdk.Competitions.CreateEpisodeRequest[];
      }

      export interface BulkCreateEpisodeResponse {
        episodes: Kaggle.Sdk.Competitions.Episode[];
      }

      export interface BulkRerunInfo {
        id: number;
        dateInitiated: /* google.protobuf.Timestamp */ string | null;
        stateCounts: Kaggle.Sdk.Competitions.RerunStateCount[];
      }

      export interface CancelBulkRerunRequest {
        bulkRerunId: number;
      }

      export interface CanSubmitRequest {
        createRequest: Kaggle.Sdk.Competitions.CreateSubmissionRequest | null;
      }

      export interface CanSubmitResponse {
        canSubmit: boolean;
        // can_submit == not_allowed_reasons.is_empty()
        notAllowedReasons: Kaggle.Sdk.Competitions.SubmissionNotAllowedReason[];
        // The Team under which the Submission would be made. Can be null if the team
        // doesn't exist, for example first submission if RulesRequired = false.
        team: Kaggle.Sdk.Competitions.Team | null;
        // The Team's submission limit stats, including how many they are allowed to submit right now, if team present.
        submissionLimitInfo: Kaggle.Sdk.Competitions.SubmissionLimitInfo | null;
        // The filename required for all Kernel Submissions for this Competition,
        // or "" if the Competition has no such constraint.
        requiredFileName: string;
      }

      export interface ClearLeaderboardSubmissionsRequest {
        // The competition to have its leaderboard cleared.
        competitionId: number;
        // Filled in by admin / engineer to specify why a submission is invalidated.
        userVisibleReason: string;
      }

      export interface ClearLeaderboardSubmissionsResponse {
        // The number of submissions that were impacted.
        submissionsCleared: number;
      }

      export interface Competition {
        // The competition ID.
        id: number;
        // The name of the competition as it appears in the URL.
        competitionName: string;
        // The name of the competition as it appears in the title.
        title: string;
        // A short description of the competition.
        briefDescription: string;
        // The competition's start date.
        dateEnabled: /* google.protobuf.Timestamp */ string | null;
        // The competition's deadline.
        deadline: /* google.protobuf.Timestamp */ string | null;
        hasLeaderboard: boolean;
        evaluationAlgorithmId: number;
        leaderboardPercentage: number;
        // The maximum number of submissions a team can make each day.
        maxDailySubmissions: number;
        numScoredSubmissions: number;
        hasSolution: boolean;
        numPrizes: number;
        forumId: number;
        leaderboardDisplayFormat: string;
        finalLeaderboardHasBeenVerified: boolean;
        disableSubmissions: boolean;
        isPrivate: boolean;
        hasHeaderImage: boolean;
        userRankMultiplier: number;
        privateGroupId: number;
        limitedParticipationGroupId: number;
        witholdFinalLeaderboardUntilItHasBeenVerified: boolean;
        hostGroupId: number;
        rewardTypeId: number;
        // The quantity of the reward, if applicable.
        rewardQuantity: number;
        publicLeaderboardDisclaimerMessage: string;
        finalLeaderboardDisclaimerMessage: string;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
        disableLeaderboardPrizeIndicator: boolean;
        competitionHostSegmentId: number;
        modelSubmissionDeadline: /* google.protobuf.Timestamp */ string | null;
        maxTeamSize: number;
        banTeamMergers: boolean;
        dateSubmitted: /* google.protobuf.Timestamp */ string | null;
        prohibitNewEntrants: boolean;
        medalsAllowed: boolean;
        enableTeamModels: boolean;
        teamModelDeadline: /* google.protobuf.Timestamp */ string | null;
        solutionSalt: string;
        prohibitSolutionDownload: boolean;
        solutionColumnMapping: string;
        submissionColumnMapping: string;
        evaluationAlgorithmParameters: string;
        totalSolutionRows: number;
        totalSolutionPublicRows: number;
        totalSolutionPrivateRows: number;
        isTemplate: boolean;
        teamMergerExplicitDeadline: /* google.protobuf.Timestamp */ string | null;
        prohibitNewEntrantsExplicitDeadline: /* google.protobuf.Timestamp */ string | null;
        organizationId: number;
        competitionTypeId: number;
        thumbnailImageUrl: string;
        coverImageUrl: string;
        cardImageUrl: string;
        rowVersion: any;
        showPrivateLeaderboard: boolean;
        isTeamCountOverridden: boolean;
        hasScripts: boolean;
        shareToken: string;
        onlyAllowKernelSubmissions: boolean;
        totalTeams: number;
        totalCompetitors: number;
        totalSubmissions: number;
        databundleId: number;
        evaluationSetupStatus: any;
        rulesRequired: boolean;
        usesSynchronousReruns: boolean;
        rerunOverrideDatabundleId: number;
        postProcessorKernelId: number;
        // The last time all Teams' Leaderboard ranks were cached, if applicable.
        leaderboardCacheDate: /* google.protobuf.Timestamp */ string | null;
        // Override for placement on Competition Listing page.
        listingOrderOverride?: /* google.protobuf.Int32Value */ number | null;
        maxCpuRuntimeMinutes?: /* google.protobuf.Int32Value */ number | null;
        maxGpuRuntimeMinutes?: /* google.protobuf.Int32Value */ number | null;
        // Linked reference types.
        databundle: Kaggle.Sdk.Competitions.Foreign.Databundle | null;
        rerunOverrideDatabundle: Kaggle.Sdk.Competitions.Foreign.Databundle | null;
        evaluationAlgorithm: Kaggle.Sdk.Competitions.EvaluationAlgorithm | null;
        // The categories assigned to the competition.
        categories: Kaggle.Sdk.Competitions.Foreign.Category[];
        organization: Kaggle.Sdk.Competitions.Foreign.Organization | null;
        // Helper derived fields.
        mergeRequestDeadline: /* google.protobuf.Timestamp */ string | null;
        // The competition's reward type.
        rewardType: Kaggle.Sdk.Competitions.RewardType | null;
        // TODO: Remove when frontend is using reward_type above instead.
        rewardTypeName: string;
        // This field indicates whether or not a user has bookmarked this competition. It will only be populated properly if
        // Refs.CompetitionUserBookmarks has been passed in along with the repository method.
        userBookmarked: boolean;
        // Indicates if the competition is launched or not
        launched: boolean;
      }

      export interface CompetitionEmail {
        id: number;
        sendDate: /* google.protobuf.Timestamp */ string | null;
        senderUserId: number;
        competitionId: number;
        fromEmail: string;
        emailSubject: string;
        emailBody: string;
        totalEmailsSent: number;
      }

      export interface CompetitionKernelRerunState {
        id: Kaggle.Sdk.Competitions.RerunState;
        name: Kaggle.Sdk.Competitions.RerunStateName;
        errorCause: Kaggle.Sdk.Competitions.RerunStateErrorCause;
        // The status we should apply to the source Submission when moving to this Rerun State.
        // Should not be applicable to non-sync rerun comps, which rely on Publish to cause changes.
        sourceSubmissionStatus: Kaggle.Sdk.Competitions.SubmissionStatus;
      }

      export interface CompetitionUserConfig {
        userId: number;
        // Optional Competition this Config is tied to.  If 0, indicates a "global"
        // Config.
        competitionId: number;
        // The "key" for this config, for example "ListingPageGettingStartedDisabled"
        name: string;
        // The optional "value" for this config.  For many Configs, the presence of
        // the Config represents a flag was flipped, and so value will be null as it
        // has no meaning.  In general, each "name" value implies its own space of
        // values.
        value?: /* google.protobuf.StringValue */ string | null;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
        dateUpdated: /* google.protobuf.Timestamp */ string | null;
      }

      export interface CreateCompetitionRequest {
        title: string;
        slug: string;
        briefDescription: string;
        hostSegment: Kaggle.Sdk.Competitions.HostSegment;
        useKernels: boolean;
      }

      export interface CreateCompetitionResponse {
        competitionUrl: string;
      }

      export interface CreateCompetitionSampleSubmissionRequest {
        competitionId: number;
        blobToken: string;
      }

      export interface CreateCompetitionSolutionRequest {
        competitionId: number;
        blobToken: string;
      }

      export interface CreateEnvironmentMetricRequest {
        // This should match the folder name for this environment in https://github.com/Kaggle/kaggle-environments/tree/master/kaggle_environments/envs
        environmentName: string;
        name: string;
        // This configuration will be patched on top of the environment's default configuration for all episodes using this algorithm
        configuration: string;
        // This is a comma separated list of the number of players that can play in each game, e.g. 1,2,4 or 2,2,2,4 (the latter giving a higher chance of 2-player games)
        playerCountSpecification: string;
        renderType: Kaggle.Sdk.Competitions.EnvironmentRenderType;
      }

      export interface CreateEpisodeRequest {
        submissionIds: number[];
        type: Kaggle.Sdk.Competitions.EpisodeType;
      }

      export interface CreatePageRequest {
        page: Kaggle.Sdk.Competitions.Page | null;
      }

      export interface CreateSubmissionRequest {
        competitionId: number;
        kernelSource?: Kaggle.Sdk.Competitions.CreateSubmissionRequest.KernelSource | null;
        fileSource?: Kaggle.Sdk.Competitions.CreateSubmissionRequest.FileSource | null;
        // If empty string, a default based on the filename will be chosen.
        description: string;
        // Only hosts or admins can set true.  If set, submission will be made under
        // the Sandbox team, where it can later be converted to a Benchmark team.
        sandbox: boolean;
      }

      export interface CreateTeamModelFileRequest {
        competitionId: number;
        blobToken: string;
      }

      export interface CreateTeamModelFileResponse {
        fileName: string;
        // Length of the file in bytes.
        sizeBytes: number;
      }

      export interface CreateTeamsInfo {
        // Team Id is ignored on request, and populated on response.
        id: number;
        name: string;
        leaderId: number;
        memberIds: number[];
      }

      export interface CreateTeamsRequest {
        competitionId: number;
        teams: Kaggle.Sdk.Competitions.CreateTeamsInfo[];
      }

      export interface CreateTeamsResponse {
        teams: Kaggle.Sdk.Competitions.CreateTeamsInfo[];
      }

      export interface DeletePageRequest {
        id: number;
      }

      export interface DownloadTeamModelFileRequest {
        competitionId: number;
      }

      export interface DownloadTeamModelFileResponse {
        downloadUrl: string;
      }

      export interface EmailParticipantsRequest {
        competitionId: number;
        userFilter: Kaggle.Sdk.Competitions.UserFilter;
        fromEmail: string;
        emailSubject: string;
        // Contents of the email to send. Will automatically replace the following:
        // @user.DisplayName (with the recipient's display name)
        // @team.Name (with the name of recipient's team for the given competition)
        // @team.OrdinalRanking (with the current rank of the recipient's team for the
        // given competition)
        emailBody: string;
        // Optional. If set, a sample email will be sent to this address, and no
        // emails will be sent to any other users.
        sendSampleTo: string;
        // If true, no emails will be sent, and the response will contain a sample
        // formatted email body as though the email was sent to the requesting user.
        dryRun: boolean;
      }
      // An episode is an individual run of a simulation with a set of agents
      export interface Episode {
        id: number;
        competitionId: number;
        // For our purposes, create_time is the same as start_time
        createTime: /* google.protobuf.Timestamp */ string | null;
        endTime: /* google.protobuf.Timestamp */ string | null;
        replayUrl?: /* google.protobuf.StringValue */ string | null;
        // This field is used to record any miscellaneous logging / meta info like reasons why an Episode failed
        adminNotes?: /* google.protobuf.StringValue */ string | null;
        state: Kaggle.Sdk.Competitions.EpisodeState;
        type: Kaggle.Sdk.Competitions.EpisodeType;
        agents: Kaggle.Sdk.Competitions.EpisodeAgent[];
      }
      // An episode agent represents a single competition submission participating in this episode
      export interface EpisodeAgent {
        id: number;
        submissionId: number;
        reward?: /* google.protobuf.DoubleValue */ number | null;
        index: number;
        // Score and Confidence of Submission at the time the Episode completed,
        // before updates were applied (if applicable).
        initialScore?: /* google.protobuf.DoubleValue */ number | null;
        initialConfidence?: /* google.protobuf.DoubleValue */ number | null;
        // Updated Submission Score and Confidence, if applicable.
        updatedScore?: /* google.protobuf.DoubleValue */ number | null;
        updatedConfidence?: /* google.protobuf.DoubleValue */ number | null;
        state: Kaggle.Sdk.Competitions.EpisodeAgentState;
        submission: Kaggle.Sdk.Competitions.Submission | null;
      }

      export interface EvaluationAlgorithm {
        id: number;
        abbreviation: string;
        name: string;
        description: string;
        isMax: boolean;
        isPublic: boolean;
        submissionFileFormatId: number;
        competitionId: number;
        requiresSameRowCountInSubmissionAndSolution: boolean;
        solutionSchema: string;
        submissionSchema: string;
        parametersSchema: string;
        dateModified: /* google.protobuf.Timestamp */ string | null;
        requiresSpecialHandling: boolean;
        isEnvironment: boolean;
        environmentConfiguration?: /* google.protobuf.StringValue */ string | null;
        environmentNumPlayersSpec?: /* google.protobuf.StringValue */ string | null;
        environmentRenderType: Kaggle.Sdk.Competitions.EnvironmentRenderType;
      }

      export interface GenerateEpisodesRequest {
        // Must be provided.
        competitionId: number;
        // Maximum number of episodes to create.  Currently we limit this to 100.
        numEpisodes: number;
        // Must be set.
        numAgentsPerEpisode: number;
        // If set, we won't call BulkCreateEpisode.
        dryRun: boolean;
      }

      export interface GenerateEpisodesResponse {
        // The BulkCreateEpisodeRequest we generated.
        bulkCreateEpisodeRequest: Kaggle.Sdk.Competitions.BulkCreateEpisodeRequest | null;
        // The response from calling BulkCreateEpisode, if dry_run was false.
        bulkCreateEpisodeResponse: Kaggle.Sdk.Competitions.BulkCreateEpisodeResponse | null;
      }

      export interface GetCompetitionRequest {
        // Look up a specific competition by ID.
        competitionId: number;
        // Look up a specific competition by name. If both this and competition_id are
        // set, competition_id will take precedence.
        competitionName: string;
      }

      export interface GetEpisodeReplayRequest {
        episodeId: number;
      }

      export interface GetEpisodeReplayResponse {
        replay?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetLeaderboardRequest {
        // The competition to get the leaderboard for.
        competitionId: number;
        // Must be admin to set to non-default value.
        // Determines which level of LB caching to draw data from.
        leaderboardMode: Kaggle.Sdk.Competitions.LeaderboardMode;
      }

      export interface GetLeaderboardResponse {
        // List of all entries on the leaderboard, including benchmark teams.
        // Sorted by rank-order; benchmark teams are in their correct location per
        // score, though their rank is 0 since they are not a real team.
        publicLeaderboard: Kaggle.Sdk.Competitions.LeaderboardEntry[];
        // Same as above, but for Private LB, provided the Current User can view the
        // Private LB. If not, this will be empty.
        privateLeaderboard: Kaggle.Sdk.Competitions.LeaderboardEntry[];
        // The unordered list of Leaderboard teams.  This should be treated as a
        // dictionary into which each LeaderboardEntry above can lookup using TeamId
        // to get more detailed information, such as TeamName and TeamMembers.
        teams: Kaggle.Sdk.Competitions.LeaderboardTeam[];
        // The unordered list of public Notebooks, if present, for all
        // LeaderboardEntry
        // objects above.  This should be treated as a dictionary into which each
        // LeaderboardEntry above can lookup using SubmissionId.
        notebooks: Kaggle.Sdk.Competitions.LeaderboardNotebook[];
      }
      // Gets a Page by some set of unique identifiers.
      // Requires either that 'id' is set or that both 'competition_id' and 'name' are
      // set. If all three are set, will use 'id'.
      export interface GetPageRequest {
        id: number;
        competitionId: number;
        name: string;
      }

      export interface GetPrivacySettingsRequest {
        competitionId: number;
      }

      export interface GetProfileUserStatsRequest {
        // user whose profile is being viewed
        userId: number;
      }

      export interface GetProfileUserStatsResponse {
        // how many competitions has user_id participated in
        competitionsCount: number;
        // how many competitions has user_id participated in without being in a team
        soloCompetitionsCount: number;
        // how many competitions has user_id participated in while in a team
        teamCompetitionsCount: number;
      }

      export interface GetRanksForUsersRequest {
        // The competition to get the leaderboard for.
        competitionId: number;
        // The userIds to lookup Ranks for.
        userIds: number[];
      }

      export interface GetRanksForUsersResponse {
        // Maps userId to rank.  If a provided userId is missing here, it means
        // they didn't have a Team on the current main (public vs private) Leaderboard.
        userRanks: { [key: number]: number };
      }

      export interface GetUserRequest {
        // Oneof the following is required to lookup the user specific fields.
        competitionId: number;
        competitionName: string;
      }

      export interface GetUserResponse {
        // The competition these user fields are associated with.
        competitionId: number;
        // The user. Unset for anonymous users.
        user: Kaggle.Sdk.Competitions.Foreign.User | null;
        // Whether the user is a site admin.
        isAdmin: boolean;
        // Whether the user has been phone-verified.
        isPhoneVerified: boolean;
        // Whether the user has accepted the competition rules, if necessary.
        // If no rules acceptance is required, will always be "true".
        hasAcceptedRules: boolean;
        // Whether the user is a host for this competition.
        isHost: boolean;
        // The user's team for this competition, if present.
        team: Kaggle.Sdk.Competitions.Team | null;
        // The user's team's submission limit stats and num allowed right now, if team present.
        submissionLimitInfo: Kaggle.Sdk.Competitions.SubmissionLimitInfo | null;
        // Whether the user can participate in this competition.
        canParticipate: boolean;
      }

      export interface HasAcceptedRulesRequest {
        competitionId: number;
      }

      export interface HasAcceptedRulesResponse {
        hasAccepted: boolean;
        // This can be unset despite has_accepted being true, for example if the comp
        // doesn't require rules acceptance.
        dateAccepted: /* google.protobuf.Timestamp */ string | null;
      }

      export interface InitiateBulkRerunRequest {
        competitionId: number;
        // Object which helps select Submissions.  Each selected Submission yields
        // exactly one child Rerun.
        submissionSelector: Kaggle.Sdk.Competitions.InitiateBulkRerunRequest.RerunSubmissionSelector | null;
        // Object which controls the Kernel Run for each Rerun.
        kernelRunSettings: Kaggle.Sdk.Competitions.InitiateBulkRerunRequest.KernelRunSettings | null;
        // Filename to look for in Kernel Run output to send for Submission.  If
        // unset, will use existing Submission's filename.
        expectedSubmissionFilename: string;
        // Max number of times to attempt a Rerun.  Default is 3.
        maxRetries: number;
        // Whether to take latest versions of all datasources or the previous
        // versions from the user's Kernel Commit.
        useUpdatedDatasources: boolean;
      }

      export interface InitiateBulkRerunResponse {
        numCreated: number;
      }

      export interface InvalidateErroringSimulationsSubmissionsRequest {
        // Look at N most recent Episodes per Submission.  Default of 40.
        episodeLookbackCount: number;
        // Max allowed error rate for a Submission.
        // If we find more than max_error_ratio * episode_lookback_count errors,
        // we will invalidate the Submission.  Default value is set by the
        // invalidate-erroring-simulations-submissions-max-error-rate config flag.
        // Note this means a Submission will have to have a certain amount of total
        // Episodes played to be invalidated, even if error rate is 100%.
        maxErrorRate: number;
        // If set, we won't modify the erroring Submissions, only return their Ids.
        dryRun: boolean;
      }

      export interface InvalidateErroringSimulationsSubmissionsResponse {
        erroringSubmissionIds: number[];
      }

      export interface InvalidateSubmissionsRequest {
        // Submission ids to invalidate
        submissionIds: number[];
        // Filled in by admin / engineer to specify why an episode is invalidated.
        userVisibleReason: string;
      }

      export interface LeaderboardEntry {
        // The Id of the team who made the entry.
        teamId: number;
        // The Id of the Team's Submission representing this entry.
        submissionId: number;
        // The rank of the entry. Should only be 0 for benchmark teams.
        rank: number;
        // The score for this entry, possibly truncated.
        displayScore: string;
        // The medal for this entry and the leaderboard it's on.  If the competition
        // is finalized, we'll use the true Team.Medal values on the final LB (public
        // LB if comp has no private LB, otherwise private).  Otherwise, we estimate
        // the medal given current standings and Team Count.
        medal: Kaggle.Sdk.Competitions.LeaderboardMedal;
        // The delta between the private and public leaderboard rank for the private leaderboard
        // Currently calculated by the client - but maybe calculated by the service in the future.
        // (public rank - private rank)
        rankDelta: number;
      }

      export interface LeaderboardNotebook {
        // The submissionId linked to this Notebook.
        submissionId: number;
        // The title of the Notebook.
        title: string;
        // Denotes the specific Notebook Version; can optionally be part of the URL.
        // (-- KAGGLE_INTERNAL: Primary key of KernelSessions table. --)
        kernelRunId: number;
        // The author of the Notebook; part of the Notebook's URL.
        authorUserName: string;
        // Slug of the Notebook, like `notebook-title`; part of the Notebook's URL.
        slug: string;
      }
      // Subset of Team object to limit return object size, as well as allowing us
      // to read from covering indexes for optimal DB performance.
      export interface LeaderboardTeam {
        teamId: number;
        teamName: string;
        isBenchmark: boolean;
        submissionCount: number;
        lastSubmissionDate: /* google.protobuf.Timestamp */ string | null;
        // The list of users on the team.
        teamMembers: Kaggle.Sdk.Competitions.Foreign.User[];
      }

      export interface LegacyRecalculateLeaderboardRequest {
        competitionId: number;
      }

      export interface LegacyRecalculateLeaderboardResponse {
        // Number of database rows affected by the leaderboard update.
        rowsAffected: number;
      }

      export interface ListBulkRerunsRequest {
        competitionId: number;
      }

      export interface ListBulkRerunsResponse {
        bulkReruns: Kaggle.Sdk.Competitions.BulkRerunInfo[];
      }

      export interface ListCompetitionsRequest {
        // Defines the query to perform.
        selector: Kaggle.Sdk.Competitions.ListCompetitionsRequest.Selector | null;
        // Max number of results to return.  Defaults to 1000 if unset.
        pageSize: number;
        // Enables retrieval of more data from the same query.  Should only be set
        // to the `ListCompetitionsResponse.next_page_token` value returned by a
        // previous ListCompetitions call with the exact same `selector` value.
        // Otherwise should be set to "", indicating a fresh query.
        pageToken: string;
      }
      // Lists the requests competitions as well as the user's teams in those
      // competitions.
      export interface ListCompetitionsResponse {
        // The results of the listing.
        competitions: Kaggle.Sdk.Competitions.Competition[];
        // The current user's active team for each of the returned competitions, if it
        // exists. Order is unspecified, but can be matched with team.competition_id.
        userTeams: Kaggle.Sdk.Competitions.Team[];
        // Maps each teamId from user_teams to its submission limit data.
        // Only populated if list_for_user_id is unset or set to current user, for privacy reasons.
        teamSubmissionLimitInfos: { [key: number]: Kaggle.Sdk.Competitions.SubmissionLimitInfo | null };
        // Maps each teamId from user_teams to its current primary Rank, if it has one. Primary Rank
        // will be from Private LB if competition is closed and private LB is publicly available,
        // otherwise Public.
        teamRanks: { [key: number]: number };
        // Enables retrieval of more data from the same query.  See the `page_token`
        // field from `ListCompetitionsRequest` above.  If the value is "", it means
        // no further results for the request.
        nextPageToken: string;
        // Used for pagination or otherwise displaying how many results are in a filtered
        // collection before pageSize and page are applied
        totalResults: number;
      }
      // If neither is set, we will return all configs for the Current User.
      export interface ListConfigsRequest {
        competitionId?: /* google.protobuf.Int32Value */ number | null;
        // ^Optional value to only get results for the given comp.  If unset, we skip
        // the comp filter. ^If set to 0, we filter on comp == null in the DB,
        // otherwise filter on the given id.
        names: string[];
      }

      export interface ListConfigsResponse {
        configs: Kaggle.Sdk.Competitions.CompetitionUserConfig[];
      }
      // Only the first populated filter will be used. Exception thrown if none
      // are populated.
      export interface ListEpisodesRequest {
        ids: number[];
        submissionId?: /* google.protobuf.Int32Value */ number | null;
        teamId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface ListEpisodesResponse {
        // EpisodeAgents refs populated, each with no refs, instead pulled out below.
        episodes: Kaggle.Sdk.Competitions.Episode[];
        // Distinct Submissions that would've been used for EpisodeAgent.Submission
        // in above.  No refs.
        submissions: Kaggle.Sdk.Competitions.Submission[];
        // Distinct Teams that would've been used for Submission.Team above.  No refs.
        teams: Kaggle.Sdk.Competitions.Team[];
      }

      export interface ListSubmissionsForUserRequest {
        userId: number;
        // Defaults to 5.
        amount: number;
      }

      export interface ListSubmissionsForUserResponse {
        submissions: Kaggle.Sdk.Competitions.Submission[];
      }

      export interface ListSubmissionsRequest {
        teamId: number;
        selector: Kaggle.Sdk.Competitions.ListSubmissionsRequest.Selector | null;
        pageSize: number;
        // Enables retrieval of more data from the same query.  Should only be set
        // to the `ListSubmissionsResponse.next_page_token` value returned by a
        // previous ListSubmissions call with the exact same `selector` value.
        // Otherwise should be set to "", indicating a fresh query.
        pageToken: string;
      }

      export interface ListSubmissionsResponse {
        submissions: Kaggle.Sdk.Competitions.Submission[];
        // Enables retrieval of more data from the same query.  See the `page_token`
        // field from `ListSubmissionsRequest` above.  If the value is "", it means
        // no further results for the request.
        nextPageToken: string;
      }

      export interface ListTeamMergeRequestsRequest {
        competitionId: number;
      }

      export interface ListTeamMergeRequestsResponse {
        inbound: Kaggle.Sdk.Competitions.TeamMergeRequest[];
        outbound: Kaggle.Sdk.Competitions.TeamMergeRequest[];
      }

      export interface ListTeamsByUserRequest {
        userId: number;
      }

      export interface ListTeamsByUserResponse {
        teams: Kaggle.Sdk.Competitions.Team[];
      }

      export interface ListTeamsRequest {
        // If set, returns all Teams for given Competition.
        // If unset, returns all Teams for the Current User.
        competitionId: number;
      }

      export interface ListTeamsResponse {
        teams: Kaggle.Sdk.Competitions.Team[];
      }
      // Representation of a top-level Competition page.
      // 
      // Note that this does not map directly to the Page database entity,
      // as it also includes elements of the Post entity (contents, mime_type).
      export interface Page {
        // Unique identifier of the Page
        id: number;
        // Unique identifier of the containing Competition
        competitionId: number;
        // The Page name/title
        name: string;
        // Contents of the page (to be rendered according to 'mime_type')
        content: string;
        // The MIME type of the 'content' field
        mimeType: string;
        // Whether the page is publicly visible
        isPublished: boolean;
        // The last time this page was updated
        updatedDate: /* google.protobuf.Timestamp */ string | null;
        // The order of the page within the competition
        order: number;
        // The title of the post associated with the page
        postTitle: string;
      }

      export interface PrivacySettings {
        privacy: Kaggle.Sdk.Competitions.CompetitionPrivacy;
        shareToken: string;
      }

      export interface PublishBulkRerunRequest {
        bulkRerunId: number;
      }

      export interface RecalculateLeaderboardRequest {
        competitionId: number;
        // If STRONG is provided (or chosen as Default, which is possible even if the
        // competition hasn't calculated a Strong LB yet), we will also recalculate
        // the Weak LB cached fields.
        leaderboardMode: Kaggle.Sdk.Competitions.LeaderboardMode;
        // If true, we won't persist changes, but still return updated_teams.
        dryRun: boolean;
      }

      export interface RecalculateLeaderboardResponse {
        // Teams whose Weak LB cached fields had an update.
        weakUpdatedTeams: Kaggle.Sdk.Competitions.Team[];
        // Teams whose Strong LB cached fields had an update.
        strongUpdatedTeams: Kaggle.Sdk.Competitions.Team[];
      }

      export interface RegenerateShareTokenRequest {
        competitionId: number;
      }

      export interface RejectTeamMergeRequest {
        mergeRequestId: number;
      }

      export interface RequestTeamMergeRequest {
        childTeamId: number;
        parentTeamId: number;
      }

      export interface RerunStateCount {
        name: Kaggle.Sdk.Competitions.RerunStateName;
        count: number;
      }

      export interface RewardType {
        id: Kaggle.Sdk.Competitions.RewardTypeId;
        name: string;
      }

      export interface SearchCompetitionsRequest {
        // TODO(Code Health): Split this endpoint into two:  GetCompetitions() and GetHostCompetitionsForUser().
        hostUserId?: /* google.protobuf.Int32Value */ number | null;
        competitionIds: number[];
      }

      export interface SearchCompetitionsResponse {
        competitions: Kaggle.Sdk.Competitions.Competition[];
      }

      export interface SearchTeamsRequest {
        competitionId: number;
        // Checks for team names beginning with this value.
        teamNamePrefix: string;
      }

      export interface SearchTeamsResponse {
        teams: Kaggle.Sdk.Competitions.SearchTeamsResponse.FoundTeam[];
      }

      export interface SetCompetitionDeadlineNowRequest {
        competitionId: number;
      }

      export interface SetCompetitionDeadlineNowResponse {
        // The new/updated competition deadline.
        deadline: /* google.protobuf.Timestamp */ string | null;
      }
      // This sets Episode.State = EpisodeState.ERRORED
      export interface SetEpisodeErroredRequest {
        episodeId: number;
      }

      export interface Submission {
        id: number;
        title: string;
        // AKA description
        details: string;
        submittedUserId: number;
        dateSubmitted: /* google.protobuf.Timestamp */ string | null;
        teamId: number;
        privateScore?: /* google.protobuf.DoubleValue */ number | null;
        publicScore?: /* google.protobuf.DoubleValue */ number | null;
        isSelected: boolean;
        status: Kaggle.Sdk.Competitions.SubmissionStatus;
        isAfterDeadline: boolean;
        publicScoreAdditionalDetails: string;
        privateScoreAdditionalDetails: string;
        processingDetails: string;
        contentLength: number;
        sourceScriptVersionId: number;
        clonedFromSubmissionId: number;
        dateInvalidated: /* google.protobuf.Timestamp */ string | null;
        syncRerunId: number;
        // This field is specific to Simulation Comps and represents the sigma
        // (stddev) for TrueSkill, and thus is "inverse" of confidence.
        publicConfidence?: /* google.protobuf.DoubleValue */ number | null;
        // TODO: Migrate Kaggle.Worker.Shared.WorkerPriority from C# Enum to Proto Enum and integrate here.
        workerPriority: number;
        // Foreign key references.
        team: Kaggle.Sdk.Competitions.Team | null;
        syncRerunState: Kaggle.Sdk.Competitions.CompetitionKernelRerunState | null;
      }
      // Stats about a Team's submissions that count towards daily and global limits, and how many submissions they are
      // currently allowed. Implicitly tied to one Team, and should only be surfaced to members of that Team for privacy
      // reasons.
      export interface SubmissionLimitInfo {
        // Number of valid submissions submitted after the beginning of today UTC.
        numToday: number;
        // Number of valid submissions ever.
        numTotal: number;
        // Number of submissions allowed for the rest of today UTC. If unset, there is no limit (eg, comp is closed).
        numAllowedNow?: /* google.protobuf.Int32Value */ number | null;
        // Whether num_allowed_now was limited by num_total rather than num_today. Very rare, should only occur on the same
        // day that two Teams merge and they barely fit under the num_total limit to be a valid merge. In that case, it may
        // cause user confusion, so we may want to highlight it in the UI somehow.
        limitedByTotal: boolean;
      }

      export interface SubmissionNotAllowedReason {
        code: Kaggle.Sdk.Competitions.SubmissionNotAllowedReasonCode;
        message: string;
      }

      export interface Team {
        id: number;
        // The name of the team.
        teamName: string;
        // The ID of the competition that the team is entered in.
        competitionId: number;
        // The userId of the team leader. Can be referenced with team_members to
        // determine the user name.
        teamLeaderId: number;
        // Whether or not the team is a benchmark team.
        isBenchmark: boolean;
        // Whether or not the team was created after the competition's deadline.
        createdAfterDeadline: boolean;
        // The current medal placement of this team.  If comp is finalized, uses
        // the stored value representing final private leaderboard rank; otherwise
        // uses current public leaderboard rank.  Value corresponds with
        // Users.Medal.
        medal: number;
        // The date that the private LB medal was awarded, if applicable.
        dateMedalAwarded: /* google.protobuf.Timestamp */ string | null;
        // The number of leaderboard-valid submissions that this team has made (submissions made before deadline with status
        // Complete). This may differ from counts related to submission limits, eg Pending submissions count towards limits
        // but not the leaderboard.
        submissionCount: number;
        // The date of this team's latest submission.
        lastSubmissionDate: /* google.protobuf.Timestamp */ string | null;
        // This will be kept up-to-date while comp is ongoing, if the Team has
        // valid submissions.
        publicLeaderboardSubmissionId?: /* google.protobuf.Int32Value */ number | null;
        // This will be kept up-to-date while comp is ongoing.
        // This is intended to be a dupe of PublicLeaderboardSubmission.PublicScore
        // which is not ideal, but improves performance of GetLeaderboard.
        publicLeaderboardScore?: /* google.protobuf.DoubleValue */ number | null;
        // This will be written when the comp is finalized and LB is "locked".
        publicLeaderboardRank?: /* google.protobuf.Int32Value */ number | null;
        // This will be written when the comp is finalized and LB is "locked".
        privateLeaderboardSubmissionId?: /* google.protobuf.Int32Value */ number | null;
        // This will be written when the comp is finalized and LB is "locked".
        // This is intended to be a dupe of PrivateLeaderboardSubmission.PrivateScore
        // which is not ideal, but improves performance of GetLeaderboard.
        privateLeaderboardScore?: /* google.protobuf.DoubleValue */ number | null;
        // This will be written when the comp is finalized and LB is "locked".
        privateLeaderboardRank?: /* google.protobuf.Int32Value */ number | null;
        // TODO(b/172009687): This should be captured by a new State enum field.
        sandbox: boolean;
        competition: Kaggle.Sdk.Competitions.Competition | null;
        // The list of users on the team.
        teamMembers: Kaggle.Sdk.Competitions.Foreign.User[];
        inboundMergeRequests: Kaggle.Sdk.Competitions.TeamMergeRequest[];
        outboundMergeRequests: Kaggle.Sdk.Competitions.TeamMergeRequest[];
      }

      export interface TeamMergeRequest {
        id: number;
        childTeamId: number;
        parentTeamId: number;
        state: Kaggle.Sdk.Competitions.TeamMergeRequestState;
        dateInitiated: /* google.protobuf.Timestamp */ string | null;
        dateUpdated: /* google.protobuf.Timestamp */ string | null;
        childTeam: Kaggle.Sdk.Competitions.Team | null;
        parentTeam: Kaggle.Sdk.Competitions.Team | null;
      }

      export interface UpdatePageRequest {
        page: Kaggle.Sdk.Competitions.Page | null;
        updateMask: google.protobuf.FieldMask | null;
      }

      export interface UpdatePrivacySettingsRequest {
        competitionId: number;
        privacySettings: Kaggle.Sdk.Competitions.PrivacySettings | null;
      }

      export interface UpdateSubmissionDescriptionRequest {
        competitionId: number;
        submissionId: number;
        description: string;
      }

      export interface UpdateSubmissionSelectionRequest {
        competitionId: number;
        submissionId: number;
        // True to select, false to unselect.
        select: boolean;
      }

      export interface UpdateSubmissionSelectionResponse {}

      export interface UpdateTeamRequest {
        teamId: number;
        teamName: string;
        teamLeaderId: number;
      }

      export interface UpsertConfigRequest {
        // Comp to link to.  If 0, implies a "global" Config which will be written as
        // null into the DB.
        competitionId: number;
        // "key" string for the configuration entry.  Cannot be null or empty string.
        name: string;
        // Optional value for more complex (than flags, eg) configuration.
        value?: /* google.protobuf.StringValue */ string | null;
      }

      export interface WaitForCompetitionAdminEvaluationEventRequest {
        competitionId: number;
        waitEvent: Kaggle.Sdk.Competitions.CompetitionAdminEvaluationEvent;
      }

      export interface WaitForCompetitionAdminEvaluationEventResponse {
        event: Kaggle.Sdk.Competitions.CompetitionAdminEvaluationEvent;
        status: Kaggle.Sdk.Competitions.CompetitionAdminEvaluationEventStatus;
        errorMessage: string;
      }

      export enum CompetitionAdminEvaluationEvent {
        UNSPECIFIED = "unspecified", // = 0;
        SOLUTION_COLUMN_MAPPING_CREATED = "solutionColumnMappingCreated", // = 1;
        SOLUTION_SAMPLED = "solutionSampled", // = 2;
        SUBMISSION_COLUMN_MAPPING_CREATED = "submissionColumnMappingCreated", // = 3;
      }

      export enum CompetitionAdminEvaluationEventStatus {
        UNSPECIFIED = "unspecified", // = 0;
        COMPLETED = "completed", // = 1;
        ERROR = "error", // = 2;
        TIMED_OUT = "timedOut", // = 3;
      }
      // Used via WithErrorInfo
      export enum CompetitionError {
        UNSPECIFIED = "unspecified", // = 0;
        // User needs to accept the rules of a competition.
        RULES_ACCEPTANCE_REQUIRED = "rulesAcceptanceRequired", // = 1;
        // Competition does not allow new entrants.
        NEW_ENTRANTS_NOT_ALLOWED = "newEntrantsNotAllowed", // = 2;
      }

      export enum CompetitionGrouping {
        NONE = "none", // = 0;
        ENTERED = "entered", // = 1;
        ACTIVE = "active", // = 2;
        COMPLETED = "completed", // = 3;
        ACTIVE_AND_COMPLETED = "activeAndCompleted", // = 4;
        UNLAUNCHED = "unlaunched", // = 5;
        BOOKMARKED = "bookmarked", // = 6;
      }

      export enum CompetitionListTab {
        GENERAL = "general", // = 0;
        ENTERED = "entered", // = 1;
        IN_CLASS = "inClass", // = 2;
        HOSTED = "hosted", // = 3;
        UNLAUNCHED = "unlaunched", // = 4;
        UNLAUNCHED_IN_CLASS = "unlaunchedInClass", // = 5;
      }

      export enum CompetitionPrivacy {
        UNSPECIFIED = "unspecified", // = 0;
        PUBLIC = "public", // = 1;
        LIMITED = "limited", // = 2;
        PRIVATE = "private", // = 3;
      }

      export enum CompetitionSortBy {
        GROUPED = "grouped", // = 0;
        BEST = "best", // = 1;
        PRIZE = "prize", // = 2;
        EARLIEST_DEADLINE = "earliestDeadline", // = 3;
        LATEST_DEADLINE = "latestDeadline", // = 4;
        NUMBER_OF_TEAMS = "numberOfTeams", // = 5;
        RELEVANCE = "relevance", // = 6;
        RECENTLY_CREATED = "recentlyCreated", // = 7;
      }

      export enum CompetitionType {
        UNSPECIFIED = "unspecified", // = 0;
        PREDICTION = "prediction", // = 1;
        CODE = "code", // = 2;
      }

      export enum EnvironmentRenderType {
        UNSPECIFIED = "unspecified", // = 0;
        JSON = "json", // = 1;
        // Generate .html file from episode json
        HTML = "html", // = 2;
        // Generate .webm file from episode json
        VIDEO = "video", // = 3;
        // Generate .webm file and episode json simultaneously during the episode run
        LIVE_VIDEO = "liveVideo", // = 4;
      }

      export enum EpisodeAgentState {
        UNSPECIFIED = "unspecified", // = 0;
        // The Episode has not yet completed.
        PENDING = "pending", // = 1;
        // The Agent completed the Episode.
        COMPLETE = "complete", // = 2;
        // The Agent threw an Exception during evaluation, or similar.
        ERROR_EVALUATION = "errorEvaluation", // = 3;
        // The Agent returned an invalid action and was disqualified.
        ERROR_INVALID_ACTION = "errorInvalidAction", // = 4;
        // The Agent did not return its action in the required time.
        ERROR_TIMEOUT = "errorTimeout", // = 5;
        // The Episode failed for unexpected reasons.
        ERROR_ON_EPISODE = "errorOnEpisode", // = 6;
      }

      export enum EpisodeState {
        UNSPECIFIED = "unspecified", // = 0;
        CREATED = "created", // = 1;
        COMPLETED = "completed", // = 2;
        ERRORED = "errored", // = 3;
        INVALIDATED = "invalidated", // = 4;
      }
      // Controls whether score is written and where
      export enum EpisodeType {
        UNSPECIFIED = "unspecified", // = 0;
        PUBLIC = "public", // = 1;
        // This is deprecated / was never supported.
        PRIVATE = "private", // = 2;
        EXHIBITION = "exhibition", // = 3;
        VALIDATION = "validation", // = 4;
      }
      // NOTE: Keep in Sync with Kaggle.Models.HostSegment until migrated! Also keep
      // the comment in competition_service.ListCompetitionsRequest.Selector.host_segment_id_filter
      // up to date
      export enum HostSegment {
        UNSPECIFIED = "unspecified", // = 0;
        DATASETS = "datasets", // = 9;
        FEATURED = "featured", // = 1;
        GE_QUESTS = "geQuests", // = 7;
        GETTING_STARTED = "gettingStarted", // = 5;
        MASTERS = "masters", // = 6;
        PLAYGROUND = "playground", // = 8;
        PROSPECT = "prospect", // = 4;
        RECRUITMENT = "recruitment", // = 3;
        RESEARCH = "research", // = 2;
        IN_CLASS = "inClass", // = 10;
        ANALYTICS = "analytics", // = 11;
      }

      export enum LeaderboardMedal {
        UNSPECIFIED = "unspecified", // = 0;
        NONE = "none", // = 1;
        BRONZE = "bronze", // = 2;
        SILVER = "silver", // = 3;
        GOLD = "gold", // = 4;
        IN_THE_MONEY = "inTheMoney", // = 5;
      }

      export enum LeaderboardMode {
        // Default indicates to decide between Weak or Strong based on the
        // competition's current state.
        // 
        // For read operations like GetLeaderboard and GetRanksForUsers, Strong is
        // used if the competition is completed, private LB is visible, and
        // Strong LB has been written; otherwise Weak is used.
        // 
        // RecalculateLeaderboard will do the full Strong LB generation (in addition
        // to Weak) if the comp is completed, otherwise Weak.
        DEFAULT = "default", // = 0;
        // Weak Leaderboard means it only uses localized caching of the best public
        // submission per team, stored in the Teams.PublicLeaderboard[SubmissionId,
        // Score, Date] fields (note -Rank is not used).
        // These fields should be kept current synchronously as the comp
        // progresses, along with Teams' SubmissionCount and LastSubmissionDate
        // fields.
        // 
        // GetLeaderboard in Weak mode will use the cached data to efficiently get
        // the public LB.  The private LB, which should only be available to admins
        // while Weak is the default, will require a more expensive full calculation.
        // 
        // RecalculateLeaderboard in Weak mode will recalculate the Team-localized
        // cached data described above, although ideally those fields are kept in
        // sync already.
        WEAK = "weak", // = 1;
        // Strong Leaderboard caches full information about both public and private
        // LBs within the Teams table, including competition-wide Ranks.
        // These fields are only written by RecalculateLeaderboard, which can be
        // invoked manually by admins, or by a forthcoming ScheduledHandler which
        // looks for Competitions which have ended but haven't calculated their
        // Strong Leaderboard.
        // 
        // We track whether a Competition has calculated its Strong Leaderboard via
        // Competitions.LeaderboardCacheDate field.
        // 
        // GetLeaderboard in Strong mode will be able to get Public and Private LBs
        // efficiently for all users.
        STRONG = "strong", // = 2;
      }

      export enum RerunState {
        UNSPECIFIED = "unspecified", // = 0;
        INITIATED = "initiated", // = 1;
        KERNEL_RUN_QUEUED = "kernelRunQueued", // = 2;
        KERNEL_RUN_RUNNING = "kernelRunRunning", // = 3;
        KERNEL_RUN_FAILED_TO_START = "kernelRunFailedToStart", // = 4;
        KERNEL_RUN_OUT_OF_MEMORY = "kernelRunOutOfMemory", // = 5;
        KERNEL_RUN_OUT_OF_DISK = "kernelRunOutOfDisk", // = 6;
        KERNEL_RUN_TIMEOUT = "kernelRunTimeout", // = 7;
        SUBMISSION_RUNNING = "submissionRunning", // = 8;
        SUBMISSION_CSV_NOT_FOUND = "submissionCsvNotFound", // = 9;
        SUBMISSION_FAILED_TO_START = "submissionFailedToStart", // = 10;
        SUBMISSION_GENERIC_FAILURE = "submissionGenericFailure", // = 11;
        SUBMISSION_SUCCEEDED = "submissionSucceeded", // = 12;
        PUBLISHED = "published", // = 13;
        KERNEL_RUN_CANCELLED = "kernelRunCancelled", // = 14;
        KERNEL_RUN_UNKNOWN_ERROR = "kernelRunUnknownError", // = 15;
        SUBMISSION_UNKNOWN_ERROR = "submissionUnknownError", // = 16;
        KERNEL_RUN_KILLED = "kernelRunKilled", // = 17;
        KERNEL_RUN_LIKELY_USER_CODE_ERROR = "kernelRunLikelyUserCodeError", // = 18;
        KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS = "kernelRunViolatedComputeConstraints", // = 19;
        KERNEL_RUN_REAPED = "kernelRunReaped", // = 20;
        SUBMISSION_REAPED = "submissionReaped", // = 21;
        SUBMISSION_FAILED_TO_PUBLISH = "submissionFailedToPublish", // = 22;
        KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED = "kernelRunMaxOutputFilesExceeded", // = 23;
        KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT = "kernelRunAbortedForSubmissionLimit", // = 24;
        KERNEL_RUN_NOT_FOUND = "kernelRunNotFound", // = 25;
      }

      export enum RerunStateErrorCause {
        // This can be used for non-error states and is a reasonable default.
        NONE = "none", // = 0;
        // This is a real value used for error states.
        UNKNOWN = "unknown", // = 1;
        KERNEL_RUN_FAILED_TO_START = "kernelRunFailedToStart", // = 2;
        KERNEL_RUN_OUT_OF_MEMORY = "kernelRunOutOfMemory", // = 3;
        KERNEL_RUN_OUT_OF_DISK = "kernelRunOutOfDisk", // = 4;
        KERNEL_RUN_TIMEOUT = "kernelRunTimeout", // = 5;
        KERNEL_RUN_KILLED = "kernelRunKilled", // = 6;
        KERNEL_RUN_LIKELY_USER_CODE_ERROR = "kernelRunLikelyUserCodeError", // = 7;
        KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS = "kernelRunViolatedComputeConstraints", // = 8;
        KERNEL_RUN_REAPED = "kernelRunReaped", // = 9;
        SUBMISSION_CSV_NOT_FOUND = "submissionCsvNotFound", // = 10;
        SUBMISSION_FAILED_TO_START = "submissionFailedToStart", // = 11;
        SUBMISSION_GENERIC_FAILURE = "submissionGenericFailure", // = 12;
        SUBMISSION_REAPED = "submissionReaped", // = 13;
        SUBMISSION_FAILED_TO_PUBLISH = "submissionFailedToPublish", // = 14;
        KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED = "kernelRunMaxOutputFilesExceeded", // = 15;
        KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT = "kernelRunAbortedForSubmissionLimit", // = 16;
        KERNEL_RUN_NOT_FOUND = "kernelRunNotFound", // = 17;
      }

      export enum RerunStateName {
        // Should never actually be used, but best practice for proto enum.
        UNSPECIFIED = "unspecified", // = 0;
        INITIATED = "initiated", // = 1;
        KERNEL_RUN_QUEUED = "kernelRunQueued", // = 2;
        KERNEL_RUN_RUNNING = "kernelRunRunning", // = 3;
        KERNEL_RUN_ERROR = "kernelRunError", // = 4;
        SUBMISSION_RUNNING = "submissionRunning", // = 5;
        SUBMISSION_ERROR = "submissionError", // = 6;
        SUBMISSION_SUCCEEDED = "submissionSucceeded", // = 7;
        PUBLISHED = "published", // = 8;
        KERNEL_RUN_CANCELLED = "kernelRunCancelled", // = 9;
      }

      export enum RewardTypeId {
        UNSPECIFIED = "unspecified", // = 0;
        USD = "usd", // = 1;
        KUDOS = "kudos", // = 2;
        AUD = "aud", // = 3;
        EUR = "eur", // = 4;
        JOBS = "jobs", // = 5;
        SWAG = "swag", // = 6;
        GBP = "gbp", // = 7;
        KNOWLEDGE = "knowledge", // = 8;
        PRIZES = "prizes", // = 9;
      }

      export enum SubmissionGroup {
        ALL = "all", // = 0;
        SUCCESSFUL = "successful", // = 1;
        SELECTED = "selected", // = 2;
      }

      export enum SubmissionNotAllowedReasonCode {
        UNSPECIFIED = "unspecified", // = 0;
        // The Comp has disabled submissions.
        COMPETITION_DISABLED = "competitionDisabled", // = 1;
        // Current User did not have Team in given comp.
        TEAM_NOT_FOUND = "teamNotFound", // = 2;
        // Checks the Current User's Team's Daily/Global Submission allowance.
        TEAM_ALLOWANCE_EXCEEDED = "teamAllowanceExceeded", // = 3;
        KERNEL_STILL_RUNNING = "kernelStillRunning", // = 4;
        KERNEL_RUNTIME_EXCEEDED = "kernelRuntimeExceeded", // = 5;
        MISSING_COMPETITION_DATASOURCE = "missingCompetitionDatasource", // = 6;
        HAS_OTHER_COMPETITION_DATASOURCE = "hasOtherCompetitionDatasource", // = 7;
        HAS_DATASET_DATASOURCE = "hasDatasetDatasource", // = 8;
        HAS_KERNEL_DATASOURCE = "hasKernelDatasource", // = 9;
        USES_GPU = "usesGpu", // = 10;
        USES_INTERNET = "usesInternet", // = 11;
        USES_CUSTOM_DOCKER_IMAGE = "usesCustomDockerImage", // = 12;
        INPUT_KERNEL_REJECTED = "inputKernelRejected", // = 13;
        WRONG_FILE_NAME = "wrongFileName", // = 14;
        // GetKernelRun() can fail if the Kernel was determined to be orphaned
        // and reaped.
        KERNEL_READ_ERROR = "kernelReadError", // = 15;
        USES_TPU = "usesTpu", // = 16;
        USES_NON_STANDARD_DATASET = "usesNonStandardDataset", // = 17;
        DATASET_SIZE_EXCEEDED = "datasetSizeExceeded", // = 18;
        NOT_PYTHON = "notPython", // = 19;
        USES_NON_VERSIONED_DATASET = "usesNonVersionedDataset", // = 20;
        EVALUATION_NOT_SETUP = "evaluationNotSetup", // = 21;
        COMPETITION_NOT_LAUNCHED = "competitionNotLaunched", // = 22;
        KERNEL_USES_PAID_TIER = "kernelUsesPaidTier", // = 23;
        FILE_BLOB_NOT_FOUND = "fileBlobNotFound", // = 24;
        FILE_TOO_LARGE = "fileTooLarge", // = 25;
        KERNEL_FILE_NOT_FOUND = "kernelFileNotFound", // = 26;
        INCORRECT_SUBMISSION_TYPE = "incorrectSubmissionType", // = 27;
        NEW_ENTRANTS_DISABLED = "newEntrantsDisabled", // = 28;
      }

      export enum SubmissionSortBy {
        DATE = "date", // = 0;
        NAME = "name", // = 1;
        PRIVATE_SCORE = "privateScore", // = 2;
        PUBLIC_SCORE = "publicScore", // = 3;
      }

      export enum SubmissionStatus {
        PENDING = "pending", // = 0;
        COMPLETE = "complete", // = 1;
        ERROR = "error", // = 2;
      }

      export enum TeamMergeRequestState {
        UNSPECIFIED = "unspecified", // = 0;
        REQUESTED = "requested", // = 1;
        ACCEPTED = "accepted", // = 2;
        REJECTED = "rejected", // = 3;
        DEACTIVATED = "deactivated", // = 4;
      }
      // Specifies a subset of users involved in a competition
      export enum UserFilter {
        UNSPECIFIED = "unspecified", // = 0;
        SUBMITTED = "submitted", // = 1;
        SUBMITTED_NONE_SELECTED = "submittedNoneSelected", // = 2;
        ACCEPTED_RULES = "acceptedRules", // = 3;
        ACCEPTED_RULES_UNSUBMITTED = "acceptedRulesUnsubmitted", // = 4;
      }
      // Contains methods related to hosting competitions.
      // Contains methods related to competitions.
      // Contains methods related to competition leaderboards.
    }

    export namespace Contact {
      export namespace Models {
        export interface ContactPageDto {
          smsVerificationLink: string | null;
          forgotPasswordLink: string | null;
          competitionsLink: string | null;
          datasetsLink: string | null;
          newDatasetLink: string | null;
          forumsLink: string | null;
          datasetsForumLink: string | null;
          hostLink: string | null;
          inClassOverviewLink: string | null;
          migrateDeprecatedSsoLink: string | null;
          complianceLink: string | null;
          logoGrayPreview: string | null;
          // ReSharper disable once InconsistentNaming
          logoGraySVG: string | null;
          // ReSharper disable once InconsistentNaming
          logoGrayPNG: string | null;
          logoTransparentPreview: string | null;
          // ReSharper disable once InconsistentNaming
          logoTransparentSVG: string | null;
          // ReSharper disable once InconsistentNaming
          logoTransparentPNG: string | null;
        }
      }
    }

    export namespace Datasets {
      export namespace Databundles {
        export interface BigqueryInfo {
          projectId?: /* google.protobuf.StringValue */ string;
          datasetId?: /* google.protobuf.StringValue */ string;
          // Last modified time from dataset as reported by Big Query service
          sourceLastModifiedDate: /* google.protobuf.Timestamp */ string;
        }
        // List of tables in a big query dataset at a given point in time
        // 
        // This is a snapshot because the tables and table schema does change over time
        export interface BigquerySnapshotInfo {
          sourceLastModifiedDate: /* google.protobuf.Timestamp */ string;
          bigqueryTables: Kaggle.Sdk.Datasets.Databundles.TableCollection;
        }

        export interface BooleanMetrics {
          trueCount: number;
          falseCount: number;
          // Ignore in Firestore.
          histogram: Kaggle.Sdk.Datasets.Databundles.Histogram | null;
        }

        export interface ColumnBaseInfo {
          name: string;
          firestorePath: string;
          order: number;
        }

        export interface ColumnSummaryInfo {
          columnTypes: Kaggle.Sdk.Datasets.Databundles.ColumnTypeSummaryInfo[];
          sampleColumnNames: string[];
          totalColumnCount: /*Int64*/ number;
        }

        export interface ColumnTypeSummaryInfo {
          columnType?: /* google.protobuf.StringValue */ string | null;
          columnCount: number;
          rowCount: number;
        }

        export interface ColumnUpdateInfo {
          firestorePath: string;
          description: string;
          /*[NotNull]*/
          type: Kaggle.Sdk.Datasets.Databundles.HarmonizedDataType;
          extendedType: Kaggle.Sdk.Datasets.Databundles.ExtendedDataType;
        }

        export interface CompetitionInfo {
          competitionId: number;
          competitionSlug?: /* google.protobuf.StringValue */ string;
        }

        export interface CompressionInfo {
          filename?: /* google.protobuf.StringValue */ string;
          fileExtension?: /* google.protobuf.StringValue */ string;
          fileSize: number;
          contentEncoding?: /* google.protobuf.StringValue */ string;
          contentMd5?: /* google.protobuf.StringValue */ string;
          archiveGcsUrl?: /* google.protobuf.StringValue */ string;
          creationLastUpdate: /* google.protobuf.Timestamp */ string;
          creationPercentComplete?: /* google.protobuf.DoubleValue */ number;
        }

        export interface CountryMetrics {
          counts: Kaggle.Sdk.Datasets.Databundles.FrequencyCount[];
          uniqueValueCount: number;
          // Ignore in Firestore.
          mostCommonValue: string | null;
          mostCommonValueCount: /*Int32*/ number;
        }

        export interface Databundle extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          databundleInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleInfo;
          datasetInfo: Kaggle.Sdk.Datasets.Databundles.DatasetInfo | null;
          competitionInfo: Kaggle.Sdk.Datasets.Databundles.CompetitionInfo | null;
          remoteDatasourceInfo: Kaggle.Sdk.Datasets.Databundles.RemoteDatasourceInfo | null;
          bigqueryInfo: Kaggle.Sdk.Datasets.Databundles.BigqueryInfo | null;
          githubInfo: Kaggle.Sdk.Datasets.Databundles.GithubInfo | null;
        }

        export interface DatabundleInfo {
          currentDatabundleVersionId?: /* google.protobuf.Int32Value */ number | null;
          databundleType: Kaggle.Sdk.Datasets.DatabundleType;
          diffType: Kaggle.Sdk.Datasets.DatabundleDiffType;
          /*[NotNull]*/
          creationDate: /* google.protobuf.Timestamp */ string;
          creatorUserId: number;
          removalDate: /* google.protobuf.Timestamp */ string | null;
          // We should only set the CurrentGoodVersionKey if the version
          // has been processed successfully, leave null if first version
          // is still in progress or if all version are bad.
          currentGoodVersionKey?: /* google.protobuf.StringValue */ string | null;
          // This always points to the latest version regardless of status
          lastestVersionKey?: /* google.protobuf.StringValue */ string | null;
          versions: Kaggle.Sdk.Datasets.Databundles.DatabundleVersionCollection | null;
        }

        export interface DatabundleOwnerCompetitionInfo {
          competitionId: number;
          scope?: /* google.protobuf.StringValue */ string | null;
        }

        export interface DatabundleOwnerDatasetInfo {
          datasetId: number;
          datasetVersionId: number;
          // security token for accessing dataview service
          scope?: /* google.protobuf.StringValue */ string | null;
        }

        export interface DatabundleOwnerInfo {
          databundleVersionId: number;
          dataset: Kaggle.Sdk.Datasets.Databundles.DatabundleOwnerDatasetInfo | null;
          competition: Kaggle.Sdk.Datasets.Databundles.DatabundleOwnerCompetitionInfo | null;
          kernel: Kaggle.Sdk.Datasets.Databundles.DatabundleOwnerKernelInfo | null;
          previewsDisabled: boolean;
        }

        export interface DatabundleOwnerKernelInfo {
          kernelId: number;
          kernelVersionId: number;
          scope?: /* google.protobuf.StringValue */ string | null;
        }
        // Object holding information that is necessary on the backend to verify the user has access to
        // a particular databundle. Included in many DataExplorer requests.
        export interface DatabundleVerificationInfo {
          databundleVersionId: number;
          competitionId?: /* google.protobuf.Int32Value */ number | null;
          datasetId?: /* google.protobuf.Int32Value */ number | null;
          datasetHashLink?: /* google.protobuf.StringValue */ string | null;
        }

        export interface DatabundleVersion extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          databundleVersionInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVersionInfo;
          datasetVersionInfo: Kaggle.Sdk.Datasets.Databundles.DatasetVersionInfo | null;
          /*[NotNull]*/
          statusInfo: Kaggle.Sdk.Datasets.Databundles.StatusInfo;
          exceptionInfo: Kaggle.Sdk.Datasets.Databundles.ExceptionInfo | null;
          filesetInfo: Kaggle.Sdk.Datasets.Databundles.DirectoryInfo | null;
          originalCompressionInfo: Kaggle.Sdk.Datasets.Databundles.CompressionInfo | null;
          bundleCompressionInfo: Kaggle.Sdk.Datasets.Databundles.CompressionInfo | null;
          bigquerySnapshotInfo: Kaggle.Sdk.Datasets.Databundles.BigquerySnapshotInfo | null;
          storageInfo: Kaggle.Sdk.Datasets.Databundles.StorageInfo | null;
          fileSummaryInfo: Kaggle.Sdk.Datasets.Databundles.FileSummaryInfo | null;
          columnSummaryInfo: Kaggle.Sdk.Datasets.Databundles.ColumnSummaryInfo | null;
          externalCopyInfo: Kaggle.Sdk.Datasets.Databundles.ExternalCopyInfo | null;
          originalRemoteUrlInfo: Kaggle.Sdk.Datasets.Databundles.OriginalRemoteUrlInfo | null;
        }

        export interface DatabundleVersionCollection extends Kaggle.Sdk.Datasets.Databundles.IContainerInfo  {
          children: Kaggle.Sdk.Datasets.Databundles.DatabundleVersion[];
        }

        export interface DatabundleVersionInfo {
          versionNumber: number;
          versionNotes?: /* google.protobuf.StringValue */ string | null;
          creatorUserId: number;
          creationDate: /* google.protobuf.Timestamp */ string | null;
          removalDate: /* google.protobuf.Timestamp */ string | null;
          databundleVersionType: Kaggle.Sdk.Datasets.DatabundleVersionType;
          // Maps ObjectType to count
          objectTypeCount: { [key: number]: number };
        }

        export interface DataObject {
          type: Kaggle.Sdk.Datasets.Databundles.ObjectType;
          // Unique identifier for the object
          /*[NotNull]*/
          key: string;
          // RelativePath + Key + ContainerName from parent object
          // 
          // This is used to find the subcollection that contains the object in firestore
          /*[NotNull]*/
          path: string;
          // DatabundleId, DatabundleVersionId, DatabundleVersionObjectId
          // from sql server objects
          legacyEntityId: /* Int32 */ number | null;
          // Relative path of this object relative to DatabundleVersion
          // 
          // This is intended to be used by UI to access the object as either
          // {DatasetSlug}/{RelativeUrl} or
          // {CompetitionSlug}/{RelativeUrl}
          /*[NotNull]*/
          relativeUrl: string;
          /*[NotNull]*/
          name: string;
          description: string | null;
        }

        export interface DatasetInfo {
          datasetId: number;
          datasetSlug?: /* google.protobuf.StringValue */ string;
          isPrivate: boolean;
        }

        export interface DatasetVersionInfo {
          datasetVersionId: number;
        }

        export interface DataSource extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          databundle: Kaggle.Sdk.Datasets.Databundles.Databundle;
          /*[NotNull]*/
          databundleVersion: Kaggle.Sdk.Datasets.Databundles.DatabundleVersion;
          imageUrl: string;
          sourceUrl: string;
          slug?: /* google.protobuf.StringValue */ string | null;
          mountSlug?: /* google.protobuf.StringValue */ string | null;
          lastUpdated: /* google.protobuf.Timestamp */ string | null;
          subtitle?: /* google.protobuf.StringValue */ string | null;
          sourceType: Kaggle.Sdk.Datasets.Databundles.DataSourceType;
          sourceId: number;
          versionNumber?: /* google.protobuf.Int32Value */ number | null;
          state: Kaggle.Sdk.Datasets.Databundles.DataSourceState;
          kernelOutputInfo: Kaggle.Sdk.Datasets.Databundles.KernelOutputInfo | null;
        }

        export interface DateTimeHistogram {
          buckets: Kaggle.Sdk.Datasets.Databundles.DateTimeHistogramBucket[];
        }

        export interface DateTimeHistogramBucket {
          index: number;
          label?: /* google.protobuf.StringValue */ string;
          leftValue: /* google.protobuf.Timestamp */ string;
          rightValue: /* google.protobuf.Timestamp */ string;
          count: number;
        }

        export interface DateTimeMetrics {
          mean: /* google.protobuf.Timestamp */ string | null;
          /*[NotNull]*/
          minimum: /* google.protobuf.Timestamp */ string;
          /*[NotNull]*/
          maximum: /* google.protobuf.Timestamp */ string;
          histogram: Kaggle.Sdk.Datasets.Databundles.DateTimeHistogram | null;
        }

        export interface Directory extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          directoryInfo: Kaggle.Sdk.Datasets.Databundles.DirectoryInfo;
          compressionInfo: Kaggle.Sdk.Datasets.Databundles.CompressionInfo | null;
          kernelSessionInfo: Kaggle.Sdk.Datasets.Databundles.KernelSessionInfo | null;
        }

        export interface DirectoryCollection extends Kaggle.Sdk.Datasets.Databundles.IContainerInfo  {
          children: Kaggle.Sdk.Datasets.Databundles.Directory[];
        }

        export interface DirectoryInfo {
          totalSize: number;
          downloadUrl?: /* google.protobuf.StringValue */ string;
          directories: Kaggle.Sdk.Datasets.Databundles.DirectoryCollection;
          files: Kaggle.Sdk.Datasets.Databundles.FileCollection;
        }

        export interface ExcelInfo {
          tables: Kaggle.Sdk.Datasets.Databundles.TableCollection;
        }

        export interface ExceptionInfo {
          // Critical exceptions are errors that cause the worker pipeline to stop, i.e. the databundle to fail.
          criticalException?: /* google.protobuf.StringValue */ string | null;
          // Warning exceptions are non-critical, the worker keeps processing. They are stored for information only.
          /*[NotNull]*/
          warningExceptions: string[];
        }

        export interface ExternalCopy {
          bucket?: /* google.protobuf.StringValue */ string | null;
          path?: /* google.protobuf.StringValue */ string | null;
          region?: /* google.protobuf.StringValue */ string | null;
          lastCopied: /* google.protobuf.Timestamp */ string | null;
          status: Kaggle.Sdk.Datasets.Databundles.ExternalCopyStatus;
          lastUpdate: /* google.protobuf.Timestamp */ string | null;
          percentFinished?: /* google.protobuf.DoubleValue */ number | null;
        }

        export interface ExternalCopyInfo {
          externalCopies: Kaggle.Sdk.Datasets.Databundles.ExternalCopy[];
        }

        export interface File extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          fileInfo: Kaggle.Sdk.Datasets.Databundles.FileInfo;
          // Csv, Tsv, etc
          fileTableInfo: Kaggle.Sdk.Datasets.Databundles.FileTableInfo | null;
          tableInfo: Kaggle.Sdk.Datasets.Databundles.TableInfo | null;
          sqliteInfo: Kaggle.Sdk.Datasets.Databundles.SqliteInfo | null;
          excelInfo: Kaggle.Sdk.Datasets.Databundles.ExcelInfo | null;
          remoteUrlInfo: Kaggle.Sdk.Datasets.Databundles.RemoteUrlInfo | null;
          kernelSessionInfo: Kaggle.Sdk.Datasets.Databundles.KernelSessionInfo | null;
        }

        export interface FileCollection extends Kaggle.Sdk.Datasets.Databundles.IContainerInfo  {
          children: Kaggle.Sdk.Datasets.Databundles.File[];
        }

        export interface FileExtensionSummaryInfo {
          extension: string;
          fileCount: number;
          totalSize: number;
        }

        export interface FileInfo {
          size: number;
          fullPath: string;
          downloadUrl?: /* google.protobuf.StringValue */ string | null;
          fileExtension: string;
          contentType: string;
          contentMd5: string;
          gcsUrl?: /* google.protobuf.StringValue */ string | null;
          gcsCompressedUrl?: /* google.protobuf.StringValue */ string | null;
        }

        export interface FileSummaryInfo {
          fileTypes: Kaggle.Sdk.Datasets.Databundles.FileExtensionSummaryInfo[];
          sampleFileNames: string[];
          totalFileCount: /*Int64*/ number;
        }

        export interface FileTableInfo {
          includesHeader: boolean;
          headerRow: number;
          delimiter?: /* google.protobuf.StringValue */ string;
        }

        export interface FrequencyCount {
          key: string;
          value: number;
        }
        // Request to get (more) children for a data object for the data explorer frontend component. For example,
        // a directory might contain 100 files, and we're showing only the first 50. This request gets triggered for
        // loading the next 50.
        export interface GetDatabundleExternalChildrenRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVerificationInfo;
          // Path for the actual object
          firestorePath?: /* google.protobuf.StringValue */ string;
          offset: number;
          count: number;
          depth: number;
        }

        export interface GetDatabundleExternalChildrenResponse {
          directories: Kaggle.Sdk.Datasets.Databundles.Directory[];
          files: Kaggle.Sdk.Datasets.Databundles.File[];
          tables: Kaggle.Sdk.Datasets.Databundles.Table[];
          tableColumns: Kaggle.Sdk.Datasets.Databundles.TableColumn[];
        }
        // Request to get columns by FirestorePath (not necessarily in storage order).
        export interface GetDatabundleExternalColumnsByFirestorePathRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVerificationInfo;
          // Note: These are the paths of individual columns, not the path of the parent object!
          firestorePaths: string[];
        }

        export interface GetDatabundleExternalColumnsByFirestorePathResponse {
          columns: Kaggle.Sdk.Datasets.Databundles.TableColumn[];
        }
        // Request to get *all* columns for a given data object (file, table). Since this can be a lot of data (e.g. for
        // 10k columns, we're only returning name, firestorepath and order here). Which columns are actually displayed
        // will then depend on the user's selection (this is just to get a summary and allow them to do the selection).
        export interface GetDatabundleExternalColumnsRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVerificationInfo;
          // Path for the actual object
          firestorePath?: /* google.protobuf.StringValue */ string;
        }

        export interface GetDatabundleExternalColumnsResponse {
          columns: Kaggle.Sdk.Datasets.Databundles.ColumnBaseInfo[];
        }
        // Request to get databundle data (for the data explorer). DatabundleVersionId is required, as well as one of
        // CompetitionId or DatasetId.
        // - DatabundleVersionId: Main parameter to identify the databundle (version).
        // - CompetitionId: Used to identify the competition and to handle access checks.
        // - DatasetId: Used to identify the dataset and to handle access checks.
        export interface GetDatabundleExternalRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVerificationInfo;
        }

        export interface GetDatabundleExternalResponse {
          /*[NotNull]*/
          dataSource: Kaggle.Sdk.Datasets.Databundles.DataSource;
        }

        export interface GithubInfo {
          ownerSlug: string;
          repositorySlug: string;
          lastUpdatedHash?: /* google.protobuf.StringValue */ string | null;
        }

        export interface Histogram {
          buckets: Kaggle.Sdk.Datasets.Databundles.HistogramBucket[];
          type: Kaggle.Sdk.Datasets.Databundles.HarmonizedDataType;
        }

        export interface HistogramBucket {
          index: number;
          label?: /* google.protobuf.StringValue */ string;
          leftValue: number;
          rightValue: number;
          count: number;
        }
        // A hack to get typescript to play nice
        export interface IContainerInfo {
          totalChildren: /*Int32*/ number;
          count: /*Int32*/ number;
        }

        export interface KernelOutputInfo {
          kernelId: number;
          url: string;
        }

        export interface KernelSessionInfo {
          kernelSessionId: number;
        }

        export interface NumericMetrics {
          finiteCount: number;
          infiniteCount: number;
          mean: number;
          standardDeviation: number;
          minimum: number;
          minimumFinite: number;
          maximum: number;
          maximumFinite: number;
          quantiles: Kaggle.Sdk.Datasets.Databundles.Quantile[];
          histogram: Kaggle.Sdk.Datasets.Databundles.Histogram | null;
        }
        // List of remote URLs originally added by the user upon upload (on the level of a databundle version).
        // Each file already stores its own remote URL, so why do we need to store this in addition?
        // - If users specify zip files as a remote URL, then this zip gets unpacked automatically
        // - When processing happens on the worker, the zip gets uncompressed and we keep only the files in there
        // - The files themselves don't have a remote URL
        // - Subsequent request then fail because there's files in a remote url dataset without actual URLs
        // To fix this situation, we need to store the original URLs that were used, which is what this object is for.
        export interface OriginalRemoteUrlInfo {
          originalRemoteUrls: Kaggle.Sdk.Datasets.Databundles.RemoteUrlInfo[];
        }

        export interface Quantile {
          point: number;
          value: number;
        }

        export interface RemoteDatasourceInfo {
          updateFrequency: Kaggle.Sdk.Datasets.RemoteUrlUpdateFrequency;
        }

        export interface RemoteUrlInfo {
          url?: /* google.protobuf.StringValue */ string | null;
          name?: /* google.protobuf.StringValue */ string | null;
        }

        export interface SqliteInfo {
          tables: Kaggle.Sdk.Datasets.Databundles.TableCollection;
        }

        export interface StatusInfo {
          status: Kaggle.Sdk.Datasets.DatabundleStatus;
          statusMessage?: /* google.protobuf.StringValue */ string | null;
          percentageCompleted: number;
        }

        export interface StorageInfo {
          uploadDataLocation: Kaggle.Sdk.Datasets.StorageLocation;
          rawDataLocation: Kaggle.Sdk.Datasets.StorageLocation;
          individualCompressedLocation: Kaggle.Sdk.Datasets.StorageLocation;
          bundleArchiveLocation: Kaggle.Sdk.Datasets.StorageLocation;
          fileSystemLocation: Kaggle.Sdk.Datasets.StorageLocation;
        }

        export interface StringMetrics {
          counts: Kaggle.Sdk.Datasets.Databundles.FrequencyCount[];
          uniqueValueCount: number;
          // Ignore in Firestore.
          mostCommonValue: string | null;
          mostCommonValueCount: /*Int32*/ number;
        }

        export interface Table extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          tableInfo: Kaggle.Sdk.Datasets.Databundles.TableInfo;
        }

        export interface TableCollection extends Kaggle.Sdk.Datasets.Databundles.IContainerInfo  {
          children: Kaggle.Sdk.Datasets.Databundles.Table[];
        }

        export interface TableColumn extends Kaggle.Sdk.Datasets.Databundles.DataObject  {
          /*[NotNull]*/
          tableColumnInfo: Kaggle.Sdk.Datasets.Databundles.TableColumnInfo;
          tableColumnMetrics: Kaggle.Sdk.Datasets.Databundles.TableColumnMetrics | null;
        }

        export interface TableColumnCollection extends Kaggle.Sdk.Datasets.Databundles.IContainerInfo  {
          children: Kaggle.Sdk.Datasets.Databundles.TableColumn[];
        }

        export interface TableColumnInfo {
          // This class is intented to be embedded in DataObjects.TableColumn
          // Name & Description are already part of that class no need to repeat
          order?: /* google.protobuf.Int32Value */ number | null;
          originalType?: /* google.protobuf.StringValue */ string | null;
          type: Kaggle.Sdk.Datasets.Databundles.HarmonizedDataType;
          extendedType: Kaggle.Sdk.Datasets.Databundles.ExtendedDataType;
          isNullable?: /* google.protobuf.BoolValue */ boolean | null;
          isPrimaryKey?: /* google.protobuf.BoolValue */ boolean | null;
          isLabel?: /* google.protobuf.BoolValue */ boolean | null;
        }

        export interface TableColumnMetrics {
          errorMessage?: /* google.protobuf.StringValue */ string | null;
          nullCount: number;
          nonNullCount: number;
          validCount: number;
          invalidCount: number;
          // Depending on the type of the column, only one of these is actually set.
          booleanMetrics: Kaggle.Sdk.Datasets.Databundles.BooleanMetrics | null;
          numericMetrics: Kaggle.Sdk.Datasets.Databundles.NumericMetrics | null;
          dateTimeMetrics: Kaggle.Sdk.Datasets.Databundles.DateTimeMetrics | null;
          stringMetrics: Kaggle.Sdk.Datasets.Databundles.StringMetrics | null;
          countryMetrics: Kaggle.Sdk.Datasets.Databundles.CountryMetrics | null;
          totalCount: /*Int32*/ number;
        }

        export interface TableInfo {
          totalRows: number;
          tableColumns: Kaggle.Sdk.Datasets.Databundles.TableColumnCollection;
          totalColumns: /*Int32*/ number;
        }
        // Request for changing metadata for multiple columns within a table. OwnerInfo needs to be specified for access checks.
        export interface UpdateDatabundleColumnsRequest {
          /*[NotNull]*/
          ownerInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleOwnerInfo;
          /*[NotNull]*/
          columns: Kaggle.Sdk.Datasets.Databundles.ColumnUpdateInfo[];
        }
        // Request for changing an object's metadata. This updates an object's description as well as optionally
        // the descriptions + types for a set of provided columns (which have to be 'under' that object).
        // Note: This currently does not return any updates to the usability rating, since it's entirely embedded within the data
        // viewer v3. We should probably change this at some point.
        export interface UpdateDatabundleMetadataExternalRequest {
          // For authorization checks.
          /*[NotNull]*/
          verificationInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVerificationInfo;
          // The path of the main object to be updated.
          firestorePath: string;
          // Description of the main object (file / table) to be updated. Optional (in which case only columns are updated).
          description?: /* google.protobuf.StringValue */ string | null;
          // List of columns under that object to be also updated. Optional (in which case only the main description are updated).
          columns: Kaggle.Sdk.Datasets.Databundles.ColumnUpdateInfo[];
        }

        export interface UpdateDatabundleMetadataExternalResponse {
          usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
        }
        // Response from a EditDatabundleObjectMetadataRequest. Returning an empty message means success.
        export interface UpdateDatabundleResponse {
          errorMessage?: /* google.protobuf.StringValue */ string | null;
          requiresReprocessing: boolean;
          blocked: boolean;
          usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
        }

        export enum DataSourceState {
          PUBLIC = "public", // = 0;
          PRIVATE = "private", // = 1;
          PRIVATE_BUT_VISIBLE = "privateButVisible", // = 2;
          DELETED = "deleted", // = 3;
        }

        export enum DataSourceType {
          UNSPECIFIED = "unspecified", // = 0;
          COMPETITION = "competition", // = 1;
          DATASET = "dataset", // = 2;
          NOTEBOOK = "notebook", // = 3;
          UTILITY_SCRIPT = "utilityScript", // = 4;
          NOTEBOOK_OUTPUT = "notebookOutput", // = 5;
        }

        export enum ExtendedDataType {
          UNSPECIFIED = "unspecified", // = 0;
          ID = "id", // = 1;
          UUID = "uuid", // = 2;
          LATITUDE = "latitude", // = 3;
          LONGITUDE = "longitude", // = 4;
          COORDINATES = "coordinates", // = 5;
          COUNTRY = "country", // = 6;
          PROVINCE = "province", // = 7;
          POSTAL_CODE = "postalCode", // = 8;
          ADDRESS = "address", // = 9;
          EMAIL = "email", // = 10;
          URL = "url", // = 11;
          INTEGER = "integer", // = 12;
          DECIMAL = "decimal", // = 13;
          CITY = "city", // = 14;
        }

        export enum ExternalCopyStatus {
          UNSPECIFIED = "unspecified", // = 0;
          STARTED = "started", // = 1;
          FINISHED = "finished", // = 2;
        }

        export enum HarmonizedDataType {
          STRING = "string", // = 0;
          BOOLEAN = "boolean", // = 1;
          NUMERIC = "numeric", // = 2;
          DATE_TIME = "dateTime", // = 3;
          UNKNOWN = "unknown", // = 4;
        }

        export enum ObjectType {
          // Default/Unknown/Undetermined
          GENERIC = "generic", // = 0;
          DATABUNDLE = "databundle", // = 1;
          DATABUNDLE_VERSION = "databundleVersion", // = 2;
          DIRECTORY = "directory", // = 100;
          FILE = "file", // = 101;
          TABLE = "table", // = 102;
          TABLE_COLUMN = "tableColumn", // = 103;
          DATA_SOURCE = "dataSource", // = 200;
        }
      }

      export namespace DataViewer {
        export namespace Protos {
          export namespace DateTimeFilter {
            export enum DateTimeOperator {
              EQUALS = "equals", // = 0;
              LESS_THAN = "lessThan", // = 1;
              GREATER_THAN = "greaterThan", // = 2;
              LESS_EQUALS = "lessEquals", // = 3;
              GREATER_EQUALS = "greaterEquals", // = 4;
            }
          }

          export namespace NumericFilter {
            export enum NumericOperator {
              EQUALS = "equals", // = 0;
              LESS_THAN = "lessThan", // = 1;
              GREATER_THAN = "greaterThan", // = 2;
              LESS_EQUALS = "lessEquals", // = 3;
              GREATER_EQUALS = "greaterEquals", // = 4;
            }
          }

          export namespace StringFilter {
            export enum StringOperator {
              IN = "in", // = 0;
              EQUALS = "equals", // = 1;
              CONTAINS = "contains", // = 2;
            }
          }

          export interface AndFilter {
            // When evaluated, all these filters have to be true for the overall filter to become true
            filters: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter[];
          }

          export interface BooleanFilter {
            // For booleans, we only allow to filter by equality
            value: boolean;
          }

          export interface Column {
            // Firestore path uniquely identifying the column
            firestorePath: string;
          }

          export interface ColumnFilter {
            // Which column to filter on
            column: Kaggle.Sdk.Datasets.DataViewer.Protos.Column | null;
            booleanFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.BooleanFilter | null;
            numericFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.NumericFilter | null;
            dateTimeFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.DateTimeFilter | null;
            stringFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.StringFilter | null;
          }

          export interface ConstantFilter {
            // For completeness only
            value: boolean;
          }

          export interface DataRaw {
            // Raw responses contain the file data as a string.
            data: string;
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataRawType;
            totalBytes: number;
            previewBytes: number;
          }

          export interface DataRow {
            // The row number identifier.
            rowNumber: number;
            // The raw data for a particular row. Each value represents one column.
            text: string[];
          }

          export interface DataTable {
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataTableType;
            // The total number of rows contained in this file.
            totalRows: number;
            // The total number of rows returned in this request.
            // This could be different than total_rows if there are query filters applied.
            rowsReturned: number;
            // The raw row data for the returned file.
            rows: Kaggle.Sdk.Datasets.DataViewer.Protos.DataRow[];
          }

          export interface DataUrl {
            // Image responses contain the url of the image to preview.
            url: string;
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataUrlType;
          }
          ////// Response objects / messages //////
          export interface DataView {
            // The type of this DataView.
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataViewType;
            // The data returned for tabular files.
            dataTable?: Kaggle.Sdk.Datasets.DataViewer.Protos.DataTable | null;
            // The data returned for image files.
            dataUrl?: Kaggle.Sdk.Datasets.DataViewer.Protos.DataUrl | null;
            // The raw data returned for "other" files.
            dataRaw?: Kaggle.Sdk.Datasets.DataViewer.Protos.DataRaw | null;
          }

          export interface DateTimeFilter {
            // Operator to use for comparisons
            operator: Kaggle.Sdk.Datasets.DataViewer.Protos.DateTimeFilter.DateTimeOperator;
            // Operand to compare against
            operand: /* google.protobuf.Timestamp */ string | null;
          }

          export interface Filter {
            columnFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.ColumnFilter | null;
            constantFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.ConstantFilter | null;
            andFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.AndFilter | null;
            orFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.OrFilter | null;
            notFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.NotFilter | null;
          }

          export interface GetDataViewResponse {
            // The materialized view of the file.
            dataView: Kaggle.Sdk.Datasets.DataViewer.Protos.DataView | null;
          }

          export interface NotFilter {
            // When evaluated, the given filter has to return false for the overall filter to become true
            filter: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter | null;
          }

          export interface NumericFilter {
            // Operator to use for comparisons
            operator: Kaggle.Sdk.Datasets.DataViewer.Protos.NumericFilter.NumericOperator;
            // Operand to compare against (using double as the widest numerical type)
            operand: number;
          }

          export interface OrFilter {
            // When evaluated, one of these filters have to be true for the overall filter to become true
            filters: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter[];
          }

          export interface SortBy {
            // What column to sort by
            column: Kaggle.Sdk.Datasets.DataViewer.Protos.Column | null;
            // Which direction?
            direction: Kaggle.Sdk.Datasets.DataViewer.Protos.SortDirection;
          }

          export interface StringFilter {
            // Operator to use for comparisons (we only allow IN here, but might extend in the future)
            operator: Kaggle.Sdk.Datasets.DataViewer.Protos.StringFilter.StringOperator;
            // Operands to compare against .
            // - IN uses the whole list of operands to compare against.
            // - EQUALS and CONTAINS use only the first one.
            operands: string[];
          }
          ////// Request objects / messages //////
          export interface TableQuery {
            // Row offset
            skip: number;
            // How many rows to return
            take: number;
            // Since we can combine filters in an AND and OR fashion, the top level filter only needs to be
            // a single entry (which itself can be a combination of filters)
            filter: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter | null;
            // Which columns to return
            selectedColumns: Kaggle.Sdk.Datasets.DataViewer.Protos.Column[];
            // Which columns to sort on
            sorts: Kaggle.Sdk.Datasets.DataViewer.Protos.SortBy[];
          }

          export enum DataRawType {
            MARKDOWN = "markdown", // = 0;
            JSON = "json", // = 1;
            TEXT = "text", // = 2;
          }

          export enum DataTableType {
            // Table is a csv file in cloud storage.
            CSV = "csv", // = 0;
            BIGQUERY = "bigquery", // = 1;
            SQLITE = "sqlite", // = 2;
            EXCEL = "excel", // = 3;
          }

          export enum DataUrlType {
            IMAGE = "image", // = 0;
            PDF = "pdf", // = 1;
            AUDIO = "audio", // = 2;
            VIDEO = "video", // = 3;
          }

          export enum DataViewType {
            TABULAR = "tabular", // = 0;
            URL = "url", // = 1;
            RAW = "raw", // = 2;
          }

          export enum SortDirection {
            ASC = "asc", // = 0;
            DESC = "desc", // = 1;
          }
        }
      }

      export namespace Models {
        export namespace DatasetFileType {
          export enum Enum {
            DATASET_FILE_TYPE_UNSPECIFIED = "datasetFileTypeUnspecified", // = 0;
            CSV = "csv", // = 1;
            JSON = "json", // = 2;
            SQLITE = "sqlite", // = 3;
            OTHER = "other", // = 4;
          }
        }

        export namespace DatasetFileTypeGroup {
          export enum Enum {
            ALL = "all", // = 0;
            CSV = "csv", // = 1;
            SQLITE = "sqlite", // = 2;
            JSON = "json", // = 3;
            BIG_QUERY = "bigQuery", // = 4;
          }
        }

        export namespace DatasetLicenseGroup {
          export enum Enum {
            ALL = "all", // = 0;
            CC = "cc", // = 1;
            GPL = "gpl", // = 2;
            ODB = "odb", // = 3;
            OTHER = "other", // = 4;
          }
        }

        export namespace DatasetSelectionGroup {
          export enum Enum {
            PUBLIC = "public", // = 0;
            MY = "my", // = 1;
            USER = "user", // = 2;
            USER_SHARED_WITH_ME = "userSharedWithMe", // = 3;
            UPVOTED = "upvoted", // = 4;
            MY_PRIVATE = "myPrivate", // = 5;
            MY_PUBLIC = "myPublic", // = 10;
            ORGANIZATION = "organization", // = 6;
            BOOKMARKED = "bookmarked", // = 11;
            COLLABORATION = "collaboration", // = 12;
            // Old
            FEATURED = "featured", // = 7;
            ALL = "all", // = 8;
            UNFEATURED = "unfeatured", // = 9;
          }
        }

        export namespace DatasetSizeGroup {
          export enum Enum {
            ALL = "all", // = 0;
            SMALL = "small", // = 1;
            MEDIUM = "medium", // = 2;
            LARGE = "large", // = 3;
          }
        }

        export namespace DatasetSortBy {
          export enum Enum {
            HOTTEST = "hottest", // = 0;
            VOTES = "votes", // = 1;
            UPDATED = "updated", // = 2;
            // Deprecated
            ACTIVE = "active", // = 3;
            PUBLISHED = "published", // = 4;
            // Old world
            RELEVANCE = "relevance", // = 5;
            LAST_VIEWED = "lastViewed", // = 6;
            USABILITY = "usability", // = 7;
          }
        }

        export namespace DatasetViewedGroup {
          export enum Enum {
            ALL = "all", // = 0;
            VIEWED = "viewed", // = 1;
          }
        }

        export interface DatasetEditImagesDto {
          cardImageUrl: string | null;
          coverImageUrl: string | null;
          thumbnailImageUrl: string | null;
          originalImageUrl: string | null;
          success: boolean;
          usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
        }

        export interface DatasetFileType {}

        export interface DatasetPublishStatusDto {
          status: Kaggle.Sdk.Datasets.DatabundleVersionStatus;
          currentStatusPercentComplete: /*Double*/ number;
          creationPercentComplete: /*Double*/ number;
          creationStep: string | null;
          creationStart: /* DateTime */ string;
        }

        export interface DatasetUploadResponseDto {
          status: Kaggle.Sdk.Datasets.Models.DatasetUploadResponseStatus;
          error: Kaggle.Sdk.Common.Models.Legacy.PageMessageDto | null;
          datasetId: /* Int32 */ number | null;
          datasetVersionId: /* Int32 */ number | null;
          databundleId: /* Int32 */ number | null;
          databundleVersionId: /* Int32 */ number | null;
          url: string | null;
          publishStatus: Kaggle.Sdk.Datasets.Models.DatasetPublishStatusDto | null;
        }

        export enum DatasetUploadResponseStatus {
          OK = "ok", // = 1;
          ERROR = "error", // = 2;
        }
      }

      export namespace Responses {
        export interface DatasetEditResponseDto {
          status: Kaggle.Sdk.Datasets.Responses.DatasetEditResponseStatus;
          errors: Kaggle.Sdk.Common.Models.Legacy.PageMessageDto[];
          datasetUrl: string | null;
          usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
        }

        export enum DatasetEditResponseStatus {
          OK = "ok", // = 1;
          ERROR = "error", // = 2;
        }
      }
      // Accepts a submission for a task.
      export interface AcceptTaskSubmissionRequest {
        taskSubmissionId: number;
      }

      export interface ActionFlags {
        disableWorker: boolean;
        disableBundleCreation: boolean;
        disableIndividualZipCreation: boolean;
        disableRawUpload: boolean;
        disableMetadata: boolean;
        disableStatus: boolean;
        disableStatusPubSub: boolean;
        disableFinalResult: boolean;
        disableEmbeddedFilesystem: boolean;
        disableDecompression: boolean;
        disableDirectoryZipCreation: boolean;
        useStandaloneZipperForBundle: boolean;
        // If the user uploaded a single zip file, then we can just use this as the bundle.zip. This flag enables that
        // functionality.
        reuseOriginalSingleGcsZip: boolean;
        // Use this path instead of the upload path to copy files from.
        gcsUploadUrl?: /* google.protobuf.StringValue */ string | null;
        // TODO(timoboz) remove these once the migration is over
        migration: boolean;
        // Needed to make sure the new version attribute doesn't get set for old versions we're migrating
        migrationIsCurrentDatabundleVersion: boolean;
      }

      export interface ActivityNotGeneratedBanner {
        title?: /* google.protobuf.StringValue */ string | null;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        img: Kaggle.Sdk.Common.Image | null;
        href?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ActivityPage {
        status: Kaggle.Sdk.Datasets.ActivityPageStatus;
        banner: Kaggle.Sdk.Datasets.ActivityNotGeneratedBanner | null;
        summaryStats: Kaggle.Sdk.Datasets.ActivitySummaryStats | null;
      }

      export interface ActivityPageContributorLocation {
        location?: /* google.protobuf.StringValue */ string | null;
        count: number;
      }

      export interface ActivityPageTimeSeries {
        key?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        points: Kaggle.Sdk.Datasets.ActivityPageTimeSeriesPoint[];
      }

      export interface ActivityPageTimeSeriesPoint {
        date: /* google.protobuf.Timestamp */ string | null;
        count: number;
      }
      // Increment DatasetConstants.ActivitySummaryStats.CurrentSchemaVersion if you make any change here
      // as this object is serialized as Json to the database for fast retrieval.
      export interface ActivitySummaryStats {
        id: number;
        schemaVersion: number;
        datasetId: number;
        generatedDate: /* google.protobuf.Timestamp */ string | null;
        datasetStats: Kaggle.Sdk.Datasets.DatasetActivityPageStat[];
        timeSeries: { [key: string]: Kaggle.Sdk.Datasets.ActivityPageTimeSeries | null };
        topContributors: Kaggle.Sdk.Datasets.DatasetActivityPageContributor[];
        contributorLocations: Kaggle.Sdk.Datasets.ActivityPageContributorLocation[];
        kernelStats: Kaggle.Sdk.Datasets.DatasetActivityPageStat[];
        kernelMedals: Kaggle.Sdk.Datasets.DatasetActivityPageMedal[];
        topKernels: Kaggle.Sdk.Datasets.DatasetActivityPageKernel[];
        tags: Kaggle.Sdk.Datasets.DatasetActivityPageTag[];
        relatedDatasets: Kaggle.Sdk.Datasets.DatasetActivityPageRelatedDataset[];
        discussionStats: Kaggle.Sdk.Datasets.DatasetActivityPageStat[];
        discussionMedals: Kaggle.Sdk.Datasets.DatasetActivityPageMedal[];
        topDiscussions: Kaggle.Sdk.Datasets.DatasetActivityPageDiscussion[];
      }

      export interface AddDatasetCategoriesRequest {
        datasetId: number;
        categoryIds: number[];
      }

      export interface AddDatasetCategoriesResponse {
        updatedUsabilityRating?: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
      }

      export interface AttachCompetitionDatasetRequest {
        competitionId: number;
        datasetId: number;
      }
      // Class that encapsulates auto-generated dataset sources of both:
      // 1. kernel generated output
      // 2. external urls (including: BigQuery, Github, and other remote urls)
      export interface AutoGeneratedSource {
        kernelReference: Kaggle.Sdk.Datasets.KernelOutputKernelReference | null;
        externalSourceUrl?: /* google.protobuf.StringValue */ string | null;
      }
      // This is just enough information for the datasets basics
      // to render.
      export interface BasicKernelOutputKernelReference {
        url: string;
      }

      export interface BigQuerySettingsDto {
        projectId?: /* google.protobuf.StringValue */ string | null;
        datasetId?: /* google.protobuf.StringValue */ string | null;
        tableId?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CompetitionDatabundleVersion {
        id: number;
        databundleId: number;
        creatorUserId: number;
        creationDate: /* google.protobuf.Timestamp */ string | null;
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        versionNotes?: /* google.protobuf.StringValue */ string | null;
        type: Kaggle.Sdk.Datasets.DatabundleVersionType;
        status: Kaggle.Sdk.Datasets.DatabundleVersionStatus;
        creationStatus: Kaggle.Sdk.Datasets.DatabundleVersionCreationStatus | null;
      }

      export interface CompetitionUploaderConfig {
        /*[NotNull]*/
        existingData: Kaggle.Sdk.Datasets.ExistingDataInfo;
      }

      export interface CreateBigQueryDatasetRequest {
        /*[NotNull]*/
        basicInfo: Kaggle.Sdk.Datasets.DataCreationBasicInfo;
        projectId: string;
        datasetId: string;
        // Optional. If no slug is provided, then the title is slugified.
        slug?: /* google.protobuf.StringValue */ string | null;
        ownerOrganizationSlug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CreateCompetitionDataRequest {
        /*[NotNull]*/
        basicInfo: Kaggle.Sdk.Datasets.DataCreationBasicInfo;
        /*[NotNull]*/
        competitionId: number;
        versionNotes: string;
        // For DatabundleVersionType: Fileset
        existingDirectories: Kaggle.Sdk.Datasets.ExistingDirectoryInfo[];
        existingFiles: Kaggle.Sdk.Datasets.ExistingFileInfo[];
      }

      export interface CreateCompetitionDataResponse {
        /*[NotNull]*/
        status: Kaggle.Sdk.Datasets.CreationStatus;
        errorMessage?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        databundleVersionReference: Kaggle.Sdk.Datasets.DatabundleVersionReference | null;
      }

      export interface CreateDatasetHashLinkRequest {
        datasetId: number;
      }

      export interface CreateDatasetHashLinkResponse {
        datasetHashLink: string;
      }

      export interface CreateDatasetRequest {
        /*[NotNull]*/
        basicInfo: Kaggle.Sdk.Datasets.DataCreationBasicInfo;
        title: string;
        slug: string;
        overview?: /* google.protobuf.StringValue */ string | null;
        description?: /* google.protobuf.StringValue */ string | null;
        /*[NotNull]*/
        isPrivate: boolean;
        /*[NotNull]*/
        licenseId: number;
        referrer: string;
        ownerOrganizationId?: /* google.protobuf.Int32Value */ number | null;
        ownerUserId?: /* google.protobuf.Int32Value */ number | null;
        taskId?: /* google.protobuf.Int32Value */ number | null;
        // This is for uploading a new dataset through competition's datasets tab
        // It is different than CreateCompetitionData which creates databundle for competition
        // and CreateCompetitionDataset which link a dataset to a competition, although
        // this upload will call CreateCompetitionDataset internally
        competitionId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface CreateDatasetVersionRequest {
        /*[NotNull]*/
        basicInfo: Kaggle.Sdk.Datasets.DataCreationBasicInfo;
        /*[NotNull]*/
        datasetId: number;
        versionNotes: string;
        overview?: /* google.protobuf.StringValue */ string | null;
        description?: /* google.protobuf.StringValue */ string | null;
        /*[NotNull]*/
        deleteOldVersions: boolean;
        // For DatabundleVersionType: Fileset
        existingDirectories: Kaggle.Sdk.Datasets.ExistingDirectoryInfo[];
        existingFiles: Kaggle.Sdk.Datasets.ExistingFileInfo[];
      }
      // Request to create the approver entry in order to grant DOI, (DataCite's Digital Object Identifier https://support.datacite.org/docs/api-create-dois)
      // for the specified version of the dataset.
      // Design doc: https://goto.google.com/granting-dois-for-kaggle-datasets
      export interface CreateDoiApproverRequest {
        // Dataset Id.
        datasetId: number;
      }
      // Response to the CreateDoiApproverRequest.
      // Create is successful if ErrorMessage is null.
      export interface CreateDoiApproverResponse {
        // Error Message that may be displayed to indicate what went wrong.
        errorMessage?: /* google.protobuf.StringValue */ string | null;
      }
      // Request to create the DOI, (DataCite's Digital Object Identifier https://support.datacite.org/docs/api-create-dois)
      // for the specified version of the dataset.
      export interface CreateDoiRequest {
        // DatasetVersion Id.
        datasetVersionId: number;
        // Force creates a new doi even if one existed already.
        replaceExistingDoi: boolean;
        // If true, before generating the doi, add the dataset persistence approval first if one doesn't exist for the dataset.
        // If false, if dataset persistence approval has not been added, will not create a doi.
        addDatasetPersistenceApproval: boolean;
      }
      // Response to the CreateDOIRequest.
      // Create is successful if ErrorMessage is null.
      export interface CreateDoiResponse {
        // Error Message that may be displayed to indicate what went wrong.
        errorMessage?: /* google.protobuf.StringValue */ string | null;
        // DOI created for the dataset version.
        doi?: /* google.protobuf.StringValue */ string | null;
      }
      // Request to create a dataset task.
      export interface CreateTaskRequest {
        datasetId: number;
        title: string;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        description: string;
        deadline: /* google.protobuf.Timestamp */ string | null;
      }

      export interface CreateTaskResponse {
        taskId: number;
      }

      export interface CreateTaskSubmissionRequest {
        datasetTaskId: number;
        kernelId?: /* google.protobuf.Int32Value */ number | null;
        datasetId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface DatabundleInfo {
        totalSize: number;
        isFileset: boolean;
        canSeeDownload: boolean;
        canUpdate: boolean;
        firestorePath: string;
        downloadUrl: string;
        versionId: number;
      }

      export interface DatabundleVersionCreationStatus {
        status: Kaggle.Sdk.Datasets.DatabundleVersionStatus;
        creationPercentComplete: number;
        creationException?: /* google.protobuf.StringValue */ string | null;
        creationLastUpdate: /* google.protobuf.Timestamp */ string | null;
        creationStep?: /* google.protobuf.StringValue */ string | null;
        creationStart: /* google.protobuf.Timestamp */ string | null;
        userMessage?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatabundleVersionReference {
        databundleId: number;
        databundleType: Kaggle.Sdk.Datasets.DatabundleType;
        databundleVersionId: number;
        databundleVersionType: Kaggle.Sdk.Datasets.DatabundleVersionType;
        diffType: Kaggle.Sdk.Datasets.DatabundleDiffType;
      }

      export interface DatabundleVersionStorageSettings {
        webDataLocation: Kaggle.Sdk.Datasets.StorageLocation | null;
        sdsDataLocation: Kaggle.Sdk.Datasets.StorageLocation | null;
        responseDataLocation: Kaggle.Sdk.Datasets.StorageLocation | null;
      }
      // Data coverage that encompasses both temporal and spatial information.
      export interface DataCoverageAttribute {
        temporalCoverageFrom: /* google.protobuf.Timestamp */ string | null;
        temporalCoverageTo: /* google.protobuf.Timestamp */ string | null;
        spatialCoverage?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DataCreationBasicInfo {
        /*[NotNull]*/
        databundleVersionType: Kaggle.Sdk.Datasets.DatabundleVersionType;
        // For DatabundleVersionType: Fileset
        directories: Kaggle.Sdk.Datasets.UploadDirectoryInfo[];
        files: Kaggle.Sdk.Datasets.UploadFileInfo[];
        // For DatabundleVersionType: RemoteUrlFileSet
        remoteUrlInfos: Kaggle.Sdk.Datasets.Databundles.RemoteUrlInfo[];
        // For DatabundleVersionType: RemoteGitRepositoryFileSet
        githubInfo: Kaggle.Sdk.Datasets.Databundles.GithubInfo | null;
        // For DatabundleVersionType: KernelOutputFileSet
        kernelOutputInfo: Kaggle.Sdk.Datasets.UploadKernelOutputInfo | null;
        // For DatabundleVersionType: GcsFileSet
        gcsFileSetInfo: Kaggle.Sdk.Datasets.GcsFileSetInfo | null;
        // Worker flags (defaults to ActionFlagsValues.DefaultFlags if null)
        flags: Kaggle.Sdk.Datasets.ActionFlags | null;
      }

      export interface DataCreationSettings {
        actions: string[];
        flags: string[];
      }

      export interface DatasetActivityDto {
        activityType: Kaggle.Sdk.Datasets.DatasetActivityType;
        url?: /* google.protobuf.StringValue */ string | null;
        userName?: /* google.protobuf.StringValue */ string | null;
        userAvatarUrl?: /* google.protobuf.StringValue */ string | null;
        date: /* google.protobuf.Timestamp */ string | null;
        userDisplayName?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        userUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetActivityPageContributor {
        totalUpvotesCount: number;
        user: Kaggle.Sdk.Users.UserAvatar | null;
      }

      export interface DatasetActivityPageDiscussion {
        id: number;
        voteButtonDto: Kaggle.Sdk.Common.VoteButton | null;
        avatar: Kaggle.Sdk.Users.UserAvatar | null;
        medal: Kaggle.Sdk.Common.Image | null;
        title?: /* google.protobuf.StringValue */ string | null;
        timeSinceLastActivity?: /* google.protobuf.StringValue */ string | null;
        replyCount: number;
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetActivityPageKernel {
        id: number;
        voteButtonDto: Kaggle.Sdk.Common.VoteButton | null;
        avatar: Kaggle.Sdk.Users.UserAvatar | null;
        medal: Kaggle.Sdk.Common.Image | null;
        title?: /* google.protobuf.StringValue */ string | null;
        timeSinceLastActivity?: /* google.protobuf.StringValue */ string | null;
        tags: Kaggle.Sdk.Tags.Tag[];
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetActivityPageMedal {
        type: Kaggle.Sdk.Users.Medal;
        count: number;
        image: Kaggle.Sdk.Common.Image | null;
      }

      export interface DatasetActivityPageRelatedDataset {
        id: number;
        voteButtonDto: Kaggle.Sdk.Common.VoteButton | null;
        thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        subTitle?: /* google.protobuf.StringValue */ string | null;
        timeSinceLastActivity?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        kernelsCount: number;
      }

      export interface DatasetActivityPageStat {
        name?: /* google.protobuf.StringValue */ string | null;
        value: number;
      }

      export interface DatasetActivityPageTag {
        name?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        kernelCount: number;
      }

      export interface DatasetAdminSettingsInfo {
        superFeatured: boolean;
        maintainerOrganization: Kaggle.Sdk.Datasets.Owner | null;
        slug: string;
      }
      // This is all of the data needed to render the header of the dataset detail
      // page
      export interface DatasetBasics {
        datasetId: number;
        slug: string;
        title: string;
        removed: boolean;
        private: boolean;
        description: string;
        viewCount: number;
        downloadCount: number;
        scriptCount: number;
        topicCount: number;
        owner: Kaggle.Sdk.Datasets.Owner | null;
        license: Kaggle.Sdk.Datasets.License | null;
        overview: string;
        canEdit: boolean;
        creatorKernel: Kaggle.Sdk.Datasets.BasicKernelOutputKernelReference | null;
        collaborators: Kaggle.Sdk.Users.CollaboratorList | null;
        coverImageUrl: string;
        data: Kaggle.Sdk.Datasets.DatabundleInfo | null;
        voteCount: number;
        medalUrl: string;
        downloadUrl: string;
        lastUpdateTime: /* google.protobuf.Timestamp */ string | null;
        datasetVersionNumber: number;
        alreadyVotedUp: boolean;
        inFlight: boolean;
        creatorDisplayName: string;
        cardImageUrl: string;
        categories: Kaggle.Sdk.Tags.TagList | null;
        bookmarked: boolean;
        datasetExternalUrl: string;
        ownerTwitter: string;
        collaborator: boolean;
        forumId: number;
        datasetVersionId: number;
        canCreateTasks: boolean;
        moderationStatus: Kaggle.Sdk.Abuse.PrivatedModerationStatus;
        isReportedBannerDismissed: boolean;
      }

      export interface DatasetCreationResponse {
        /*[NotNull]*/
        status: Kaggle.Sdk.Datasets.CreationStatus;
        errorMessage?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        databundleVersionReference: Kaggle.Sdk.Datasets.DatabundleVersionReference | null;
        datasetVersionReference: Kaggle.Sdk.Datasets.DatasetVersionReference | null;
      }

      export interface DatasetDatasourceListItem {
        datasetId: number;
        currentDatasetVersionId: number;
        currentDatasetVersionNumber?: /* google.protobuf.Int32Value */ number;
        type: Kaggle.Sdk.Datasets.DatabundleVersionType;
        diffType: Kaggle.Sdk.Datasets.DatabundleDiffType;
        title?: /* google.protobuf.StringValue */ string;
        overview?: /* google.protobuf.StringValue */ string;
        thumbnailImageUrl?: /* google.protobuf.StringValue */ string;
        isPrivate: boolean;
        isDeleted: boolean;
        isFeatured: boolean;
        isSuperFeatured: boolean;
      }

      export interface DatasetDto {
        title?: /* google.protobuf.StringValue */ string | null;
        slug?: /* google.protobuf.StringValue */ string | null;
        licenseId: number;
        data: Kaggle.Sdk.Datasets.LegacyDatabundleInfo | null;
        isPrivate: boolean;
        owner: Kaggle.Sdk.Datasets.OwnerDto | null;
        licenseGroups: Kaggle.Sdk.Datasets.LicenseGroupDto[];
        owners: Kaggle.Sdk.Datasets.OwnerDto[];
        overview?: /* google.protobuf.StringValue */ string | null;
        description?: /* google.protobuf.StringValue */ string | null;
        datasetId: number;
        isRemoved: boolean;
        isVersionRemoved: boolean;
        isFeatured: boolean;
        isSuperFeatured: boolean;
        scheduledToBeFeatured: /* google.protobuf.Timestamp */ string | null;
        scheduledToBeUnFeatured: /* google.protobuf.Timestamp */ string | null;
        scheduledToBeSuperFeatured: /* google.protobuf.Timestamp */ string | null;
        scheduledToBeUnSuperFeatured: /* google.protobuf.Timestamp */ string | null;
        datasetVersionId: number;
        datasetVersionNumber: number;
        lastVersionNumber: number;
        datasetUrl?: /* google.protobuf.StringValue */ string | null;
        datasetExternalUrl?: /* google.protobuf.StringValue */ string | null;
        originalImageUrl?: /* google.protobuf.StringValue */ string | null;
        coverImageUrl?: /* google.protobuf.StringValue */ string | null;
        cardImageUrl?: /* google.protobuf.StringValue */ string | null;
        thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        license: Kaggle.Sdk.Datasets.LicenseDto | null;
        voteCount: number;
        creatorUserId: number;
        creatorDisplayName?: /* google.protobuf.StringValue */ string | null;
        ownerTwitter?: /* google.protobuf.StringValue */ string | null;
        lastUpdated: /* google.protobuf.Timestamp */ string | null;
        downloadUrl?: /* google.protobuf.StringValue */ string | null;
        newNotebookUrl?: /* google.protobuf.StringValue */ string | null;
        newScriptUrl?: /* google.protobuf.StringValue */ string | null;
        hasAlreadyVotedUp: boolean;
        isOldDatasetVersion: boolean;
        numberOfViews: number;
        numberOfDownloads: number;
        numberOfScripts: number;
        numberOfTopics: number;
        numberOfTasks: number;
        canEdit: boolean;
        canPerformOwnerTasks: boolean;
        canEditSlug: boolean;
        canEditPublishStatus: boolean;
        canEditFeatureStatus: boolean;
        canEditDescription: boolean;
        hideVersionStatuses: boolean;
        cardImageLeft?: /* google.protobuf.Int32Value */ number | null;
        cardImageTop?: /* google.protobuf.Int32Value */ number | null;
        cardImageWidth?: /* google.protobuf.Int32Value */ number | null;
        cardImageHeight?: /* google.protobuf.Int32Value */ number | null;
        coverImageLeft?: /* google.protobuf.Int32Value */ number | null;
        coverImageTop?: /* google.protobuf.Int32Value */ number | null;
        coverImageWidth?: /* google.protobuf.Int32Value */ number | null;
        coverImageHeight?: /* google.protobuf.Int32Value */ number | null;
        datasetVersions: Kaggle.Sdk.Datasets.DatasetVersionDto[];
        datasetVersionTotalCount: number;
        feed: Kaggle.Sdk.Datasets.DatasetActivityDto[];
        topicId?: /* google.protobuf.Int32Value */ number | null;
        isNewTopic: boolean;
        canSeeDeletionButton: boolean;
        checklistDismissed: boolean;
        type: Kaggle.Sdk.Datasets.DatabundleVersionType;
        diffType: Kaggle.Sdk.Datasets.DatabundleDiffType;
        checklistCollapsed: boolean;
        isInFlight: boolean;
        maintainerOrganization: Kaggle.Sdk.Datasets.OwnerDto | null;
        createdByKernel: Kaggle.Sdk.Datasets.KernelOutputKernelReference | null;
        usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
        bookmarked: boolean;
        discussion: Kaggle.Sdk.Discussions.TopicListDto | null;
        currentTab: Kaggle.Sdk.Datasets.DatasetTab;
        newTopic: Kaggle.Sdk.Discussions.NewTopicDto | null;
        categories: Kaggle.Sdk.Tags.TagList | null;
        upvoteSuggestion: Kaggle.Sdk.Datasets.UpvoteSuggestionDto | null;
        readerGroupId?: /* google.protobuf.Int32Value */ number | null;
        writerGroupId?: /* google.protobuf.Int32Value */ number | null;
        collaborators: Kaggle.Sdk.Users.CollaboratorList | null;
        isCollaborator: boolean;
        deletionNeedsReview: boolean;
        hasDatasetDoiApproved: boolean;
        canSeeConfigAsCode?: /* google.protobuf.BoolValue */ boolean | null;
        // controls if the current user can create tasks
        canCreateDatasetTasks: boolean;
        // general settings for if the dataset should check for editor permission when creating task
        blockTaskCreation: boolean;
        canSeeDatasetHashLink: boolean;
        medalUrl?: /* google.protobuf.StringValue */ string | null;
        datasetHashLink?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetFileSummary {
        fileType: Kaggle.Sdk.Datasets.Models.DatasetFileType.Enum;
        count: number;
        totalSize: number;
      }
      // Describes a dataset that needs to be reviewed, with minimal information about
      // the dataset
      export interface DatasetForReview {
        // The id of the dataset that needs to be reviewed
        datasetId: number;
        // The name of the dataset
        name?: /* google.protobuf.StringValue */ string | null;
        // The url that links to it
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetHistory {
        items: Kaggle.Sdk.Datasets.DatasetHistoryItem[];
        totalItems: number;
      }

      export interface DatasetHistoryItem {
        type: Kaggle.Sdk.Datasets.DatasetsActivityTypeEnum;
        user: Kaggle.Sdk.Datasets.OwnerDto | null;
        changes: Kaggle.Sdk.Datasets.DatasetSchemaDiff[];
        date: /* google.protobuf.Timestamp */ string | null;
        summary: Kaggle.Sdk.Datasets.DatasetSchemaDiffSummary | null;
        versionInfo: Kaggle.Sdk.Datasets.DatasetHistoryVersionInfo | null;
      }

      export interface DatasetHistoryVersionInfo {
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        versionNotes?: /* google.protobuf.StringValue */ string | null;
        versionUrl?: /* google.protobuf.StringValue */ string | null;
        userMessage?: /* google.protobuf.StringValue */ string | null;
        databundleVersionId: number;
        status: Kaggle.Sdk.Datasets.DatabundleVersionStatus;
      }

      export interface DatasetImageInfo {
        cardImageUrl: string;
        cardImageLeft: number;
        cardImageTop: number;
        cardImageHeight: number;
        cardImageWidth: number;
        coverImageLeft: number;
        coverImageHeight: number;
        coverImageTop: number;
        coverImageWidth: number;
        coverImageUrl: string;
        originalImageUrl: string;
        thumbnailImageUrl: string;
      }

      export interface DatasetLimits {
        publicLimits: Kaggle.Sdk.Datasets.DatasetPublicLimits | null;
        privateLimits: Kaggle.Sdk.Datasets.DatasetPrivateLimits | null;
        maxFiles: number;
      }

      export interface DatasetList {
        totalResults?: /* google.protobuf.Int32Value */ number | null;
        items: Kaggle.Sdk.Datasets.DatasetListItem[];
      }

      export interface DatasetListItem {
        datasetUrl: string;
        ownerAvatarUrl: string;
        ownerName: string;
        ownerUrl: string;
        ownerUserId?: /* google.protobuf.Int32Value */ number | null;
        ownerTier: Kaggle.Sdk.Users.UserAchievementTier;
        creatorName: string;
        creatorUrl: string;
        creatorUserId: number;
        scriptCount: number;
        taskCount: number;
        scriptsUrl: string;
        topicCount: number;
        forumUrl: string;
        viewCount: number;
        downloadCount: number;
        fileCount: number;
        /*[NotNull]*/
        dateCreated: /* google.protobuf.Timestamp */ string;
        /*[NotNull]*/
        dateUpdated: /* google.protobuf.Timestamp */ string;
        isHidden: boolean;
        isFailed: boolean;
        bookmarked: boolean;
        isCollaborator: boolean;
        /*[NotNull]*/
        voteButton: Kaggle.Sdk.Common.VoteButton;
        /*[NotNull]*/
        categories: Kaggle.Sdk.Tags.Tag[];
        licenseName: string;
        licenseShortName: string;
        datasetSize?: /* google.protobuf.Int64Value */ number | null;
        /*[NotNull]*/
        commonFileTypes: Kaggle.Sdk.Datasets.DatasetFileSummary[];
        maintainerOrganization: Kaggle.Sdk.Datasets.OwnerDto | null;
        downloadUrl: string;
        newKernelNotebookUrl: string;
        newKernelScriptUrl: string;
        description: string;
        usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
        firestorePath?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        rank: number;
        medalUrl?: /* google.protobuf.StringValue */ string | null;
        hasHashLink: boolean;
        /*[NotNull]*/
        datasource: Kaggle.Sdk.Datasets.DatasetDatasourceListItem;
      }
      // Dataset Metadata, denormalized data object that will serve the dataset metadata page.
      export interface DatasetMetadata {
        // Auto generated sources (ex. github url, BigQuery url, kernel outputted data) for the specified version of dataset.
        /*[NotNull]*/
        autoGeneratedSources: Kaggle.Sdk.Datasets.AutoGeneratedSource[];
        // Collaborator list, including owner, for the dataset.
        /*[NotNull]*/
        collaboratorList: Kaggle.Sdk.Users.CollaboratorList;
        // Collection methods for current version of dataset.
        collectionMethods?: /* google.protobuf.StringValue */ string | null;
        // Current version number for the dataset.
        currentVersionNumber?: /* google.protobuf.Int32Value */ number | null;
        // Versioning type, aka DatabundleDiffType, for the dataset.
        /*[NotNull]*/
        databundleDiffType: Kaggle.Sdk.Datasets.DatabundleDiffType;
        // Data coverage, including temporal and spatial for the specified version of dataset.
        /*[NotNull]*/
        dataCoverageAttribute: Kaggle.Sdk.Datasets.DataCoverageAttribute;
        // Creation timestamp for the dataset.
        /*[NotNull]*/
        datasetCreationTimestamp: /* google.protobuf.Timestamp */ string;
        // Dataset Id, for which the metadata is for.
        datasetId: number;
        // Authors for the current version of dataset.
        /*[NotNull]*/
        datasetVersionAuthors: Kaggle.Sdk.Datasets.DatasetVersionAuthor[];
        // Dataset version Id, for which the metadata is for.
        datasetVersionId: number;
        // Data object identity for specified version of dataset.
        doi?: /* google.protobuf.StringValue */ string | null;
        // Expected update frequency for the dataset.
        /*[NotNull]*/
        expectedUpdateFrequency: Kaggle.Sdk.Datasets.ExpectedUpdateFrequency;
        // Dataset has hash link or not.
        hasHashLink: boolean;
        // Boolean to indicate if the dataset has been approved for doi generation.
        isDatasetDoiApproved: boolean;
        // True if the DatasetVersionId provided is the same as the CurrentDatasetVersionId.
        isEditable: boolean;
        // Dataset is private or not.
        isPrivate: boolean;
        // Last data updated timestamp for the dataset (ie. the current version creation timestamp).
        lastDataUpdatedTimestamp: /* google.protobuf.Timestamp */ string | null;
        // License groups, containing all current license options for display purposes.
        licenseGroups: Kaggle.Sdk.Datasets.LicenseGroupDto[];
        // License Id for specified version of dataset.
        licenseId: number;
        // User specified sources for the specified version of dataset.
        userSpecifiedSources?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetPrivateLimits {
        totalBytes: number;
        usedBytes: number;
        totalBytesAllVersions: number;
        usedBytesAllVersions: number;
      }

      export interface DatasetPublicLimits {
        maxBytes: number;
        isOrganizationLimit: boolean;
        isAdminLimit: boolean;
      }

      export interface DatasetSchemaDiff {
        action: Kaggle.Sdk.Datasets.DatasetSchemaDiffAction;
        level: Kaggle.Sdk.Datasets.DatasetSchemaDiffContainerLevel;
        parentLevel: Kaggle.Sdk.Datasets.DatasetSchemaDiffContainerLevel;
        oldValue?: /* google.protobuf.StringValue */ string | null;
        newValue?: /* google.protobuf.StringValue */ string | null;
        path?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetSchemaDiffSummary {
        addedCount: number;
        modifiedCount: number;
        deletedCount: number;
        totalChangedEntities: number;
        changedEntities: Kaggle.Sdk.Datasets.DatasetSchemaEntity[];
      }

      export interface DatasetSchemaEntity {
        name?: /* google.protobuf.StringValue */ string | null;
        level: Kaggle.Sdk.Datasets.DatasetSchemaDiffContainerLevel;
      }

      export interface DatasetSettings {
        title?: /* google.protobuf.StringValue */ string | null;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        description?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
        keywords: string[];
        licenses: Kaggle.Sdk.Datasets.SettingsLicense[];
        collaborators: Kaggle.Sdk.Datasets.UserRole[];
        data: Kaggle.Sdk.Datasets.DatasetSettingsFile[];
      }

      export interface DatasetSettingsFile {
        name: string;
        description?: /* google.protobuf.StringValue */ string | null;
        totalBytes: number;
        columns: Kaggle.Sdk.Datasets.DatasetSettingsFileColumn[];
      }

      export interface DatasetSettingsFileColumn {
        name: string;
        description?: /* google.protobuf.StringValue */ string | null;
        type?: /* google.protobuf.StringValue */ string | null;
      }
      // IMPORTANT: This is serialized as Json and stored in the Settings column of
      // the DatabundleVersions column so be very careful while making any changes.
      export interface DataSettingsDto {
        bigQuerySettings: Kaggle.Sdk.Datasets.BigQuerySettingsDto | null;
        storageSettings: Kaggle.Sdk.Datasets.DatabundleVersionStorageSettings | null;
        remoteUrlSettings: Kaggle.Sdk.Datasets.RemoteUrlSettings | null;
        remoteGithubSettings: Kaggle.Sdk.Datasets.RemoteGithubSettings | null;
      }

      export interface DatasetTopicContent {
        topicType: Kaggle.Sdk.Datasets.DatasetTopicEnum;
        datasets: Kaggle.Sdk.Datasets.DatasetListItem[];
        tasks: Kaggle.Sdk.Datasets.TaskListItem[];
      }

      export interface DatasetUploaderConfig {
        existingData: Kaggle.Sdk.Datasets.ExistingDataInfo;
        allowedOwners: Kaggle.Sdk.Datasets.OwnerDto[];
        licenseGroups: Kaggle.Sdk.Datasets.LicenseGroupDto[];
        limits: Kaggle.Sdk.Datasets.DatasetLimits;
      }
      // Frontend model of usability rating scores for dataset usability rating
      export interface DatasetUsabilityRating {
        // Final score of the usability rating, out of 1
        score: number;
        // Individual sub-scores for each category, out of 1
        columnDescriptionScore?: /* google.protobuf.FloatValue */ number | null;
        coverImageScore: number;
        fileDescriptionScore: number;
        fileFormatScore: number;
        licenseScore: number;
        overviewScore: number;
        provenanceScore: number;
        publicKernelScore: number;
        subtitleScore: number;
        tagScore: number;
        updateFrequencyScore: number;
      }
      // the creation of this version of dataset.
      export interface DatasetVersionAuthor {
        // The backend Id of DatasetVersionAuthor table.
        // This is served to frontend, so an update of the exact record can be made.
        datasetVersionAuthorId?: /* google.protobuf.Int32Value */ number | null;
        // Author Name.
        authorName?: /* google.protobuf.StringValue */ string | null;
        // Author Biography.
        authorBio?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DatasetVersionDto {
        id: number;
        slug: string;
        name: string;
        /*[NotNull]*/
        creationDate: /* google.protobuf.Timestamp */ string;
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        versionNotes: string;
        thumbnailImageUrl: string;
        datasetVersionUrl: string;
        status: Kaggle.Sdk.Datasets.DatabundleVersionStatus;
        userMessage?: /* google.protobuf.StringValue */ string | null;
        isRemoved: boolean;
        /*[NotNull]*/
        creator: Kaggle.Sdk.Datasets.OwnerDto;
        userSpecifiedSources?: /* google.protobuf.StringValue */ string | null;
        doi?: /* google.protobuf.StringValue */ string | null;
        /*[NotNull]*/
        databundleVersionId: number;
      }

      export interface DatasetVersionReference {
        datasetId: number;
        datasetVersionId: number;
        slug?: /* google.protobuf.StringValue */ string | null;
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DeleteDatasetBySlugRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DeleteDatasetCategoriesRequest {
        datasetId: number;
        categoryIds: number[];
      }

      export interface DeleteDatasetCategoriesResponse {
        updatedUsabilityRating?: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
      }

      export interface DeleteDatasetHashLinkRequest {
        datasetId: number;
      }
      // Request to delete a dataset task.
      export interface DeleteTaskRequest {
        taskId: number;
      }

      export interface DeleteTaskSubmissionRequest {
        taskSubmissionId: number;
      }

      export interface DetectDuplicateRequest {
        blobFileToken: string;
        currentDatasetId?: /* google.protobuf.Int32Value */ number | null;
        currentCompetitionId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface DuplicationReference {
        type: Kaggle.Sdk.Datasets.DuplicationReferenceType;
        name?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        id: number;
      }
      // Set a new description for a dataset.
      export interface EditDatasetDescriptionRequest {
        datasetId: number;
        description?: /* google.protobuf.StringValue */ string | null;
      }

      export interface EditDatasetDescriptionResponse {
        usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
      }
      // Request to edit a dataset task.
      export interface EditTaskRequest {
        taskId: number;
        title: string;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        description: string;
        deadline: /* google.protobuf.Timestamp */ string | null;
      }

      export interface ExistingDataInfo {
        existingUploadDirectories: Kaggle.Sdk.Datasets.ExistingDirectoryInfo[];
        existingUploadFiles: Kaggle.Sdk.Datasets.ExistingFileInfo[];
        existingRemoteUrls: Kaggle.Sdk.Datasets.Databundles.RemoteUrlInfo[];
      }

      export interface ExistingDirectoryInfo {
        name: string;
        directories: Kaggle.Sdk.Datasets.ExistingDirectoryInfo[];
        files: Kaggle.Sdk.Datasets.ExistingFileInfo[];
      }

      export interface ExistingFileInfo {
        name: string;
        size: number;
        // For v2 datasets, GcsPath is mandatory
        gcsPath?: /* google.protobuf.StringValue */ string | null;
        // For v1 datasets, LegacyInfo is mandatory
        legacyInfo: Kaggle.Sdk.Datasets.LegacyExistingFileInfo | null;
      }
      // Expected update frequency for the dataset.
      export interface ExpectedUpdateFrequency {
        // Dataset sources where Kaggle offers the option for automatic scheduled updates.
        // Currently, it's either Remote URL or Remote Github sourced datasets.
        isAutoUpdatedTypedDataset: boolean;
        // Update frequency that:
        // 1. Kaggle will use for scheduled refreshing from the sources when IsAutoUpdatedTypedDataset is true.
        // 2. User specified, but Kaggle will not perform any scheduled refreshing when IsAutoUpdatedTypedDataset is false.
        updateFrequency: string;
      }

      export interface GcsFileSetInfo {
        gcsUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetCompetitionUploaderConfigRequest {
        competitionId: number;
      }

      export interface GetDatabundleVersionCreationStatusRequest {
        databundleVersionId: number;
      }

      export interface GetDatasetActivityFeedRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        hashLink?: /* google.protobuf.StringValue */ string | null;
        page: number;
      }

      export interface GetDatasetActivityFeedResponse {
        activities: Kaggle.Sdk.Datasets.DatasetActivityDto[];
      }

      export interface GetDatasetActivityRequest {
        datasetId: number;
      }

      export interface GetDatasetAdminSettingsRequest {
        datasetId: number;
      }

      export interface GetDatasetAdminSettingsResponse {
        info: Kaggle.Sdk.Datasets.DatasetAdminSettingsInfo | null;
      }

      export interface GetDatasetBasicsRequest {
        ownerSlug: string;
        datasetSlug: string;
      }

      export interface GetDatasetByUrlRequest {
        url: string;
      }

      export interface GetDatasetHistoryRequest {
        datasetId: number;
        count: number;
        // Hash link for the dataset, used to bypass canSee permission check
        hashLink?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetDatasetImageInfoRequest {
        datasetId: number;
        datasetVersionId: number;
      }

      export interface GetDatasetImageInfoResponse {
        info: Kaggle.Sdk.Datasets.DatasetImageInfo | null;
      }

      export interface GetDatasetLimitsRequest {
        userId: number;
        organizationId?: /* google.protobuf.Int32Value */ number | null;
        excludeDatasetVersionId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface GetDatasetMetadataRequest {
        datasetVersionId: number;
        hashLink?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetDatasetsByIdRequest {
        ids: number[];
        initialRank: number;
        // Expand determines whether Dataset description is included in results
        includeDescription?: /* google.protobuf.BoolValue */ boolean;
      }

      export interface GetDatasetSettingsRequest {
        datasetId: number;
      }

      export interface GetDatasetSuggestionsRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetDatasetSuggestionsResponse {
        suggestions: Kaggle.Sdk.Datasets.Suggestion[];
      }

      export interface GetDatasetTasksRequest {
        datasetId: number;
      }
      // Response for a GetDatasetTasksRequest, containing a list of tasks.
      export interface GetDatasetTasksResponse {
        tasks: Kaggle.Sdk.Datasets.TaskListItem[];
      }

      export interface GetDatasetUploaderConfigRequest {
        // Optional: Id of the current dataset version, used to populate existing files/directories and subtract the usage from limit.
        currentDatasetVersionId?: /* google.protobuf.Int32Value */ number | null;
        // Optional: If the dataset was created as an organization, also used for quota calculation.
        ownerOrganizationId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface GetDatasetUsabilityRatingRequest {
        datasetId: number;
      }

      export interface GetDatasetUsabilityRatingResponse {
        rating?: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
      }

      export interface GetDataViewExternalRequest {
        /*[NotNull]*/
        verificationInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleVerificationInfo;
        firestorePath: string;
        tableQuery: Kaggle.Sdk.Datasets.DataViewer.Protos.TableQuery | null;
      }

      export interface GetGithubRepositoryInfoRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        repositorySlug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetGithubRepositoryInfoResponse {
        repositoryContents: Kaggle.Sdk.Datasets.GithubRepositoryContent[];
      }

      export interface GetKernelOutputDatasetRequest {
        kernelId: number;
      }

      export interface GetKernelOutputDataViewExternalRequest {
        kernelSessionId: number;
        fileName?: /* google.protobuf.StringValue */ string | null;
        tableQuery: Kaggle.Sdk.Datasets.DataViewer.Protos.TableQuery | null;
      }

      export interface GetLandingPageTopicsRequest {}

      export interface GetLandingPageTopicsResponse {
        topics: Kaggle.Sdk.Datasets.DatasetTopicContent[];
      }

      export interface GetPossibleCompetitionDatasetsRequest {
        competitionId: number;
        search?: /* google.protobuf.StringValue */ string | null;
        offset: number;
        limit: number;
      }

      export interface GetPossibleTaskSubmissionsRequest {
        datasetTaskId: number;
        submissionType: Kaggle.Sdk.Datasets.TaskSubmissionType;
        search?: /* google.protobuf.StringValue */ string | null;
        offset: number;
        limit: number;
      }

      export interface GetPossibleTaskSubmissionsResponse {
        submissionType: Kaggle.Sdk.Datasets.TaskSubmissionType;
        totalCount: number;
        results: Kaggle.Sdk.Datasets.TaskSubmissionListItem[];
      }

      export interface GetProfileDatasetStatsRequest {
        // What user's data are we interested in?
        userId: number;
      }

      export interface GetProfileDatasetStatsResponse {
        // How many datasets has user_id created?
        datasetsCount: number;
        // How many upvotes on datasets has user_id received?
        upvotesCount: number;
        // How many Tasks has user_id created?
        tasksCount: number;
        // How many of user_id's submissions have been accepted?
        acceptedSubmissionsCount: number;
      }
      // Gets the user's recently viewed datasets.
      // If UserId is null, then return the current user's recently viewed datasets.
      export interface GetRecentlyViewedDatasetsRequest {
        userId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface GetRemoteUrlFileInfoRequest {
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetSidebarTasksRequest {}
      // Response for a GetSidebarTasksRequest, containing two lists of tasks.
      // - The tasks the user has created or has made a submission
      // - New / open tasks
      export interface GetSidebarTasksResponse {
        yourTasks: Kaggle.Sdk.Datasets.TaskListItem[];
        openTasks: Kaggle.Sdk.Datasets.TaskListItem[];
      }

      export interface GetTaskRequest {
        taskId: number;
      }

      export interface GetTaskSubmissionsRequest {
        taskId: number;
        offset: number;
        limit: number;
      }

      export interface GetTaskSubmissionsResponse {
        totalCount: number;
        taskSubmissions: Kaggle.Sdk.Datasets.TaskSubmissionListItem[];
      }

      export interface GetTopicalDatasetsRequest {
        /*[NotNull]*/
        topicType: Kaggle.Sdk.Datasets.DatasetTopicEnum;
        sortBy: Kaggle.Sdk.Datasets.Models.DatasetSortBy.Enum;
        offset?: /* google.protobuf.Int32Value */ number | null;
        count?: /* google.protobuf.Int32Value */ number | null;
        // InitialResponseUpdateTime is required for accurate pagination for subsequent pages. This is because the
        // underlying list of contents are changing dynamically (daily), so knowing when the initial responses' update
        // time were allowed paging for subsequent pages on the same initial response date. Without it, re-populating /
        // re-ranking of the underlying contents may result in pagination that returns duplicated results as previous
        // pages.
        initialResponseUpdateTime: /* google.protobuf.Timestamp */ string | null;
      }

      export interface GetTopicalDatasetsResponse {
        datasets: Kaggle.Sdk.Datasets.DatasetListItem[];
        hasMore: boolean;
        initialResponseUpdateTime: /* google.protobuf.Timestamp */ string | null;
      }

      export interface GetTopicalTasksRequest {
        topicType: Kaggle.Sdk.Datasets.DatasetTopicEnum;
        offset?: /* google.protobuf.Int32Value */ number | null;
        count?: /* google.protobuf.Int32Value */ number | null;
        // InitialResponseUpdateTime is required for accurate pagination for subsequent pages. This is because the
        // underlying list of contents are changing dynamically (daily), so knowing when the initial responses' update
        // time were allowed paging for subsequent pages on the same initial response date. Without it, re-populating /
        // re-ranking of the underlying contents may result in pagination that returns duplicated results as previous
        // pages.
        initialResponseUpdateTime: /* google.protobuf.Timestamp */ string | null;
      }

      export interface GetTopicalTasksResponse {
        tasks: Kaggle.Sdk.Datasets.TaskListItem[];
        hasMore: boolean;
        initialResponseUpdateTime: /* google.protobuf.Timestamp */ string | null;
      }

      export interface GetUserDoiDatasetsRequest {
        userId: number;
      }

      export interface GetUserDoiDatasetsResponse {
        datasetIds: number[];
      }

      export interface GetUserSubmissionsRequest {
        userId: number;
        acceptedOnly: boolean;
        offset: number;
        limit: number;
      }

      export interface GetUserSubmissionsResponse {
        totalCount: number;
        taskSubmissions: Kaggle.Sdk.Datasets.TaskSubmissionListItem[];
      }

      export interface GithubRepositoryContent {
        type: Kaggle.Sdk.Datasets.GithubRepositoryContentType;
        name: string;
        repositoryPath: string;
        size: number;
        children: Kaggle.Sdk.Datasets.GithubRepositoryContent[];
      }

      export interface KernelOutputDatasetReference {
        datasetId: number;
        currentDatasetVersionId: number;
        title: string;
        isPrivate: boolean;
        slug: string;
        /*[NotNull]*/
        license: Kaggle.Sdk.Datasets.LicenseDto;
      }

      export interface KernelOutputKernelReference {
        kernelId: number;
        isPrivate: boolean;
        url?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        owner: Kaggle.Sdk.Datasets.OwnerDto | null;
        outputFiles: Kaggle.Sdk.Kernels.KernelSessionOutputFile[];
        dateOutputToDatasetEnabled: /* google.protobuf.Timestamp */ string | null;
      }
      // If a notebook is used as a (accepted) submission for a task, this object contains the info the frontend
      // needs to display a corresponding info.
      export interface KernelTaskSubmissionInfo {
        taskUrl?: /* google.protobuf.StringValue */ string | null;
        taskTitle?: /* google.protobuf.StringValue */ string | null;
        datasetUrl?: /* google.protobuf.StringValue */ string | null;
        datasetTitle?: /* google.protobuf.StringValue */ string | null;
        isAcceptedSolution: boolean;
      }

      export interface LegacyDatabundleInfo {
        firestorePath?: /* google.protobuf.StringValue */ string | null;
        databundleVersionId: number;
        databundle: Kaggle.Sdk.Datasets.Databundles.Databundle | null;
        databundleVersion: Kaggle.Sdk.Datasets.Databundles.DatabundleVersion | null;
      }

      export interface LegacyExistingFileInfo {
        databundleVersionObjectId: number;
        blobFileId: number;
      }

      export interface License {
        id: number;
        name: string;
        url: string;
      }

      export interface LicenseDto {
        id: number;
        name: string;
        description: string;
        url?: /* google.protobuf.StringValue */ string | null;
        displaySequence?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface LicenseGroupDto {
        id: number;
        name?: /* google.protobuf.StringValue */ string;
        licenses: Kaggle.Sdk.Datasets.LicenseDto[];
        displaySequence?: /* google.protobuf.Int32Value */ number;
      }

      export interface Owner {
        id: number;
        imageUrl: string;
        organization: boolean;
        maxFileSizeBytes: number;
        name: string;
        organizationMemberCount: number;
        profileUrl: string;
        slug: string;
        userTier: Kaggle.Sdk.Users.UserAchievementTier;
      }

      export interface OwnerDto {
        id: number;
        imageUrl?: /* google.protobuf.StringValue */ string | null;
        isOrganization: boolean;
        name: string;
        profileUrl?: /* google.protobuf.StringValue */ string | null;
        slug: string;
        maxFileSizeBytes?: /* google.protobuf.Int64Value */ number | null;
        userTier: Kaggle.Sdk.Users.UserAchievementTier;
        organizationMemberCount?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface RecreateDatasetArchiveRequest {
        // The dataset that needs to have the zip file recreated
        datasetId: number;
        // Force recreate the zip file even if archive file already exists or if another zipper process is on going
        force: boolean;
      }

      export interface RecreateDatasetArchiveResponse {
        // The databundle version that is getting zip file recreated
        databundleVersionId: number;
        // Status of the request
        message: string;
      }

      export interface RefreshRemoteDatasetRequest {
        /*[NotNull]*/
        datasetId: number;
        /*[NotNull]*/
        settings: Kaggle.Sdk.Datasets.DataCreationSettings;
      }

      export interface RemoteGithubSettings {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        repositorySlug?: /* google.protobuf.StringValue */ string | null;
        // This should be defined in proto but currently there is no way to defined a nullable enum in proto.
        // The zero value of the enum is not UNSPECIFIED so it is risky to change it to a non-nullable enum
        // because that may cause all remote datasets to be created with a Daily update frequency.
        // TODO(b/200150198): Either make UNSPECIFIED value 0 or make sure frontend (and kaggle-api if applicable)
        // sends UNSPECIFIED instead of not specifying it or sending null/None.
        updateFrequency: Kaggle.Sdk.Datasets.RemoteUrlUpdateFrequency;
      }

      export interface RemoteUrlSettings {
        url?: /* google.protobuf.StringValue */ string | null;
        // This should be defined in proto but currently there is no way to defined a nullable enum in proto.
        // The zero value of the enum is not UNSPECIFIED so it is risky to change it to a non-nullable enum
        // because that may cause all remote datasets to be created with a Daily update frequency.
        // TODO(b/200150198): Either make UNSPECIFIED value 0 or make sure frontend (and kaggle-api if applicable)
        // sends UNSPECIFIED instead of not specifying it or sending null/None.
        updateFrequency: Kaggle.Sdk.Datasets.RemoteUrlUpdateFrequency;
      }

      export interface RemoteUrlUploadFile {
        name?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        warning?: /* google.protobuf.StringValue */ string | null;
        contentLength: number;
        contentType?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SearchDatasetsRequest {
        /*[NotNull]*/
        group: Kaggle.Sdk.Datasets.Models.DatasetSelectionGroup.Enum;
        /*[NotNull]*/
        size: Kaggle.Sdk.Datasets.Models.DatasetSizeGroup.Enum;
        /*[NotNull]*/
        fileType: Kaggle.Sdk.Datasets.Models.DatasetFileTypeGroup.Enum;
        /*[NotNull]*/
        license: Kaggle.Sdk.Datasets.Models.DatasetLicenseGroup.Enum;
        /*[NotNull]*/
        viewed: Kaggle.Sdk.Datasets.Models.DatasetViewedGroup.Enum;
        /*[NotNull]*/
        sortBy: Kaggle.Sdk.Datasets.Models.DatasetSortBy.Enum;
        /*[NotNull]*/
        categoryIds: number[];
        search: string;
        userId?: /* google.protobuf.Int32Value */ number | null;
        organizationId?: /* google.protobuf.Int32Value */ number | null;
        maintainerOrganizationId?: /* google.protobuf.Int32Value */ number | null;
        minSize?: /* google.protobuf.Int64Value */ number | null;
        maxSize?: /* google.protobuf.Int64Value */ number | null;
        page: number;
        hasTasks: boolean;
        competitionId?: /* google.protobuf.Int32Value */ number | null;
        // V1 topical dataset feature info to determine what datasets to prepend in first response and filter out
        // in subsequent responses.
        topicalDataset: Kaggle.Sdk.Datasets.TopicalDataset | null;
        includeTopicalDatasets: boolean;
      }

      export interface SearchDatasetsResponse {
        // Dataset list
        datasetList: Kaggle.Sdk.Datasets.DatasetList | null;
        // Indicate if there is more datasets that can be loaded
        hasMore: boolean;
        // V1 topical dataset feature info to determine what datasets to prepend in first response and filter out
        // in subsequent responses.
        topicalDataset: Kaggle.Sdk.Datasets.TopicalDataset | null;
      }

      export interface SearchTasksRequest {
        query?: /* google.protobuf.StringValue */ string | null;
        includeClosed: boolean;
        includeWithAcceptedSubmission: boolean;
        includeOwnTasks: boolean;
        maxResults: number;
        offset: number;
      }
      // Response for a SearchTasksRequest, a list of tasks found
      export interface SearchTasksResponse {
        tasks: Kaggle.Sdk.Datasets.TaskListItem[];
        totalResults: number;
      }

      export interface SetDatabundleVersionNotesRequest {
        databundleVersionId: number;
        versionNotes?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SetDatasetChecklistVisibilityRequest {
        datasetId: number;
        visibility: Kaggle.Sdk.Datasets.ChecklistVisibility;
      }

      export interface SetDatasetCollaboratorListRequest {
        datasetId: number;
        /*[NotNull]*/
        collaboratorList: Kaggle.Sdk.Users.CollaboratorList;
      }

      export interface SetDatasetSettingsRequest {
        datasetId: number;
        settings: Kaggle.Sdk.Datasets.DatasetSettings | null;
      }

      export interface SettingsLicense {
        name?: /* google.protobuf.StringValue */ string | null;
      }
      // This class is only used by pre-KM upvote button.
      export interface SimpleUserDto {
        avatarThumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        displayName?: /* google.protobuf.StringValue */ string | null;
        profileUrl?: /* google.protobuf.StringValue */ string | null;
        tier: Kaggle.Sdk.Users.UserAchievementTier;
        tierInt: number;
        userId: number;
        userName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SoftDeleteDatasetsForOrgRequest {
        organizationId: number;
      }

      export interface SoftDeleteDatasetsForUserRequest {
        userId: number;
      }

      export interface StorageLocation {
        bucket?: /* google.protobuf.StringValue */ string | null;
        path?: /* google.protobuf.StringValue */ string | null;
      }

      export interface Suggestion {
        entityType: Kaggle.Sdk.Datasets.SuggestionType;
        entityId: number;
        title?: /* google.protobuf.StringValue */ string | null;
        entityUrl?: /* google.protobuf.StringValue */ string | null;
        thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        owner: Kaggle.Sdk.Datasets.OwnerDto | null;
      }
      // Information about the author of a task.
      export interface TaskAuthor {
        id: number;
        displayName: string;
        slug: string;
        thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        tier: Kaggle.Sdk.Users.UserAchievementTier;
        isOrganization: boolean;
      }
      // Info about the dataset a task belongs to.
      export interface TaskDatasetInfo {
        datasetId: number;
        datasetTitle?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        datasetThumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
        usabilityRating: number;
        datasetOwnerName?: /* google.protobuf.StringValue */ string | null;
        datasetOwnerSlug?: /* google.protobuf.StringValue */ string | null;
      }
      // A task item in the task list.
      export interface TaskListItem {
        id: number;
        title: string;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        submissionCount: number;
        hasAcceptedSubmission: boolean;
        /*[NotNull]*/
        author: Kaggle.Sdk.Datasets.TaskAuthor;
        /*[NotNull]*/
        voteButton: Kaggle.Sdk.Datasets.TaskVoteButton;
        /*[NotNull]*/
        datasetInfo: Kaggle.Sdk.Datasets.TaskDatasetInfo;
        /*[NotNull]*/
        tags: Kaggle.Sdk.Tags.TagList;
        creationDate: /* google.protobuf.Timestamp */ string | null;
        deadline: /* google.protobuf.Timestamp */ string | null;
        forumId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface TaskModel {
        description: string;
        removedTags: Kaggle.Sdk.Tags.TagList | null;
        /*[NotNull]*/
        item: Kaggle.Sdk.Datasets.TaskListItem;
      }

      export interface TaskSubmissionDatasetInfo {
        datasetId: number;
        fileCount: number;
      }

      export interface TaskSubmissionListItem {
        id: number;
        /*[NotNull]*/
        type: Kaggle.Sdk.Datasets.TaskSubmissionType;
        url: string;
        title: string;
        /*[NotNull]*/
        author: Kaggle.Sdk.Datasets.TaskAuthor;
        submittedDate: /* google.protobuf.Timestamp */ string | null;
        lastUpdated: /* google.protobuf.Timestamp */ string | null;
        acceptedDate: /* google.protobuf.Timestamp */ string | null;
        voteButton: Kaggle.Sdk.Common.VoteButton | null;
        /*[NotNull]*/
        commentCount: number;
        // Depending on TaskSubmissionType, either of the following has to be set.
        notebookInfo: Kaggle.Sdk.Datasets.TaskSubmissionNotebookInfo | null;
        datasetInfo: Kaggle.Sdk.Datasets.TaskSubmissionDatasetInfo | null;
      }

      export interface TaskSubmissionNotebookInfo {
        kernelId: number;
        language?: /* google.protobuf.StringValue */ string;
      }
      // Details for the upvote button in tasks. We're not using the common VoteButton model here, since it's
      // too complex and contains unnecessary properties.
      export interface TaskVoteButton {
        totalVotes: number;
        hasVotedUp: boolean;
        isDisabled: boolean;
      }
      // Request to vote on a dataset task. Based on IsUpvote, it can be an actual upvote or removing it.
      export interface TaskVoteRequest {
        taskId: number;
        isUpvote: boolean;
      }

      export interface TopicalDataset {
        isPopular: boolean;
        isTrending: boolean;
        categoryId?: /* google.protobuf.Int32Value */ number | null;
        topicUpdateTime: /* google.protobuf.Timestamp */ string | null;
      }
      // Removes the accepted submission (all if there are multiple) for a task.
      export interface UnacceptTaskSubmissionsRequest {
        taskId: number;
      }

      export interface UndeleteDatasetsForUserRequest {
        userId: number;
      }

      export interface UpdateDatasetCollaboratorsRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        collaborators: Kaggle.Sdk.Users.CollaboratorList | null;
      }

      export interface UpdateDatasetGeneralRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        overview?: /* google.protobuf.StringValue */ string | null;
        licenseId: number;
        owner: Kaggle.Sdk.Datasets.OwnerDto | null;
        diffType: Kaggle.Sdk.Datasets.DatabundleDiffType;
        updateFrequency: Kaggle.Sdk.Datasets.RemoteUrlUpdateFrequency;
        blockTaskCreation: boolean;
      }

      export interface UpdateDatasetGeneralSettingsResponse {
        // Updated dataset url, upon change of owner.
        datasetUrl?: /* google.protobuf.StringValue */ string | null;
        // Updated usability rating if not null.
        usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
      }

      export interface UpdateDatasetImagesRequest {
        // Currently requiring slugs and id for historical reasons (and to do authz check).
        // Can be refactored later to just use the id.
        ownerSlug: string;
        datasetSlug: string;
        datasetId: number;
        image: Kaggle.Sdk.Common.CroppedImageUpload | null;
        originalImageUrl: string;
        cardImageUrl: string;
        coverImageUrl: string;
        thumbnailImageUrl: string;
      }

      export interface UpdateDatasetImagesResponse {
        cardImageUrl: string;
        coverImageUrl: string;
        thumbnailImageUrl: string;
        originalImageUrl: string;
        usabilityRating: Kaggle.Sdk.Datasets.DatasetUsabilityRating | null;
      }
      // Request to update the fields listed in this request as specified.
      // If the field is not specified, it is assumed that a deletion of the existing record is made.
      // If the field is specified, then will update existing record as such, otherwise, a new record will be created.
      // Returns an updated dataset usability rating if successful, otherwise throws exceptions.
      export interface UpdateDatasetMetadataRequest {
        // DatasetVersion Id.
        datasetVersionId: number;
        // Data coverage, including temporal and spatial.
        dataCoverageAttribute?: Kaggle.Sdk.Datasets.DataCoverageAttribute | null;
        // Collection methods for current version of dataset.
        collectionMethods?: /* google.protobuf.StringValue */ string | null;
        // Dataset version authors, people (including non-Kaggle users) who helped with
        // the creation of this version of dataset.
        datasetVersionAuthors: Kaggle.Sdk.Datasets.DatasetVersionAuthor[];
        // Data object identity for current version of dataset.
        doi?: /* google.protobuf.StringValue */ string | null;
        // License Id for current version of dataset.
        licenseId: number;
        // User specified sources for current version of dataset.
        userSpecifiedSources?: /* google.protobuf.StringValue */ string | null;
        // Expected update frequency of dataset.
        expectedUpdateFrequency?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdateDatasetPrivacyRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
      }

      export interface UpdateDatasetRequest {
        ownerSlug?: /* google.protobuf.StringValue */ string | null;
        datasetSlug?: /* google.protobuf.StringValue */ string | null;
        slug?: /* google.protobuf.StringValue */ string | null;
        isRemoved: boolean;
        isFeatured: boolean;
        isSuperFeatured: boolean;
        scheduledToBeFeatured: /* google.protobuf.Timestamp */ string | null;
        scheduledToBeUnFeatured: /* google.protobuf.Timestamp */ string | null;
        scheduledToBeSuperFeatured: /* google.protobuf.Timestamp */ string | null;
        scheduledToBeUnSuperFeatured: /* google.protobuf.Timestamp */ string | null;
        maintainerOrganization: Kaggle.Sdk.Datasets.OwnerDto | null;
      }

      export interface UpdateDatasetResponse {
        datasetUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UploadDirectoryInfo {
        name?: /* google.protobuf.StringValue */ string | null;
        directories: Kaggle.Sdk.Datasets.UploadDirectoryInfo[];
        files: Kaggle.Sdk.Datasets.UploadFileInfo[];
      }

      export interface UploadFileInfo {
        name?: /* google.protobuf.StringValue */ string | null;
        token?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UploadKernelOutputInfo {
        // Info about the kernel where the output files should be pulled from
        kernelVersionId: number;
        kernelId: number;
      }

      export interface UpvoteSuggestionDto {
        voteCount: number;
        medalVoteCount: number;
        upVoters: Kaggle.Sdk.Datasets.SimpleUserDto[];
      }

      export interface UserRole {
        username: string;
        role: Kaggle.Sdk.Users.CollaboratorType;
      }

      export interface VoteOnDatasetRequest {
        datasetId: number;
        voteType: Kaggle.Sdk.Common.VoteType;
      }

      export enum ActivityPageStatus {
        NOT_RELEVANT = "notRelevant", // = 0;
        NO_SUMMARY_GENERATED = "noSummaryGenerated", // = 1;
        HAS_SUMMARY = "hasSummary", // = 2;
      }

      export enum ChecklistVisibility {
        UNSPECIFIED = "unspecified", // = 0;
        EXPANDED = "expanded", // = 1;
        COLLAPSED = "collapsed", // = 2;
        DISMISSED = "dismissed", // = 3;
      }

      export enum CreationStatus {
        OK = "ok", // = 0;
        ERROR = "error", // = 1;
      }

      export enum DatabundleDiffType {
        REALTIME = "realtime", // = 0;
        UNVERSIONED = "unversioned", // = 1;
        VERSIONED = "versioned", // = 2;
      }

      export enum DatabundleStatus {
        CREATED = "created", // = 0;
        PROCESSING = "processing", // = 1;
        ERROR = "error", // = 2;
        READY = "ready", // = 3;
      }

      export enum DatabundleType {
        UNSPECIFIED = "unspecified", // = 0;
        GENERAL = "general", // = 1;
        DATASET = "dataset", // = 2;
        COMPETITION = "competition", // = 3;
        NOTEBOOK = "notebook", // = 4;
      }

      export enum DatabundleVersionStatus {
        NOT_YET_PERSISTED = "notYetPersisted", // = 0;
        BLOBS_RECEIVED = "blobsReceived", // = 1;
        BLOBS_DECOMPRESSED = "blobsDecompressed", // = 2;
        BLOBS_COPIED_TO_SDS = "blobsCopiedToSds", // = 3;
        INDIVIDUAL_BLOBS_COMPRESSED = "individualBlobsCompressed", // = 4;
        READY = "ready", // = 5;
        FAILED = "failed", // = 6;
        DELETED = "deleted", // = 7;
        REPROCESSING = "reprocessing", // = 8;
      }

      export enum DatabundleVersionType {
        UNSPECIFIED = "unspecified", // = 0;
        FILESET = "fileset", // = 1;
        BIG_QUERY = "bigQuery", // = 2;
        REMOTE_URL_FILE_SET = "remoteUrlFileSet", // = 3;
        REMOTE_GIT_REPOSITORY_FILE_SET = "remoteGitRepositoryFileSet", // = 4;
        KERNEL_OUTPUT_FILE_SET = "kernelOutputFileSet", // = 5;
        GCS_FILE_SET = "gcsFileSet", // = 6;
      }

      export enum DatasetActivityType {
        SCRIPT = "script", // = 0;
        SCRIPT_FORK = "scriptFork", // = 1;
        SCRIPT_RUN = "scriptRun", // = 2;
        DATASET = "dataset", // = 3;
        DATASET_VERSION = "datasetVersion", // = 4;
        COMMENT = "comment", // = 5;
        SCRIPT_COMMENT = "scriptComment", // = 6;
        TOPIC = "topic", // = 7;
      }

      export enum DatasetsActivityTypeEnum {
        UNSPECIFIED = "unspecified", // = 0;
        CREATE = "create", // = 1;
        NEW_VERSION = "newVersion", // = 2;
        FEATURE = "feature", // = 3;
        SUPER_FEATURE = "superFeature", // = 4;
        UN_FEATURE = "unFeature", // = 5;
        UN_SUPER_FEATURE = "unSuperFeature", // = 6;
        REMOVE = "remove", // = 7;
        REMOVE_VERSION = "removeVersion", // = 8;
        PUBLISH = "publish", // = 9;
        UN_PUBLISH = "unPublish", // = 10;
        MAKE_PUBLIC = "makePublic", // = 11;
        MAKE_PRIVATE = "makePrivate", // = 12;
        INTRA_VERSION_SCHEMA_UPDATE = "intraVersionSchemaUpdate", // = 13;
      }

      export enum DatasetSchemaDiffAction {
        ADD = "add", // = 0;
        DELETE = "delete", // = 1;
        MODIFY_DESCRIPTION = "modifyDescription", // = 2;
        MODIFY_TYPE = "modifyType", // = 3;
        ROW_COUNT_CHANGE = "rowCountChange", // = 4;
        SIZE_CHANGE = "sizeChange", // = 5;
      }

      export enum DatasetSchemaDiffContainerLevel {
        UNKNOWN = "unknown", // = 0;
        DATASET = "dataset", // = 1;
        FILE = "file", // = 2;
        TABLE = "table", // = 3;
        COLUMN = "column", // = 4;
      }

      export enum DatasetTab {
        DATA = "data", // = 0;
        DATA_OLD = "dataOld", // = 1;
        KERNELS = "kernels", // = 2;
        NOTEBOOKS = "notebooks", // = 3;
        CODE = "code", // = 4;
        DISCUSSION = "discussion", // = 5;
        ACTIVITY = "activity", // = 6;
        METADATA = "metadata", // = 7;
        SETTINGS = "settings", // = 8;
        TASKS = "tasks", // = 9;
        HOME = "home", // = 10;
      }

      export enum DatasetTopicEnum {
        UNSPECIFIED = "unspecified", // = 0;
        POPULAR_DATASET = "popularDataset", // = 1;
        TRENDING_DATASET = "trendingDataset", // = 2;
        TRENDING_TASK = "trendingTask", // = 3;
        RECENTLY_VIEWED = "recentlyViewed", // = 4;
        BUSINESS_DATASET = "businessDataset", // = 11102;
        ARTS_AND_ENTERTAINMENT_DATASET = "artsAndEntertainmentDataset", // = 2200;
        EDUCATION_DATASET = "educationDataset", // = 11105;
        HEALTH_DATASET = "healthDataset", // = 11111;
        IMAGE_DATASET = "imageDataset", // = 14102;
        ECONOMICS_DATASET = "economicsDataset", // = 11205;
        COVID_DATASET = "covidDataset", // = 16575;
        CLASSIFICATION_DATASET = "classificationDataset", // = 13302;
        NLP_DATASET = "nlpDataset", // = 13204;
        EARTH_AND_NATURE_DATASET = "earthAndNatureDataset", // = 7000;
        COMPUTER_SCIENCE_DATASET = "computerScienceDataset", // = 12107;
        CLOTHING_AND_ACCESSORIES_DATASET = "clothingAndAccessoriesDataset", // = 8301;
        INTERNET_DATASET = "internetDataset", // = 12116;
        ONLINE_COMMUNITIES_DATASET = "onlineCommunitiesDataset", // = 16489;
        SOFTWARE_DATASET = "softwareDataset", // = 12127;
        EXERCISE_DATASET = "exerciseDataset", // = 4130;
        FOOD_DATASET = "foodDataset", // = 16113;
        MOVIES_AND_TV_SHOWS_DATASET = "moviesAndTvShowsDataset", // = 2303;
        NEWS_DATASET = "newsDataset", // = 16430;
        PROGRAMMING_DATASET = "programmingDataset", // = 12125;
        BIOLOGY_DATASET = "biologyDataset", // = 7100;
        SOCIAL_SCIENCE_DATASET = "socialScienceDataset", // = 11200;
        MUSIC_DATASET = "musicDataset", // = 2304;
        FINANCE_DATASET = "financeDataset", // = 11108;
        CANCER_DATASET = "cancerDataset", // = 16382;
        AUTOMOBILES_AND_VEHICLES_DATASET = "automobilesAndVehiclesDataset", // = 12402;
        RETAIL_AND_SHOPPING_DATASET = "retailAndShoppingDataset", // = 16281;
        INVESTING_DATASET = "investingDataset", // = 16371;
        SPORTS_DATASET = "sportsDataset", // = 4141;
        STANDARDIZED_TESTING_DATASET = "standardizedTestingDataset", // = 16410;
        TRANSPORTATION_DATASET = "transportationDataset", // = 12400;
        UNIVERSITIES_AND_COLLEGES_DATASET = "universitiesAndCollegesDataset", // = 1222;
        LAW_DATASET = "lawDataset", // = 11115;
        GAMES_DATASET = "gamesDataset", // = 2500;
        TRAVEL_DATASET = "travelDataset", // = 16461;
        SOCIAL_NETWORKS_DATASET = "socialNetworksDataset", // = 16502;
        SOCIAL_ISSUES_AND_ADVOCACY_DATASET = "socialIssuesAndAdvocacyDataset", // = 16453;
        TEXT_DATASET = "textDataset", // = 14104;
      }

      export enum DuplicationReferenceType {
        COMPETITION = "competition", // = 0;
        DATASET = "dataset", // = 1;
      }

      export enum GithubRepositoryContentType {
        FILE = "file", // = 0;
        FOLDER = "folder", // = 1;
      }

      export enum RemoteUrlUpdateFrequency {
        DAILY = "daily", // = 0;
        WEEKLY = "weekly", // = 1;
        MONTHLY = "monthly", // = 2;
        NEVER = "never", // = 3;
        // The value of UNSPECIFIED should be 0 but we can't change the value of DAILY
        // because it is serialized as a number in the database (see the Settings column
        // in the DatabundleVersions table).
        UNSPECIFIED = "unspecified", // = -1;
      }

      export enum SuggestionType {
        COMPETITION = "competition", // = 0;
        KERNEL = "kernel", // = 1;
        DATASET = "dataset", // = 2;
        CATEGORY = "category", // = 3;
      }

      export enum TaskSubmissionType {
        DATASET = "dataset", // = 0;
        NOTEBOOK = "notebook", // = 1;
      }
    }

    export namespace Diagnostics {
      export interface RecordPageLoadMetricsRequest {
        // Relative url of the page that was loaded.
        // Examples: "/", "/competitions", "/c/titanic".
        pageUrl: string;
        // Whether this request is a full page refresh or an in-app navigation where the data is fetched
        // via AJAX and the page is updated with a full refresh.
        isFullPageRefresh: boolean;
        // Server-side timestamp when the request to "page_url" was initiated by the frontend, i.e.,
        // right after the user clicks on a link to open a page.
        pageRequestStartEpochMs: number;
        // Server-side timestamp when the request to "page_url" was finished.
        // The difference between "page_request_end_epoch_ms" and "page_request_start_epoch_ms"
        // is the time it takes to download the initial HTML/JSON for the page.
        pageRequestEndEpochMs: number;
        // Client-side timestamp when the frontend starts loading the page.
        // The difference between "page_load_start_epoch_ms" and "page_request_end_epoch_ms"
        // is the time it takes to parse the initial HTML/JSON.
        pageLoadStartEpochMs: number;
        // Client-side timestamp when the frontend finishes loading the page. At this point, the page is
        // assumed to be completely rendered and ready to be used by the user.
        // The difference between "page_load_end_epoch_ms" and "page_request_start_epoch_ms" is
        // the total page load latency, i.e., time it takes to completely load the page after a user clicks
        // on a link.
        pageLoadEndEpochMs: number;
      }
    }

    export namespace Discussions {
      export namespace Models {
        export interface Discussion {
          currentUser: Kaggle.Sdk.Users.User | null;
          siteForums: Kaggle.Sdk.Discussions.Forum[];
          topicSort: Kaggle.Sdk.Discussions.TopicListSortBy;
        }

        export interface DiscussionForum extends Kaggle.Sdk.Discussions.Models.Discussion  {
          forum: Kaggle.Sdk.Discussions.Forum | null;
        }

        export interface DiscussionTopic extends Kaggle.Sdk.Discussions.Models.Discussion  {
          topic: Kaggle.Sdk.Discussions.ForumTopic | null;
        }
      }

      export interface AddToAdminForumTopicGroupingRequest {
        // The ID of the forum topic grouping to add to
        groupingId: number;
        // The IDs of the forum topics to add
        forumTopicIds: number[];
      }

      export interface AddToAdminForumTopicGroupingResponse {}

      export interface AdminStarForumTopicRequest {
        // The ID for the forum topic to star
        forumTopicId: number;
      }

      export interface AdminStarForumTopicResponse {}

      export interface AdminStarForumTopicsRequest {
        // The ID sfor the forum topics to star
        forumTopicIds: number[];
      }

      export interface AdminStarForumTopicsResponse {}

      export interface AdminUnstarForumTopicRequest {
        // The ID for the forum topic to unstar
        forumTopicId: number;
      }

      export interface AdminUnstarForumTopicResponse {}

      export interface AdminUnstarForumTopicsRequest {
        // The IDs for the forum topics to unstar
        forumTopicIds: number[];
      }

      export interface AdminUnstarForumTopicsResponse {}

      export interface BlobCreationInfo {
        // Opaque string token used to reference the new BlobFile.
        token: string;
        // URL to use to start the upload.
        createUrl: string;
      }

      export interface BlobFileInfo {
        // The name of the file, minus any path segments.
        name: string;
        // The content type of the file.
        contentType: string;
        // The total size (bytes) of the file.
        contentLength: number;
        // The date last modified, used to help determine whether the file has been updated since previous uploads.
        lastModifiedDate: /* google.protobuf.Timestamp */ string | null;
      }

      export interface CommentAttachment {
        fileType?: /* google.protobuf.StringValue */ string | null;
        id: number;
        name: string;
        totalBytes: number;
        url?: /* google.protobuf.StringValue */ string | null;
        blobToken?: /* google.protobuf.StringValue */ string | null;
      }
      // This is a version of ForumMessage meant for displaying comments
      export interface CommentForumMessage {
        id: number;
        postDate: /* google.protobuf.Timestamp */ string | null;
        rawMarkdown?: /* google.protobuf.StringValue */ string | null;
        content: string;
        replies: Kaggle.Sdk.Discussions.CommentForumMessage[];
        attachments: Kaggle.Sdk.Discussions.CommentAttachment[];
        parent: Kaggle.Sdk.Discussions.DiscussionItemLink | null;
        author: Kaggle.Sdk.Users.UserAvatar | null;
        authorType: Kaggle.Sdk.Discussions.CommentAuthorType;
        votes: Kaggle.Sdk.Discussions.CommentVoteButton | null;
        // Permissions/Display
        canDelete: boolean;
        isUserAuthor: boolean;
        hasFlags: boolean;
        isDeleted: boolean;
        isAdminDeleted: boolean;
        isFlagged: boolean;
        isSpammed: boolean;
        currentKernelVersion: number;
        isPinned: boolean;
        isPrivate: boolean;
        kernelVersion?: /* google.protobuf.Int32Value */ number | null;
        // Medals/Rankings
        competitionRanking?: /* google.protobuf.Int32Value */ number | null;
        medal: Kaggle.Sdk.Users.Medal;
        feedbackTrackingData: Kaggle.Sdk.Discussions.FeedbackTrackingData | null;
        moderationStatus: Kaggle.Sdk.Abuse.PrivatedModerationStatus;
      }

      export interface CommentVoteButton {
        totalVotes: number;
        hasAlreadyVotedUp: boolean;
        hasAlreadyVotedDown: boolean;
        canUpvote: boolean;
        canDownvote: boolean;
        voters: Kaggle.Sdk.Users.UserAvatar[];
        upvoters: Kaggle.Sdk.Users.UserAvatar[];
      }

      export interface CreateAdminForumTopicGroupingRequest {
        // The name for the forum topic grouping
        name: string;
        // The forum topic IDs to initially seed the grouping with
        forumTopicIds: number[];
      }

      export interface CreateAdminForumTopicGroupingResponse {
        // The ID of the created forum topic grouping
        groupingId: number;
      }

      export interface CreateAttachmentRequest {
        // The info for the blob file being created.
        blobFileInfo: Kaggle.Sdk.Discussions.BlobFileInfo | null;
      }

      export interface CreateAttachmentResponse {
        // The info used for creating a blob.
        /*[NotNull]*/
        blobCreationInfo: Kaggle.Sdk.Discussions.BlobCreationInfo;
      }

      export interface CreateKernelMessageRequest {
        // The kernel ID to create the message on.
        kernelId: number;
        // The message content & blobs.
        message: Kaggle.Sdk.Discussions.Message | null;
      }

      export interface CreateKernelMessageResponse {
        // The created message ID.
        messageId: number;
        // The topic ID associated with the kernel messages.
        topicId: number;
      }

      export interface CreateReplyRequest {
        // The message ID of the parent message being replied to.
        messageId: number;
        // The message content & blobs.
        message: Kaggle.Sdk.Discussions.Message | null;
      }

      export interface CreateReplyResponse {
        // The created message ID.
        messageId: number;
      }

      export interface CreateTopicRequest {
        // The forum ID of the parent forum for the topic being created.
        forumId: number;
        // The name of the topic being created.
        topicName: string;
        // The message content & blobs.
        message: Kaggle.Sdk.Discussions.Message | null;
        // Optional tags to add to the forum topic
        tagIds: number[];
      }

      export interface CreateTopicResponse {
        // The created topic ID.
        topicId: number;
        // The created message ID.
        messageId: number;
      }

      export interface DeleteAdminForumTopicGroupingRequest {
        // The ID of the forum topic grouping to delete
        groupingId: number;
      }

      export interface DeleteAdminForumTopicGroupingResponse {}

      export interface DeleteAttachmentRequest {
        // The ForumMessageAttachmentFiles.Id of the file to delete.
        attachmentId: number;
      }

      export interface DeleteMessageRequest {
        messageId: number;
      }

      export interface DeleteTopicRequest {
        topicId: number;
      }
      // Used to store data about a related item which we'll want to link to.
      // Eg a message's topic, or a message's script.
      export interface DiscussionItemLink {
        id: number;
        name?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DiscussionParamValues {
        page: number;
        search?: /* google.protobuf.StringValue */ string | null;
        group: Kaggle.Sdk.Discussions.TopicListGroup;
        sortBy: Kaggle.Sdk.Discussions.TopicListSortBy;
        category: Kaggle.Sdk.Discussions.TopicListCategory;
      }
      // This is serialized/deserialized to the database using JsonConvert. Ensure
      // backward compatibility with existing data when adding/removing/changing fields.
      export interface FeedbackTrackingData {
        buganizerId?: /* google.protobuf.Int32Value */ number | null;
        followUpStatus: Kaggle.Sdk.Discussions.FollowUpStatus;
      }

      export interface Forum {
        allowAttachments: boolean;
        currentUserCanDownvote: boolean;
        currentUserTier: Kaggle.Sdk.Users.UserAchievementTier;
        id?: /* google.protobuf.Int32Value */ number | null;
        imageUrl?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
        lastPostDate: /* google.protobuf.Timestamp */ string | null;
        lastPostUrl?: /* google.protobuf.StringValue */ string | null;
        name?: /* google.protobuf.StringValue */ string | null;
        subscriptionState: Kaggle.Sdk.Notifications.SubscribeState;
        subtitle?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
        hasUnreadTopics: boolean;
        recentAuthors: Kaggle.Sdk.Users.UserAvatar[];
        lastPostUser: Kaggle.Sdk.Users.UserAvatar | null;
      }

      export interface ForumMessage {
        id: number;
        postDate: /* google.protobuf.Timestamp */ string | null;
        postUserId?: /* google.protobuf.Int32Value */ number | null;
        postUserThumbnailName?: /* google.protobuf.StringValue */ string | null;
        postUsername?: /* google.protobuf.StringValue */ string | null;
        postUserDisplayName?: /* google.protobuf.StringValue */ string | null;
        topicName?: /* google.protobuf.StringValue */ string | null;
        topicUrl: string;
        scriptId?: /* google.protobuf.Int32Value */ number | null;
        forumName?: /* google.protobuf.StringValue */ string | null;
        message?: /* google.protobuf.StringValue */ string | null;
        messageUrl: string;
        medal: Kaggle.Sdk.Users.Medal;
        score: number;
        isFirstMessageInTopic: boolean;
        isSpam: boolean;
        isDeleted: boolean;
        isPinned: boolean;
        isPrivate: boolean;
        topicId: number;
        forumId: number;
      }

      export interface ForumTopic {
        allowAttachments: boolean;
        authorId?: /* google.protobuf.Int32Value */ number | null;
        authorThumbnailName?: /* google.protobuf.StringValue */ string | null;
        authorUserDisplayName?: /* google.protobuf.StringValue */ string | null;
        authorUserName?: /* google.protobuf.StringValue */ string | null;
        canDelete: boolean;
        comments: Kaggle.Sdk.Discussions.CommentForumMessage[];
        commentSort: Kaggle.Sdk.Discussions.CommentListSortBy;
        firstMessage: Kaggle.Sdk.Discussions.CommentForumMessage | null;
        firstMessageId?: /* google.protobuf.Int32Value */ number | null;
        forumId: number;
        forumName: string;
        id: number;
        isAdminStarred: boolean;
        isDeleted: boolean;
        isDeletedLegacy: boolean;
        isFollowed: boolean;
        isLocked: boolean;
        isSpammed: boolean;
        isStickied: boolean;
        name: string;
        parentName?: /* google.protobuf.StringValue */ string | null;
        parentUrl?: /* google.protobuf.StringValue */ string | null;
        postDate: /* google.protobuf.Timestamp */ string | null;
        tags: Kaggle.Sdk.Tags.Tag[];
        totalVotes: number;
        url: string;
        isBookmarked: boolean;
        isPrivate: boolean;
      }

      export interface ForumTopicGrouping {
        groupingId: number;
        name: string;
      }

      export interface GetAdminForumTopicGroupingsForCurrentUserRequest {}

      export interface GetAdminForumTopicGroupingsForCurrentUserResponse {
        // The forum topic groupings owned by the current user
        forumTopicGroupings: Kaggle.Sdk.Discussions.ForumTopicGrouping[];
      }

      export interface GetForumMessagesInTopicRequest {
        topicId: number;
        page?: /* google.protobuf.Int32Value */ number | null;
        pageSize?: /* google.protobuf.Int32Value */ number | null;
        newUserSort: Kaggle.Sdk.Discussions.CommentListSortBy;
        filter: Kaggle.Sdk.Discussions.CommentListFilter;
        includeFirstForumMessage: boolean;
      }

      export interface GetForumMessagesInTopicResponse {
        comments: Kaggle.Sdk.Discussions.CommentForumMessage[];
        commentSort: Kaggle.Sdk.Discussions.CommentListSortBy;
      }

      export interface GetForumRequest {
        forumId?: /* google.protobuf.Int32Value */ number | null;
        forumSlug?: /* google.protobuf.StringValue */ string | null;
        readMask?: google.protobuf.FieldMask | null;
      }

      export interface GetForumResponse {
        forum: Kaggle.Sdk.Discussions.Forum | null;
        topicSort: Kaggle.Sdk.Discussions.TopicListSortBy;
      }

      export interface GetForumTopicByIdRequest {
        forumTopicId: number;
        includeComments: boolean;
        readMask: google.protobuf.FieldMask | null;
      }

      export interface GetForumTopicByIdResponse {
        forumTopic: Kaggle.Sdk.Discussions.ForumTopic | null;
      }

      export interface GetSiteForumsRequest {}

      export interface GetSiteForumsResponse {
        forums: Kaggle.Sdk.Discussions.Forum[];
      }

      export interface GetTopicListByForumIdRequest {
        category: Kaggle.Sdk.Discussions.TopicListCategory;
        customGroupingIds: number[];
        forumId?: /* google.protobuf.Int32Value */ number | null;
        group: Kaggle.Sdk.Discussions.TopicListGroup;
        page: number;
        searchQuery?: /* google.protobuf.StringValue */ string | null;
        sortBy: Kaggle.Sdk.Discussions.TopicListSortBy;
        recency: Kaggle.Sdk.Discussions.TopicListRecency;
        myActivity: Kaggle.Sdk.Discussions.TopicListMyActivity;
        author: Kaggle.Sdk.Discussions.TopicListAuthor;
        filterCategoryIds: number[];
      }

      export interface GetTopicListResponse {
        topics: Kaggle.Sdk.Discussions.TopicListItem[];
        count: number;
      }

      export interface Message {
        // The markdown of the message.
        markdown: string;
        // The HTML of the message.
        html: string;
        // The blob file tokens of the files attached to the message.
        blobFileTokens: string[];
      }

      export interface NewTopicDto {
        allowAttachments: boolean;
        authorTier: Kaggle.Sdk.Users.UserAchievementTier;
        authorType: Kaggle.Sdk.Discussions.CommentAuthorType;
        forumId: number;
        parentName?: /* google.protobuf.StringValue */ string | null;
        parentUrl?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
      }

      export interface PinForumMessageRequest {
        forumMessageId: number;
      }

      export interface RemoveFromAdminForumTopicGroupingRequest {
        // The ID of the forum topic grouping to remove from
        groupingId: number;
        // The IDs of the forum topics to remove
        forumTopicIds: number[];
      }

      export interface RemoveFromAdminForumTopicGroupingResponse {}

      export interface ToggleFlagMessageRequest {
        messageId?: /* google.protobuf.Int32Value */ number | null;
        explanation?: /* google.protobuf.StringValue */ string | null;
        reasonType: Kaggle.Sdk.Discussions.FlagReason;
        scriptVersionId?: /* google.protobuf.Int32Value */ number | null;
        datasetVersionId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface ToggleSpamMessageRequest {
        messageId: number;
      }

      export interface ToggleSpamMessageResponse {
        messageUrl: string;
      }

      export interface TopicListDto {
        canDownvote: boolean;
        dataUrl?: /* google.protobuf.StringValue */ string | null;
        id?: /* google.protobuf.Int32Value */ number | null;
        showSubscribeButton: boolean;
        isSubscribed: boolean;
        subscription: Kaggle.Sdk.Notifications.SubscribeState;
        paramValues: Kaggle.Sdk.Discussions.DiscussionParamValues | null;
      }

      export interface TopicListItem {
        authorUser: Kaggle.Sdk.Users.UserAvatar | null;
        authorType: Kaggle.Sdk.Discussions.CommentAuthorType;
        commentCount: number;
        currentUserVote: number;
        canUpvote: boolean;
        canDownvote: boolean;
        firstForumMessageId: number;
        hasAdminResponse: boolean;
        id: number;
        isAdminStarred: boolean;
        isSticky: boolean;
        lastCommenterType: Kaggle.Sdk.Discussions.CommentAuthorType;
        lastCommenterName: string;
        lastCommenterUrl: string;
        lastCommentPostDate: /* google.protobuf.Timestamp */ string | null;
        lastViewDate: /* google.protobuf.Timestamp */ string | null;
        medal: Kaggle.Sdk.Users.Medal;
        parentName?: /* google.protobuf.StringValue */ string | null;
        parentUrl?: /* google.protobuf.StringValue */ string | null;
        postDate: /* google.protobuf.Timestamp */ string | null;
        tags: Kaggle.Sdk.Tags.Tag[];
        title: string;
        topicUrl: string;
        voteResumeUrl: string;
        votes: number;
        isBookmarked: boolean;
        oldestUnreadCommentUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UnsubscribeWatchesRequest {
        userId: number;
      }

      export interface UpdateFeedbackTrackingDataRequest {
        messageId: number;
        feedbackTrackingData: Kaggle.Sdk.Discussions.FeedbackTrackingData | null;
      }

      export interface UpdateForumMessageSettingsRequest {
        forumMessageId: number;
        settingToToggle: Kaggle.Sdk.Discussions.ForumMessageSettings;
      }

      export interface UpdateForumSettingsRequest {
        forumId: number;
        settingToToggle: Kaggle.Sdk.Discussions.ForumSettings;
      }

      export interface UpdateForumTopicSettingsRequest {
        forumTopicId: number;
        //  Indicates which field should be toggled
        settingToToggle: Kaggle.Sdk.Discussions.ForumTopicSettings;
      }

      export interface UpdateManyFeedbackTrackingDataRequest {
        messageIds: number[];
        feedbackTrackingData: Kaggle.Sdk.Discussions.FeedbackTrackingData | null;
      }

      export interface UpdateMessageRequest {
        // The message ID of the message being updated.
        messageId: number;
        // The message content & blobs.
        message: Kaggle.Sdk.Discussions.Message | null;
      }

      export interface UpdateMessageResponse {}

      export interface UpdateTopicRequest {
        // The topic ID of the topic being updated.
        topicId: number;
        // The updated name of the topic.
        topicName: string;
        // The message content & blobs.
        message: Kaggle.Sdk.Discussions.Message | null;
        // Optional tags to add to the forum topic
        tagIds: number[];
      }

      export interface UpdateTopicResponse {}

      export interface VoteOnForumMessageRequest {
        forumMessageId: number;
        score: number;
      }

      export interface VoteOnForumMessageResponse {}

      export enum CommentAuthorType {
        ADMIN = "admin", // = 0;
        HOST = "host", // = 1;
        DATASET_CREATOR = "datasetCreator", // = 2;
        TOPIC = "topic", // = 3;
        COMMENT = "comment", // = 4;
      }

      export enum CommentListFilter {
        ALL = "all", // = 0;
        KERNEL_VERSION = "kernelVersion", // = 1;
      }

      export enum CommentListSortBy {
        UNSPECIFIED = "unspecified", // = 0;
        HOT = "hot", // = 1;
        NEW = "new", // = 2;
        OLD = "old", // = 3;
        TOP = "top", // = 4;
        CHRONOLOGICAL = "chronological", // = 5;
      }

      export enum FlagReason {
        UNSPECIFIED = "unspecified", // = 0;
        OTHER = "other", // = 1;
        SPAM = "spam", // = 2;
        PLAGIARISM = "plagiarism", // = 3;
        VOTE_MANIPULATION = "voteManipulation", // = 4;
        ABUSIVE = "abusive", // = 5;
        PRIVACY_VIOLATION = "privacyViolation", // = 6;
        COPYRIGHT_VIOLATION = "copyrightViolation", // = 7;
        UPVOTE_BEGGING = "upvoteBegging", // = 8;
      }

      export enum FollowUpStatus {
        NONE = "none", // = 0;
        IN_PROGRESS = "inProgress", // = 1;
        DONE = "done", // = 2;
      }

      export enum ForumMessageSettings {
        UNSPECIFIED = "unspecified", // = 0;
        IS_PRIVATE = "isPrivate", // = 1;
      }

      export enum ForumSettings {
        IS_READ_ONLY = "isReadOnly", // = 0;
      }

      export enum ForumTopicSettings {
        IS_READ_ONLY = "isReadOnly", // = 0;
        IS_STICKY = "isSticky", // = 1;
      }

      export enum TopicListAuthor {
        UNSPECIFIED = "unspecified", // = 0;
        ADMIN = "admin", // = 1;
      }

      export enum TopicListCategory {
        UNSPECIFIED = "unspecified", // = 0;
        ALL = "all", // = 1;
        FORUMS = "forums", // = 2;
        COMPETITIONS = "competitions", // = 3;
        DATASETS = "datasets", // = 4;
      }

      export enum TopicListGroup {
        UNSPECIFIED = "unspecified", // = 0;
        ALL = "all", // = 1;
        OWNED = "owned", // = 2;
        UPVOTED = "upvoted", // = 3;
        STARRED = "starred", // = 4;
        CUSTOM = "custom", // = 5;
        BOOKMARKED = "bookmarked", // = 6;
        MY_ACTIVITY = "myActivity", // = 7;
      }

      export enum TopicListMyActivity {
        UNSPECIFIED = "unspecified", // = 0;
        PUBLISHED = "published", // = 1;
        COMMENTED = "commented", // = 2;
        VIEWED = "viewed", // = 3;
      }

      export enum TopicListRecency {
        UNSPECIFIED = "unspecified", // = 0;
        LAST_30_DAYS = "last30Days", // = 1;
        LAST_7_DAYS = "last7Days", // = 2;
        TODAY = "today", // = 3;
      }

      export enum TopicListSortBy {
        UNSPECIFIED = "unspecified", // = 0;
        HOT = "hot", // = 1;
        TOP = "top", // = 2;
        NEW = "new", // = 3;
        RECENT = "recent", // = 4;
        ACTIVE = "active", // = 5;
        RELEVANCE = "relevance", // = 6;
      }
    }

    export namespace Education {
      export namespace Models {
        export interface LearnHome {
          tracks: Kaggle.Sdk.Education.LearnTrack[];
          recentlyProgressedTracks: Kaggle.Sdk.Education.LearnTrack[];
        }

        export interface LearnNudge {
          courseIndex: /*Int32*/ number;
          courseName: string | null;
          courseSlug: string | null;
          nextItemName: string | null;
          nextItemUrl: string | null;
          nextItemType: Kaggle.Sdk.Education.Models.LearnNudgeType;
        }

        export interface LessonInfo {
          tracks: Kaggle.Sdk.Education.LearnTrack[];
        }

        export enum LearnNudgeType {
          COURSE_COMPLETE_NO_BONUS_LESSONS = "courseCompleteNoBonusLessons", // = 0;
          COURSE_COMPLETE_WITH_BONUS_LESSONS = "courseCompleteWithBonusLessons", // = 1;
          COURSE_INCOMPLETE = "courseIncomplete", // = 2;
          DO_EXERCISE = "doExercise", // = 3;
          DO_TUTORIAL = "doTutorial", // = 4;
        }
      }

      export interface AddLessonsToTrackRequest {
        trackId: number;
        lessonIds: number[];
      }

      export interface Certificate {
        // This is deprecated. Use author_usernames instead.
        authorUsername: string;
        completionDate: /* google.protobuf.Timestamp */ string | null;
        courseName: string;
        fullUsername: string;
        gcsAccessImageUrl: string;
        isViewingOwnCertificate: boolean;
        trackId: number;
        trackUrl: string;
        // Globally disabled on 2020-07-08.  Remove in a few months when all
        // clients are updated.
        showOldCertificate: boolean;
        authorUsernames: string[];
      }

      export interface EditLessonRequest {
        lessonId: number;
        description?: /* google.protobuf.StringValue */ string | null;
        exerciseKernelId?: /* google.protobuf.Int32Value */ number | null;
        exerciseKernelVersionId?: /* google.protobuf.Int32Value */ number | null;
        questionCount?: /* google.protobuf.Int32Value */ number | null;
        tutorialKernelId?: /* google.protobuf.Int32Value */ number | null;
        isExtraCredit?: /* google.protobuf.BoolValue */ boolean | null;
      }

      export interface GetCertificateUploadUrlRequest {
        contentLength: number;
        trackId: number;
      }

      export interface GetCertificateUploadUrlResponse {
        uploadUrl: string;
      }

      export interface GetExerciseVersionsRequest {
        exerciseId: number;
      }

      export interface GetExerciseVersionsResponse {
        exerciseVersions: Kaggle.Sdk.Education.LearnExerciseVersion[];
      }

      export interface GetTrackRequest {
        trackSlug: string;
      }

      export interface GetTracksRequest {}

      export interface GetTracksResponse {
        tracks: Kaggle.Sdk.Education.LearnTrack[];
      }

      export interface LearnExercise {
        id: number;
        scriptId: number;
        name: string;
        url: string;
        authorUsername: string;
        scriptSlug: string;
        progress?: /* google.protobuf.DoubleValue */ number | null;
      }

      export interface LearnExerciseVersion {
        kernelVersionId: number;
        questionCount: number;
      }

      export interface LearnLesson {
        id: number;
        description: string;
        learnTutorial: Kaggle.Sdk.Education.LearnTutorial | null;
        learnExercise: Kaggle.Sdk.Education.LearnExercise | null;
        isExtraCredit: boolean;
        dataSource: Kaggle.Sdk.Education.LearnLessonDataSource | null;
      }

      export interface LearnLessonDataSource {
        type: Kaggle.Sdk.Education.LearnLessonDataSourceType;
        id: number;
        url: string;
        thumbnailImageUrl: string;
      }

      export interface LearnNudge {
        courseIndex: number;
        courseName: string;
        courseSlug: string;
        nextItemName: string;
        nextItemUrl: string;
        nextItemType: Kaggle.Sdk.Education.LearnNudgeType;
      }

      export interface LearnSeriesNavigationData {
        learnCourse: Kaggle.Sdk.Education.LearnTrack | null;
        learnNudge: Kaggle.Sdk.Education.LearnNudge | null;
      }

      export interface LearnTrack {
        id: number;
        trackIndex: number;
        name: string;
        description: string;
        hasDailyDelivery: boolean;
        visible: boolean;
        trackSlug: string;
        thumbnailImageUrl: string;
        estimatedTimeHours: number;
        userProgress: number;
        certificateUrl: string;
        lessons: Kaggle.Sdk.Education.LearnLesson[];
        prerequisites: Kaggle.Sdk.Education.LearnTrack[];
        dependencyFor: Kaggle.Sdk.Education.LearnTrack[];
        authors: Kaggle.Sdk.Users.User[];
        tags: Kaggle.Sdk.Tags.Tag[];
        forumId: number;
      }

      export interface LearnTutorial {
        id: number;
        scriptId: number;
        name: string;
        url: string;
        authorDisplayName: string;
        authorUsername: string;
        scriptSlug: string;
        thumbnailImageUrl: string;
        creationDate: /* google.protobuf.Timestamp */ string | null;
        progress?: /* google.protobuf.DoubleValue */ number | null;
      }

      export interface ReorderTracksRequest {
        trackIds: number[];
      }

      export interface ReorderTracksResponse {
        tracks: Kaggle.Sdk.Education.LearnTrack[];
      }

      export interface RescoreExerciseVersionRequest {
        scriptVersionId: number;
      }

      export interface RescoreResponse {
        affectedUsers: number;
      }

      export interface TrackEducationRequest {
        type: Kaggle.Sdk.Education.LearnTrackerStatus;
        id: string;
      }

      export interface TrackExerciseInteractionRequest {
        exceptionClass: string;
        failureMessage: string;
        interactionType: Kaggle.Sdk.Education.LearnExerciseInteractionType;
        learnToolsVersion: string;
        forkParentScriptVersionId: number;
        outcomeType: Kaggle.Sdk.Education.LearnExerciseOutcomeType;
        questionId: string;
        questionType: Kaggle.Sdk.Education.LearnExerciseQuestionType;
        trace: string;
        valueTowardsCompletion?: /* google.protobuf.DoubleValue */ number | null;
      }

      export interface TrackExerciseInteractionResponse {
        nudge: Kaggle.Sdk.Education.LearnNudge | null;
        showLoginPrompt: boolean;
      }

      export enum LearnExerciseInteractionType {
        UNSPECIFIED = "unspecified", // = 0;
        CHECK = "check", // = 1;
        HINT = "hint", // = 2;
        SOLUTION = "solution", // = 3;
      }

      export enum LearnExerciseOutcomeType {
        UNSPECIFIED = "unspecified", // = 0;
        PASS = "pass", // = 1;
        FAIL = "fail", // = 2;
        EXCEPTION = "exception", // = 3;
        UNATTEMPTED = "unattempted", // = 4;
      }

      export enum LearnExerciseQuestionType {
        UNSPECIFIED = "unspecified", // = 0;
        EQUALITY_CHECK_PROBLEM = "equalityCheckProblem", // = 1;
        CODING_PROBLEM = "codingProblem", // = 2;
        FUNCTION_PROBLEM = "functionProblem", // = 3;
        THOUGHT_EXPERIMENT = "thoughtExperiment", // = 4;
      }

      export enum LearnLessonDataSourceType {
        UNSPECIFIED = "unspecified", // = 0;
        COMPETITION = "competition", // = 1;
        DATASET = "dataset", // = 2;
      }

      export enum LearnNudgeType {
        COURSE_COMPLETE_NO_BONUS_LESSONS = "courseCompleteNoBonusLessons", // = 0;
        COURSE_COMPLETE_WITH_BONUS_LESSONS = "courseCompleteWithBonusLessons", // = 1;
        COURSE_INCOMPLETE = "courseIncomplete", // = 2;
        DO_EXERCISE = "doExercise", // = 3;
        DO_TUTORIAL = "doTutorial", // = 4;
      }

      export enum LearnTrackerStatus {
        UNSPECIFIED = "unspecified", // = 0;
        TRACK_VIEW = "trackView", // = 1;
        KERNEL_VIEW = "kernelView", // = 2;
        PAGE_VIEW = "pageView", // = 3;
        EXERCISE_FORK = "exerciseFork", // = 4;
      }
    }

    export namespace Emails {
      export interface SendEmailResponse {
        wasSent: boolean;
      }

      export interface SendPrivateDatasetSummaryEmailRequest {
        userId: number;
        startDate: /* google.protobuf.Timestamp */ string | null;
        endDate: /* google.protobuf.Timestamp */ string | null;
      }
    }

    export namespace Kernels {
      export namespace Models {
        export enum ValidationExceptionType {
          CONCURRENCY_VIOLATION = "concurrencyViolation", // = 0;
        }
      }

      export namespace UpdateKernelDraftRequest {
        export interface ExternalSourceData {
          // This is typically a url, but may also indicate that a file was uploaded. 
          sourceDescription: string;
          // The source is private for private github repos as well as file uploads. 
          isPublic: boolean;
        }
      }

      export interface AcceleratorQuotaStatistics {
        hasEverRun: boolean;
        /*[NotNull]*/
        minimumTimeAllowed: google.protobuf.Duration;
        /*[NotNull]*/
        timeReserved: google.protobuf.Duration;
        /*[NotNull]*/
        timeUsed: google.protobuf.Duration;
        /*[NotNull]*/
        totalTimeAllowed: google.protobuf.Duration;
      }

      export interface AcceptKernelCompetitionRulesRequest {
        kernelSessionId: number;
      }

      export interface AddKernelCategoryRequest {
        kernelId: number;
        categoryId: number;
      }

      export interface AgentEntry {
        submissionId: number;
        teamName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface BatchAutoTagKernelsRequest {
        batchSize: number;
        startingKernelId: number;
      }

      export interface BatchAutoTagKernelsResponse {
        endingKernelId: number;
        taggedKernelCount: number;
      }

      export interface CancelKernelSessionRequest {
        kernelSessionId: number;
      }

      export interface ClearPinnedKernelSessionRequest {
        kernelId: number;
      }

      export interface CommitAndRunRequest {
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
        forkParentScriptVersionId?: /* google.protobuf.Int32Value */ number | null;
        isLanguageTemplate?: /* google.protobuf.BoolValue */ boolean | null;
        newText?: /* google.protobuf.StringValue */ string | null;
        newTitle?: /* google.protobuf.StringValue */ string | null;
        scriptId: number;
        scriptLanguageName?: /* google.protobuf.StringValue */ string | null;
        dockerImageVersionId?: /* google.protobuf.Int32Value */ number | null;
        isPrivate: boolean;
        editorType?: Kaggle.Sdk.Kernels.EditorType;
        dockerImageTag?: /* google.protobuf.StringValue */ string | null;
        workerPoolName?: /* google.protobuf.StringValue */ string | null;
        sequence?: /* google.protobuf.Int32Value */ number | null;
        compute: Kaggle.Sdk.Kernels.ComputeState | null;
        kernelVersionId?: /* google.protobuf.Int32Value */ number | null;
        versionName?: /* google.protobuf.StringValue */ string | null;
        versionType: Kaggle.Sdk.Kernels.KernelVersionType;
        // Used for downgrade commits (run commit as free even if on pro). Defaults to current plan of the user.
        userPlanOverride?: Kaggle.Sdk.Users.UserPlan;
        submissionRequestedDetails: Kaggle.Sdk.Kernels.SubmissionRequestedDetails | null;
        executedByScheduleId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface CommitAndRunResponse {
        message?: /* google.protobuf.StringValue */ string | null;
        newUrl?: /* google.protobuf.StringValue */ string | null;
        submitRedirectUrl?: /* google.protobuf.StringValue */ string | null;
        sequence?: /* google.protobuf.Int32Value */ number | null;
        parentKernelVersionId?: /* google.protobuf.Int32Value */ number | null;
        diff: Kaggle.Sdk.Kernels.KernelDiff | null;
        kernelId: number;
        kernelVersionId: number;
        kernelRunId: number;
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        status: Kaggle.Sdk.Kernels.KernelWorkerStatus;
        blobUploadUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CompleteQuickSessionRequest {
        kernelSessionId: number;
        workerPoolName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CompleteQuickSessionResponse {
        errorMessage?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ComputeConstraintState {
        sessionTimeoutSeconds?: /* google.protobuf.Int32Value */ number | null;
        maxCpuCores?: /* google.protobuf.Int32Value */ number | null;
        maxStorageBytes?: /* google.protobuf.Int64Value */ number | null;
        maxMemoryBytes?: /* google.protobuf.Int64Value */ number | null;
        disallowInternet?: /* google.protobuf.BoolValue */ boolean | null;
      }

      export interface ComputeInternetState {
        isEnabled: boolean;
      }

      export interface ComputeKernelDiffRequest {
        leftSessionId: number;
        rightSessionId: number;
        includeContents: boolean;
      }

      export interface ComputeKernelDiffResponse {
        diff: Kaggle.Sdk.Kernels.KernelDiff | null;
        leftContent?: /* google.protobuf.StringValue */ string | null;
        rightContent?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ComputeState {
        accelerator: Kaggle.Sdk.Kernels.AcceleratorType;
        internet: Kaggle.Sdk.Kernels.ComputeInternetState | null;
        constraints: Kaggle.Sdk.Kernels.ComputeConstraintState | null;
      }

      export interface CreateKernelParameters {
        title?: /* google.protobuf.StringValue */ string | null;
        languageId: number;
        dockerImageVersionId?: /* google.protobuf.Int32Value */ number | null;
        compute: Kaggle.Sdk.Kernels.ComputeState | null;
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
      }

      export interface CreateKernelSessionRequest {
        kernelId: number;
        versionType: Kaggle.Sdk.Kernels.KernelVersionType;
        dockerImageTag?: /* google.protobuf.StringValue */ string | null;
        workerPoolName?: /* google.protobuf.StringValue */ string | null;
        // Used for downgrade commits (run commit as free even if on pro). Defaults to current plan of the user.
        userPlanOverride?: Kaggle.Sdk.Users.UserPlan;
        immediatelyCancelSession: boolean;
        executedByScheduleId?: /* google.protobuf.Int32Value */ number | null;
        // These properties are only set for batch runs.
        kernelVersionId?: /* google.protobuf.Int32Value */ number | null;
        diff: Kaggle.Sdk.Kernels.KernelDiff | null;
        forkParentDiff: Kaggle.Sdk.Kernels.KernelDiff | null;
        submissionRequestedDetails: Kaggle.Sdk.Kernels.SubmissionRequestedDetails | null;
        // This is a hack to support two different use cases for CreateKernelSession:  The normal (typically interactive)
        // use case of starting up a new session using the latest [Comp|Dataset|Kernel] Version for each data source,
        // and the reproducibility use case (right now, specifically for Competition Reruns) where we need to use
        // the same Versions for each data source as the original KernelRun used.
        // 
        // Setting this flag to `true` will bypass the default behavior of querying the latest Versions for each data
        // source and instead use the VersionIds which are already provided in the `DataSources` field above.
        // 
        // A future version of this API should handle this more cleanly, for example by acting as if this flag was
        // always set to true and requiring callers to fetch VersionIds according to their needs.
        useGivenDataSourceVersionIds: boolean;
        parameters: Kaggle.Sdk.Kernels.CreateKernelParameters | null;
      }

      export interface CreateKernelSessionResponse {
        id: number;
        resources: Kaggle.Sdk.Kernels.KernelSessionResources | null;
        error?: /* google.protobuf.StringValue */ string | null;
        useNewKernelsBackend: boolean;
        showParentForkSecretWarning: boolean;
      }

      export interface CreateKernelUpvoteRequest {
        kernelId: number;
      }

      export interface CreateKernelUpvoteResponse {
        voteId: number;
        isSelfVote: boolean;
      }

      export interface CreateKernelWithSettingsRequest {
        kernelLanguageId: number;
        sourceType: Kaggle.Sdk.Kernels.EditorType;
        accelerator: Kaggle.Sdk.Kernels.AcceleratorType;
        // URL to fetch for initial content.
        sourceUrl?: /* google.protobuf.StringValue */ string | null;
        enableInternet?: /* google.protobuf.BoolValue */ boolean | null;
        enableBigQuery?: /* google.protobuf.BoolValue */ boolean | null;
        forkParentScriptVersionId?: /* google.protobuf.Int32Value */ number | null;
        // Create a kernel using this competition's data.
        competitionId?: /* google.protobuf.Int32Value */ number | null;
        // Create a kernel with this dataset.
        datasetVersionId?: /* google.protobuf.Int32Value */ number | null;
        // Link the kernel to a particular task on a dataset.
        datasetTaskId?: /* google.protobuf.Int32Value */ number | null;
        // Use the output of a kernel as an input data source.
        kernelOutputVersionId?: /* google.protobuf.Int32Value */ number | null;
        bigQuerySecretId?: /* google.protobuf.Int32Value */ number | null;
        dockerImagePinningType: Kaggle.Sdk.Kernels.DockerImagePinningType;
      }

      export interface CreateKernelWithSettingsResponse {
        id: number;
        currentUrlSlug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CreateSnippetRequest {
        data: Kaggle.Sdk.Kernels.SnippetData | null;
      }

      export interface CreateSnippetResponse {
        id: number;
      }

      export interface DailySubmissionInfo {
        submissionCount: number;
        submissionLimit?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface DataSource {
        reference: Kaggle.Sdk.Kernels.DataSourceReference | null;
        name?: /* google.protobuf.StringValue */ string | null;
        dataSourceUrl?: /* google.protobuf.StringValue */ string | null;
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
      }

      export interface DataSourceReference {
        // Currently only Competition, DatasetVersion, and KernelVersion supported.
        sourceType: Kaggle.Sdk.Kernels.DataSourceType;
        // CompetitionId for Competitions
        // DatasetVersionId for DatasetVersions
        // KernelRunId (ScriptVersionId) for KernelVersions
        sourceId: number;
        // Used for denormalizing KernelDatasetDataSources to improve performance
        // This value needs to be set for DataSourceType.DatasetVersion
        datasetId?: /* google.protobuf.Int32Value */ number | null;
        // Represents the low-level DatabundleVersion to use for this datasource.
        // Currently only used for Competition datasources, since a Competition's databundle can be updated
        // over time, or reruns may use a different databundle altogether.
        // This field does not need to be set, it will be auto-populated with the Competition's current DBVID if not.
        // DatasetVersion implies DatabundleVersion (and it cannot change) so Dataset datasources don't need this.
        databundleVersionId?: /* google.protobuf.Int32Value */ number | null;
        // The sub-directory used for mounting in a kernel's input directory or empty if data source should be
        // mounted directly in the input path (legacy, single-source session).
        mountSlug?: /* google.protobuf.StringValue */ string | null;
      }
      // Version of a data source attached to a kernel session. Data source can be either a dataset,
      // competition dataset or output of another kernel. Depending on the type of the dataset,
      // meanings of the fields in this model change.
      export interface DataSourceVersion {
        // For datasets, this is the databundle version id.
        // For competition datasets, this is the databundle version id.
        // For kernel output files, this is the kernel session id.
        id?: /* google.protobuf.Int32Value */ number | null;
        // For datasets, this is the databundle version number.
        // For competition datasets, this is the databundle version number.
        // For kernel output files, this is the kernel session version number.
        number?: /* google.protobuf.Int32Value */ number | null;
        // Mount slug for the data source.
        slug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface DefaultSessionSettings {
        saveQuickVersionOutputFiles?: /* google.protobuf.BoolValue */ boolean | null;
        batchSessionDefaultAccelerator?: Kaggle.Sdk.Kernels.AcceleratorType;
        defaultUserPlan?: Kaggle.Sdk.Users.UserPlan;
      }

      export interface DeleteKernelRequest {
        kernelId: number;
      }

      export interface DeleteKernelUpvoteRequest {
        kernelId: number;
      }

      export interface DeleteScheduledKernelSessionRequest {
        // ID of the scheduling.
        id: number;
      }

      export interface DeleteScheduledKernelSessionResponse {}

      export interface DeleteSnippetRequest {
        id: number;
      }

      export interface DockerImageVersionDetails {
        id?: /* google.protobuf.Int32Value */ number | null;
        type: Kaggle.Sdk.Kernels.DockerImageVersionType;
        disabledReason: Kaggle.Sdk.Kernels.DockerImageVersionDisabledReason;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
      }

      export interface DockerImageVersionDetailsList {
        images: Kaggle.Sdk.Kernels.DockerImageVersionDetails[];
        selectedVersionType: Kaggle.Sdk.Kernels.DockerImageVersionType;
        // Set only if SelectedVersionType == Custom.
        selectedVersionId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface ExportKernelRunForCaipRequest {
        kernelSessionId: number;
        useDraft: boolean;
      }

      export interface ExportKernelRunForCaipResponse {
        signedUrl?: /* google.protobuf.StringValue */ string | null;
        warnings: /* google.protobuf.StringValue */ string[];
      }

      export interface FetchExternalKernelContentRequest {
        sourceUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface FetchExternalKernelContentResponse {
        externalContent: string;
      }

      export interface FetchGitHubContentRequest {
        // The owner of the repo. e.g. "Kaggle".
        owner?: /* google.protobuf.StringValue */ string | null;
        // The name of the repo. e.g. "docker-python".
        repo?: /* google.protobuf.StringValue */ string | null;
        // The path of the file. e.g. "README.md", "directory/foo.txt" relative to the root of the repo.
        path?: /* google.protobuf.StringValue */ string | null;
        // The name of the commit/branch/tag
        ref?: /* google.protobuf.StringValue */ string | null;
      }

      export interface FetchGitHubContentResponse {
        content: string;
        isPublic: boolean;
      }

      export interface ForkParentInfo {
        // If IsDeleted || !IsVisible, some other fields may be empty.
        isDeleted: boolean;
        isVisible: boolean;
        authorDisplayName?: /* google.protobuf.StringValue */ string | null;
        kernelId: number;
        kernelUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetAcceleratorQuotaStatisticsRequest {}

      export interface GetAcceleratorQuotaStatisticsResponse {
        /*[NotNull]*/
        quotaRefreshTime: /* google.protobuf.Timestamp */ string;
        kernelsMaxSizeInMb: number;
        tpuQuota: Kaggle.Sdk.Kernels.AcceleratorQuotaStatistics | null;
        gpuQuota: Kaggle.Sdk.Kernels.AcceleratorQuotaStatistics | null;
      }

      export interface GetCompetitionsPaneInfoRequest {
        kernelId: number;
        competitionId: number;
      }

      export interface GetCompetitionsPaneInfoResponse {
        bestKernelSessionScore: Kaggle.Sdk.Kernels.KernelSessionScore | null;
        latestKernelSessionScore: Kaggle.Sdk.Kernels.KernelSessionScore | null;
        dailySubmissionInfo: Kaggle.Sdk.Kernels.DailySubmissionInfo | null;
      }

      export interface GetDefaultSessionSettingsRequest {
        kernelId: number;
      }

      export interface GetDeletedKernelRequest {
        kernelId: number;
      }

      export interface GetDeletedKernelResponse {
        defaultDatasourceImageUrl?: /* google.protobuf.StringValue */ string | null;
        defaultUserImageUrl?: /* google.protobuf.StringValue */ string | null;
        deletedKernelUrl?: /* google.protobuf.StringValue */ string | null;
        topicId?: /* google.protobuf.Int32Value */ number | null;
        commentCount: number;
        userCanDownvoteComments: boolean;
      }

      export interface GetFirebaseAuthTokenRequest {}

      export interface GetFirebaseAuthTokenResponse {
        authToken: string;
      }

      export interface GetFirebaseConfigRequest {}

      export interface GetFirebaseConfigResponse {
        apiKey: string;
        authDomain: string;
        databaseUrl: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
        proxyDomain: string;
      }

      export interface GetKernelCategoryIdsRequest {
        kernelId: number;
      }

      export interface GetKernelCollaboratorListRequest {
        kernelId: number;
      }

      export interface GetKernelCollaboratorListResponse {
        collaboratorList: Kaggle.Sdk.Users.CollaboratorList;
        errorMessage?: /* google.protobuf.StringValue */ string;
      }

      export interface GetKernelEmbedResponse {
        ipynbContent?: /* google.protobuf.StringValue */ string | null;
        renderedOutputUrl?: /* google.protobuf.StringValue */ string | null;
        viewerUrl: string;
      }

      export interface GetKernelLandingPageRequest {}

      export interface GetKernelLandingPageResponse {
        shelves: Kaggle.Sdk.Kernels.KernelShelf[];
        totalPublicKernels: number;
      }

      export interface GetKernelListDetailsRequest {
        kernelIds: number[];
        unauthorizedAccessBehavior: Kaggle.Sdk.Kernels.AccessBehavior;
        deletedAccessBehavior: Kaggle.Sdk.Kernels.AccessBehavior;
        // The following 5 fields are for controlling output file responses
        excludeResultsFilesOutputs: boolean;
        wantOutputFiles: boolean;
        outputFileTypes: string[];
        maxOutputFilesPerKernel?: /* google.protobuf.Int32Value */ number | null;
        gcsTimeoutMs?: /* google.protobuf.Int32Value */ number | null;
        readMask: google.protobuf.FieldMask | null;
      }

      export interface GetKernelRequest {
        kernelId?: /* google.protobuf.Int32Value */ number | null;
        // TODO(aagundez): Switch to just `KernelId` when finished migrating.
        username?: /* google.protobuf.StringValue */ string | null;
        slug?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetKernelRunSourceRequest {
        kernelRunId: number;
        includeOutputIfAvailable: boolean;
      }

      export interface GetKernelRunSourceResponse {
        source: string;
      }

      export interface GetKernelSessionDataSourcesRequest {
        kernelSessionId: number;
        includeOutputFiles: boolean;
        hierarchicalOutputFiles: boolean;
      }

      export interface GetKernelSessionDataSourcesResponse {
        dataSources: Kaggle.Sdk.Datasets.Databundles.DataSource[];
      }

      export interface GetKernelStatusRequest {
        kernelSessionId: number;
        existingStatus?: Kaggle.Sdk.Kernels.KernelWorkerStatus;
      }

      export interface GetKernelStatusResponse {
        status: Kaggle.Sdk.Kernels.KernelWorkerStatus;
      }

      export interface GetKernelVersionRequest {
        kernelSessionId: number;
      }

      export interface GetKernelVersionResponse {
        kernelVersionAndRun: Kaggle.Sdk.Kernels.KernelVersionAndRun | null;
      }

      export interface GetKernelViewModelResponse {
        redirectUrl?: /* google.protobuf.StringValue */ string | null;
        /*[NotNull]*/
        kernel: Kaggle.Sdk.Kernels.Kernel;
        kernelBlob: Kaggle.Sdk.Kernels.KernelBlob | null;
        /*[NotNull]*/
        kernelRun: Kaggle.Sdk.Kernels.KernelRun;
        author: Kaggle.Sdk.Users.User | null;
        baseUrl?: /* google.protobuf.StringValue */ string | null;
        /*[NotNull]*/
        collaborators: Kaggle.Sdk.Users.CollaboratorList;
        initialTab?: /* google.protobuf.StringValue */ string | null;
        log?: /* google.protobuf.StringValue */ string | null;
        outputFiles: Kaggle.Sdk.Kernels.KernelSessionOutputFile[];
        ouputFilesOwnerInfo: Kaggle.Sdk.Datasets.Databundles.DatabundleOwnerInfo | null;
        pageMessages: Kaggle.Sdk.Common.PageMessage[];
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
        renderableDataSources: Kaggle.Sdk.Kernels.DataSource[];
        versions: Kaggle.Sdk.Kernels.KernelVersionHistory[];
        categories: Kaggle.Sdk.Tags.TagList | null;
        downloadAllFilesUrl?: /* google.protobuf.StringValue */ string | null;
        submission: Kaggle.Sdk.Kernels.KernelSubmission | null;
        bestSubmissionScore: Kaggle.Sdk.Kernels.KernelSessionScore | null;
        latestSubmissionScore: Kaggle.Sdk.Kernels.KernelSessionScore | null;
        menuLinks: Kaggle.Sdk.Kernels.LinkModel[];
        rightMenuLinks: Kaggle.Sdk.Kernels.LinkModel[];
        callToAction: Kaggle.Sdk.Kernels.LinkModel | null;
        voteButton: Kaggle.Sdk.Common.VoteButton | null;
        canWrite: boolean;
        canAdminister: boolean;
        currentUserForkParentSessionId?: /* google.protobuf.Int32Value */ number | null;
        currentUserHasForked: boolean;
        forkParentIsRedacted: boolean;
        forkDiffLinesChanged: number;
        forkDiffLinesDeleted: number;
        forkDiffLinesInserted: number;
        forkDiffUrl?: /* google.protobuf.StringValue */ string | null;
        forkParentAuthorDisplayName?: /* google.protobuf.StringValue */ string | null;
        forkParentAuthorUrl?: /* google.protobuf.StringValue */ string | null;
        forkParentTitle?: /* google.protobuf.StringValue */ string | null;
        forkParentUrl?: /* google.protobuf.StringValue */ string | null;
        simplifiedViewer: boolean;
        kernelOutputDataset: Kaggle.Sdk.Datasets.KernelOutputDatasetReference | null;
        disableComments: boolean;
        taskSubmissionInfo: Kaggle.Sdk.Datasets.KernelTaskSubmissionInfo | null;
        learnSeriesNavigationData: Kaggle.Sdk.Education.LearnSeriesNavigationData | null;
        showSharingControls: boolean;
        showUnchangedCopyWarning: boolean;
        moderationStatus: Kaggle.Sdk.Abuse.PrivatedModerationStatus;
        isReportedBannerDismissed: boolean;
        // TODO(b/206535084): DEPRECATED: These are only used by classic viewer client code and should be removed when we
        // delete the unused FE code. 
        parentName?: /* google.protobuf.StringValue */ string | null;
        parentUrl?: /* google.protobuf.StringValue */ string | null;
        thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetOrCreateKernelSessionRequest {
        kernelId: number;
      }

      export interface GetOrCreateKernelSessionResponse {
        draft: Kaggle.Sdk.Kernels.KernelDraft | null;
        sessionId?: /* google.protobuf.Int32Value */ number | null;
        sessionTimeoutSeconds: number;
        sessionCreationFailureMessage?: /* google.protobuf.StringValue */ string | null;
        unusedAcceleratorRemoved?: Kaggle.Sdk.Kernels.AcceleratorType;
        hasMoreRecentCollaboratorVersion: boolean;
        // Set when the user forks a kernel from a paid tier, but is itself on the free tier
        // (only during first edit after the fork).
        kernelForkedFromPaidTierWarning: boolean;
        sessionStatus?: Kaggle.Sdk.Kernels.KernelWorkerStatus;
      }

      export interface GetScheduledKernelSessionRequest {
        kernelId: number;
      }

      export interface GetSourceIndexDataRequest {
        continuationToken?: /* google.protobuf.StringValue */ string | null;
        maxReferencesToReturn: number;
        maxSnippetsPerReference: number;
        referent?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetSourceIndexDataResponse {
        referent?: /* google.protobuf.StringValue */ string | null;
        continuationToken?: /* google.protobuf.StringValue */ string | null;
        definition: Kaggle.Sdk.Kernels.SourceIndexReference | null;
        references: Kaggle.Sdk.Kernels.SourceIndexReference[];
      }

      export interface GetUserKernelAchievementsRequest {
        userId: number;
      }

      export interface GetUserKernelAchievementsResponse {
        totalUpvotes: number;
        totalKernels: number;
        totalForks: number;
      }

      export interface GithubBranchInfo {
        // The name of the branch. e.g. "master".
        name: string;
      }

      export interface GithubFileInfo {
        // The owner of the repo. e.g. "Kaggle".
        owner: string;
        // The name of the repo. e.g. "docker-python".
        repo: string;
        // The path of the file. e.g. "README.md", "directory/foo.txt" relative to the root of the repo.
        path: string;
        // The name of the commit/branch/tag
        ref: string;
        // The URL pointing to the raw file. e.g. "https://raw.githubusercontent.com/Kaggle/docker-python/master/Dockerfile".
        rawUrl: string;
      }

      export interface GithubRepositoryInfo {
        // The owner of the repo. e.g. "Kaggle".
        owner: string;
        // The name of the repo. e.g. "docker-python".
        name: string;
        // The default branch of the repo. e.g. "master".
        defaultBranch: string;
      }

      export interface HasAcceptedKernelCompetitionRulesRequest {
        kernelSessionId: number;
      }

      export interface HasAcceptedKernelCompetitionRulesResponse {
        competitionsRequiringAcceptance: Kaggle.Sdk.Kernels.KernelCompetition[];
      }

      export interface IndexAllSnippetsRequest {}

      export interface IndexAllSnippetsResponse {
        numberOfSnippetsToIndex: number;
        searchIndexResult?: Kaggle.Sdk.Search.Protos.IndexSnippetResponse | null;
      }

      export interface Kernel {
        id: number;
        title?: /* google.protobuf.StringValue */ string | null;
        forkParent: Kaggle.Sdk.Kernels.KernelForkInfo | null;
        currentRunId?: /* google.protobuf.Int32Value */ number | null;
        mostRecentRunId?: /* google.protobuf.Int32Value */ number | null;
        url?: /* google.protobuf.StringValue */ string | null;
        tags: Kaggle.Sdk.Kernels.Tag[];
        commentCount: number;
        upvoteCount: number;
        viewCount: number;
        forkCount: number;
        bestPublicScore?: /* google.protobuf.DoubleValue */ number | null;
        author: Kaggle.Sdk.Users.User | null;
        isPrivate: boolean;
        updatedTime: /* google.protobuf.Timestamp */ string | null;
        selfLink?: /* google.protobuf.StringValue */ string | null;
        pinnedDockerImageVersionId?: /* google.protobuf.Int32Value */ number | null;
        dockerImagePinningType: Kaggle.Sdk.Kernels.DockerImagePinningType;
        originalDockerImageId?: /* google.protobuf.Int32Value */ number | null;
        isLanguageTemplate: boolean;
        medal: Kaggle.Sdk.Users.Medal;
        topicId?: /* google.protobuf.Int32Value */ number | null;
        readGroupId?: /* google.protobuf.Int32Value */ number | null;
        writeGroupId?: /* google.protobuf.Int32Value */ number | null;
        slug?: /* google.protobuf.StringValue */ string | null;
        hasUsedAccelerator?: /* google.protobuf.BoolValue */ boolean | null;
        pinnedSessionId?: /* google.protobuf.Int32Value */ number | null;
        disableComments: boolean;
        // Whether or not any child KernelSession was used to make a successful Competition Submission
        hasLinkedSubmission: boolean;
        // Whether or not the current user has bookmarked this notebook
        currentUserHasBookmarked: boolean;
        dateOutputToDatasetEnabled: /* google.protobuf.Timestamp */ string | null;
      }

      export interface KernelBlob {
        id: number;
        settings: Kaggle.Sdk.Kernels.KernelBlobSettings | null;
        source?: /* google.protobuf.StringValue */ string | null;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
      }

      export interface KernelBlobSettings {
        dockerImageVersionId?: /* google.protobuf.Int32Value */ number | null;
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
        sourceType: Kaggle.Sdk.Kernels.EditorType;
        language: Kaggle.Sdk.Kernels.Language;
        accelerator: Kaggle.Sdk.Kernels.AcceleratorType;
        isInternetEnabled: boolean;
        // This property is deprecated and only used for backwards compatibility. Use Accelerator instead.
        // TODO(vimota) Remove this once sufficient time has passed that there are no reruns using the old property.
        isGpuEnabled: boolean;
      }

      export interface KernelCategoryIdList {
        // This is the total number of categories that match the specified filters, even
        // though "category_ids" below will contain only a single page of results.
        totalCount?: /* google.protobuf.Int32Value */ number | null;
        categoryIds: number[];
      }

      export interface KernelCompetition {
        competitionId: number;
        title: string;
        rulesUrl: string;
      }

      export interface KernelDataSourceListItemDto {
        kernelId: number;
        sourceType: Kaggle.Sdk.Kernels.LegacyDataSourceType;
        sourceId: number;
        description?: /* google.protobuf.StringValue */ string | null;
        siteName?: /* google.protobuf.StringValue */ string | null;
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
      }

      export interface KernelDiff {
        linesInserted: number;
        linesDeleted: number;
        linesChanged: number;
        linesUnchanged: number;
        newTotalLines: number;
      }

      export interface KernelDraft {
        sequence: number;
        kernelVersionId: number;
        parentKernelVersionId?: /* google.protobuf.Int32Value */ number | null;
        blob: Kaggle.Sdk.Kernels.KernelBlob | null;
        hasMoreRecentCollaboratorVersion: boolean;
      }

      export interface KernelForkInfo {
        kernelId: number;
        runId: number;
        url?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        author: Kaggle.Sdk.Users.User | null;
        diff: Kaggle.Sdk.Kernels.KernelDiff | null;
        isRedacted: boolean;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
        workerStatus: Kaggle.Sdk.Kernels.KernelWorkerStatus;
        isolatorResults?: /* google.protobuf.StringValue */ string | null;
        languageId?: /* google.protobuf.Int32Value */ number | null;
        versionType: Kaggle.Sdk.Kernels.KernelVersionType;
        isPrivate: boolean;
        isFork: boolean;
      }

      export interface KernelList {
        // This is the total number of kernels that match the specified filters, even
        // though the Kernels IEnumerable below will contain only a single page of results.
        totalCount?: /* google.protobuf.Int32Value */ number | null;
        kernels: Kaggle.Sdk.Kernels.KernelListItem[];
      }

      export interface KernelListItem {
        author: Kaggle.Sdk.Users.User | null;
        currentUserHasVotedForThisScript: boolean;
        dataSources: Kaggle.Sdk.Kernels.DataSource[];
        forkDiffLinesChanged: number;
        forkDiffLinesDeleted: number;
        forkDiffLinesInserted: number;
        forkDiffUrl?: /* google.protobuf.StringValue */ string | null;
        hasCollaborators: boolean;
        id: number;
        scriptVersionId?: /* google.protobuf.Int32Value */ number | null;
        isFork: boolean;
        isPrivate: boolean;
        languageName?: /* google.protobuf.StringValue */ string | null;
        aceLanguageName?: /* google.protobuf.StringValue */ string | null;
        isNotebook: boolean;
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        isGpuEnabled: boolean;
        bestPublicScore?: /* google.protobuf.DoubleValue */ number | null;
        forumTopicId?: /* google.protobuf.Int32Value */ number | null;
        lastRunExecutionTimeSeconds?: /* google.protobuf.Int32Value */ number | null;
        medal: Kaggle.Sdk.Users.Medal;
        categories: Kaggle.Sdk.Common.Category[];
        title?: /* google.protobuf.StringValue */ string | null;
        totalComments: number;
        totalForks: number;
        totalScripts: number;
        totalViews: number;
        totalVotes: number;
        totalLines: number;
        currentUserHasBookmarked: boolean;
        isRunning: boolean;
        isDeleted: boolean;
        isMyUncommittedDraft: boolean;
        currentUrlSlug?: /* google.protobuf.StringValue */ string | null;
        scriptVersionDateCreated: /* google.protobuf.Timestamp */ string | null;
        dateEvaluated: /* google.protobuf.Timestamp */ string | null;
        outputFiles: Kaggle.Sdk.Kernels.KernelSessionOutputFile[];
        canCurrentUserDeleteKernel: boolean;
        canCurrentUserEditKernel: boolean;
        // Whether or not any child KernelSession was used to make a successful Competition Submission
        hasLinkedSubmission: boolean;
        disableComments: boolean;
        taskSubmissionInfo: Kaggle.Sdk.Datasets.KernelTaskSubmissionInfo | null;
        forkParentInfo: Kaggle.Sdk.Kernels.ForkParentInfo | null;
        cardImageUrl?: /* google.protobuf.StringValue */ string | null;
        dateOutputToDatasetEnabled: /* google.protobuf.Timestamp */ string | null;
        lastRunTime: /* DateTime */ string;
        scriptUrl: string | null;
        scriptCommentsUrl: string | null;
        scriptInputUrl: string | null;
        scriptEditUrl: string | null;
      }

      export interface KernelRun {
        id: number;
        kernelId: number;
        status: Kaggle.Sdk.Kernels.KernelWorkerStatus;
        kernelVersionType: Kaggle.Sdk.Kernels.KernelVersionType;
        sourceType: Kaggle.Sdk.Kernels.EditorType;
        language: Kaggle.Sdk.Kernels.Language;
        title?: /* google.protobuf.StringValue */ string | null;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
        dateEvaluated: /* google.protobuf.Timestamp */ string | null;
        dateCancelled: /* google.protobuf.Timestamp */ string | null;
        workerContainerPort?: /* google.protobuf.Int32Value */ number | null;
        workerUptimeSeconds?: /* google.protobuf.Int32Value */ number | null;
        workerIpAddress?: /* google.protobuf.StringValue */ string | null;
        workerIpAddressExternal?: /* google.protobuf.StringValue */ string | null;
        // TODO(bergam): Remove these once we're no longer using them in ScriptsController.EditScript.
        scriptLanguageId: number;
        scriptLanguageName?: /* google.protobuf.StringValue */ string | null;
        renderedOutputUrl?: /* google.protobuf.StringValue */ string | null;
        commit: Kaggle.Sdk.Kernels.KernelBlob | null;
        resources: Kaggle.Sdk.Kernels.KernelSessionResources | null;
        isolatorResults?: /* google.protobuf.StringValue */ string | null;
        runInfo: Kaggle.Sdk.Kernels.KernelSessionInfo | null;
        dockerImageVersionId?: /* google.protobuf.Int32Value */ number | null;
        usedCustomDockerImage: boolean;
        // This is the list of DataSources used by the KernelSession as pulled from the
        // KernelSession[Competition|Dataset|Script]Sources tables.  Note that there is an alternative list
        // within Commit.Settings which may differ.  The results here hopefully more accurately represent
        // which versions were used by the KernelSession, whereas Commit.Settings better reflects what the caller
        // had requested.
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
        useNewKernelsBackend?: /* google.protobuf.BoolValue */ boolean | null;
        isGpuEnabled: boolean;
        isTpuEnabled: boolean;
        acceleratorType: Kaggle.Sdk.Kernels.AcceleratorType;
        isInternetEnabled: boolean;
        userPlan: Kaggle.Sdk.Users.UserPlan;
        executedByScheduleId?: /* google.protobuf.Int32Value */ number | null;
        nextScheduledSessionDate: /* google.protobuf.Timestamp */ string | null;
        isKernelScheduled: boolean;
      }

      export interface KernelRunLog {
        lineNumber: number;
        elapsedSeconds: number;
        content?: /* google.protobuf.StringValue */ string | null;
        streamName: Kaggle.Sdk.Kernels.StreamName;
      }
      // Represents a flattening of Kernel Version / Kernel Run entities for a running session. Primarily used in client.
      export interface KernelSession {
        kernelId: number;
        kernelRunId: number;
        type: Kaggle.Sdk.Kernels.KernelVersionType;
        sourceType: Kaggle.Sdk.Kernels.EditorType;
        title?: /* google.protobuf.StringValue */ string | null;
        dateCreated: /* google.protobuf.Timestamp */ string | null;
        languageName?: /* google.protobuf.StringValue */ string | null;
        accelerator: Kaggle.Sdk.Kernels.AcceleratorType;
        isInternetEnabled: boolean;
        versionNumber?: /* google.protobuf.Int32Value */ number | null;
        versionName?: /* google.protobuf.StringValue */ string | null;
      }
      // This class is serialized to XML and saved in the KernelSessions table's IsolatorResults column.
      // If you make a change (add a field, remove a field) here, also change the serializer/deserializer
      // in "Kaggle.Service.Kernels/Utils/IsolatorResults.cs".
      export interface KernelSessionInfo {
        dockerfileUrl?: /* google.protobuf.StringValue */ string | null;
        // This url now points to Google Container Registry (gcr.io).
        dockerHubUrl?: /* google.protobuf.StringValue */ string | null;
        dockerImageDigest?: /* google.protobuf.StringValue */ string | null;
        dockerImageId?: /* google.protobuf.StringValue */ string | null;
        dockerImageName?: /* google.protobuf.StringValue */ string | null;
        diskKbFree?: /* google.protobuf.Int32Value */ number | null;
        failureMessage?: /* google.protobuf.StringValue */ string | null;
        exitCode: number;
        queuedSeconds?: /* google.protobuf.Int32Value */ number | null;
        outputSizeBytes?: /* google.protobuf.Int64Value */ number | null;
        runTimeSeconds: number;
        usedAllSpace: boolean;
        timeoutExceeded: boolean;
        isValidStatus?: /* google.protobuf.BoolValue */ boolean | null;
        wasGpuEnabled?: /* google.protobuf.BoolValue */ boolean | null;
        wasInternetEnabled?: /* google.protobuf.BoolValue */ boolean | null;
        outOfMemory: boolean;
        invalidPathErrors: boolean;
        succeeded: boolean;
        wasKilled: boolean;
      }
      // A list of running kernel sessions that are currently counting against user quota.
      export interface KernelSessionList {
        totalCount: number;
        /*[NotNull]*/
        quotaLimits: Kaggle.Sdk.Kernels.KernelSessionQuotaLimits;
        sessions: Kaggle.Sdk.Kernels.KernelSession[];
      }

      export interface KernelSessionOutputFile {
        kernelSessionId: number;
        kernelId: number;
        name?: /* google.protobuf.StringValue */ string | null;
        contentLength: number;
        fullPath?: /* google.protobuf.StringValue */ string | null;
        downloadUrl?: /* google.protobuf.StringValue */ string | null;
        fileType?: /* google.protobuf.StringValue */ string | null;
      }
      // Represents the maximum Kernel session quota limits for the current user.
      export interface KernelSessionQuotaLimits {
        gpuInteractive: number;
        gpuBatch: number;
        cpuInteractive: number;
        cpuBatch: number;
        tpuInteractive: number;
        tpuBatch: number;
      }
      // Describes resource limits for kernel requests.
      export interface KernelSessionResources {
        storageBytes: number;
        memoryBytes: number;
        cpuCores: number;
        sessionTimeoutSeconds: number;
        idleTimeoutSeconds: number;
        // For enabling or disabling internet access. Should be "external" or "no-external".
        network?: /* google.protobuf.StringValue */ string | null;
      }

      export interface KernelSessionScore {
        score: number;
        kernelVersionName?: /* google.protobuf.StringValue */ string | null;
        kernelVersionNumber: number;
        kernelSessionUrl: string;
      }

      export interface KernelShelf {
        kernels: Kaggle.Sdk.Kernels.KernelListItem[];
        label?: /* google.protobuf.StringValue */ string | null;
        totalKernels: number;
        moreKernelsRequest: Kaggle.Sdk.Kernels.ListKernelIdsRequest | null;
      }

      export interface KernelSubmission {
        date: /* google.protobuf.Timestamp */ string | null;
        privateScore?: /* google.protobuf.StringValue */ string | null;
        publicScore?: /* google.protobuf.StringValue */ string | null;
        submissionId: number;
        teamName?: /* google.protobuf.StringValue */ string | null;
        status: number;
      }

      export interface KernelVersion {
        id: number;
        versionNumber: number;
        linesTotal: number;
        linesInserted: number;
        linesDeleted: number;
        pinningType: Kaggle.Sdk.Kernels.KernelVersionPinningType;
        versionName?: /* google.protobuf.StringValue */ string | null;
        versionType: Kaggle.Sdk.Kernels.KernelVersionType;
        userPlan: Kaggle.Sdk.Users.UserPlan;
      }

      export interface KernelVersionAndRun {
        author: Kaggle.Sdk.Users.User | null;
        version: Kaggle.Sdk.Kernels.KernelVersion | null;
        run: Kaggle.Sdk.Kernels.KernelRun | null;
        blob: Kaggle.Sdk.Kernels.KernelBlob | null;
        isForkParent: boolean;
        currentUrlSlug?: /* google.protobuf.StringValue */ string | null;
        kernelAuthorUserName?: /* google.protobuf.StringValue */ string | null;
        // Falling back to session id = 0 takes the user to the current version.
        viewerUrl: string | null;
      }

      export interface KernelVersionHistory {
        id: number;
        isForkParent: boolean;
        isNotebook: boolean;
        languageName?: /* google.protobuf.StringValue */ string | null;
        lastRunTime: /* google.protobuf.Timestamp */ string | null;
        linesChangedFromPrevious: number;
        linesDeletedFromPrevious: number;
        linesInsertedFromPrevious: number;
        outputFilesTotalSizeBytes: number;
        runInfo: Kaggle.Sdk.Kernels.KernelVersionRunInfo | null;
        status: Kaggle.Sdk.Kernels.KernelWorkerStatus;
        title?: /* google.protobuf.StringValue */ string | null;
        url: string;
        versionNumber: number;
        hasVersionNumber: boolean;
        isRedacted: boolean;
        versionAuthor: Kaggle.Sdk.Users.User | null;
        versionType: Kaggle.Sdk.Kernels.KernelVersionType;
        userPlan: Kaggle.Sdk.Users.UserPlan;
      }
      // NOTE: This model only works until we move away from the 1:1 relationship for Version:Run.
      export interface KernelVersionList {
        items: Kaggle.Sdk.Kernels.KernelVersionAndRun[];
      }

      export interface KernelVersionRunInfo {
        dockerfileUrl?: /* google.protobuf.StringValue */ string | null;
        dockerHubUrl?: /* google.protobuf.StringValue */ string | null;
        dockerImageId?: /* google.protobuf.StringValue */ string | null;
        dockerImageName?: /* google.protobuf.StringValue */ string | null;
        exitCode: number;
        failureMessage?: /* google.protobuf.StringValue */ string | null;
        isValidStatus: boolean;
        runTimeSeconds?: /* google.protobuf.DoubleValue */ number | null;
        succeeded: boolean;
        timeoutExceeded: boolean;
        usedAllSpace?: /* google.protobuf.BoolValue */ boolean | null;
      }

      export interface LinkModel {
        count?: /* google.protobuf.Int32Value */ number | null;
        href?: /* google.protobuf.StringValue */ string | null;
        reportEventCategory?: /* google.protobuf.StringValue */ string | null;
        reportEventType?: /* google.protobuf.StringValue */ string | null;
        showZeroCountExplicitly: boolean;
        showOnMobile?: /* google.protobuf.BoolValue */ boolean | null;
        tab?: /* google.protobuf.StringValue */ string | null;
        text?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListDockerImagesRequest {
        kernelSessionId: number;
      }

      export interface ListGithubRepositoriesRequest {
        // Free form search query term.
        query?: /* google.protobuf.StringValue */ string | null;
        // Page index, starts at 0.
        page?: /* google.protobuf.Int32Value */ number | null;
        // Results to include per page.
        perPage?: /* google.protobuf.Int32Value */ number | null;
        // Include private results.
        // If the user doesn't have a GitHub OAuth access token, only public results are returned.
        includePrivate: boolean;
      }

      export interface ListGithubRepositoriesResponse {
        repositories: Kaggle.Sdk.Kernels.GithubRepositoryInfo[];
      }

      export interface ListGithubRepositoryBranchesRequest {
        // The owner of the repo. e.g. "Kaggle".
        owner: string;
        // The name of the repo. e.g. "docker-python".
        name: string;
        // Include private results.
        // If the user doesn't have a GitHub OAuth access token, only public results are returned.
        includePrivate: boolean;
      }

      export interface ListGithubRepositoryBranchesResponse {
        branches: Kaggle.Sdk.Kernels.GithubBranchInfo[];
      }

      export interface ListGithubRepositoryFilesRequest {
        // The owner of the repo. e.g. "Kaggle".
        owner?: /* google.protobuf.StringValue */ string | null;
        // The name of the repo. e.g. "docker-python".
        name?: /* google.protobuf.StringValue */ string | null;
        // The name of the branch. e.g. "master".
        branch?: /* google.protobuf.StringValue */ string | null;
        // Extensions (including the period ".") to filter by. If empty, return all files.
        fileExtensionFilter: /* google.protobuf.StringValue */ string[];
        // Include private results.
        // If the user doesn't have a GitHub OAuth access token, only public results are returned.
        includePrivate: boolean;
      }

      export interface ListGithubRepositoryFilesResponse {
        files: Kaggle.Sdk.Kernels.GithubFileInfo[];
      }

      export interface ListKernelIdsRequest {
        after?: /* google.protobuf.Int32Value */ number | null;
        competitionId?: /* google.protobuf.Int32Value */ number | null;
        datasetId?: /* google.protobuf.Int32Value */ number | null;
        datasourceType?: /* google.protobuf.StringValue */ string | null;
        forkParentScriptId?: /* google.protobuf.Int32Value */ number | null;
        group: Kaggle.Sdk.Kernels.KernelsListViewType;
        kernelType?: /* google.protobuf.StringValue */ string | null;
        language?: /* google.protobuf.StringValue */ string | null;
        outputType?: /* google.protobuf.StringValue */ string | null;
        excludeResultsFilesOutputs: boolean;
        page: number;
        pageSize: number;
        sortBy: Kaggle.Sdk.Kernels.KernelsListSortType;
        userId?: /* google.protobuf.Int32Value */ number | null;
        // SmartList can't handle int[], so we use a comma-delimited string of ints.
        tagIds?: /* google.protobuf.StringValue */ string | null;
        wantOutputFiles: boolean;
        hasGpuRun?: /* google.protobuf.BoolValue */ boolean | null;
        // Whether to return public, private kernels or both. Ignored if Group != (Profile or Collaboration).
        privacy?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListKernelIdsResponse {
        kernelIds: number[];
      }

      export interface ListKernelRunLogsRequest {
        kernelRunId: number;
      }

      export interface ListKernelRunLogsResponse {
        logs: Kaggle.Sdk.Kernels.KernelRunLog[];
      }

      export interface ListKernelSessionOutputFilesHierarchicalRequest {
        /*[NotNull]*/
        kernelSessionId: number;
        relativePath?: /* google.protobuf.StringValue */ string | null;
        offset?: /* google.protobuf.StringValue */ string | null;
        maxResults: number;
      }

      export interface ListKernelSessionOutputFilesHierarchicalResponse {
        directories: Kaggle.Sdk.Datasets.Databundles.Directory[];
        files: Kaggle.Sdk.Datasets.Databundles.File[];
        nextPageToken?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListKernelSessionOutputRequest {
        kernelSessionId: number;
        pageSize?: /* google.protobuf.Int32Value */ number | null;
        pageToken?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListKernelSessionOutputResponse {
        items: Kaggle.Sdk.Kernels.KernelSessionOutputFile[];
        nextPageToken?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListKernelSessionsRequest {}

      export interface ListKernelsRequest {
        kernelFilterCriteria: Kaggle.Sdk.Kernels.SearchKernelIdsRequest | null;
        detailFilterCriteria: Kaggle.Sdk.Kernels.GetKernelListDetailsRequest | null;
      }

      export interface ListKernelVersionsRequest {
        kernelId: number;
      }

      export interface ListSnippetsRequest {
        query?: /* google.protobuf.StringValue */ string | null;
        languageName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListSnippetsResponse {
        snippets: Kaggle.Sdk.Kernels.Snippet[];
      }

      export interface ParentKernelVersionData {
        kernelVersionId: number;
        copyAndEditUrl?: /* google.protobuf.StringValue */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        viewUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface PromoteKernelDraftRequest {
        kernelId: number;
        kernelVersionId: number;
        newSourceType: Kaggle.Sdk.Kernels.EditorType;
        newSource?: /* google.protobuf.StringValue */ string | null;
        versionName?: /* google.protobuf.StringValue */ string | null;
        versionType: Kaggle.Sdk.Kernels.KernelVersionType;
      }

      export interface PromoteKernelDraftResponse {
        versionId: number;
        versionNumber: number;
        diff: Kaggle.Sdk.Kernels.KernelDiff | null;
        forkParentDiff: Kaggle.Sdk.Kernels.KernelDiff | null;
      }

      export interface RemoveKernelCategoryRequest {
        kernelId: number;
        categoryId: number;
      }

      export interface RunEpisodeRequest {
        competitionId: number;
        episodeId: number;
        environment?: /* google.protobuf.StringValue */ string | null;
        episodeType: Kaggle.Sdk.Competitions.EpisodeType;
        agents: Kaggle.Sdk.Kernels.AgentEntry[];
        configuration?: /* google.protobuf.StringValue */ string | null;
        renderType: Kaggle.Sdk.Competitions.EnvironmentRenderType;
        dockerImageNameOverride?: /* google.protobuf.StringValue */ string | null;
        poolNameOverride?: /* google.protobuf.StringValue */ string | null;
      }

      export interface RunEpisodeResponse {
        episode?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ScheduledKernelSession {
        // ID of the scheduling.
        id: number;
        // ID of the kernel which is being scheduled.
        kernelId: number;
        // Timestamp of the creation of the scheduling.
        creationDate: /* google.protobuf.Timestamp */ string | null;
        // Timestamp after which the first scheduled run will be triggered.
        startDate: /* google.protobuf.Timestamp */ string | null;
        // Timestamp when this schedule was last executed.
        lastSessionDate: /* google.protobuf.Timestamp */ string | null;
        // How often to execute the notebook.
        // SCHEDULED_TIME only.
        frequency: Kaggle.Sdk.Kernels.ScheduleFrequencyType;
        // Number of times this schedule should be repeated.
        // SCHEDULED_TIME only.
        iterations: number;
        // Number of times this schedule has been run already.
        iteration: number;
        // Determines what triggers this kernel to be run.
        trigger: Kaggle.Sdk.Kernels.ScheduleTriggerType;
      }

      export interface ScheduleKernelSessionRequest {
        // ID of the kernel which is being scheduled.
        kernelId: number;
        // Determines what triggers this kernel to be run.
        trigger: Kaggle.Sdk.Kernels.ScheduleTriggerType;
        // How often to execute the notebook.
        // SCHEDULED_TIME only.
        frequency: Kaggle.Sdk.Kernels.ScheduleFrequencyType;
        // Timestamp after which the first scheduled run will be triggered.
        startDate: /* google.protobuf.Timestamp */ string | null;
        // Number of times this schedule should be repeated.
        // SCHEDULED_TIME only.
        iterations: number;
      }

      export interface SearchKernelIdsRequest {
        search?: /* google.protobuf.StringValue */ string | null;
        listRequest: Kaggle.Sdk.Kernels.ListKernelIdsRequest | null;
        // Temporarily duplicated from ListKernelIdsRequest for a smooth transition.
        // TODO(b/198457499): Move a few days after this is on production.
        after?: /* google.protobuf.Int32Value */ number | null;
        competitionId?: /* google.protobuf.Int32Value */ number | null;
        datasetId?: /* google.protobuf.Int32Value */ number | null;
        datasourceType?: /* google.protobuf.StringValue */ string | null;
        forkParentScriptId?: /* google.protobuf.Int32Value */ number | null;
        group: Kaggle.Sdk.Kernels.KernelsListViewType;
        kernelType?: /* google.protobuf.StringValue */ string | null;
        language?: /* google.protobuf.StringValue */ string | null;
        outputType?: /* google.protobuf.StringValue */ string | null;
        excludeResultsFilesOutputs: boolean;
        page: number;
        pageSize: number;
        sortBy: Kaggle.Sdk.Kernels.KernelsListSortType;
        userId?: /* google.protobuf.Int32Value */ number | null;
        // SmartList can't handle int[], so we use a comma-delimited string of ints.
        tagIds?: /* google.protobuf.StringValue */ string | null;
        wantOutputFiles: boolean;
        hasGpuRun?: /* google.protobuf.BoolValue */ boolean | null;
        // Whether to return public, private kernels or both. Ignored if Group != (Profile or Collaboration).
        privacy?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SearchKernelIdsResponse {
        kernelIds: number[];
      }

      export interface Snippet {
        id: number;
        title?: /* google.protobuf.StringValue */ string | null;
        authorUserId: number;
        tags?: /* google.protobuf.StringValue */ string | null;
        content?: /* google.protobuf.StringValue */ string | null;
        languageName?: /* google.protobuf.StringValue */ string | null;
        isPrivate?: /* google.protobuf.BoolValue */ boolean | null;
      }

      export interface SnippetData {
        title?: /* google.protobuf.StringValue */ string | null;
        tags?: /* google.protobuf.StringValue */ string | null;
        content?: /* google.protobuf.StringValue */ string | null;
        languageName?: /* google.protobuf.StringValue */ string | null;
        isPrivate: boolean;
      }

      export interface SnippetReference {
        snippetText?: /* google.protobuf.StringValue */ string | null;
        lineNumber: number;
      }

      export interface SourceIndexReference {
        kernelId: number;
        kernelRunId: number;
        // Author information
        authorDisplayName?: /* google.protobuf.StringValue */ string | null;
        authorProfileUrl?: /* google.protobuf.StringValue */ string | null;
        authorThumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        // Kernel information
        dataSources: Kaggle.Sdk.Kernels.DataSource[];
        dateEvaluated: /* google.protobuf.Timestamp */ string | null;
        title?: /* google.protobuf.StringValue */ string | null;
        totalVotes: number;
        url?: /* google.protobuf.StringValue */ string | null;
        // Snippet information
        definitions: Kaggle.Sdk.Kernels.SnippetReference[];
        snippets: Kaggle.Sdk.Kernels.SnippetReference[];
        totalSnippetCount: number;
      }
      // The list of file names which are checked in order for a valid submission file.
      // This field requires a list as simulation competitions allow multiple different file names.
      export interface SubmissionRequestedDetails {
        fileNames: /* google.protobuf.StringValue */ string[];
        description?: /* google.protobuf.StringValue */ string | null;
      }

      export interface Tag {
        name?: /* google.protobuf.StringValue */ string | null;
        slug?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdateDataSourceResult {
        // Data source reference passed to UpdateKernelRunDataSourcesRequest.
        /*[NotNull]*/
        reference: Kaggle.Sdk.Kernels.DataSourceReference;
        // The version that was mounted to the kernel before calling UpdateKernelRunDataSources.
        /*[NotNull]*/
        mountedVersion: Kaggle.Sdk.Kernels.DataSourceVersion;
        // The new/latest version to which the data source is upgraded.
        newVersion: Kaggle.Sdk.Kernels.DataSourceVersion | null;
      }

      export interface UpdateDefaultSessionSettingsRequest {
        kernelId: number;
        settings: Kaggle.Sdk.Kernels.DefaultSessionSettings | null;
      }

      export interface UpdateDockerImageVersionRequest {
        scriptId: number;
        dockerImageVersionId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface UpdateDockerPinningTypeRequest {
        kernelId: number;
        dockerImagePinningType: Kaggle.Sdk.Kernels.DockerImagePinningType;
      }

      export interface UpdateKernelCollaboratorsRequest {
        kernelId: number;
        collaborators: Kaggle.Sdk.Users.CollaboratorList | null;
      }

      export interface UpdateKernelCollaboratorsResponse {
        privateDataSources: Kaggle.Sdk.Kernels.DataSource[];
        collaborators: Kaggle.Sdk.Users.CollaboratorList | null;
      }

      export interface UpdateKernelDraftRequest {
        kernelId: number;
        sequence: number;
        parentKernelVersionId?: /* google.protobuf.Int32Value */ number | null;
        settings: Kaggle.Sdk.Kernels.KernelBlobSettings | null;
        source?: /* google.protobuf.StringValue */ string | null;
        // This field is deprecated in favor of external_source_data. Remove
        // it once clients have stopped sending it.
        externalSourceUrl?: /* google.protobuf.StringValue */ string | null;
        externalSourceData: Kaggle.Sdk.Kernels.UpdateKernelDraftRequest.ExternalSourceData | null;
      }

      export interface UpdateKernelDraftResponse {
        sequence: number;
        kernelVersionId: number;
        computedParent?: Kaggle.Sdk.Kernels.ParentKernelVersionData | null;
      }

      export interface UpdateKernelOutputToDatasetRequest {
        kernelId: number;
        enabled: boolean;
      }

      export interface UpdateKernelPrivacyRequest {
        kernelId: number;
        disableComments?: /* google.protobuf.BoolValue */ boolean | null;
        isPrivate: boolean;
      }

      export interface UpdateKernelRunDataSourcesRequest {
        sessionId: number;
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
        dryRun: boolean;
      }

      export interface UpdateKernelRunDataSourcesResponse {
        results: Kaggle.Sdk.Kernels.UpdateDataSourceResult[];
        anyChanges: boolean;
      }

      export interface UpdateKernelRunRequest {
        kernelRunId: number;
        isInternetEnabled: boolean;
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
      }

      export interface UpdateKernelRunResponse {
        errorMessage?: /* google.protobuf.StringValue */ string | null;
        restartRequired: boolean;
        dataSources: Kaggle.Sdk.Kernels.DataSourceReference[];
      }

      export interface UpdateKernelSessionKeepaliveRequest {
        kernelSessionId: number;
      }
      // Command handler request to update a Kernel title. Returns an error if title change is not valid.
      export interface UpdateKernelTitleRequest {
        newTitle?: /* google.protobuf.StringValue */ string | null;
        scriptVersionId: number;
      }

      export interface UpdateKernelTitleResponse {
        errorMessage?: /* google.protobuf.StringValue */ string | null;
        username?: /* google.protobuf.StringValue */ string | null;
        slug?: /* google.protobuf.StringValue */ string | null;
        newUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdateKernelVersionNameRequest {
        versionId: number;
        newName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdatePinnedKernelSessionRequest {
        sessionId: number;
        pinningType: Kaggle.Sdk.Kernels.KernelVersionPinningType;
      }

      export interface UpdateSnippetRequest {
        id: number;
        data: Kaggle.Sdk.Kernels.SnippetData | null;
      }

      export interface UpdateUserKernelFirestoreAuthRequest {
        kernelRunId: number;
        firebaseIdToken?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdateUserKernelFirestoreAuthResponse {
        sessionId?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UploadKernelSessionOutputRequest {
        interactiveSessionId: number;
        batchSessionId: number;
      }

      export enum AcceleratorType {
        // Note: the enum values below should correspond
        // exactly to the values in AcceleratorTypes table.
        NONE = "none", // = 0;
        GPU = "gpu", // = 2;
        TPU_V3_8 = "tpuV38", // = 4;
        TPU_V2_32 = "tpuV232", // = 5;
        TPU_V2_256 = "tpuV2256", // = 7;
      }

      export enum AccessBehavior {
        RETURN_SHELL_ENTRY = "returnShellEntry", // = 0;
        RETURN_NOTHING = "returnNothing", // = 1;
      }

      export enum DataSourceType {
        COMPETITION = "competition", // = 0;
        DATASET_VERSION = "datasetVersion", // = 1;
        KERNEL_VERSION = "kernelVersion", // = 2;
      }

      export enum DockerImagePinningType {
        UNSPECIFIED = "unspecified", // = 0;
        ORIGINAL = "original", // = 1;
        LATEST = "latest", // = 2;
      }

      export enum DockerImageVersionDisabledReason {
        UNSPECIFIED = "unspecified", // = 0;
        TPU_RESTRICTION = "tpuRestriction", // = 1;
      }

      export enum DockerImageVersionType {
        LATEST = "latest", // = 0;
        ORIGINAL = "original", // = 1;
        COMPETITION = "competition", // = 2;
      }

      export enum EditorType {
        UNSPECIFIED = "unspecified", // = 0;
        SCRIPT = "script", // = 1;
        NOTEBOOK = "notebook", // = 2;
      }

      export enum KernelAccessType {
        ADMINISTRATIVE = "administrative", // = 0;
        READ = "read", // = 1;
        WRITE = "write", // = 2;
        COMMENT = "comment", // = 3;
      }

      export enum KernelsListSortType {
        HOTNESS = "hotness", // = 0;
        COMMENT_COUNT = "commentCount", // = 1;
        DATE_CREATED = "dateCreated", // = 2;
        DATE_RUN = "dateRun", // = 3;
        RELEVANCE = "relevance", // = 4;
        SCORE_ASCENDING = "scoreAscending", // = 5;
        SCORE_DESCENDING = "scoreDescending", // = 6;
        VIEW_COUNT = "viewCount", // = 7;
        VOTE_COUNT = "voteCount", // = 8;
      }

      export enum KernelsListViewType {
        UNSPECIFIED = "unspecified", // = 0;
        PROFILE = "profile", // = 1;
        UPVOTED = "upvoted", // = 2;
        EVERYONE = "everyone", // = 3;
        COLLABORATION = "collaboration", // = 4;
        FORK = "fork", // = 5;
        BOOKMARKED = "bookmarked", // = 6;
        RECENTLY_VIEWED = "recentlyViewed", // = 7;
      }

      export enum KernelVersionPinningType {
        UNPINNED = "unpinned", // = 0;
        PINNED = "pinned", // = 1;
      }

      export enum KernelVersionType {
        UNSPECIFIED = "unspecified", // = 0;
        BATCH = "batch", // = 1;
        INTERACTIVE = "interactive", // = 2;
        QUICK = "quick", // = 3;
      }

      export enum KernelWorkerStatus {
        QUEUED = "queued", // = 0;
        RUNNING = "running", // = 1;
        COMPLETE = "complete", // = 2;
        ERROR = "error", // = 3;
        CANCEL_REQUESTED = "cancelRequested", // = 4;
        CANCEL_ACKNOWLEDGED = "cancelAcknowledged", // = 5;
        NEW_SCRIPT = "newScript", // = 6;
      }

      export enum Language {
        UNSPECIFIED = "unspecified", // = 0;
        PYTHON = "python", // = 1;
        R = "r", // = 2;
        RMARKDOWN = "rmarkdown", // = 3;
        JULIA = "julia", // = 4;
        SQLITE = "sqlite", // = 5;
      }
      // TODO: Combine this with DataSourceType above.
      export enum LegacyDataSourceType {
        DATASET = "dataset", // = 0;
        COMPETITION = "competition", // = 1;
        KERNEL = "kernel", // = 2;
      }
      // How often to execute the notebook.
      export enum ScheduleFrequencyType {
        SCHEDULE_FREQUENCY_UNSPECIFIED = "scheduleFrequencyUnspecified", // = 0;
        DAILY = "daily", // = 1;
        WEEKLY = "weekly", // = 2;
        MONTHLY = "monthly", // = 3;
      }
      // What triggers the schedule to be run.
      export enum ScheduleTriggerType {
        UNSPECIFIED = "unspecified", // = 0;
        SCHEDULED_TIME = "scheduledTime", // = 1;
        DATASOURCE_UPDATE = "datasourceUpdate", // = 2;
      }

      export enum StreamName {
        STDOUT = "stdout", // = 0;
        STDERR = "stderr", // = 1;
      }
    }

    export namespace NerdChallenges {
      export namespace Models {
        export interface NerdChallengesDto {
          token: string | null;
          redirectUrl: string | null;
        }
      }
    }

    export namespace Newsfeed {
      export namespace Protos {
        export interface GetDsSurveyBannerStateRequest {}

        export interface GetDsSurveyBannerStateResponse {
          showBanner: boolean;
        }

        export interface GetNewsfeedSidebarContentRequest {}

        export interface GetStoriesRequest {
          page: number;
        }

        export interface GetStoriesResponse {
          stories: Kaggle.Sdk.Newsfeed.Protos.NewsfeedStory[];
        }

        export interface NewsfeedBlog {
          imageUrl: string;
          summary: string;
          title: string;
          url: string;
        }

        export interface NewsfeedCompetition {
          coverImageUrl: string;
          currentUserRank?: /* google.protobuf.Int32Value */ number | null;
          deadline: /* google.protobuf.Timestamp */ string | null;
          title?: /* google.protobuf.StringValue */ string | null;
          imageUrl: string;
          briefDescription: string;
          overview: Kaggle.Sdk.Newsfeed.Protos.NewsfeedCompetitionOverview | null;
          resultsAreFinal?: /* google.protobuf.BoolValue */ boolean | null;
          rewardQuantity?: /* google.protobuf.DoubleValue */ number | null;
          rewardType?: /* google.protobuf.StringValue */ string | null;
          teams: Kaggle.Sdk.Newsfeed.Protos.NewsfeedCompetitionTeam[];
          totalEnteredTeams?: /* google.protobuf.Int32Value */ number | null;
          url?: /* google.protobuf.StringValue */ string | null;
          winningSubmissionUrl?: /* google.protobuf.StringValue */ string | null;
        }

        export interface NewsfeedCompetitionOverview {
          content: string;
          type: string;
        }

        export interface NewsfeedCompetitionTeam {
          name: string;
          rank?: /* google.protobuf.Int32Value */ number | null;
          team: Kaggle.Sdk.Competitions.Team | null;
          users: Kaggle.Sdk.Users.User[];
        }

        export interface NewsfeedDataset {
          commonFileType: Kaggle.Sdk.Datasets.Models.DatasetFileType.Enum;
          databundleVersionId?: /* google.protobuf.Int32Value */ number | null;
          datasetIsDeleted: boolean;
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          licenseName: string;
          overview: string;
          title?: /* google.protobuf.StringValue */ string | null;
          totalSize?: /* google.protobuf.Int64Value */ number | null;
          totalFiles?: /* google.protobuf.Int32Value */ number | null;
          totalKernels?: /* google.protobuf.Int32Value */ number | null;
          totalTopics?: /* google.protobuf.Int32Value */ number | null;
          totalViews?: /* google.protobuf.Int32Value */ number | null;
          url?: /* google.protobuf.StringValue */ string | null;
          versionNotes: string;
          datasetId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface NewsfeedDiscussion {
          forumName: string;
          forumUrl?: /* google.protobuf.StringValue */ string | null;
          messageId?: /* google.protobuf.Int32Value */ number | null;
          messageRawHtml: string;
          messageRawMarkdown?: /* google.protobuf.StringValue */ string | null;
          messageUrl: string;
          topicDate: /* google.protobuf.Timestamp */ string | null;
          topicId?: /* google.protobuf.Int32Value */ number | null;
          topicName: string;
          topicRawHtml: string;
          topicRawMarkdown?: /* google.protobuf.StringValue */ string | null;
          topicUrl: string;
        }

        export interface NewsfeedKernel {
          commentCount: number;
          dataUrl: string;
          disableComments: boolean;
          fileOutputCount?: /* google.protobuf.Int32Value */ number | null;
          hasMultipleDataSources: boolean;
          kernelId?: /* google.protobuf.Int32Value */ number | null;
          kernelType: Kaggle.Sdk.Kernels.EditorType;
          language: string;
          lineCount?: /* google.protobuf.Int32Value */ number | null;
          name: string;
          runTimeSeconds?: /* google.protobuf.DoubleValue */ number | null;
          url: string;
          views?: /* google.protobuf.Int32Value */ number | null;
          visualizationUrls: string[];
        }

        export interface NewsfeedSidebarContent {
          userName?: /* google.protobuf.StringValue */ string | null;
          avatarUrl?: /* google.protobuf.StringValue */ string | null;
          userUrl?: /* google.protobuf.StringValue */ string | null;
          userTier: Kaggle.Sdk.Users.UserAchievementTier;
          userJoinDate: /* google.protobuf.Timestamp */ string | null;
          progression: Kaggle.Sdk.Users.GetCurrentUserProgressionResponse | null;
          competitionSidebarList: Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarItem[];
          datasetSidebarList: Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarItem[];
          kernelSidebarList: Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarItem[];
        }

        export interface NewsfeedSidebarItem {
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          title?: /* google.protobuf.StringValue */ string | null;
          linkUrl?: /* google.protobuf.StringValue */ string | null;
          icon?: /* google.protobuf.StringValue */ string | null;
          iconTitle?: /* google.protobuf.StringValue */ string | null;
          iconRight?: /* google.protobuf.StringValue */ string | null;
          iconRightTitle?: /* google.protobuf.StringValue */ string | null;
          dateCreated: /* google.protobuf.Timestamp */ string | null;
        }

        export interface NewsfeedStory {
          // Only users can do actions on the newsfeed, such as upvoting and commenting
          actionUser: Kaggle.Sdk.Users.User | null;
          blog: Kaggle.Sdk.Newsfeed.Protos.NewsfeedBlog | null;
          competition: Kaggle.Sdk.Newsfeed.Protos.NewsfeedCompetition | null;
          dataset: Kaggle.Sdk.Newsfeed.Protos.NewsfeedDataset | null;
          date: /* google.protobuf.Timestamp */ string | null;
          discussion: Kaggle.Sdk.Newsfeed.Protos.NewsfeedDiscussion | null;
          isFollowingItem?: /* google.protobuf.BoolValue */ boolean | null;
          isFollowingUser?: /* google.protobuf.BoolValue */ boolean | null;
          kernel: Kaggle.Sdk.Newsfeed.Protos.NewsfeedKernel | null;
          // Owners can be either a user or an organization
          ownerOrganization: Kaggle.Sdk.Newsfeed.Protos.Organization | null;
          ownerUser: Kaggle.Sdk.Users.User | null;
          storyInfo: Kaggle.Sdk.Newsfeed.Protos.NewsfeedStoryInfo | null;
          vote: Kaggle.Sdk.Newsfeed.Protos.NewsfeedVote | null;
        }

        export interface NewsfeedStoryInfo {
          experimentId: string;
          id: number;
          sortId: number;
          storyType: Kaggle.Sdk.Newsfeed.Protos.ItemType;
        }

        export interface NewsfeedVote {
          canDownvote?: /* google.protobuf.BoolValue */ boolean | null;
          canUpvote?: /* google.protobuf.BoolValue */ boolean | null;
          hasAlreadyDownvoted?: /* google.protobuf.BoolValue */ boolean | null;
          hasAlreadyUpvoted?: /* google.protobuf.BoolValue */ boolean | null;
          voteCount?: /* google.protobuf.Int32Value */ number | null;
          kernelId?: /* google.protobuf.Int32Value */ number | null;
          datasetId?: /* google.protobuf.Int32Value */ number | null;
          forumMessageId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface Organization {
          id: number;
          creationDate: /* google.protobuf.Timestamp */ string | null;
          name: string;
          creatorUser: Kaggle.Sdk.Users.User | null;
          url: string;
          thumbnailUrl: string;
          joinDate: /* google.protobuf.Timestamp */ string | null;
          location: string;
          datasetCount: number;
          competitionCount: number;
          memberCount: number;
        }

        export interface SetDsSurveyBannerStateRequest {
          dismissed: boolean;
          clicked: boolean;
        }
        // The ItemType enum defines all the possible newsfeed items that the front
        // end knows how to render.
        export enum ItemType {
          UNSPECIFIED = "unspecified", // = 0;
          RAN_KERNEL = "ranKernel", // = 1;
          PUBLISHED_KERNEL = "publishedKernel", // = 2;
          COMMENTED_ON_KERNEL = "commentedOnKernel", // = 3;
          UPVOTED_KERNEL = "upvotedKernel", // = 4;
          DATASET_TRENDING = "datasetTrending", // = 5;
          POSTED_DATASET = "postedDataset", // = 6;
          DATASET_FEATURED = "datasetFeatured", // = 7;
          UPVOTED_DATASET = "upvotedDataset", // = 8;
          BLOG_POST = "blogPost", // = 9;
          CREATED_TOPIC = "createdTopic", // = 10;
          REPLIED_TO_TOPIC = "repliedToTopic", // = 11;
          UPVOTED_TOPIC = "upvotedTopic", // = 12;
          COMPETITION_LAUNCH = "competitionLaunch", // = 13;
          COMPETITION_END = "competitionEnd", // = 14;
          COMPETITION_FINAL = "competitionFinal", // = 15;
          LEARN_CHALLENGE = "learnChallenge", // = 16;
        }
      }
    }

    export namespace Notifications {
      export interface AddTestNotificationRequest {
        // What notification type do you want for the notification to be added?
        // Not all notification types are currently supported
        notificationType: Kaggle.Sdk.Notifications.NotificationType;
        // for the notification type specified, there are pre-made notifications - which one of those do you want?
        // Not all types have variants - simply specify 0 for them
        // the invoking user must have permission to the any objects (dataset/comp/etc) mentioned in the variant
        variant: number;
        // By default the notification will be sent to the invoking user as a web notification,
        // when send_email is true, it will also be sent as an email to the invoking user.
        sendEmail: boolean;
      }

      export interface AddTestNotificationResponse {
        // id of the notification that was created
        notificationId: number;
        // the number of emails that we attempted to send - does not always succeed.
        emailsProcessedCount: number;
      }

      export interface GetMySubscribeStateRequest {
        id: number;
        type: Kaggle.Sdk.Notifications.SubscriptionType;
      }

      export interface GetSubscribeStateResponse {
        state: Kaggle.Sdk.Notifications.SubscribeState;
      }

      export interface GetUserNotificationSettingsRequest {}

      export interface GetUserNotificationSettingsResponse {
        // The user's current notification settings.
        settings: Kaggle.Sdk.Notifications.UserNotificationSettings | null;
      }

      export interface GetUserNotificationsRequest {
        // Notification Id used for pagination. Will grab the notifications after this id
        afterNotificationId?: /* google.protobuf.Int32Value */ number | null;
        // The number of notifications to retrieve, for pagination
        pageSize: number;
        // The newest Id that the client has already cached. If there aren't newer
        // notifications than this, then the server will skip loading notifications.
        // It will still load the unviewed count as that can change.
        cachedNotificationId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface GetUserNotificationsResponse {
        containsMore: boolean;
        enabled: boolean;
        countUnviewed: number;
        notifications: Kaggle.Sdk.Notifications.Notification[];
        newestNotificationId: number;
        cacheIsValid: boolean;
      }

      export interface MarkAllNotificationsRequest {
        newestNotificationId: number;
        commandMark: Kaggle.Sdk.Notifications.CommandMark;
      }

      export interface MarkNotificationsRequest {
        // when you want to change a single notification's status, set this field
        singleNotificationId?: number;
        // setting this field will mark all notification ids <= this id
        newestNotificationId?: number;
        // set to true when you want the DatedViewed set on the notification
        markViewed: boolean;
        // set to true when you want the DateRead set on the notification
        markRead: boolean;
      }

      export interface MessageObject {
        key?: /* google.protobuf.StringValue */ string | null;
        text?: /* google.protobuf.StringValue */ string | null;
        url?: /* google.protobuf.StringValue */ string | null;
      }

      export interface Notification {
        id: number;
        subscriptionType: Kaggle.Sdk.Notifications.SubscriptionType;
        relatedItemId: number;
        relatedItemType: Kaggle.Sdk.Notifications.NotificationRelatedItemType;
        isRead: boolean;
        isViewed: boolean;
        createdDate: /* google.protobuf.Timestamp */ string | null;
        imageUrl?: /* google.protobuf.StringValue */ string | null;
        imageHref?: /* google.protobuf.StringValue */ string | null;
        messageFormat?: /* google.protobuf.StringValue */ string | null;
        messageObjects: Kaggle.Sdk.Notifications.MessageObject[];
        title?: /* google.protobuf.StringValue */ string | null;
        message?: /* google.protobuf.StringValue */ string | null;
        // if non-null, this indicates that the notification represents a bundle of notifications
        // the count is the number of notifications in the bundle. Value will never be 0 or 1.
        bundleCount?: /* google.protobuf.Int32Value */ number | null;
        // The following fields are only defined for emails or summary/full views
        messagePreview?: /* google.protobuf.StringValue */ string | null;
        actionUrl?: /* google.protobuf.StringValue */ string | null;
        upvoteUrl?: /* google.protobuf.StringValue */ string | null;
        downvoteUrl?: /* google.protobuf.StringValue */ string | null;
        voteCount?: /* google.protobuf.Int32Value */ number | null;
        medalUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SetUserNotificationSettingsRequest {
        // The user who's settings are being set. This must be the current user unless the current user is an admin.
        userId: number;
        // The settings to update to.
        settings: Kaggle.Sdk.Notifications.UserNotificationSettings | null;
        // Which fields are being passed in to be set. If you don't pass this, then all fields will be updated.
        updateMask: google.protobuf.FieldMask | null;
      }

      export interface SubscribeToRequest {
        subscribe: Kaggle.Sdk.Notifications.SubscribeState;
        // Is the user being subscribed implictly (e.g. as a result of commenting) or explicitly (as a result of them clicking follow)
        // Implicit subscription never overwrites explicit unsubscribing
        isImplicit: boolean;
        id?: /* google.protobuf.Int32Value */ number | null;
        type: Kaggle.Sdk.Notifications.SubscriptionType;
        parentType: Kaggle.Sdk.Notifications.NotificationRelatedItemType;
        parentId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface TimeTaken {
        // Which notification this timing is for.
        notificationId: number;
        // How long it took to query for it (find one to process).
        queryTimeMilliseconds?: /* google.protobuf.Int64Value */ number | null;
        // How long it took to mark it as sent (done before processing to prevent race conditions).
        markTimeMilliseconds?: /* google.protobuf.Int64Value */ number | null;
        // How long it took to load all the details for it.
        loadTimeMilliseconds?: /* google.protobuf.Int64Value */ number | null;
        // How long it took to process the notification (render it etc).
        processTimeMilliseconds?: /* google.protobuf.Int64Value */ number | null;
        // How long it took to queue it to send.
        sendTimeMilliseconds?: /* google.protobuf.Int64Value */ number | null;
        // How long it took to log it as being sent (in notification history DB table).
        logTimeMilliseconds?: /* google.protobuf.Int64Value */ number | null;
        // How long the entire process took.
        totalTimeMilliseconds: number;
      }
      // Settings for notifications.
      export interface UserNotificationSettings {
        // Are notifications enabled at all (global setting).
        enabled: boolean;
        // A list of your current subscriptions, currently not populated (because of a performance issue).
        subscriptions: Kaggle.Sdk.Notifications.UserSubscription[];
        // Whether email notifications are aggregated, currently not used.
        aggregation: Kaggle.Sdk.Notifications.NotificationAggregationOption;
        // How to receive dataset digest emails. Should only be Email or None. 
        datasetSummaryEmail: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive private dataset digest emails. Should only be Email or None.
        privateDatasetSummaryEmail: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive trending dataset digest emails. Should only be Email or None.
        datasetTrendingSummaryEmail: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive dataset task emails. Should only be Email or None.
        datasetTaskEmail: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive collaboration emails from other users. Should only be Email or None.
        userCollaborationMessages: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // Whether you are subscribed to the mailing list ("News and Tips").
        isSubscribedToMailingList: boolean;
        // How to receive notifications about @-mentions from users you are following.
        atMentionFollowedUser: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about @-mentions from other users.
        atMentionRegularUser: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications for competition announcements.
        competitionAnnouncements: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about updates for your competition team.
        competitionTeamUpdates: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about your datasets.
        datasetAlerts: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about your notebooks.
        notebookAlerts: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about topics you've participated in.
        engagedTopicComment: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications when a user follows you.
        userNewFollower: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about new topics in a forum you're following.
        newTopic: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications about new medals you've achieved or tier level-ups.
        newTierAchievedOrMedal: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications when one of your topics is upvoted
        topicUpvote: Kaggle.Sdk.Notifications.NotificationDeliveryType;
        // How to receive notifications when a topic you are following is commented on
        topicComment: Kaggle.Sdk.Notifications.NotificationDeliveryType;
      }

      export interface UserSubscription {
        id: number;
        subscriptionStateId: number;
        subscriptionType: string;
        name: string;
        kernelName: string;
        notificationCount: number;
        lastNotificationCreatedDate: /* google.protobuf.Timestamp */ string | null;
        link: string;
      }

      export enum CommandMark {
        READ = "read", // = 0;
        VIEWED = "viewed", // = 1;
      }

      export enum NotificationAggregationOption {
        NO_AGGREGATION = "noAggregation", // = 0;
        DAILY = "daily", // = 1;
        WEEKLY = "weekly", // = 2;
      }

      export enum NotificationDeliveryType {
        NONE = "none", // = 0;
        WEB = "web", // = 1;
        EMAIL = "email", // = 2;
        BOTH = "both", // = 3;
      }

      export enum NotificationRelatedItemType {
        UNSPECIFIED = "unspecified", // = 0;
        FORUM_MESSAGE = "forumMessage", // = 1;
        KERNEL = "kernel", // = 2;
        KERNEL_RUN = "kernelRun", // = 3;
        USER_TIER_LOG = "userTierLog", // = 4;
        USER_MEDAL = "userMedal", // = 5;
        COMPETITION = "competition", // = 6;
        DATASET = "dataset", // = 7;
        TEAM = "team", // = 8;
        DATASET_TASK = "datasetTask", // = 9;
        DATASET_TASK_SOLUTION = "datasetTaskSolution", // = 10;
        USER = "user", // = 11;
      }

      export enum NotificationType {
        UNSPECIFIED = "unspecified", // = 0;
        TOPIC_COMMENT = "topicComment", // = 1;
        AT_MENTION = "atMention", // = 2;
        TOPIC_UPVOTE = "topicUpvote", // = 3;
        NEW_TOPIC = "newTopic", // = 4;
        NEW_KERNEL_VERSION = "newKernelVersion", // = 5;
        USER_NEW_TIER_ACHIEVED = "userNewTierAchieved", // = 6;
        NEW_MEDAL = "newMedal", // = 7;
        USER_NEW_FOLLOWER = "userNewFollower", // = 8;
        NOTEBOOK_FINISHED_RUNNING = "notebookFinishedRunning", // = 20;
        NOTEBOOK_MADE_PUBLIC = "notebookMadePublic", // = 21;
        NOTEBOOK_FORK_COUNT = "notebookForkCount", // = 22;
        NOTEBOOK_FEATURED = "notebookFeatured", // = 23;
        NOTEBOOK_VIEW_COUNT = "notebookViewCount", // = 24;
        NOTEBOOK_DISCUSSION_COUNT = "notebookDiscussionCount", // = 25;
        COMPETITION_DEADLINE_ONE_DAY = "competitionDeadlineOneDay", // = 101;
        COMPETITION_DEADLINE_ONE_WEEK = "competitionDeadlineOneWeek", // = 102;
        COMPETITION_FINALIZED = "competitionFinalized", // = 103;
        COMPETITION_TEAM_MERGE = "competitionTeamMerge", // = 104;
        COMPETITION_TEAM_INVITE = "competitionTeamInvite", // = 105;
        COMPETITION_NOTEBOOK_COUNT = "competitionNotebookCount", // = 106;
        COMPETITION_SUBMISSION_COUNT = "competitionSubmissionCount", // = 107;
        COMPETITION_ENTRANT_COUNT = "competitionEntrantCount", // = 108;
        DATASET_NEW_PUBLIC_NOTEBOOK = "datasetNewPublicNotebook", // = 200;
        DATASET_NEW_TASK = "datasetNewTask", // = 201;
        DATASET_NEW_TASK_SOLUTION = "datasetNewTaskSolution", // = 202;
        DATASET_PUBLISHED = "datasetPublished", // = 203;
        DATASET_UPLOADED = "datasetUploaded", // = 204;
        ACCOUNT_ALERT = "accountAlert", // = 205;
        DATASET_NOTEBOOK_COUNT = "datasetNotebookCount", // = 206;
        DATASET_PARTICIPATION_COUNT = "datasetParticipationCount", // = 207;
        DATASET_TRENDING = "datasetTrending", // = 208;
        DATASET_VIEW_COUNT = "datasetViewCount", // = 209;
        DATASET_DOWNLOAD_COUNT = "datasetDownloadCount", // = 210;
      }
      // Key for messages to show on the settings page (to replace page messages)
      // These aren't fully qualified because the transpiler is including the prefix
      // on the enum value for some reason
      export enum SettingsPageMessage {
        UNSPECIFIED = "unspecified", // = 0;
        UNSUBSCRIBED_DATASET_UPDATES = "unsubscribedDatasetUpdates", // = 1;
        UNSUBSCRIBED_PRIVATE_DATASET_SUMMARIES = "unsubscribedPrivateDatasetSummaries", // = 2;
        UNSUBSCRIBED_DATASET_TASK_SUMMARIES = "unsubscribedDatasetTaskSummaries", // = 3;
        UNSUBSCRIBED_DATASET_TRENDING_SUMMARIES = "unsubscribedDatasetTrendingSummaries", // = 4;
        UNSUBSCRIBED_DATASET_TASKS = "unsubscribedDatasetTasks", // = 5;
        UNSUBSCRIBED_GENERIC = "unsubscribedGeneric", // = 6;
        UNSUBSCRIBED_COLLABORATION = "unsubscribedCollaboration", // = 7;
      }

      export enum SubscribeState {
        INVALID = "invalid", // = 0;
        UNSUBSCRIBE = "unsubscribe", // = 1;
        // out of date, do not use except for back compat 
        SUBSCRIBE_SINGLE = "subscribeSingle", // = 2;
        SUBSCRIBE_ALL = "subscribeAll", // = 3;
        // Forums 
        FORUM_NEW_TOPICS = "forumNewTopics", // = 10;
        FORUM_NEW_TOPICS_AND_COMMENTS = "forumNewTopicsAndComments", // = 11;
        // Topic 
        TOPIC_NEW_COMMENTS = "topicNewComments", // = 20;
        // Kernels 
        KERNEL_NEW_COMMENTS = "kernelNewComments", // = 30;
        KERNEL_NEW_COMMENTS_AND_VERSIONS = "kernelNewCommentsAndVersions", // = 31;
      }

      export enum SubscriptionType {
        NOT_APPLICABLE = "notApplicable", // = 0;
        FORUM_TOPIC = "forumTopic", // = 1;
        FORUM = "forum", // = 2;
        KERNEL = "kernel", // = 3;
      }
    }

    export namespace Search {
      export namespace Protos {
        export interface CategoryFilter {
          name: Kaggle.Sdk.Search.Protos.DocumentType;
          count: number;
        }

        export interface CommentItemInfo {
          forumName: string;
          forumType: string;
          matchingText: string;
        }

        export interface CompetitionItemInfo {
          teamsCount: number;
          deadlineDate: /* google.protobuf.Timestamp */ string | null;
          prizeValue: number;
          hasEntered: boolean;
          type: Kaggle.Sdk.Competitions.HostSegment;
          isKernelsOnly: boolean;
        }

        export interface DatasetItemInfo {
          size: number;
          fileTypes: string[];
          kernelsCount: number;
          filesCount: number;
          maintainedByKaggle: boolean;
        }

        export interface FilterOption {
          name: string;
          count: number;
        }

        export interface FullSearchResponse {
          documents: Kaggle.Sdk.Search.Protos.SearchItem[];
          count: number;
          filters: Kaggle.Sdk.Search.Protos.SearchFilter[];
          categories: Kaggle.Sdk.Search.Protos.CategoryFilter[];
        }

        export interface FullSearchWebRequest {
          query?: /* google.protobuf.StringValue */ string | null;
          page: number;
          resultsPerPage: number;
          // Option to filter out private content, this treats the searcher as an anonymous user
          showPrivate: boolean;
        }

        export interface GetAutoCompleteSuggestionsRequest {
          prefix: string;
        }

        export interface GetAutoCompleteSuggestionsResponse {
          autoCompleteSuggestions: string[];
        }

        export interface GetPopularTagsRequest {}

        export interface GetPopularTagsResponse {
          popularTags: Kaggle.Sdk.Search.Protos.FilterOption[];
        }

        export interface GetRecentSearchesRequest {
          userId?: /* google.protobuf.Int32Value */ number | null;
          // If empty, will not filter out any query histories based
          // on search indices.
          // List of specific search indices to limit the result to only
          // search queries made from these indices.
          specificSearchIndices: Kaggle.Sdk.Search.Protos.SearchIndex[];
        }

        export interface GetRecentSearchesResponse {
          recentSearches: string[];
        }

        export interface GetTrendingSearchesRequest {}

        export interface GetTrendingSearchesResponse {
          trendingSearches: string[];
        }

        export interface IndexSnippetResponse {
          indexCreateResponse: string;
          createdIndex: string;
          bulkIndexResponse: string;
          indexedCount: number;
          deleteIndexResponse: string;
          deletedIndex: string;
          aliasResponse: string;
        }

        export interface KernelItemInfo {
          languageGroup: string;
          secondsToRun: number;
          dataSource: string;
          forksCount: number;
        }

        export interface LogSearchRequest {
          index: string;
          isQuick: boolean;
          query: string;
          rank?: /* google.protobuf.Int32Value */ number | null;
          id?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
          secondsSpentSearching: number;
          token?: /* google.protobuf.StringValue */ string | null;
          isPrivate?: /* google.protobuf.BoolValue */ boolean | null;
        }

        export interface OrganizationItemInfo {
          location: string;
          datasetCount: number;
          competitionCount: number;
          memberCount: number;
        }

        export interface SearchFilter {
          name: Kaggle.Sdk.Search.Protos.FilterName;
          type: Kaggle.Sdk.Search.Protos.FilterType;
          options: Kaggle.Sdk.Search.Protos.FilterOption[];
          categories: Kaggle.Sdk.Search.Protos.DocumentType[];
        }

        export interface SearchItem {
          id: string;
          documentType: Kaggle.Sdk.Search.Protos.DocumentType;
          databaseId: number;
          title: string;
          url: string;
          thumbnailImageUrl: string;
          rank: number;
          score: number;
          isPrivate: boolean;
          votes: number;
          date: /* google.protobuf.Timestamp */ string | null;
          authorSlug: string;
          authorDisplayName: string;
          commentInfo?: Kaggle.Sdk.Search.Protos.CommentItemInfo | null;
          competitionInfo?: Kaggle.Sdk.Search.Protos.CompetitionItemInfo | null;
          datasetInfo?: Kaggle.Sdk.Search.Protos.DatasetItemInfo | null;
          kernelInfo?: Kaggle.Sdk.Search.Protos.KernelItemInfo | null;
          topicInfo?: Kaggle.Sdk.Search.Protos.TopicItemInfo | null;
          userInfo?: Kaggle.Sdk.Search.Protos.UserItemInfo | null;
          organizationInfo?: Kaggle.Sdk.Search.Protos.OrganizationItemInfo | null;
          matchedText: string;
          isCreatedByCurrentUser: boolean;
        }

        export interface SearchResultGroup {
          documents: Kaggle.Sdk.Search.Protos.SearchItem[];
          type: Kaggle.Sdk.Search.Protos.DocumentType;
          count: number;
        }

        export interface SuggestedSearchResponse {
          groups: Kaggle.Sdk.Search.Protos.SearchResultGroup[];
        }

        export interface SuggestedSearchWebRequest {
          query?: /* google.protobuf.StringValue */ string | null;
        }

        export interface TimeSpentOnClickedResultRequest {
          seconds: number;
          resultToken: string;
        }

        export interface TopicItemInfo {
          creationDate: /* google.protobuf.Timestamp */ string | null;
          forumName: string;
          forumType: string;
          matchingText: string;
        }

        export interface UserItemInfo {
          kernelsCount: number;
          topicsCount: number;
          description: string;
          lastSeenDate: /* google.protobuf.Timestamp */ string | null;
          performanceTier: Kaggle.Sdk.Users.UserAchievementTier;
          location: string;
        }

        export enum DocumentType {
          UNSPECIFIED = "unspecified", // = 0;
          BLOG = "blog", // = 1;
          COMPETITION = "competition", // = 2;
          DATASET = "dataset", // = 3;
          KERNEL = "kernel", // = 5;
          COMMENT = "comment", // = 6;
          ORGANIZATION = "organization", // = 7;
          TOPIC = "topic", // = 8;
          USER = "user", // = 9;
          COURSE = "course", // = 10;
          TUTORIAL = "tutorial", // = 11;
        }

        export enum FilterName {
          DATE = "date", // = 0;
          IN = "in", // = 1;
          BY = "by", // = 2;
          TAG = "tag", // = 3;
          AUTHOR_USER_NAME = "authorUserName", // = 4;
          SORT_BY = "sortBy", // = 6;
          COMPETITION_EVALUATION_ALGORITHM = "competitionEvaluationAlgorithm", // = 7;
          DATASET_LICENSE = "datasetLicense", // = 8;
          DATASET_SIZE = "datasetSize", // = 9;
          DATASET_SIZE_GROUP = "datasetSizeGroup", // = 10;
          DATASET_FILE_TYPES = "datasetFileTypes", // = 11;
          KERNEL_LANGUAGE = "kernelLanguage", // = 12;
          VIEWED_BY_YOU = "viewedByYou", // = 13;
        }

        export enum FilterType {
          RADIO = "radio", // = 0;
          CHECKBOX = "checkbox", // = 1;
          TEXT = "text", // = 2;
        }
        // Specific search index name used to get/set in recent search
        // history results.
        export enum SearchIndex {
          UNSPECIFIED = "unspecified", // = 0;
          COMPETITIONS = "competitions", // = 1;
          DATASETS = "datasets", // = 2;
          GLOBAL = "global", // = 3;
          KERNELS = "kernels", // = 5;
          TOPICS = "topics", // = 6;
        }
        // Search is structured such that some handlers live on a service-host container and a proxied by web pods, while some
        // handlers live on the actual web monolith. Because a ProtoServiceRegistration requires all RPCs to have mapped
        // handlers, it's thus necessary to divide these two services so that web pods can have their own RPCs while not
        // defining handlers for the proxied requests.
      }
    }

    export namespace Tags {
      export interface CreateCompetitionTagsRequest {
        // The competition to tag
        competitionId: number;
        // The tags to apply
        tagIds: number[];
      }

      export interface CreateCompetitionTagsResponse {}

      export interface CreateLearnTrackTagsRequest {
        // The learn track to tag
        learnTrackId: number;
        // The tags to apply
        tagIds: number[];
      }

      export interface CreateLearnTrackTagsResponse {}

      export interface CreateTagRequest {
        name: string;
        displayName?: /* google.protobuf.StringValue */ string | null;
        parentCategoryId?: /* google.protobuf.Int32Value */ number | null;
        slug?: /* google.protobuf.StringValue */ string | null;
        description?: /* google.protobuf.StringValue */ string | null;
        isFeatured?: /* google.protobuf.BoolValue */ boolean | null;
      }

      export interface DeleteCompetitionTagsRequest {
        // The competition to untag
        competitionId: number;
        // The tags to remove
        tagIds: number[];
      }

      export interface DeleteCompetitionTagsResponse {}

      export interface DeleteLearnTrackTagsRequest {
        // The learn track to untag
        learnTrackId: number;
        // The tags to remove
        tagIds: number[];
      }

      export interface DeleteLearnTrackTagsResponse {}

      export interface GetTagHierarchyRequest {}

      export interface GetTagHierarchyResponse {
        // The roots of various tag linked lists
        roots: Kaggle.Sdk.Tags.TagNode[];
      }

      export interface GetTagsByIdRequest {
        tagIds: number[];
      }

      export interface ListTagsResponse {
        featuredTags: Kaggle.Sdk.Tags.Tag[];
        hotTags: Kaggle.Sdk.Tags.Tag[];
        tagsCount: number;
        pageSize: number;
      }

      export interface SearchTagsLegacyRequest {
        search?: /* google.protobuf.StringValue */ string | null;
        page: number;
      }

      export interface SearchTagsLegacyResponse {
        tags: Kaggle.Sdk.Tags.Tag[];
      }

      export interface SearchTagsRequest {
        /*[NotNull]*/
        searchType: Kaggle.Sdk.Tags.TagType;
        searchQuery?: /* google.protobuf.StringValue */ string | null;
        showSystemTags: boolean;
        skip: number;
        take: number;
      }

      export interface Tag {
        // The unique identifier for a tag
        id: number;
        // The name of a tag
        name: string;
        // The complete path for a tag, showing its ancestors, separated by >
        fullPath: string;
        // The URL to link to an appropriate listing for the tag, e.g. datasets listing filtered by tag
        listingUrl: string;
        // The description for a given tag
        description?: /* google.protobuf.StringValue */ string | null;
        // The count of datasets tagged with a given tag
        datasetCount: number;
        // The count of competitions tagged with a given tag
        competitionCount: number;
        // The count of notebooks tagged with a given tag
        notebookCount: number;
        // The URL to link directly to a given tag
        tagUrl: string;
        // The display name for a given tag
        displayName: string;
        // Font Awesome icon used in some legacy spots for tags
        fontAwesomeIcon: string;
      }

      export interface TagDatasetTaskRequest {
        taskId: number;
        tagId: number;
      }

      export interface TagList {
        tags: Kaggle.Sdk.Tags.Tag[];
        type: Kaggle.Sdk.Tags.TagType;
      }

      export interface TagNode {
        // The current node's tag
        tag: Kaggle.Sdk.Tags.Tag | null;
        // Child nodes of the current node
        children: Kaggle.Sdk.Tags.TagNode[];
      }

      export interface UntagDatasetTaskRequest {
        taskId: number;
        tagIds: number[];
        rereview: boolean;
      }

      export interface UpdateForumTopicTagsRequest {
        // The forum topic to tag
        forumTopicId: number;
        // The set of tags to apply to the forum topic, any existing tags not in the set are removed
        tagIds: number[];
      }

      export interface UpdateForumTopicTagsResponse {}

      export enum TagType {
        UNSPECIFIED = "unspecified", // = 0;
        SEARCH_RESULT = "searchResult", // = 1;
        DATASET = "dataset", // = 2;
        COMPETITION = "competition", // = 3;
        NOTEBOOK = "notebook", // = 4;
        TASK = "task", // = 5;
      }
    }

    export namespace Users {
      export namespace Models {
        export interface AchievementSummaryDto {
          tier: Kaggle.Sdk.Users.UserAchievementTier;
          totalResults: /*Int32*/ number;
          rankPercentage: /*Single*/ number;
          rankOutOf: /*Int32*/ number;
          rankCurrent: /* Int32 */ number | null;
          rankHighest: /* Int32 */ number | null;
          totalGoldMedals: /*Int32*/ number;
          totalSilverMedals: /*Int32*/ number;
          totalBronzeMedals: /*Int32*/ number;
          highlights: Kaggle.Sdk.Users.Models.AchievementSummaryHighlightDto[];
          summaryType: Kaggle.Sdk.Users.AchievementSummaryType;
        }

        export interface AchievementSummaryHighlightDto {
          title: string | null;
          date: /* DateTime */ string;
          medal: Kaggle.Sdk.Users.Medal;
          score: /*Int32*/ number;
          scoreOutOf: /*Int32*/ number;
          url: string | null;
          thumbnailUrl: string | null;
          isOngoingCompetition: boolean;
        }

        export interface FollowersItemDto {
          displayName: string | null;
          thumbnailUrl: string | null;
          userId: /*Int32*/ number;
          userName: string | null;
          userUrl: string | null;
          tier: Kaggle.Sdk.Users.UserAchievementTier;
        }

        export interface FollowersListDto {
          type: Kaggle.Sdk.Users.Models.FollowersListType;
          count: /*Int32*/ number;
          list: Kaggle.Sdk.Users.Models.FollowersItemDto[];
          containsSelf: boolean;
          maxCountReached: boolean;
        }

        export interface FollowersResponseDto {
          message: string | null;
          status: Kaggle.Sdk.Users.Models.FollowersReponseStatus;
        }

        export interface ProfileDto {
          userId: /*Int32*/ number;
          displayName: string | null;
          country: string | null;
          region: string | null;
          city: string | null;
          gitHubUserName: string | null;
          twitterUserName: string | null;
          linkedInUrl: string | null;
          websiteUrl: string | null;
          occupation: string | null;
          organization: string | null;
          bio: string | null;
          userLastActive: /* DateTime */ string | null;
          userJoinDate: /* DateTime */ string;
          performanceTier: Kaggle.Sdk.Users.UserAchievementTier;
          performanceTierCategory: Kaggle.Sdk.Users.AchievementSummaryType;
          activePaneTier: Kaggle.Sdk.Users.UserAchievementTier;
          activePaneCategory: Kaggle.Sdk.Users.AchievementSummaryType;
          userUrl: string | null;
          userAvatarUrl: string | null;
          email: string | null;
          canEdit: boolean;
          canCreateDatasets: boolean;
          userName: string | null;
          activePane: Kaggle.Sdk.Users.Models.ProfileArea;
          totalDatasets: /*Int32*/ number;
          totalOrganizations: /*Int32*/ number;
          competitionsSummary: Kaggle.Sdk.Users.Models.AchievementSummaryDto | null;
          scriptsSummary: Kaggle.Sdk.Users.Models.AchievementSummaryDto | null;
          discussionsSummary: Kaggle.Sdk.Users.Models.AchievementSummaryDto | null;
          datasetsSummary: Kaggle.Sdk.Users.Models.AchievementSummaryDto | null;
          pageMessages: Kaggle.Sdk.Common.Models.Legacy.PageMessageDto[];
          followers: Kaggle.Sdk.Users.Models.FollowersListDto | null;
          following: Kaggle.Sdk.Users.Models.FollowersListDto | null;
          canSeeFollowers: boolean;
          canSeeCallToAction: boolean;
          canSeeNotifications: boolean;
          canSeeAtMentions: boolean;
          totalScripts: /*Int32*/ number;
          isAdmin: boolean;
          isEditing: boolean;
          userAllowsUserMessages: boolean;
        }

        export interface VerifyPhoneDto {
          returnUrl: string | null;
          alreadySentCode: boolean;
        }

        export enum FollowersListType {
          FOLLOWERS = "followers", // = 1;
          FOLLOWING = "following", // = 2;
        }

        export enum FollowersReponseStatus {
          OK = "ok", // = 1;
          ERROR = "error", // = 2;
        }

        export enum ProfileArea {
          HOME = "home", // = 0;
          COMPETITIONS = "competitions", // = 1;
          CODE = "code", // = 2;
          DISCUSSION = "discussion", // = 3;
          DATASETS = "datasets", // = 4;
          ACCOUNT = "account", // = 5;
          CONTACT = "contact", // = 6;
          FOLLOWERS = "followers", // = 7;
          FOLLOWING = "following", // = 8;
          GENIE = "genie", // = 9;
          NOTIFICATIONS = "notifications", // = 10;
          NOTEBOOKS = "notebooks", // = 11;
        }

        export enum UserStatus {
          INACTIVATED = "inactivated", // = 1;
          ACTIVE = "active", // = 2;
          LOCKED_OUT = "lockedOut", // = 3;
          SPAM_BLOCKED = "spamBlocked", // = 4;
          CHEAT_BLOCKED = "cheatBlocked", // = 5;
          SOFT_DELETED = "softDeleted", // = 6;
          HARD_DELETED = "hardDeleted", // = 7;
          KERNEL_ABUSE_BLOCKED = "kernelAbuseBlocked", // = 8;
        }
      }

      export interface AcceptCookiesRequest {}

      export interface AccountDto {
        userId: number;
        userName?: /* google.protobuf.StringValue */ string | null;
        emailAddress?: /* google.protobuf.StringValue */ string | null;
        editedEmailAddress?: /* google.protobuf.StringValue */ string | null;
        verifyAccountUrl?: /* google.protobuf.StringValue */ string | null;
        isSmsVerified: boolean;
        isSubscribedToMailingList?: /* google.protobuf.BoolValue */ boolean | null;
        logins: Kaggle.Sdk.Users.UserLoginDto[];
        canSeeApi: boolean;
        datasetLimits: Kaggle.Sdk.Datasets.DatasetLimits | null;
      }

      export interface AchievementTypeRanking {
        // The progression type for the ranking
        type: Kaggle.Sdk.Users.UserAchievementType;
        // The ranking for this user for the corresponding progression type
        ranking: number;
      }

      export interface ActivateAccountRequest {
        userId: number;
        reason?: /* google.protobuf.StringValue */ string | null;
        verificationCode?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ActivateMarketplaceUserRequest {
        // Id of that user in the external billing system.
        procurementAccountId: string;
      }

      export interface ActivateMarketplaceUserResponse {}

      export interface ActivityCalendar {
        // This name cannot be changed as react-calendar-heatmap relies on the name of this property being "date"
        date: /* google.protobuf.Timestamp */ string | null;
        totalSubmissionsCount: number;
        totalScriptsCount: number;
        totalDiscussionsCount: number;
        totalDatasetsCount: number;
      }

      export interface AttributeValue {
        // The attribute ID for the corresponding value
        attributeId: Kaggle.Sdk.Users.AttributeId;
        // The value for this attribute
        value?: /* google.protobuf.StringValue */ string | null;
      }

      export interface Bookmark {
        // The content type for a given Bookmark
        bookmarkType: Kaggle.Sdk.Users.BookmarkType;
        // The ID for the underlying entity, of content type bookmark_type
        bookmarkedEntityId: number;
        // Title of the piece of content
        title?: /* google.protobuf.StringValue */ string | null;
        // URL linking to the piece of content
        url?: /* google.protobuf.StringValue */ string | null;
        // Slug to link to the author user
        authorSlug?: /* google.protobuf.StringValue */ string | null;
        // URL for the thumbnail of the piece of content
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        // The timestamp for when a bookmark was created
        bookmarkedDate: /* google.protobuf.Timestamp */ string | null;
      }

      export interface BulkVerifyPhoneRequest {
        // List of user ids to verify.
        userIds: number[];
        // List of corresponding phone numbers to verify.
        // Counts need to match, each user_id corresponds to one phone_numer.
        phoneNumbers: /* google.protobuf.StringValue */ string[];
        // Whether to verify the phone numbers without checking for users already using those phone numbers.
        forceVerify: boolean;
      }

      export interface CancelMarketplaceActivationRequest {
        // Id of that user in the external billing system.
        procurementAccountId: string;
      }

      export interface CancelMarketplaceActivationResponse {}

      export interface CheatBlockAccountRequest {
        // User to block for cheating.
        userId: number;
        // Reason the user is being blocked for cheating.
        reason?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CheckForNudgeRequest {}

      export interface CheckForNudgeResponse {
        potentialNudges: Kaggle.Sdk.Users.PotentialNudge[];
      }

      export interface Collaborator {
        userId?: /* google.protobuf.Int32Value */ number | null;
        groupId?: /* google.protobuf.Int32Value */ number | null;
        groupMemberCount?: /* google.protobuf.Int32Value */ number | null;
        profileUrl: string;
        thumbnailUrl: string;
        name: string;
        slug: string;
        userTier: Kaggle.Sdk.Users.UserAchievementTier;
        joinDate: /* google.protobuf.Timestamp */ string | null;
        type: Kaggle.Sdk.Users.CollaboratorType;
        isUser: boolean;
        isGroup: boolean;
      }

      export interface CollaboratorList {
        /*[NotNull]*/
        owner: Kaggle.Sdk.Users.Collaborator;
        /*[NotNull]*/
        collaborators: Kaggle.Sdk.Users.Collaborator[];
      }

      export interface ContactSupportRequest {
        name: string;
        email: string;
        responses: { [key: string]: string };
        question?: /* google.protobuf.StringValue */ string | null;
        requireCaptcha: boolean;
        captchaResponse?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ConvertLegacyFavoritesRequest {
        // The content type to convert to Bookmarks
        bookmarkType: Kaggle.Sdk.Users.BookmarkType;
        // Enum indicating which conversion method to use, disposal or migration
        conversionMethod: Kaggle.Sdk.Users.ConversionMethod;
      }

      export interface ConvertLegacyFavoritesResponse {}

      export interface CreateBookmarkRequest {
        // A Bookmark message describing what Bookmark to create for the current user
        bookmark: Kaggle.Sdk.Users.Bookmark | null;
      }

      export interface CreateBookmarkResponse {}

      export interface CreateKaggleAccountRequest {
        // User who will be getting a kaggle login.
        userId: number;
        // Password to use for that kaggle login. 
        password?: /* google.protobuf.StringValue */ string | null;
      }

      export interface CreateUserMessageRequest {
        // The user to send a message to.
        userId: number;
        // The subject of the message.
        subject: string;
        // The body of the message. Text only (no markdown/html).
        body: string;
      }

      export interface CreateUserMessageResponse {}

      export interface DeleteBookmarkRequest {
        // A Bookmark message describing what Bookmark to delete for the current user
        bookmark: Kaggle.Sdk.Users.Bookmark | null;
      }

      export interface DeleteBookmarkResponse {}

      export interface DeleteCurrentAccountRequest {
        // The user-provided reason for why they are deleting their account.
        reason: string;
        // The response from the captcha to validate.
        captchaResponseToken: string;
      }

      export interface DeletePhoneVerificationsRequest {
        userId: number;
      }

      export interface DeleteRecentlyViewedItemsRequest {
        userId: number;
      }

      export interface DeleteRecentlyViewedItemsResponse {}

      export interface DiscussionCounts {
        totalDiscussionsCount: number;
        totalTopicsCount: number;
        totalRepliesCount: number;
        totalUpvotesCount: number;
      }

      export interface DiscussionItem {
        id: number;
        totalScore: number;
        postTime: /* google.protobuf.Timestamp */ string | null;
        message: string;
        medal: Kaggle.Sdk.Users.Medal;
        attachments: Kaggle.Sdk.Discussions.CommentAttachment[];
        type: Kaggle.Sdk.Users.DiscussionType;
        script: Kaggle.Sdk.Discussions.DiscussionItemLink | null;
        forum: Kaggle.Sdk.Discussions.DiscussionItemLink | null;
        forumTopic: Kaggle.Sdk.Discussions.DiscussionItemLink | null;
        vote: Kaggle.Sdk.Discussions.CommentVoteButton | null;
      }

      export interface DismissHatsRequest {
        location: Kaggle.Sdk.Users.HatsLocation;
        userClickedLink: boolean;
      }

      export interface DismissHatsResponse {}

      export interface DismissSurveyRequest {
        location: Kaggle.Sdk.Users.HatsLocation;
        userClickedSurvey: boolean;
        surveyType: Kaggle.Sdk.Users.SurveyType;
      }

      export interface DismissSurveyResponse {}

      export interface ExpireApiTokensRequest {
        // Username of the user whose api tokens will be expired/invalidated.
        userName: string;
        // Why are we expiring api tokens of the user.
        reason: string;
      }

      export interface FailNerdchaRequest {
        // User who's pending nerdchas will be marked as failed.
        userId: number;
      }

      export interface FollowUserRequest {
        // The username of the user to follow
        userName: string;
      }

      export interface FollowUserResponse {}

      export interface GenerateAnalyticsTokenRequest {}

      export interface GenerateAnalyticsTokenResponse {
        token: string;
      }

      export interface GenerateApiTokenRequest {}

      export interface GenerateApiTokenResponse {
        userName: string;
        apiToken: string;
      }

      export interface GetBookmarkMigrationStatusRequest {
        // The content type to fetch bookmark status for
        bookmarkType: Kaggle.Sdk.Users.BookmarkType;
      }

      export interface GetBookmarkMigrationStatusResponse {
        // Remaining legacy favorites to migrate to bookmarks
        remainingCount: number;
      }

      export interface GetCaptchaConfigRequest {
        // The ReCaptcha version. Valid values are `v2` or `v3`.
        version: string;
      }

      export interface GetCaptchaConfigResponse {
        // The ReCaptcha site key.
        siteKey: string;
        // Whether captcha verification is enabled.
        enabled: boolean;
      }

      export interface GetContactUserInfoRequest {}

      export interface GetContactUserInfoResponse {
        canSend: boolean;
        emailsRemaining: number;
        error: Kaggle.Sdk.Users.ContactUserInfoError;
      }

      export interface GetCurrentUserIdRequest {}

      export interface GetCurrentUserIdResponse {
        // Id of the current user, or null if the user isn't logged in.
        currentUserId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface GetCurrentUserProgressionRequest {}

      export interface GetCurrentUserProgressionResponse {
        // Sets of requirements for each progression type for the user. A group consists of all requirements
        // for a given type (Competitions, Kernels, etc.) and tier (Expert, Master, etc.). A group can have
        // multiple requirements, where a single requirement may be "3 Gold Competition Medals".
        tierRequirementGroups: Kaggle.Sdk.Users.TierRequirementGroup[];
        // The user's ranking for each progression type
        achievementTypeRankings: Kaggle.Sdk.Users.AchievementTypeRanking[];
      }

      export interface GetCurrentUserRequest {
        // Whether to also load the groups the user is a part of.
        includeGroups: boolean;
      }

      export interface GetDuplicateUsersRequest {
        // User to run the duplicate detection on.
        userId: number;
      }

      export interface GetDuplicateUsersResponse {
        // List of users who might be duplicates.
        duplicateUserIds: number[];
      }

      export interface GetMyAttributesRequest {
        attributes: Kaggle.Sdk.Users.AttributeId[];
      }

      export interface GetMyAttributesResponse {
        attributes: string[];
      }

      export interface GetNerdChallengeRequest {
        challengeIdToken?: string;
        userId?: number;
        createNewIfNoActiveChallenge: boolean;
        forceNewChallenge: boolean;
        newChallengeReason: string;
      }

      export interface GetNerdChallengeResponse {
        challengeIdToken: string;
        question: string;
      }

      export interface GetNewPasswordRequest {}

      export interface GetNewPasswordResponse {
        // The randomly generated new password.
        newPassword?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetOrganizationsRequest {
        filter?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetOrganizationsResponse {
        organizations: Kaggle.Sdk.Users.OrganizationCard[];
      }

      export interface GetProfilePreviewRequest {
        // The user ID for whom to return a profile preview
        userId?: number;
        // The user name for whom to return a profile preview
        userName?: string;
      }

      export interface GetProfilePreviewResponse {
        // The requested user's user name
        userName: string;
        // The requested user's display name
        displayName: string;
        // The URL for the requested user's profile
        profileUrl: string;
        // The URL For the requested user's avatar
        thumbnailUrl: string;
        // The requested user's tier
        performanceTier: Kaggle.Sdk.Users.UserAchievementTier;
        // The requested user's country
        country: string;
        // The requested user's region
        region: string;
        // The requested user's city
        city: string;
        // The requested user's occupation
        occupation: string;
        // Boolean indicating whether or not the current user is following the requested user
        isFollowing: boolean;
      }

      export interface GetRecentlyViewedItemsRequest {
        userId: number;
        itemCount: number;
        returnedType: Kaggle.Sdk.Users.ReturnedItemsType;
      }

      export interface GetRecentlyViewedItemsResponse {
        recentlyViewedItems: Kaggle.Sdk.Users.RecentlyViewedItem[];
      }

      export interface GetUserActivityRequest {
        userName: string;
      }

      export interface GetUserActivityResponse {
        activities: Kaggle.Sdk.Users.ActivityCalendar[];
      }

      export interface GetUserCountRequest {}

      export interface GetUserCountResponse {
        userCount: number;
      }

      export interface GetUserDiscussionCountsRequest {
        userName: string;
      }

      export interface GetUserDiscussionMessagesRequest {
        userName: string;
        sortBy: Kaggle.Sdk.Users.DiscussionSortBy;
        group: Kaggle.Sdk.Users.DiscussionSelectionGroup;
        page: number;
      }

      export interface GetUserDiscussionMessagesResponse {
        messages: Kaggle.Sdk.Users.DiscussionItem[];
      }

      export interface GetUserHatsStatusRequest {
        location: Kaggle.Sdk.Users.HatsLocation;
      }

      export interface GetUserHatsStatusResponse {
        // Deprecated: use survey_type enum instead
        showPrompt: boolean;
        // Deprecated: used to show the 2020 diversity study
        showDiversityStudyPrompt: boolean;
        // What type of survey to show
        surveyType: Kaggle.Sdk.Users.SurveyType;
      }

      export interface GetUserPlanLogRequest {
        // Id of the user to change the history for. This request is admin-only.
        userId: number;
      }

      export interface GetUserPlanLogResponse {
        // History of plans for the requested user. If empty, it means the user is on the FREE plan by default.
        log: Kaggle.Sdk.Users.UserPlanLog[];
      }

      export interface GetUserPlanRequest {
        // Id of the user to get the info for (since the "free" / "pro" status should be public knowledge, other users
        // should be able to query that (not just for your own user) e.g. when viewing profile pages.
        userId: number;
      }

      export interface GetUserPlanResponse {
        // Enum reflecting the plan the requested user is currently on.
        currentPlan: Kaggle.Sdk.Users.UserPlan;
        // Optionally whether this plan expires at some future date. In most cases, this will be null.
        expiryDate: /* google.protobuf.Timestamp */ string | null;
        // When did the current plan come into effect.
        signupDate: /* google.protobuf.Timestamp */ string | null;
      }

      export interface GetUserRankingsRequest {
        group: Kaggle.Sdk.Users.AchievementSummaryType;
        page: number;
      }

      export interface GetUserRequest {
        // User to retrieve information about.
        userId?: /* google.protobuf.Int32Value */ number | null;
        // Which fields to retrieve (to avoid loading unnecessary fields).
        readMask: google.protobuf.FieldMask | null;
      }

      export interface GetUserStatusLogsRequest {
        // User to get status logs of.
        userId: number;
      }

      export interface GetUserStatusLogsResponse {
        // List of status logs for the user.
        userStatusLogs: Kaggle.Sdk.Users.UserStatusLog[];
      }

      export interface GrantSiteAdminRequest {
        // The user who will be given admin privileges. Must only have a "google.com" or "kaggle.com" OAuth login.
        userId: number;
      }

      export interface KernelAbuseBlockAccountRequest {
        // User to block for kernel abuse.
        userId: number;
        // Reason the user is being blocked for kernel abuse.
        reason?: /* google.protobuf.StringValue */ string | null;
      }

      export interface KernelAbuseMassBlockAccountsRequest {
        // List of users to block for kernel abuse.
        userIds: number[];
        // Reason to apply to each user for the block.
        reason?: /* google.protobuf.StringValue */ string | null;
      }

      export interface KernelAbuseMassBlockAccountsResponse {
        // The summary of actions taken or errors encountered.
        summary: /* google.protobuf.StringValue */ string[];
      }

      export interface LeaderboardCounts {
        tier: Kaggle.Sdk.Users.UserAchievementTier;
        count: number;
      }

      export interface LeaderboardsListItem {
        currentRanking?: /* google.protobuf.Int32Value */ number | null;
        displayName?: /* google.protobuf.StringValue */ string | null;
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        userId: number;
        userUrl?: /* google.protobuf.StringValue */ string | null;
        tier: Kaggle.Sdk.Users.UserAchievementTier;
        points: number;
        joinTime: /* google.protobuf.Timestamp */ string | null;
        totalGoldMedals: number;
        totalSilverMedals: number;
        totalBronzeMedals: number;
      }

      export interface LegacyChangePasswordRequest {
        userName?: /* google.protobuf.StringValue */ string | null;
        currentPassword?: /* google.protobuf.StringValue */ string | null;
        newPassword?: /* google.protobuf.StringValue */ string | null;
      }

      export interface LegacyDeleteUserLoginRequest {
        userName?: /* google.protobuf.StringValue */ string | null;
        providerName?: /* google.protobuf.StringValue */ string | null;
        userLoginId: number;
      }

      export interface LegacyGetAccountRequest {
        userName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface LegacyUpdateAccountEmailAddressRequest {
        userName?: /* google.protobuf.StringValue */ string | null;
        emailAddress?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ListAllBookmarksRequest {
        // The number of bookmarks to return
        itemCount: number;
      }

      export interface ListAllBookmarksResponse {
        // Bookmark objects for the current user
        bookmarks: Kaggle.Sdk.Users.Bookmark[];
      }

      export interface MigrateTermsAcceptancesRequest {
        date: /* google.protobuf.Timestamp */ string | null;
        pageSize: number;
        pagesToRetrievePerRun: number;
      }

      export interface MigrateTermsAcceptancesResponse {
        unsuccessfulMigrations: number;
      }

      export interface NewEmailRegistrationUserRequest {
        // The display name for the new user.
        displayName: string;
        // The username for the new user.
        userName: string;
        // The email for the new user.
        email: string;
        // The password for the new user.
        password: string;
        // The captcha response from the registration page.
        captchaResponse: string;
        // Whether the new user wants to subscribe to receiving Kaggle news.
        iWishToSubscribeToYourNewsletter: boolean;
        // The URL to redirect the user to after successful registration.
        returnUrl: string;
        // Whether opt-out logic was used for the email signup.
        newsEmailSignupWasOptOut: boolean;
      }

      export interface NewEmailRegistrationUserResponse {
        // The registration errors for each field on the form.
        errors: Kaggle.Sdk.Users.RegistrationError[];
        // The user ID that was created for the user.
        createdUserId: number;
      }

      export interface OrganizationCard {
        name: string;
        id: number;
        thumbnailImageUrl: string;
      }

      export interface Place {
        displayLocation?: /* google.protobuf.StringValue */ string | null;
        normalizedLocation?: /* google.protobuf.StringValue */ string | null;
      }

      export interface PotentialNudge {
        // What kind of nudge to show (or NO_NUDGE)
        type: Kaggle.Sdk.Users.NudgeType;
        // the pages that this nudge is allowed to show on
        page: Kaggle.Sdk.Users.NudgePage;
        // what priority value to use when evaluating which nudge to show to user. Higher priority value == more important
        priority: number;
        // What variant this nudge is. Variants are different versons of the same nudge
        // Currently no display differences between variants, it's only for selecting different groups of users
        variant?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface ReactToNudgeRequest {
        // Which nudge to dismiss
        nudgeId: number;
        // Whether the user acted upon the nudge (clicked the call to action) or just dismissed it
        reaction: Kaggle.Sdk.Users.NudgeReactions;
        // Whether the user wants these messages to never show for them again
        dontShowAgain: boolean;
      }

      export interface ReactToNudgeResponse {}

      export interface RecentlyViewedItem {
        title: string;
        url: string;
        itemType: Kaggle.Sdk.Users.RecentlyViewedItemType;
        authorSlug: string;
        mostRecentView: /* google.protobuf.Timestamp */ string | null;
        thumbnailUrl: string;
      }

      export interface RegistrationError {
        // The field on the registration form.
        field: Kaggle.Sdk.Users.RegistrationInfoFields;
        // The ID of the message to display to the user.
        messageId: Kaggle.Sdk.Users.LoginMessageId;
      }

      export interface RegistrationValidationRequest {
        // The display name for the new user.
        displayName: string;
        // The username for the new user.
        userName: string;
        // The email for the new user.
        email: string;
        // The password for the new user.
        password: string;
        // The captcha response from the registration page.
        captcha: string;
      }

      export interface RegistrationValidationResponse {
        // The registration errors for each field on the form.
        errors: Kaggle.Sdk.Users.RegistrationError[];
      }

      export interface ResendVerificationEmailRequest {
        email?: /* google.protobuf.StringValue */ string | null;
        userId?: /* google.protobuf.Int32Value */ number | null;
        returnUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ResetPasswordRequest {
        // The url the user started the password reset flow on (to send the back to).
        returnUrl?: /* google.protobuf.StringValue */ string | null;
        // The user whose password we're trying to reset. Must match the code.
        userId: number;
        // The new password the user would like.
        newPassword?: /* google.protobuf.StringValue */ string | null;
        // The reset code, an alphanumeric 6-character code generated by the start of the flow.
        resetPasswordCode?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ResetPasswordResponse {
        // The URl of where the user should be redirected to.
        returnUrl: string;
      }

      export interface RevokeSiteAdminRequest {
        // The user who's admin privileges will be taken away.
        userId: number;
      }

      export interface SearchPlacesRequest {
        input?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SearchPlacesResponse {
        places: Kaggle.Sdk.Users.Place[];
      }

      export interface SearchUsersSuggestionsRequest {
        pageSize: number;
        query?: /* google.protobuf.StringValue */ string | null;
        topicId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface SearchUsersSuggestionsResponse {
        usersSuggestions: Kaggle.Sdk.Users.UserSuggestion[];
      }

      export interface SetCancelPlanReasonRequest {
        reason: Kaggle.Sdk.Users.CancelPlanReason;
      }

      export interface SetCancelPlanReasonResponse {}

      export interface SetMyAttributesRequest {
        attributes: Kaggle.Sdk.Users.AttributeValue[];
      }

      export interface SetPhoneReputableRequest {
        userId: number;
        phoneNumber?: /* google.protobuf.StringValue */ string | null;
        force: boolean;
      }

      export interface ShowingNudgeRequest {
        // type of the nudge that the user will see
        type: Kaggle.Sdk.Users.NudgeType;
        // What variant the user will see
        variant?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface ShowingNudgeResponse {
        // Unique Id to identify the nudge, used to dismiss
        // If value is 0 then this is a duplicate and the nudge should not be shown to the user
        userNudgeId: number;
      }

      export interface SignOutRequest {}

      export interface SoftDeleteAccountRequest {
        // The id of the user to delete.
        userId: number;
        // The reason the account is being deleted.
        reason: string;
      }

      export interface SoftDeleteAccountResponse {
        // Whether the user was successfully deleted.
        userSoftDeleted: boolean;
        // Which (if any) datasets of the user need to be reviewed before deletion.
        datasetsNeedingReview: Kaggle.Sdk.Datasets.DatasetForReview[];
      }

      export interface SpamBlockAccountRequest {
        // User to block for spam.
        userId: number;
        // Reason the user is being blocked for spam.
        reason?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SpamBlockMultipleAccountRequest {
        // Space-separated list of users to block for spam.
        userIdList?: /* google.protobuf.StringValue */ string | null;
        // Reason to apply to each user for the block.
        reason?: /* google.protobuf.StringValue */ string | null;
      }

      export interface SpamBlockMultipleAccountResponse {
        // List of users who were successfully blocked.
        blockedUserIds: number[];
        // Count of users who were successfully blocked.
        blockedCount: number;
        // List of users who couldn't be blocked because of an exception.
        failedBlockUserIds: number[];
        // Count of users who couldn't be blocked.
        failedBlockCount: number;
        // How much time in milliseconds it took to block these users.
        elapsedTimeMillis: number;
      }

      export interface StartMigrateSsoRequest {
        email?: /* google.protobuf.StringValue */ string | null;
        returnUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface StartMigrateSsoResponse {
        outcome: Kaggle.Sdk.Users.StartMigrateSsoOutcome;
        userId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface StartPhoneVerificationRequest {
        // The phone number to verify
        phoneNumber: string;
        // The captcha response from the phone verification page
        captchaResponse: string;
        // The URL to return the user to after completing verification
        returnUrl: string;
      }

      export interface StartPhoneVerificationResponse {
        // Whether a code was successfully sent
        successful: boolean;
        // Whether the user is already phone verified
        phoneVerified: boolean;
        // The response message for the user
        message: string;
        // Whether the user is in India, requiring a different verification path
        india: boolean;
      }

      export interface StartResetPasswordRequest {
        // The email of the user who's password is being reset. If there's a matching user an email will be sent to this
        // address. If there's no matching user, the response will be identical, but without any email being sent.
        email: string;
        // The return Url for after this process is complete, sent as part of a link to the user's email.
        returnUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface TierRequirement {
        // The copy shown to the user for the requirement
        label: string;
        // The call-to-action URL for the requirement
        url: string;
        // The total number required to satisfy the requirement
        numberRequired: number;
        // The current number of the requirement completed by the user
        numberMet: number;
      }

      export interface TierRequirementGroup {
        // The progression tier for the set of requirements
        tier: Kaggle.Sdk.Users.UserAchievementTier;
        // The progression type for the set of requirements
        type: Kaggle.Sdk.Users.UserAchievementType;
        // Whether the full set of requirements is complete
        isComplete: boolean;
        // Whether this progression type/tier is the current in-progress tier
        isInProgress: boolean;
        // The set of requirements for the type/tier
        requirements: Kaggle.Sdk.Users.TierRequirement[];
      }

      export interface UnfollowUserRequest {
        // The username of the user to unfollow
        userName: string;
      }

      export interface UnfollowUserResponse {}

      export interface UnsubscribeNewsletterRequest {
        userId: number;
      }

      export interface UnverifyPhoneRequest {
        // User to unverify.
        userId: number;
      }

      export interface UpdateBioRequest {
        // The new bio to be saved.
        bio: string;
        // The user this bio is for, usually the current user.
        userId: number;
      }

      export interface UpdateBioResponse {}

      export interface UpdateProfileImageRequest {
        // The Id of the user to update the profile image.
        userId: number;
        // The profile image along with a cropping rectangle. 
        profileImage: Kaggle.Sdk.Common.CroppedImageUpload | null;
      }

      export interface UpdateProfileImageResponse {
        // URL for the primary profile image.
        imageUrl: string;
        // URL for the smaller/thumbnail image.
        thumbnailUrl: string;
      }

      export interface UpdateProfileRequest {
        // The Id of the user being updated
        userId?: number;
        // The username of the user being updated
        userName?: string;
        // The user's display name
        displayName?: /* google.protobuf.StringValue */ string | null;
        // The user's username in github
        gitHubUserName?: /* google.protobuf.StringValue */ string | null;
        // The user's username on twitter
        twitterUserName?: /* google.protobuf.StringValue */ string | null;
        // A url corresponding to the user's linked in page
        linkedInUrl?: /* google.protobuf.StringValue */ string | null;
        // City the user lives in
        city?: /* google.protobuf.StringValue */ string | null;
        // Region the user lives in (state, province etc)
        region?: /* google.protobuf.StringValue */ string | null;
        // Country the user lives in
        country?: /* google.protobuf.StringValue */ string | null;
        // User's current occupation
        occupation?: /* google.protobuf.StringValue */ string | null;
        // Organization user currently works for
        organization?: /* google.protobuf.StringValue */ string | null;
        // A link to the user's website
        website?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdateProfileResponse {
        wasSuccessful: boolean;
        errorMessage?: /* google.protobuf.StringValue */ string | null;
        parsedTwitterUserName?: /* google.protobuf.StringValue */ string | null;
        parsedGitHubUserName?: /* google.protobuf.StringValue */ string | null;
        parsedLinkedInUrl?: /* google.protobuf.StringValue */ string | null;
        parsedWebsite?: /* google.protobuf.StringValue */ string | null;
        displayName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UpdateUserPlanRequest {
        // Id of the user to change the plan for. These requests will be only executed by a background service (which needs
        // to do this for arbitrary users).
        userId: number;
        // Enum reflecting the new plan.
        newPlan: Kaggle.Sdk.Users.UserPlan;
        // Optionally an effective date for the new plan. If this is null, the new plan is effective immediately.
        effectiveDate: /* google.protobuf.Timestamp */ string | null;
        // Optionally an end date for the new plan. If this is null, this plan won't expire unless a new plan is set.
        endDate: /* google.protobuf.Timestamp */ string | null;
        // Id of that user in the external billing system. Required for all paid plans, optional if new_plan is FREE.
        procurementAccountId: string;
      }

      export interface UpdateUserPlanResponse {}

      export interface User {
        id?: /* google.protobuf.Int32Value */ number | null;
        displayName?: /* google.protobuf.StringValue */ string | null;
        email?: /* google.protobuf.StringValue */ string | null;
        editedEmail?: /* google.protobuf.StringValue */ string | null;
        editedEmailCode?: /* google.protobuf.StringValue */ string | null;
        userName?: /* google.protobuf.StringValue */ string | null;
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        profileUrl?: /* google.protobuf.StringValue */ string | null;
        registerDate: /* google.protobuf.Timestamp */ string | null;
        lastVisitDate: /* google.protobuf.Timestamp */ string | null;
        statusId: number;
        performanceTier: Kaggle.Sdk.Users.UserAchievementTier;
        userLogins: Kaggle.Sdk.Users.UserLogin[];
        groupIds: number[];
        duplicateUsers: Kaggle.Sdk.Users.User[];
        hasPhoneVerifications: boolean;
        failedNerdchas: number;
        hasPendingNerdcha: boolean;
        deleteRequests: string[];
        isAdmin: boolean;
        isKaggleBot: boolean;
        // bool is_anonymous = 22;
        canAct: boolean;
        canBeSeen: boolean;
        thumbnailName?: /* google.protobuf.StringValue */ string | null;
        isPhoneVerified: boolean;
        grandfatheredCompetitionTier?: /* google.protobuf.Int32Value */ number | null;
        isAnonymous: boolean;
      }

      export interface UserAvatar {
        // Display name for the given user
        displayName?: /* google.protobuf.StringValue */ string | null;
        // Thumbnail URL for the given user
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        // Profile URL for the given user
        url?: /* google.protobuf.StringValue */ string | null;
        // User name for the given user
        userName?: /* google.protobuf.StringValue */ string | null;
        // Tier for the given user
        tier: Kaggle.Sdk.Users.UserAchievementTier;
        // ID for the given user
        id: number;
      }

      export interface UserLogin {
        name?: /* google.protobuf.StringValue */ string | null;
        email?: /* google.protobuf.StringValue */ string | null;
        isDisabled: boolean;
        linkedDate: /* google.protobuf.Timestamp */ string | null;
      }

      export interface UserLoginDto {
        loginId: number;
        loginIdentifier?: /* google.protobuf.StringValue */ string | null;
        emailFromProvider?: /* google.protobuf.StringValue */ string | null;
        loginProviderId: number;
        loginProviderName?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UserPlanLog {
        // The plan that was active between start_date and end_date
        plan: Kaggle.Sdk.Users.UserPlan;
        // When did the plan become active
        startDate: /* google.protobuf.Timestamp */ string | null;
        // Optionally an end date for the plan. If this is null, this plan is active and won't expire unless a new plan is set.
        endDate: /* google.protobuf.Timestamp */ string | null;
      }

      export interface UserRankings {
        group: Kaggle.Sdk.Users.AchievementSummaryType;
        userRanking: Kaggle.Sdk.Users.LeaderboardsListItem | null;
        totalUsers: number;
        counts: Kaggle.Sdk.Users.LeaderboardCounts[];
        list: Kaggle.Sdk.Users.LeaderboardsListItem[];
      }

      export interface UserStatusLog {
        // Status that the user was changed to.
        statusId: number;
        // The date the status was changed.
        logDate: /* google.protobuf.Timestamp */ string | null;
        // The reason the status was changed.
        reason?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UserSuggestion {
        id: number;
        userName?: /* google.protobuf.StringValue */ string | null;
        displayName?: /* google.protobuf.StringValue */ string | null;
        thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
        profileUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ValidateResetPasswordCodeRequest {
        // The email address of the user you are validating the password of.
        email: string;
        // The code sent to email of the password to reset.
        resetPasswordCode: string;
        // Whether the code should automatically be resent if it is expired.
        resendIfExpired: boolean;
        // The return url for the user, needed for resending the code.
        returnUrl?: /* google.protobuf.StringValue */ string | null;
      }

      export interface ValidateResetPasswordCodeResponse {
        // What was the outcome of validating the code.
        outcome: Kaggle.Sdk.Users.ValidateResetPasswordCodeOutcome;
        // The user id of the matching user. Only returned if code and email are a valid match.
        userId?: /* google.protobuf.Int32Value */ number | null;
      }

      export interface VerifyAccountEmailRequest {
        // The verification code typed in by the user
        verificationCode: string;
        // The user to be verified.
        userId: number;
        // Their return URL, used in case the email needs to be resent.
        returnUrl: string;
      }

      export interface VerifyAccountEmailResponse {
        // The given return url, verified to be a local url (safe to redirect to).
        localReturnUrl: string;
      }

      export interface VerifyCaptchaRequest {
        // The ReCaptcha response token.
        token: string;
      }

      export interface VerifyCaptchaResponse {}

      export interface VerifyNerdChallengeAnswerRequest {
        challengeIdToken: string;
        answer: string;
        comment: string;
      }

      export interface VerifyNerdChallengeAnswerResponse {
        success: boolean;
        error: string;
        challengeIdToken: string;
        question: string;
        overrideUrl: string;
      }

      export interface VerifyPhoneRequest {
        userId: number;
        phoneNumber?: /* google.protobuf.StringValue */ string | null;
        forceVerify: boolean;
      }

      export interface VerifyPhoneVerificationCodeRequest {
        // The verification code entered by the user.
        verificationCode: string;
        // Whether this phone number is being reassigned to a different account.
        reassignPhoneNumber: boolean;
      }

      export interface VerifyPhoneVerificationCodeResponse {
        // Whether a code was successfully sent.
        isSuccessful: boolean;
        // Whether the user is already phone verified.
        isPhoneVerified: boolean;
        // The response message for the user.
        message: string;
        // Whether this phone number can be reassigned to a different account.
        canReassign: boolean;
        // Whether this phone number is a duplicate from another account.
        isDuplicate: boolean;
      }
      // Used via WithErrorInfo
      export enum AccountError {
        UNSPECIFIED = "unspecified", // = 0;
        // User needs to verify their phone number.
        PHONE_VERIFICATION_REQUIRED = "phoneVerificationRequired", // = 1;
      }
      // NOTE: The frontend assumes (see NextTier.tsx) that this type is the same as UserAchievementType.
      // These should likely be refactored to a single enum.
      export enum AchievementSummaryType {
        UNSPECIFIED = "unspecified", // = 0;
        COMPETITIONS = "competitions", // = 1;
        NOTEBOOKS = "notebooks", // = 2;
        DISCUSSION = "discussion", // = 3;
        DATASETS = "datasets", // = 4;
      }

      export enum AttributeId {
        UNSPECIFIED = "unspecified", // = 0;
        NOTIFICATIONS_SUBSCRIBE_TO_KAGGLE_NEWSLETTER = "notificationsSubscribeToKaggleNewsletter", // = 17;
        ADDRESS_COUNTRY = "addressCountry", // = 18;
        ADDRESS_REGION = "addressRegion", // = 19;
        ADDRESS_CITY = "addressCity", // = 20;
        WEBSITE = "website", // = 26;
        LINKEDIN_URL = "linkedinUrl", // = 27;
        TWITTER_USER_NAME = "twitterUserName", // = 28;
        GITHUB_USER_NAME = "githubUserName", // = 29;
        BIO = "bio", // = 42;
        OCCUPATION = "occupation", // = 96;
        ORGANIZATION = "organization", // = 97;
        DISCUSSION_SETTINGS = "discussionSettings", // = 102;
        NOTIFICATIONS_ENABLED = "notificationsEnabled", // = 109;
        NOTIFICATIONS_AT_MENTIONS_SETTING = "notificationsAtMentionsSetting", // = 110;
        NOTIFICATIONS_BLOCK_COLLABORATION_EMAILS = "notificationsBlockCollaborationEmails", // = 111;
        NOTIFICATIONS_DEFAULT_DELIVERY_SETTING = "notificationsDefaultDeliverySetting", // = 113;
        NOTIFICATIONS_AGGREGATION_TYPE = "notificationsAggregationType", // = 114;
        DISMISSABLE_BANNER_NEWSFEED = "dismissableBannerNewsfeed", // = 115;
        KERNEL_EDITOR_NOTEBOOKS_DARK_MODE = "kernelEditorNotebooksDarkMode", // = 116;
        KERNEL_EDITOR_SCRIPTS_DARK_MODE = "kernelEditorScriptsDarkMode", // = 117;
        NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_SUMMARY_EMAIL = "notificationsUnsubscribedFromDatasetSummaryEmail", // = 118;
        HATS_LAST_DISMISSAL_DATE = "hatsLastDismissalDate", // = 120;
        HATS_LAST_CLICK_DATE = "hatsLastClickDate", // = 121;
        NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_TASK_SUMMARY_EMAIL = "notificationsUnsubscribedFromDatasetTaskSummaryEmail", // = 122;
        NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_TASK_EMAIL = "notificationsUnsubscribedFromDatasetTaskEmail", // = 123;
        NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_FOLLOWED_USER = "notificationsNotificationsAtMentionFollowedUser", // = 124;
        NOTIFICATIONS_NOTIFICATIONS_AT_MENTION_REGULAR_USER = "notificationsNotificationsAtMentionRegularUser", // = 125;
        NOTIFICATIONS_UNSUBSCRIBED_FROM_PRIVATE_DATASET_TASK_SUMMARY_EMAIL = "notificationsUnsubscribedFromPrivateDatasetTaskSummaryEmail", // = 127;
        NOTIFICATIONS_COMPETITION_ANNOUNCEMENTS = "notificationsCompetitionAnnouncements", // = 128;
        NOTIFICATIONS_COMPETITION_TEAM_UPDATES = "notificationsCompetitionTeamUpdates", // = 129;
        NOTIFICATIONS_ENGAGED_TOPIC_COMMENT = "notificationsEngagedTopicComment", // = 130;
        NOTIFICATIONS_DATASET_ALERTS = "notificationsDatasetAlerts", // = 131;
        DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY_2020_INTERACTION = "dataScienceAndMachineLearningSurvey2020Interaction", // = 132;
        REGISTRATION_RETURN_URL = "registrationReturnUrl", // = 133;
        TAG_COMMUNITY_FILTER = "tagCommunityFilter", // = 134;
        NOTIFICATIONS_UNSUBSCRIBED_FROM_DATASET_TRENDING_SUMMARY_EMAIL = "notificationsUnsubscribedFromDatasetTrendingSummaryEmail", // = 135;
        NOTIFICATIONS_NOTEBOOK_ALERTS = "notificationsNotebookAlerts", // = 136;
        BOOKMARKS_COMPETITIONS_MIGRATED = "bookmarksCompetitionsMigrated", // = 137;
        BOOKMARKS_DATASETS_MIGRATED = "bookmarksDatasetsMigrated", // = 138;
        BOOKMARKS_FORUM_TOPICS_MIGRATED = "bookmarksForumTopicsMigrated", // = 139;
        BOOKMARKS_KERNELS_MIGRATED = "bookmarksKernelsMigrated", // = 140;
        EMAIL_NUDGES_DISABLED = "emailNudgesDisabled", // = 141;
        EMPLOYER_NUDGES_DISABLED = "employerNudgesDisabled", // = 142;
        GOOGLE_ML_SUMMIT_2021_INTERACTION = "googleMlSummit2021Interaction", // = 143;
        REGISTRATION_NEWS_EMAIL_SIGNUP_WAS_OPT_OUT = "registrationNewsEmailSignupWasOptOut", // = 144;
        NOTIFICATIONS_USER_NEW_FOLLOWER = "notificationsUserNewFollower", // = 145;
        DS_SURVEY_2021_BANNER_LAST_CLICK_DATE = "dsSurvey2021BannerLastClickDate", // = 146;
        DS_SURVEY_2021_BANNER_LAST_DISMISSAL_DATE = "dsSurvey2021BannerLastDismissalDate", // = 147;
        DS_SURVEY_2021_NUDGE_LAST_CLICK_DATE = "dsSurvey2021NudgeLastClickDate", // = 148;
        DS_SURVEY_2021_NUDGE_LAST_DISMISSAL_DATE = "dsSurvey2021NudgeLastDismissalDate", // = 149;
        MODERATION_REPORTED_BANNER_DISMISSED_KERNEL_IDS = "moderationReportedBannerDismissedKernelIds", // = 150;
        MODERATION_REPORTED_BANNER_DISMISSED_DATASET_IDS = "moderationReportedBannerDismissedDatasetIds", // = 151;
      }

      export enum BookmarkType {
        UNSPECIFIED = "unspecified", // = 0;
        COMPETITION = "competition", // = 1;
        DATASET = "dataset", // = 2;
        FORUM_TOPIC = "forumTopic", // = 3;
        KERNEL = "kernel", // = 4;
      }

      export enum CancelPlanReason {
        OTHER = "other", // = 0;
        TOO_EXPENSIVE = "tooExpensive", // = 1;
        TEMPORARILY_LEAVING = "temporarilyLeaving", // = 2;
        INSUFFICIENT_COMPUTE = "insufficientCompute", // = 3;
      }

      export enum CollaboratorType {
        UNSPECIFIED = "unspecified", // = 0;
        READER = "reader", // = 1;
        WRITER = "writer", // = 2;
        OWNER = "owner", // = 3;
      }

      export enum ContactUserInfoError {
        UNSPECIFIED = "unspecified", // = 0;
        CONTACT_USER_INFO_NOVICE_USER = "contactUserInfoNoviceUser", // = 1;
        CONTACT_USER_INFO_QUOTA_REACHED = "contactUserInfoQuotaReached", // = 2;
      }

      export enum ConversionMethod {
        UNSPECIFIED = "unspecified", // = 0;
        MIGRATE = "migrate", // = 1;
        DISPOSE = "dispose", // = 2;
      }

      export enum DiscussionSelectionGroup {
        UNSPECIFIED = "unspecified", // = 0;
        COMMENTS_AND_TOPICS = "commentsAndTopics", // = 1;
        COMMENTS = "comments", // = 2;
        TOPICS = "topics", // = 3;
        UPVOTED = "upvoted", // = 4;
      }

      export enum DiscussionSortBy {
        UNSPECIFIED = "unspecified", // = 0;
        LATEST_POST = "latestPost", // = 1;
        MOST_VOTES = "mostVotes", // = 2;
      }

      export enum DiscussionType {
        UNSPECIFIED = "unspecified", // = 0;
        SCRIPT_COMMENT = "scriptComment", // = 1;
        FORUM_TOPIC = "forumTopic", // = 2;
        FORUM_MESSAGE = "forumMessage", // = 3;
      }

      export enum HatsLocation {
        UNSPECIFIED = "unspecified", // = 0;
        HOMEPAGE = "homepage", // = 1;
        COMPETITIONS = "competitions", // = 2;
        DATASETS = "datasets", // = 3;
        NOTEBOOKS = "notebooks", // = 4;
        COURSES = "courses", // = 5;
        DISCUSSIONS = "discussions", // = 6;
      }
      // These aren't fully qualified because the transpilier is including the prefix
      // on the enum value for some reason
      export enum LoginMessageId {
        UNSPECIFIED = "unspecified", // = 0;
        UNKNOWN = "unknown", // = 1;
        LOCKED_OUT = "lockedOut", // = 2;
        INVALID_LOGIN = "invalidLogin", // = 3;
        INVALID_GOOGLE_SSO = "invalidGoogleSso", // = 4;
        MISSING_LOGIN = "missingLogin", // = 5;
        DISABLED_LOGIN = "disabledLogin", // = 6;
        INTERNAL_ERROR = "internalError", // = 7;
        BANNED_LOGIN = "bannedLogin", // = 8;
        ALREADY_CONFIRMED = "alreadyConfirmed", // = 9;
        EXPIRED_CODE = "expiredCode", // = 10;
        GOOGLE_SSO_EMAIL_MISSING = "googleSsoEmailMissing", // = 11;
        GOOGLE_LINK_SUCCESS = "googleLinkSuccess", // = 12;
        GOOGLE_SSO_INACTIVE = "googleSsoInactive", // = 13;
        ADMINS_USE_GOOGLE = "adminsUseGoogle", // = 14;
        ADMINS_USE_GOOGLE_EMAIL = "adminsUseGoogleEmail", // = 15;
        DATASETS_WELCOME = "datasetsWelcome", // = 16;
        CAPTCHA_MISSING = "captchaMissing", // = 17;
        USERNAME_TAKEN = "usernameTaken", // = 18;
        USERNAME_NUMBER = "usernameNumber", // = 19;
        USERNAME_ALPHANUMERIC = "usernameAlphanumeric", // = 20;
        USERNAME_MIN_LENGTH = "usernameMinLength", // = 21;
        USERNAME_MAX_LENGTH = "usernameMaxLength", // = 22;
        FULL_NAME_LENGTH = "fullNameLength", // = 23;
        EMAIL_EXISTS = "emailExists", // = 24;
        EMAIL_LENGTH = "emailLength", // = 25;
        INVALID_EMAIL = "invalidEmail", // = 26;
        PASSWORD_TOO_SHORT = "passwordTooShort", // = 27;
        DATASETS_LOGIN = "datasetsLogin", // = 28;
        TOPIC_LOGIN = "topicLogin", // = 29;
        VOTE_LOGIN = "voteLogin", // = 30;
        CONTACT_USERS = "contactUsers", // = 31;
        USE_GOOGLE_SSO = "useGoogleSso", // = 32;
        MISSING_EMAIL = "missingEmail", // = 33;
        MISSING_USER_NAME = "missingUserName", // = 34;
        MISSING_DISPLAY_NAME = "missingDisplayName", // = 35;
        MISSING_PASSWORD = "missingPassword", // = 36;
        BOOKMARK_LOGIN = "bookmarkLogin", // = 37;
        INVALID_CODE = "invalidCode", // = 38;
        CHANGE_EMAIL_VERIFY_LOGIN = "changeEmailVerifyLogin", // = 39;
      }

      export enum Medal {
        UNSPECIFIED = "unspecified", // = 0;
        GOLD = "gold", // = 1;
        SILVER = "silver", // = 2;
        BRONZE = "bronze", // = 3;
      }

      export enum NudgePage {
        ANY = "any", // = 0;
        COMPETITIONS = "competitions", // = 1;
        PROFILE = "profile", // = 2;
        LANDING = "landing", // = 3;
      }

      export enum NudgeReactions {
        REASON_UNSPECIFIED = "reasonUnspecified", // = 0;
        USER_DISMISSED = "userDismissed", // = 1;
        ACCEPTED = "accepted", // = 2;
        AUTO_DISMISSED = "autoDismissed", // = 3;
      }
      // These values should match Ids of Nudge table
      export enum NudgeType {
        UNSPECIFIED = "unspecified", // = 0;
        INTRODUCE_YOURSELF = "introduceYourself", // = 1;
        GETTING_NOTICED = "gettingNoticed", // = 2;
        PROMOTED = "promoted", // = 3;
        STILL_WORK_AT = "stillWorkAt", // = 4;
        COMPETITION_EMAIL = "competitionEmail", // = 5;
        BRAND_NEW = "brandNew", // = 6;
        DATASET_GRAB_AND_GO = "datasetGrabAndGo", // = 7;
        NEWLY_RETURNED = "newlyReturned", // = 8;
      }

      export enum RecentlyViewedItemType {
        UNSPECIFIED = "unspecified", // = 0;
        COMPETITION = "competition", // = 1;
        DATASET = "dataset", // = 2;
        KERNEL = "kernel", // = 4;
        TOPIC = "topic", // = 5;
        COURSE = "course", // = 6;
        FORUM = "forum", // = 7;
      }

      export enum RegistrationInfoFields {
        UNSPECIFIED = "unspecified", // = 0;
        USER_NAME = "userName", // = 1;
        DISPLAY_NAME = "displayName", // = 2;
        EMAIL = "email", // = 3;
        PASSWORD = "password", // = 4;
        CAPTCHA = "captcha", // = 5;
      }

      export enum ReturnedItemsType {
        UNSPECIFIED = "unspecified", // = 0;
        EDITED = "edited", // = 1;
        VIEWED = "viewed", // = 2;
        ALL = "all", // = 3;
      }

      export enum StartMigrateSsoOutcome {
        GOOGLE_SSO_EXISTS = "googleSsoExists", // = 0;
        EMAIL_LOGIN_EXISTS = "emailLoginExists", // = 1;
        CREATE_PASSWORD = "createPassword", // = 2;
      }

      export enum SurveyType {
        UNSPECIFIED = "unspecified", // = 0;
        HATS = "hats", // = 1;
        DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY = "dataScienceAndMachineLearningSurvey", // = 2;
        GOOGLE_CLOUD_ML_SUMMIT_2021 = "googleCloudMlSummit2021", // = 3;
      }

      export enum UserAchievementTier {
        NOVICE = "novice", // = 0;
        CONTRIBUTOR = "contributor", // = 1;
        EXPERT = "expert", // = 2;
        MASTER = "master", // = 3;
        GRANDMASTER = "grandmaster", // = 4;
        // Kaggle admins
        STAFF = "staff", // = 5;
        // Flag user for tier recalculation
        RECALC = "recalc", // = 21;
      }

      export enum UserAchievementType {
        UNSPECIFIED = "unspecified", // = 0;
        COMPETITIONS = "competitions", // = 1;
        NOTEBOOKS = "notebooks", // = 2;
        DISCUSSION = "discussion", // = 3;
        DATASETS = "datasets", // = 4;
      }
      // These values do not match the ones used in the database. See UserPlanId class to see how they are mapped.
      export enum UserPlan {
        UNSPECIFIED = "unspecified", // = 0;
        FREE = "free", // = 1;
        KAGGLE_PRO = "kagglePro", // = 2;
      }

      export enum ValidateResetPasswordCodeOutcome {
        UNSPECIFIED = "unspecified", // = 0;
        // Code was not valid.
        INVALID_CODE = "invalidCode", // = 1;
        // Code was valid, but the user is blocked.
        USER_BLOCKED = "userBlocked", // = 2;
        // No problems.
        SUCCESS = "success", // = 3;
        // No problems, but the user also has a google login they could use.
        SUCCESS_USER_HAS_GOOGLE_LOGIN = "successUserHasGoogleLogin", // = 4;
      }
      // These RPCs are implemented in Kaggle.Services.Legacy due to dependency issues:
      // Service for nudges (pop-up dismissible prompts to the user)
      // Currently only used for Employer/Organization Info nudges, but extensible to others
    }

    export namespace UserSecrets {
      // Adds the association between user secret and a kernel for the logged in user.
      export interface AddSecretKernelAttachmentRequest {
        secretId: number;
        kernelId: number;
      }
      // Request to delete a kernel/secret attachment for current user.
      export interface DeleteSecretKernelAttachmentRequest {
        attachmentId: number;
      }
      // Request to delete a user secret and kernel attachments for current user.
      export interface DeleteUserSecretRequest {
        secretId: number;
      }

      export interface DeleteUserSecretResponse {
        wasAttached: boolean;
        secretId: number;
      }

      export interface ExchangeGcloudAuthorizationCodeRequest {
        authorizationCode?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetGitHubAccessInfoRequest {}

      export interface GetGitHubAccessInfoResponse {
        secretId: number;
        // The user's associated GitHub account's login.
        login?: /* google.protobuf.StringValue */ string | null;
        email?: /* google.protobuf.StringValue */ string | null;
        avatarUrl?: /* google.protobuf.StringValue */ string | null;
      }
      // Requests user secret with given Label for the current user.
      export interface GetUserSecretByLabelRequest {
        label?: /* google.protobuf.StringValue */ string | null;
        // Only required for access via a Kernel session.
        jwe?: /* google.protobuf.StringValue */ string | null;
      }

      export interface GetUserSecretResponse {
        secretId: number;
        secret?: /* google.protobuf.StringValue */ string | null;
        expiresInSeconds: number;
        secretType: Kaggle.Sdk.UserSecrets.UserSecretType;
        secretProvider: Kaggle.Sdk.UserSecrets.UserSecretProviderType;
      }
      // Requests a list of secrets' metadata for the currently logged in user, and a kernel id.
      export interface ListKernelSecretsMetadataRequest {
        kernelId: number;
      }

      export interface ListKernelSecretsMetadataResponse {
        kernelSecretsMetadata: Kaggle.Sdk.UserSecrets.UserSecretKernelAttachmentMetadata[];
      }
      // Request to retrieve kernel ids associated with a particular secret id and
      // currently logged in user.
      export interface ListKernelsWithSecretRequest {
        secretId: number;
      }

      export interface ListKernelsWithSecretResponse {
        kernelsWithSecret: number[];
      }
      // Requests secret metadata for the logged in user.
      export interface ListUserSecretsMetadataRequest {
        // The request is always for the current user, so we don't pass user id.
        // Exactly one of these parameters must be provided.
        target?: Kaggle.Sdk.UserSecrets.UserSecretTargetType;
        provider?: Kaggle.Sdk.UserSecrets.UserSecretProviderType;
      }

      export interface ListUserSecretsMetadataResponse {
        userSecretsMetadata: Kaggle.Sdk.UserSecrets.UserSecretMetadata[];
      }

      export interface UpsertCustomUserSecretRequest {
        // The request is always for the current user,
        // so we don't pass user id.
        secret?: /* google.protobuf.StringValue */ string | null;
        secretLabel?: /* google.protobuf.StringValue */ string | null;
      }

      export interface UserSecretKernelAttachmentMetadata {
        attachmentId: number;
        secretId: number;
        secretType: Kaggle.Sdk.UserSecrets.UserSecretType;
        secretProvider: Kaggle.Sdk.UserSecrets.UserSecretProviderType;
        secretTargets: Kaggle.Sdk.UserSecrets.UserSecretTargetType[];
      }

      export interface UserSecretMetadata {
        secretId: number;
        secretLabel?: /* google.protobuf.StringValue */ string | null;
        secretType: Kaggle.Sdk.UserSecrets.UserSecretType;
        secretProvider: Kaggle.Sdk.UserSecrets.UserSecretProviderType;
        secretTargets: Kaggle.Sdk.UserSecrets.UserSecretTargetType[];
        openIdConnectSubject?: /* google.protobuf.StringValue */ string | null;
        userDisplayName?: /* google.protobuf.StringValue */ string | null;
        userProfileImage?: /* google.protobuf.StringValue */ string | null;
        userEmail?: /* google.protobuf.StringValue */ string | null;
      }
      // UserSecretProviderType values correspond to UserSecretProviderTypes.Id column
      // in the db.
      export enum UserSecretProviderType {
        UNSPECIFIED = "unspecified", // = 0;
        GOOGLE = "google", // = 1;
        USER = "user", // = 2;
        GITHUB = "github", // = 3;
      }
      // UserSecretTargetType values correspond to UserSecretTargetTypes.Id column in the db.
      export enum UserSecretTargetType {
        UNSPECIFIED = "unspecified", // = 0;
        BIGQUERY = "bigquery", // = 1;
        GCS = "gcs", // = 2;
        CLOUD_AI = "cloudAi", // = 3;
        // Left AutoMl temporarily for transition (in this order)
        AUTO_ML = "autoMl", // = 4;
      }
      // UserSecretType values correspond to UserSecretType.Id column in the db.
      export enum UserSecretType {
        UNSPECIFIED = "unspecified", // = 0;
        REFRESH_TOKEN = "refreshToken", // = 1;
        CUSTOM = "custom", // = 2;
        ACCESS_TOKEN = "accessToken", // = 3;
      }
    }
  }
}

// This was in the legacy sdk.ts and is still used. It should likely be part of the template.
export namespace Kaggle {
  export namespace Framework {
    export namespace Service {
      export interface IRequest {}
      export type ListSelection<L extends any[]> = Partial<
        { [P in keyof L[0]]: Selection<L[0][P]> }
      >;

      export type ObjectSelection<T> = Partial<
        { [P in keyof T]: Selection<T[P]> }
      >;

      export type Selection<T> = ListSelection<T[]> | ObjectSelection<T> | null;
    }
  }
}

export const activeEventsClient = {
  activeEventService: {
    // DeleteActiveEvent deletes the specified ActiveEvent from firestore under the current user.
    deleteActiveEvent: createRequestClient<
      Kaggle.Sdk.ActiveEvents.DeleteActiveEventRequest,
      google.protobuf.Empty
    >("ActiveEventService/DeleteActiveEvent"),
    getActiveEventsFirebaseConfig: createRequestClient<
      Kaggle.Sdk.ActiveEvents.GetActiveEventsFirebaseConfigRequest,
      Kaggle.Sdk.ActiveEvents.GetActiveEventsFirebaseConfigResponse
    >("ActiveEventService/GetActiveEventsFirebaseConfig"),
  },
};
export const adminClient = {
  adminService: {
    addSiteConfig: createRequestClient<
      Kaggle.Sdk.Admin.AddSiteConfigRequest,
      google.protobuf.Empty
    >("AdminService/AddSiteConfig"),
    // Generate a link that allows anyone with the link to access an IDMEC record. This is used in response to a request
    // from legal to access the data we stored for a user under the IDMEC jurisdiction.
    createIdmecLink: createRequestClient<
      Kaggle.Sdk.Admin.CreateIdmecLinkRequest,
      Kaggle.Sdk.Admin.CreateIdmecLinkResponse
    >("AdminService/CreateIdmecLink"),
    deleteSiteConfig: createRequestClient<
      Kaggle.Sdk.Admin.DeleteSiteConfigRequest,
      google.protobuf.Empty
    >("AdminService/DeleteSiteConfig"),
    getAdminUser: createRequestClient<
      Kaggle.Sdk.Admin.GetAdminUserRequest,
      Kaggle.Sdk.Admin.AdminUser
    >("AdminService/GetAdminUser"),
    // Returns all SiteConfigs, sorted by name.
    // This RPC will honor C#-defined flags annotated with FlagDefault if a DB-specified value is not found (represented
    // by unset Id)
    getAllSiteConfigs: createRequestClient<
      Kaggle.Sdk.Admin.GetAllSiteConfigsRequest,
      Kaggle.Sdk.Admin.GetSiteConfigsResponse
    >("AdminService/GetAllSiteConfigs"),
    getAutoFormModel: createRequestClient<
      Kaggle.Sdk.Admin.GetAutoFormModelRequest,
      Kaggle.Sdk.Admin.AutoFormModel
    >("AdminService/GetAutoFormModel"),
    getDatabaseSize: createRequestClient<
      Kaggle.Sdk.Admin.GetDatabaseSizeRequest,
      Kaggle.Sdk.Admin.GetDatabaseSizeResponse
    >("AdminService/GetDatabaseSize"),
    getLoggingConfig: createRequestClient<
      Kaggle.Sdk.Admin.GetLoggingConfigRequest,
      Kaggle.Sdk.Admin.GetLoggingConfigResponse
    >("AdminService/GetLoggingConfig"),
    getSampleRequest: createRequestClient<
      Kaggle.Sdk.Admin.GetSampleRequestRequest,
      Kaggle.Sdk.Admin.GetSampleRequestResponse
    >("AdminService/GetSampleRequest"),
    listRequestTypes: createRequestClient<
      Kaggle.Sdk.Admin.ListRequestTypesRequest,
      Kaggle.Sdk.Admin.ListRequestTypesResponse
    >("AdminService/ListRequestTypes"),
    resetSearchIndex: createRequestClient<
      Kaggle.Sdk.Admin.ResetSearchIndexRequest,
      google.protobuf.Empty
    >("AdminService/ResetSearchIndex"),
    resetSearchIndexes: createRequestClient<
      Kaggle.Sdk.Admin.ResetSearchIndexesRequest,
      google.protobuf.Empty
    >("AdminService/ResetSearchIndexes"),
    updateAutoFormModel: createRequestClient<
      Kaggle.Sdk.Admin.UpdateAutoFormModelRequest,
      google.protobuf.Empty
    >("AdminService/UpdateAutoFormModel"),
    updateLoggingConfig: createRequestClient<
      Kaggle.Sdk.Admin.UpdateLoggingConfigRequest,
      google.protobuf.Empty
    >("AdminService/UpdateLoggingConfig"),
    // Updates an existing DB-backed SiteConfig row. To update a FlagDefault-specified config, use AddSiteConfig.
    updateSiteConfig: createRequestClient<
      Kaggle.Sdk.Admin.UpdateSiteConfigRequest,
      google.protobuf.Empty
    >("AdminService/UpdateSiteConfig"),
  },
  genieService: {
    // Create a token that can be used to impersonate another user.
    createDelegatedUserAccessToken: createRequestClient<
      Kaggle.Sdk.Admin.CreateDelegatedUserAccessTokenRequest,
      Kaggle.Sdk.Admin.CreateDelegatedUserAccessTokenResponse
    >("GenieService/CreateDelegatedUserAccessToken"),
  },
  inboxFileService: {
    // Creates (aka "drops") a new file into the inbox.
    createInboxFile: createRequestClient<
      Kaggle.Sdk.Admin.CreateInboxFileRequest,
      Kaggle.Sdk.Admin.CreateInboxFileResponse
    >("InboxFileService/CreateInboxFile"),
    // Deletes an existing inbox file.
    deleteInboxFile: createRequestClient<
      Kaggle.Sdk.Admin.DeleteInboxFileRequest,
      google.protobuf.Empty
    >("InboxFileService/DeleteInboxFile"),
    // Lists all available inbox files (optionally filtering to just a specific directory)
    listInboxFiles: createRequestClient<
      Kaggle.Sdk.Admin.ListInboxFilesRequest,
      Kaggle.Sdk.Admin.ListInboxFilesResponse
    >("InboxFileService/ListInboxFiles"),
  },
  ipBanService: {
    // Bans a particular IP range.
    createIpBan: createRequestClient<
      Kaggle.Sdk.Admin.CreateIpBanRequest,
      Kaggle.Sdk.Admin.IpBan
    >("IpBanService/CreateIpBan"),
    // Unbans an existing IP range.
    deleteIpBan: createRequestClient<
      Kaggle.Sdk.Admin.DeleteIpBanRequest,
      google.protobuf.Empty
    >("IpBanService/DeleteIpBan"),
    // Lists all active IP bans that are being enforced.
    listIpBans: createRequestClient<
      Kaggle.Sdk.Admin.ListIpBansRequest,
      Kaggle.Sdk.Admin.ListIpBansResponse
    >("IpBanService/ListIpBans"),
    // Test to see if IP address(es) is/are banned.
    testIpBans: createRequestClient<
      Kaggle.Sdk.Admin.TestIpBansRequest,
      Kaggle.Sdk.Admin.TestIpBansResponse
    >("IpBanService/TestIpBans"),
  },
  loggingService: {
    // Creates a sample log message (useful for testing log reporters).
    createLogMessage: createRequestClient<
      Kaggle.Sdk.Admin.CreateLogMessageRequest,
      Kaggle.Sdk.Admin.CreateLogMessageResponse
    >("LoggingService/CreateLogMessage"),
  },
  organizationsService: {
    // Create a new organization given some seed input
    createOrganization: createRequestClient<
      Kaggle.Sdk.Admin.CreateOrganizationRequest,
      Kaggle.Sdk.Admin.CreateOrganizationResponse
    >("OrganizationsService/CreateOrganization"),
  },
  rateLimitService: {
    // Resets multiple rate limit statuses.
    batchResetRateLimitStatuses: createRequestClient<
      Kaggle.Sdk.Admin.BatchResetRateLimitStatusesRequest,
      Kaggle.Sdk.Admin.BatchResetRateLimitStatusesResponse
    >("RateLimitService/BatchResetRateLimitStatuses"),
    // Lists rate limit definitions.
    listRateLimits: createRequestClient<
      Kaggle.Sdk.Admin.ListRateLimitsRequest,
      Kaggle.Sdk.Admin.ListRateLimitsResponse
    >("RateLimitService/ListRateLimits"),
    // Lists all rate limits statuses (that optionally match filters).
    listRateLimitStatuses: createRequestClient<
      Kaggle.Sdk.Admin.ListRateLimitStatusesRequest,
      Kaggle.Sdk.Admin.ListRateLimitStatusesResponse
    >("RateLimitService/ListRateLimitStatuses"),
    // Resets a single rate limit status by its key.
    resetRateLimitStatus: createRequestClient<
      Kaggle.Sdk.Admin.ResetRateLimitStatusRequest,
      Kaggle.Sdk.Admin.ResetRateLimitStatusResponse
    >("RateLimitService/ResetRateLimitStatus"),
  },
};
export const blobsClient = {
  blobService: {
    // Starts a blob upload (i.e. reserves a spot for the upload on GCS).
    startBlobUpload: createRequestClient<
      Kaggle.Sdk.Blobs.StartBlobUploadRequest,
      Kaggle.Sdk.Blobs.StartBlobUploadResponse
    >("BlobService/StartBlobUpload"),
  },
};
export const chimeClient = {
  chimeService: {
    // Used by admins to test an SMS send.
    testSms: createRequestClient<
      Kaggle.Sdk.Chime.TestSmsRequest,
      Kaggle.Sdk.Chime.SendSmsResponse
    >("ChimeService/TestSms"),
  },
};
export const cmsClient = {
  legacyCmsService: {
    // Lists all of the documentation pages (used by the outline sidebar).
    listDocs: createRequestClient<
      Kaggle.Sdk.Cms.ListDocsRequest,
      Kaggle.Sdk.Cms.ListDocsResponse
    >("LegacyCmsService/ListDocs"),
    // Lists all pages (documentation and regular CMS pages).
    listPages: createRequestClient<
      Kaggle.Sdk.Cms.ListPagesRequest,
      Kaggle.Sdk.Cms.ListPagesResponse
    >("LegacyCmsService/ListPages"),
    // Allows an admin to specify where on the documentation main page a doc
    // page should appear.
    updateDocPageOrder: createRequestClient<
      Kaggle.Sdk.Cms.UpdateDocPageOrderRequest,
      google.protobuf.Empty
    >("LegacyCmsService/UpdateDocPageOrder"),
    // Updates the metadata and content of a CMS/doc page.
    updatePage: createRequestClient<
      Kaggle.Sdk.Cms.UpdatePageRequest,
      Kaggle.Sdk.Cms.UpdatePageResponse
    >("LegacyCmsService/UpdatePage"),
  },
};
export const competitionsClient = {
  competitionHostService: {
    // Creates a new (unlaunched) competition.
    // (-- aip.dev/not-precedent: Not returning a Competition message yet to keep it simple. Consider refactoring.)
    createCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.CreateCompetitionRequest,
      Kaggle.Sdk.Competitions.CreateCompetitionResponse
    >("CompetitionHostService/CreateCompetition"),
    // "Privacy" tab:
    getPrivacySettings: createRequestClient<
      Kaggle.Sdk.Competitions.GetPrivacySettingsRequest,
      Kaggle.Sdk.Competitions.PrivacySettings
    >("CompetitionHostService/GetPrivacySettings"),
    // This keeps existing UI behavior, but it could be refactored into the
    // UpdatePrivacySettings RPC above with a convention like setting it to "regenerate"
    // would cause it to be regenerated.
    regenerateShareToken: createRequestClient<
      Kaggle.Sdk.Competitions.RegenerateShareTokenRequest,
      Kaggle.Sdk.Competitions.PrivacySettings
    >("CompetitionHostService/RegenerateShareToken"),
    updatePrivacySettings: createRequestClient<
      Kaggle.Sdk.Competitions.UpdatePrivacySettingsRequest,
      Kaggle.Sdk.Competitions.PrivacySettings
    >("CompetitionHostService/UpdatePrivacySettings"),
  },
  competitionService: {
    archiveCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.ArchiveCompetitionRequest,
      google.protobuf.Empty
    >("CompetitionService/ArchiveCompetition"),
    createCompetitionSampleSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.CreateCompetitionSampleSubmissionRequest,
      google.protobuf.Empty
    >("CompetitionService/CreateCompetitionSampleSubmission"),
    createCompetitionSolution: createRequestClient<
      Kaggle.Sdk.Competitions.CreateCompetitionSolutionRequest,
      google.protobuf.Empty
    >("CompetitionService/CreateCompetitionSolution"),
    createEnvironmentMetric: createRequestClient<
      Kaggle.Sdk.Competitions.CreateEnvironmentMetricRequest,
      google.protobuf.Empty
    >("CompetitionService/CreateEnvironmentMetric"),
    // Emails participants in a competition that match criteria.
    // Requestor must be Admin.
    emailParticipants: createRequestClient<
      Kaggle.Sdk.Competitions.EmailParticipantsRequest,
      Kaggle.Sdk.Competitions.CompetitionEmail
    >("CompetitionService/EmailParticipants"),
    // Gets information about the requested competition.
    // (-- KAGGLE_INTERNAL This RPC does check the user's read access. --)
    getCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.GetCompetitionRequest,
      Kaggle.Sdk.Competitions.Competition
    >("CompetitionService/GetCompetition"),
    // Returns data used to create the "Competitions Summary" on a user profile's Competitions tab
    getProfileUserStats: createRequestClient<
      Kaggle.Sdk.Competitions.GetProfileUserStatsRequest,
      Kaggle.Sdk.Competitions.GetProfileUserStatsResponse
    >("CompetitionService/GetProfileUserStats"),
    // Lists the competitions according the query and sorting parameters
    // specified. Also includes information about the current user's team for each
    // competition.
    // (-- KAGGLE_INTERNAL This RPC does check the user's read access. --)
    listCompetitions: createRequestClient<
      Kaggle.Sdk.Competitions.ListCompetitionsRequest,
      Kaggle.Sdk.Competitions.ListCompetitionsResponse
    >("CompetitionService/ListCompetitions"),
    searchCompetitions: createRequestClient<
      Kaggle.Sdk.Competitions.SearchCompetitionsRequest,
      Kaggle.Sdk.Competitions.SearchCompetitionsResponse
    >("CompetitionService/SearchCompetitions"),
    // Sets the competition deadline to now (ending the competition immediately).
    // Requestor must be Admin.
    setCompetitionDeadlineNow: createRequestClient<
      Kaggle.Sdk.Competitions.SetCompetitionDeadlineNowRequest,
      Kaggle.Sdk.Competitions.SetCompetitionDeadlineNowResponse
    >("CompetitionService/SetCompetitionDeadlineNow"),
    waitForCompetitionAdminEvaluationEvent: createRequestClient<
      Kaggle.Sdk.Competitions.WaitForCompetitionAdminEvaluationEventRequest,
      Kaggle.Sdk.Competitions.WaitForCompetitionAdminEvaluationEventResponse
    >("CompetitionService/WaitForCompetitionAdminEvaluationEvent"),
  },
  episodeService: {
    // For each active Sims Comp, kick off some new Episodes.  Intended for use
    // by the GenerateEpisodesScheduledTask.
    generateEpisodes: createRequestClient<
      Kaggle.Sdk.Competitions.GenerateEpisodesRequest,
      Kaggle.Sdk.Competitions.GenerateEpisodesResponse
    >("EpisodeService/GenerateEpisodes"),
    getEpisodeReplay: createRequestClient<
      Kaggle.Sdk.Competitions.GetEpisodeReplayRequest,
      Kaggle.Sdk.Competitions.GetEpisodeReplayResponse
    >("EpisodeService/GetEpisodeReplay"),
    invalidateErroringSimulationsSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.InvalidateErroringSimulationsSubmissionsRequest,
      Kaggle.Sdk.Competitions.InvalidateErroringSimulationsSubmissionsResponse
    >("EpisodeService/InvalidateErroringSimulationsSubmissions"),
    // Lists Episodes of type Completed for a given filter. Currently top 1000 only, by most recent EndTime.
    listEpisodes: createRequestClient<
      Kaggle.Sdk.Competitions.ListEpisodesRequest,
      Kaggle.Sdk.Competitions.ListEpisodesResponse
    >("EpisodeService/ListEpisodes"),
    setEpisodeErrored: createRequestClient<
      Kaggle.Sdk.Competitions.SetEpisodeErroredRequest,
      google.protobuf.Empty
    >("EpisodeService/SetEpisodeErrored"),
  },
  leaderboardService: {
    // Gets the leaderboard for the specified competition.
    getLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.GetLeaderboardRequest,
      Kaggle.Sdk.Competitions.GetLeaderboardResponse
    >("LeaderboardService/GetLeaderboard"),
    // Given a Competition and set of UserIds, returns each User's Team's Rank.
    // 
    // Uses the current main Leaderboard:  Public LB if comp is in Weak LB mode
    // (~= comp is ongoing), Private LB if comp is in Strong LB mode (and comp
    // has Private LB).  See LeaderboardMode enum below.
    getRanksForUsers: createRequestClient<
      Kaggle.Sdk.Competitions.GetRanksForUsersRequest,
      Kaggle.Sdk.Competitions.GetRanksForUsersResponse
    >("LeaderboardService/GetRanksForUsers"),
    // Admin-only RPC that uses the legacy recalculate version of the above RPC.
    // NOTE: This RPC should be removed once the newer one is fully live.
    legacyRecalculateLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.LegacyRecalculateLeaderboardRequest,
      Kaggle.Sdk.Competitions.LegacyRecalculateLeaderboardResponse
    >("LeaderboardService/LegacyRecalculateLeaderboard"),
    // Admin-only RPC which recalculates cached LB data stored on Teams rows.
    // Can either recalculate only Weak LB fields, or both Weak and Strong.
    // 
    // NOTE: This is the only way for the Strong LB fields, such as Ranks, to be
    // written.
    // It is not intended for frequent usage; the Weak LB should be kept up-to-
    // date synchronously as the competition progresses.
    recalculateLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.RecalculateLeaderboardRequest,
      Kaggle.Sdk.Competitions.RecalculateLeaderboardResponse
    >("LeaderboardService/RecalculateLeaderboard"),
  },
  legacyCompetitionBackgroundService: {
    getBackgroundOperation: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetBackgroundOperationRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionBackgroundService/GetBackgroundOperation"),
    waitBackgroundOperation: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.WaitBackgroundOperationRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionBackgroundService/WaitBackgroundOperation"),
  },
  legacyCompetitionHostService: {
    // Adds a user to the competition's admin group.
    addHostUser: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.AddHostUserRequest,
      Kaggle.Sdk.Competitions.Legacy.AddHostUserResponse
    >("LegacyCompetitionHostService/AddHostUser"),
    // Note that this name is somewhat overloaded in that it checks if there is a
    // mapping OR if it's a simulations competition. It should likely be
    // refactored to clean this up.
    getCompetitionHasSubmissionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetCompetitionHasSubmissionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Legacy.GetCompetitionHasSubmissionColumnMappingResponse
    >("LegacyCompetitionHostService/GetCompetitionHasSubmissionColumnMapping"),
    getEvaluationMetric: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetEvaluationMetricRequest,
      Kaggle.Sdk.Competitions.Legacy.EvaluationMetric
    >("LegacyCompetitionHostService/GetEvaluationMetric"),
    // Gets details to render the host checklist page.
    getHostChecklist: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetHostChecklistRequest,
      Kaggle.Sdk.Competitions.Legacy.HostChecklist
    >("LegacyCompetitionHostService/GetHostChecklist"),
    // Gets claims/permissions that inform the host what they can do (and adjust
    // the UI appropriately).
    getHostClaims: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetHostClaimsRequest,
      Kaggle.Sdk.Competitions.Legacy.CompetitionHostClaims
    >("LegacyCompetitionHostService/GetHostClaims"),
    getHostEvaluationInfo: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetHostEvaluationInfoRequest,
      Kaggle.Sdk.Competitions.Legacy.HostEvaluationInfo
    >("LegacyCompetitionHostService/GetHostEvaluationInfo"),
    // (-- aip.dev/not-precedent: Not returning a ColumnMapping message directly
    // yet to preserve existing client behavior of
    //     expecting a null value if not set.)
    getSolutionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetSolutionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Legacy.GetSolutionColumnMappingResponse
    >("LegacyCompetitionHostService/GetSolutionColumnMapping"),
    getSolutionInfo: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetSolutionInfoRequest,
      Kaggle.Sdk.Competitions.Legacy.SolutionInfo
    >("LegacyCompetitionHostService/GetSolutionInfo"),
    // (-- aip.dev/not-precedent: Not returning a ColumnMapping message directly
    // yet to preserve existing client behavior of
    //     expecting a null value if not set.)
    getSubmissionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetSubmissionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Legacy.GetSubmissionColumnMappingResponse
    >("LegacyCompetitionHostService/GetSubmissionColumnMapping"),
    invalidateSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.InvalidateSubmissionsRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/InvalidateSubmissions"),
    // Launch the competition (or set it to be launched in the future) so that it
    // becomes visible to participants.
    launchCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.LaunchCompetitionRequest,
      Kaggle.Sdk.Competitions.Legacy.LaunchCompetitionResponse
    >("LegacyCompetitionHostService/LaunchCompetition"),
    // Lists all of the users that are members of the competition's admin group.
    listHostUsers: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.ListHostUsersRequest,
      Kaggle.Sdk.Competitions.Legacy.ListHostUsersResponse
    >("LegacyCompetitionHostService/ListHostUsers"),
    obliterateEvaluationFromStep: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.ObliterateEvaluationFromStepRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/ObliterateEvaluationFromStep"),
    // Removes a user from the competition's admin group.
    removeHostUser: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.RemoveHostUserRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/RemoveHostUser"),
    // Rescores the specified submission.
    rescoreSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.RescoreSubmissionRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/RescoreSubmission"),
    // Rescores the specified submissions.
    rescoreSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.RescoreSubmissionsRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/RescoreSubmissions"),
    // Searches for users that could be added as a host to a competition's admin
    // group.
    searchHostUsers: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.SearchHostUsersRequest,
      Kaggle.Sdk.Competitions.Legacy.SearchHostUsersResponse
    >("LegacyCompetitionHostService/SearchHostUsers"),
    setBenchmarkSubmissionName: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.SetBenchmarkSubmissionNameRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/SetBenchmarkSubmissionName"),
    setEvaluationMetric: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.SetEvaluationMetricRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/SetEvaluationMetric"),
    setEvaluationMetricParameters: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.SetEvaluationMetricParametersRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/SetEvaluationMetricParameters"),
    toggleBenchmarkSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.ToggleBenchmarkSubmissionRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/ToggleBenchmarkSubmission"),
    // Saves the data on the "Settings" page.
    // (-- aip.dev/not-precedent: Not returning anything on Update to match legacy
    // API.)
    updateCompetitionSettings: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdateCompetitionSettingsRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/UpdateCompetitionSettings"),
    // Updates the header and/or thumbnail images associated with the competition.
    updateImages: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdateImagesRequest,
      Kaggle.Sdk.Competitions.Legacy.UpdateImagesResponse
    >("LegacyCompetitionHostService/UpdateImages"),
    // Updates the competition overview pages.
    updateOverview: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdateOverviewRequest,
      Kaggle.Sdk.Competitions.Legacy.UpdateOverviewResponse
    >("LegacyCompetitionHostService/UpdateOverview"),
    // Updates a single page.
    updatePage: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdatePageRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/UpdatePage"),
    updateSolutionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdateSolutionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/UpdateSolutionColumnMapping"),
    updateSubmissionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdateSubmissionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/UpdateSubmissionColumnMapping"),
    updateTeamVisibility: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.UpdateTeamVisibilityRequest,
      Kaggle.Sdk.Competitions.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/UpdateTeamVisibility"),
  },
  legacyCompetitionService: {
    getCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.LegacyGetCompetitionRequest,
      Kaggle.Sdk.Competitions.Legacy.CompetitionDto
    >("LegacyCompetitionService/GetCompetition"),
    getLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.LegacyGetLeaderboardRequest,
      Kaggle.Sdk.Competitions.Legacy.LegacyGetLeaderboardResponse
    >("LegacyCompetitionService/GetLeaderboard"),
    listCompetitions: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.LegacyListCompetitionsRequest,
      Kaggle.Sdk.Competitions.Legacy.LegacyListCompetitionsResponse
    >("LegacyCompetitionService/ListCompetitions"),
    listTeams: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.LegacyListTeamsRequest,
      Kaggle.Sdk.Competitions.Legacy.LegacyListTeamsResponse
    >("LegacyCompetitionService/ListTeams"),
  },
  legacySubmissionService: {
    // Gets the status of the current user's most recent submission.
    getMostRecentSubmissionStatus: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.GetMostRecentSubmissionStatusRequest,
      Kaggle.Sdk.Competitions.Legacy.LegacySubmissionExtended
    >("LegacySubmissionService/GetMostRecentSubmissionStatus"),
    listMySubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.ListMySubmissionsRequest,
      Kaggle.Sdk.Competitions.Legacy.ListMySubmissionsResponse
    >("LegacySubmissionService/ListMySubmissions"),
    listSandboxSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.ListSandboxSubmissionsRequest,
      Kaggle.Sdk.Competitions.Legacy.ListSandboxSubmissionsResponse
    >("LegacySubmissionService/ListSandboxSubmissions"),
    listTeamSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Legacy.ListTeamSubmissionsRequest,
      Kaggle.Sdk.Competitions.Legacy.ListTeamSubmissionsResponse
    >("LegacySubmissionService/ListTeamSubmissions"),
  },
  pageService: {
    createPage: createRequestClient<
      Kaggle.Sdk.Competitions.CreatePageRequest,
      Kaggle.Sdk.Competitions.Page
    >("PageService/CreatePage"),
    deletePage: createRequestClient<
      Kaggle.Sdk.Competitions.DeletePageRequest,
      google.protobuf.Empty
    >("PageService/DeletePage"),
    getPage: createRequestClient<
      Kaggle.Sdk.Competitions.GetPageRequest,
      Kaggle.Sdk.Competitions.Page
    >("PageService/GetPage"),
    updatePage: createRequestClient<
      Kaggle.Sdk.Competitions.UpdatePageRequest,
      Kaggle.Sdk.Competitions.Page
    >("PageService/UpdatePage"),
  },
  rerunService: {
    // Bulk Reruns
    cancelBulkRerun: createRequestClient<
      Kaggle.Sdk.Competitions.CancelBulkRerunRequest,
      google.protobuf.Empty
    >("RerunService/CancelBulkRerun"),
    initiateBulkRerun: createRequestClient<
      Kaggle.Sdk.Competitions.InitiateBulkRerunRequest,
      Kaggle.Sdk.Competitions.InitiateBulkRerunResponse
    >("RerunService/InitiateBulkRerun"),
    listBulkReruns: createRequestClient<
      Kaggle.Sdk.Competitions.ListBulkRerunsRequest,
      Kaggle.Sdk.Competitions.ListBulkRerunsResponse
    >("RerunService/ListBulkReruns"),
    publishBulkRerun: createRequestClient<
      Kaggle.Sdk.Competitions.PublishBulkRerunRequest,
      google.protobuf.Empty
    >("RerunService/PublishBulkRerun"),
  },
  submissionService: {
    canSubmit: createRequestClient<
      Kaggle.Sdk.Competitions.CanSubmitRequest,
      Kaggle.Sdk.Competitions.CanSubmitResponse
    >("SubmissionService/CanSubmit"),
    // Invalidates the entire leaderboard for a specified Competition.
    clearLeaderboardSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.ClearLeaderboardSubmissionsRequest,
      Kaggle.Sdk.Competitions.ClearLeaderboardSubmissionsResponse
    >("SubmissionService/ClearLeaderboardSubmissions"),
    createSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.CreateSubmissionRequest,
      Kaggle.Sdk.Competitions.Submission
    >("SubmissionService/CreateSubmission"),
    // Used to bulk-invalidate particular submission ids.
    invalidateSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.InvalidateSubmissionsRequest,
      google.protobuf.Empty
    >("SubmissionService/InvalidateSubmissions"),
    listSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.ListSubmissionsRequest,
      Kaggle.Sdk.Competitions.ListSubmissionsResponse
    >("SubmissionService/ListSubmissions"),
    // Returns submissions for the user. Sorts by most recent first.
    // TODO: This is only used by the Genie page and should be replaced by PLX.
    listSubmissionsForUser: createRequestClient<
      Kaggle.Sdk.Competitions.ListSubmissionsForUserRequest,
      Kaggle.Sdk.Competitions.ListSubmissionsForUserResponse
    >("SubmissionService/ListSubmissionsForUser"),
    updateSubmissionDescription: createRequestClient<
      Kaggle.Sdk.Competitions.UpdateSubmissionDescriptionRequest,
      Kaggle.Sdk.Competitions.Submission
    >("SubmissionService/UpdateSubmissionDescription"),
    updateSubmissionSelection: createRequestClient<
      Kaggle.Sdk.Competitions.UpdateSubmissionSelectionRequest,
      Kaggle.Sdk.Competitions.UpdateSubmissionSelectionResponse
    >("SubmissionService/UpdateSubmissionSelection"),
  },
  teamService: {
    acceptTeamMerge: createRequestClient<
      Kaggle.Sdk.Competitions.AcceptTeamMergeRequest,
      google.protobuf.Empty
    >("TeamService/AcceptTeamMerge"),
    createTeamModelFile: createRequestClient<
      Kaggle.Sdk.Competitions.CreateTeamModelFileRequest,
      Kaggle.Sdk.Competitions.CreateTeamModelFileResponse
    >("TeamService/CreateTeamModelFile"),
    createTeams: createRequestClient<
      Kaggle.Sdk.Competitions.CreateTeamsRequest,
      Kaggle.Sdk.Competitions.CreateTeamsResponse
    >("TeamService/CreateTeams"),
    // TODO(b/204171009): Use HTTP Get and redirect once file downloads are supported by frontend clients
    downloadTeamModelFile: createRequestClient<
      Kaggle.Sdk.Competitions.DownloadTeamModelFileRequest,
      Kaggle.Sdk.Competitions.DownloadTeamModelFileResponse
    >("TeamService/DownloadTeamModelFile"),
    listTeamMergeRequests: createRequestClient<
      Kaggle.Sdk.Competitions.ListTeamMergeRequestsRequest,
      Kaggle.Sdk.Competitions.ListTeamMergeRequestsResponse
    >("TeamService/ListTeamMergeRequests"),
    listTeams: createRequestClient<
      Kaggle.Sdk.Competitions.ListTeamsRequest,
      Kaggle.Sdk.Competitions.ListTeamsResponse
    >("TeamService/ListTeams"),
    listTeamsByUser: createRequestClient<
      Kaggle.Sdk.Competitions.ListTeamsByUserRequest,
      Kaggle.Sdk.Competitions.ListTeamsByUserResponse
    >("TeamService/ListTeamsByUser"),
    rejectTeamMerge: createRequestClient<
      Kaggle.Sdk.Competitions.RejectTeamMergeRequest,
      google.protobuf.Empty
    >("TeamService/RejectTeamMerge"),
    requestTeamMerge: createRequestClient<
      Kaggle.Sdk.Competitions.RequestTeamMergeRequest,
      google.protobuf.Empty
    >("TeamService/RequestTeamMerge"),
    // Searches TeamName by a prefix, and returns up to 100 matching teams ordered by length.
    searchTeams: createRequestClient<
      Kaggle.Sdk.Competitions.SearchTeamsRequest,
      Kaggle.Sdk.Competitions.SearchTeamsResponse
    >("TeamService/SearchTeams"),
    updateTeam: createRequestClient<
      Kaggle.Sdk.Competitions.UpdateTeamRequest,
      Kaggle.Sdk.Competitions.Team
    >("TeamService/UpdateTeam"),
  },
  userService: {
    // Logs that the Current User has accepted the rules for the given
    // Competition.
    acceptRules: createRequestClient<
      Kaggle.Sdk.Competitions.AcceptRulesRequest,
      google.protobuf.Empty
    >("UserService/AcceptRules"),
    // Returns information about the calling User in the context of the given
    // Competition.
    getUser: createRequestClient<
      Kaggle.Sdk.Competitions.GetUserRequest,
      Kaggle.Sdk.Competitions.GetUserResponse
    >("UserService/GetUser"),
    // Returns whether the Current User has accepted the rules for the given
    // Competition. Returns true if the Competition does not require rules
    // acceptance.
    hasAcceptedRules: createRequestClient<
      Kaggle.Sdk.Competitions.HasAcceptedRulesRequest,
      Kaggle.Sdk.Competitions.HasAcceptedRulesResponse
    >("UserService/HasAcceptedRules"),
    // Returns all User Configs linked to the Current User with optional key
    // filters.
    listConfigs: createRequestClient<
      Kaggle.Sdk.Competitions.ListConfigsRequest,
      Kaggle.Sdk.Competitions.ListConfigsResponse
    >("UserService/ListConfigs"),
    // Inserts or updates a User Config row.  For updates, name and competition_id
    // comprise the key, and value will be updated to whatever was provided.
    upsertConfig: createRequestClient<
      Kaggle.Sdk.Competitions.UpsertConfigRequest,
      Kaggle.Sdk.Competitions.CompetitionUserConfig
    >("UserService/UpsertConfig"),
  },
};
export const datasetsClient = {
  databundleService: {
    getDatabundleExternal: createRequestClient<
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalRequest,
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalResponse
    >("DatabundleService/GetDatabundleExternal"),
    getDatabundleExternalChildren: createRequestClient<
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalChildrenRequest,
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalChildrenResponse
    >("DatabundleService/GetDatabundleExternalChildren"),
    getDatabundleExternalColumns: createRequestClient<
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalColumnsRequest,
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalColumnsResponse
    >("DatabundleService/GetDatabundleExternalColumns"),
    getDatabundleExternalColumnsByFirestorePath: createRequestClient<
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalColumnsByFirestorePathRequest,
      Kaggle.Sdk.Datasets.Databundles.GetDatabundleExternalColumnsByFirestorePathResponse
    >("DatabundleService/GetDatabundleExternalColumnsByFirestorePath"),
    updateDatabundleColumns: createRequestClient<
      Kaggle.Sdk.Datasets.Databundles.UpdateDatabundleColumnsRequest,
      Kaggle.Sdk.Datasets.Databundles.UpdateDatabundleResponse
    >("DatabundleService/UpdateDatabundleColumns"),
    updateDatabundleMetadataExternal: createRequestClient<
      Kaggle.Sdk.Datasets.Databundles.UpdateDatabundleMetadataExternalRequest,
      Kaggle.Sdk.Datasets.Databundles.UpdateDatabundleMetadataExternalResponse
    >("DatabundleService/UpdateDatabundleMetadataExternal"),
  },
  datasetDetailService: {
    getDatasetAdminSettings: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetAdminSettingsRequest,
      Kaggle.Sdk.Datasets.GetDatasetAdminSettingsResponse
    >("DatasetDetailService/GetDatasetAdminSettings"),
    getDatasetBasics: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetBasicsRequest,
      Kaggle.Sdk.Datasets.DatasetBasics
    >("DatasetDetailService/GetDatasetBasics"),
    getDatasetImageInfo: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetImageInfoRequest,
      Kaggle.Sdk.Datasets.GetDatasetImageInfoResponse
    >("DatasetDetailService/GetDatasetImageInfo"),
    getDatasetSettings: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetSettingsRequest,
      Kaggle.Sdk.Datasets.DatasetSettings
    >("DatasetDetailService/GetDatasetSettings"),
    getDatasetUsabilityRating: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetUsabilityRatingRequest,
      Kaggle.Sdk.Datasets.GetDatasetUsabilityRatingResponse
    >("DatasetDetailService/GetDatasetUsabilityRating"),
    setDatasetSettings: createRequestClient<
      Kaggle.Sdk.Datasets.SetDatasetSettingsRequest,
      google.protobuf.Empty
    >("DatasetDetailService/SetDatasetSettings"),
    updateDatasetImages: createRequestClient<
      Kaggle.Sdk.Datasets.UpdateDatasetImagesRequest,
      Kaggle.Sdk.Datasets.UpdateDatasetImagesResponse
    >("DatasetDetailService/UpdateDatasetImages"),
  },
  datasetService: {
    acceptTaskSubmission: createRequestClient<
      Kaggle.Sdk.Datasets.AcceptTaskSubmissionRequest,
      google.protobuf.Empty
    >("DatasetService/AcceptTaskSubmission"),
    addDatasetCategories: createRequestClient<
      Kaggle.Sdk.Datasets.AddDatasetCategoriesRequest,
      Kaggle.Sdk.Datasets.AddDatasetCategoriesResponse
    >("DatasetService/AddDatasetCategories"),
    attachCompetitionDataset: createRequestClient<
      Kaggle.Sdk.Datasets.AttachCompetitionDatasetRequest,
      google.protobuf.Empty
    >("DatasetService/AttachCompetitionDataset"),
    createBigQueryDataset: createRequestClient<
      Kaggle.Sdk.Datasets.CreateBigQueryDatasetRequest,
      Kaggle.Sdk.Datasets.DatasetCreationResponse
    >("DatasetService/CreateBigQueryDataset"),
    createCompetitionData: createRequestClient<
      Kaggle.Sdk.Datasets.CreateCompetitionDataRequest,
      Kaggle.Sdk.Datasets.CreateCompetitionDataResponse
    >("DatasetService/CreateCompetitionData"),
    createDataset: createRequestClient<
      Kaggle.Sdk.Datasets.CreateDatasetRequest,
      Kaggle.Sdk.Datasets.DatasetCreationResponse
    >("DatasetService/CreateDataset"),
    createDatasetHashLink: createRequestClient<
      Kaggle.Sdk.Datasets.CreateDatasetHashLinkRequest,
      Kaggle.Sdk.Datasets.CreateDatasetHashLinkResponse
    >("DatasetService/CreateDatasetHashLink"),
    createDatasetVersion: createRequestClient<
      Kaggle.Sdk.Datasets.CreateDatasetVersionRequest,
      Kaggle.Sdk.Datasets.DatasetCreationResponse
    >("DatasetService/CreateDatasetVersion"),
    createDoi: createRequestClient<
      Kaggle.Sdk.Datasets.CreateDoiRequest,
      Kaggle.Sdk.Datasets.CreateDoiResponse
    >("DatasetService/CreateDoi"),
    createDoiApprover: createRequestClient<
      Kaggle.Sdk.Datasets.CreateDoiApproverRequest,
      Kaggle.Sdk.Datasets.CreateDoiApproverResponse
    >("DatasetService/CreateDoiApprover"),
    createTask: createRequestClient<
      Kaggle.Sdk.Datasets.CreateTaskRequest,
      Kaggle.Sdk.Datasets.CreateTaskResponse
    >("DatasetService/CreateTask"),
    createTaskSubmission: createRequestClient<
      Kaggle.Sdk.Datasets.CreateTaskSubmissionRequest,
      google.protobuf.Empty
    >("DatasetService/CreateTaskSubmission"),
    deleteDatasetBySlug: createRequestClient<
      Kaggle.Sdk.Datasets.DeleteDatasetBySlugRequest,
      google.protobuf.Empty
    >("DatasetService/DeleteDatasetBySlug"),
    deleteDatasetCategories: createRequestClient<
      Kaggle.Sdk.Datasets.DeleteDatasetCategoriesRequest,
      Kaggle.Sdk.Datasets.DeleteDatasetCategoriesResponse
    >("DatasetService/DeleteDatasetCategories"),
    deleteDatasetHashLink: createRequestClient<
      Kaggle.Sdk.Datasets.DeleteDatasetHashLinkRequest,
      google.protobuf.Empty
    >("DatasetService/DeleteDatasetHashLink"),
    deleteTask: createRequestClient<
      Kaggle.Sdk.Datasets.DeleteTaskRequest,
      google.protobuf.Empty
    >("DatasetService/DeleteTask"),
    deleteTaskSubmission: createRequestClient<
      Kaggle.Sdk.Datasets.DeleteTaskSubmissionRequest,
      google.protobuf.Empty
    >("DatasetService/DeleteTaskSubmission"),
    detectDuplicate: createRequestClient<
      Kaggle.Sdk.Datasets.DetectDuplicateRequest,
      Kaggle.Sdk.Datasets.DuplicationReference
    >("DatasetService/DetectDuplicate"),
    editDatasetDescription: createRequestClient<
      Kaggle.Sdk.Datasets.EditDatasetDescriptionRequest,
      Kaggle.Sdk.Datasets.EditDatasetDescriptionResponse
    >("DatasetService/EditDatasetDescription"),
    editTask: createRequestClient<
      Kaggle.Sdk.Datasets.EditTaskRequest,
      google.protobuf.Empty
    >("DatasetService/EditTask"),
    getCompetitionUploaderConfig: createRequestClient<
      Kaggle.Sdk.Datasets.GetCompetitionUploaderConfigRequest,
      Kaggle.Sdk.Datasets.CompetitionUploaderConfig
    >("DatasetService/GetCompetitionUploaderConfig"),
    getDatabundleVersionCreationStatus: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatabundleVersionCreationStatusRequest,
      Kaggle.Sdk.Datasets.DatabundleVersionCreationStatus
    >("DatasetService/GetDatabundleVersionCreationStatus"),
    getDatasetActivity: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetActivityRequest,
      Kaggle.Sdk.Datasets.ActivityPage
    >("DatasetService/GetDatasetActivity"),
    getDatasetActivityFeed: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetActivityFeedRequest,
      Kaggle.Sdk.Datasets.GetDatasetActivityFeedResponse
    >("DatasetService/GetDatasetActivityFeed"),
    getDatasetByUrl: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetByUrlRequest,
      Kaggle.Sdk.Datasets.DatasetListItem
    >("DatasetService/GetDatasetByUrl"),
    getDatasetHistory: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetHistoryRequest,
      Kaggle.Sdk.Datasets.DatasetHistory
    >("DatasetService/GetDatasetHistory"),
    getDatasetLimits: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetLimitsRequest,
      Kaggle.Sdk.Datasets.DatasetLimits
    >("DatasetService/GetDatasetLimits"),
    getDatasetMetadata: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetMetadataRequest,
      Kaggle.Sdk.Datasets.DatasetMetadata
    >("DatasetService/GetDatasetMetadata"),
    getDatasetsById: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetsByIdRequest,
      Kaggle.Sdk.Datasets.DatasetList
    >("DatasetService/GetDatasetsById"),
    getDatasetSuggestions: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetSuggestionsRequest,
      Kaggle.Sdk.Datasets.GetDatasetSuggestionsResponse
    >("DatasetService/GetDatasetSuggestions"),
    getDatasetTasks: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetTasksRequest,
      Kaggle.Sdk.Datasets.GetDatasetTasksResponse
    >("DatasetService/GetDatasetTasks"),
    getDatasetUploaderConfig: createRequestClient<
      Kaggle.Sdk.Datasets.GetDatasetUploaderConfigRequest,
      Kaggle.Sdk.Datasets.DatasetUploaderConfig
    >("DatasetService/GetDatasetUploaderConfig"),
    getDataViewExternal: createRequestClient<
      Kaggle.Sdk.Datasets.GetDataViewExternalRequest,
      Kaggle.Sdk.Datasets.DataViewer.Protos.GetDataViewResponse
    >("DatasetService/GetDataViewExternal"),
    getGithubRepositoryInfo: createRequestClient<
      Kaggle.Sdk.Datasets.GetGithubRepositoryInfoRequest,
      Kaggle.Sdk.Datasets.GetGithubRepositoryInfoResponse
    >("DatasetService/GetGithubRepositoryInfo"),
    getKernelOutputDataset: createRequestClient<
      Kaggle.Sdk.Datasets.GetKernelOutputDatasetRequest,
      Kaggle.Sdk.Datasets.KernelOutputDatasetReference
    >("DatasetService/GetKernelOutputDataset"),
    getKernelOutputDataViewExternal: createRequestClient<
      Kaggle.Sdk.Datasets.GetKernelOutputDataViewExternalRequest,
      Kaggle.Sdk.Datasets.DataViewer.Protos.GetDataViewResponse
    >("DatasetService/GetKernelOutputDataViewExternal"),
    getLandingPageTopics: createRequestClient<
      Kaggle.Sdk.Datasets.GetLandingPageTopicsRequest,
      Kaggle.Sdk.Datasets.GetLandingPageTopicsResponse
    >("DatasetService/GetLandingPageTopics"),
    getPossibleCompetitionDatasets: createRequestClient<
      Kaggle.Sdk.Datasets.GetPossibleCompetitionDatasetsRequest,
      Kaggle.Sdk.Datasets.DatasetList
    >("DatasetService/GetPossibleCompetitionDatasets"),
    getPossibleTaskSubmissions: createRequestClient<
      Kaggle.Sdk.Datasets.GetPossibleTaskSubmissionsRequest,
      Kaggle.Sdk.Datasets.GetPossibleTaskSubmissionsResponse
    >("DatasetService/GetPossibleTaskSubmissions"),
    // retrieve counts of the content that the user has created. This is used for display on the User Profile > Dataset tab
    getProfileDatasetStats: createRequestClient<
      Kaggle.Sdk.Datasets.GetProfileDatasetStatsRequest,
      Kaggle.Sdk.Datasets.GetProfileDatasetStatsResponse
    >("DatasetService/GetProfileDatasetStats"),
    getRecentlyViewedDatasets: createRequestClient<
      Kaggle.Sdk.Datasets.GetRecentlyViewedDatasetsRequest,
      Kaggle.Sdk.Datasets.DatasetList
    >("DatasetService/GetRecentlyViewedDatasets"),
    getRemoteUrlFileInfo: createRequestClient<
      Kaggle.Sdk.Datasets.GetRemoteUrlFileInfoRequest,
      Kaggle.Sdk.Datasets.RemoteUrlUploadFile
    >("DatasetService/GetRemoteUrlFileInfo"),
    getSidebarTasks: createRequestClient<
      Kaggle.Sdk.Datasets.GetSidebarTasksRequest,
      Kaggle.Sdk.Datasets.GetSidebarTasksResponse
    >("DatasetService/GetSidebarTasks"),
    getTask: createRequestClient<
      Kaggle.Sdk.Datasets.GetTaskRequest,
      Kaggle.Sdk.Datasets.TaskModel
    >("DatasetService/GetTask"),
    getTaskSubmissions: createRequestClient<
      Kaggle.Sdk.Datasets.GetTaskSubmissionsRequest,
      Kaggle.Sdk.Datasets.GetTaskSubmissionsResponse
    >("DatasetService/GetTaskSubmissions"),
    getTopicalDatasets: createRequestClient<
      Kaggle.Sdk.Datasets.GetTopicalDatasetsRequest,
      Kaggle.Sdk.Datasets.GetTopicalDatasetsResponse
    >("DatasetService/GetTopicalDatasets"),
    getTopicalTasks: createRequestClient<
      Kaggle.Sdk.Datasets.GetTopicalTasksRequest,
      Kaggle.Sdk.Datasets.GetTopicalTasksResponse
    >("DatasetService/GetTopicalTasks"),
    getUserDoiDatasets: createRequestClient<
      Kaggle.Sdk.Datasets.GetUserDoiDatasetsRequest,
      Kaggle.Sdk.Datasets.GetUserDoiDatasetsResponse
    >("DatasetService/GetUserDoiDatasets"),
    getUserSubmissions: createRequestClient<
      Kaggle.Sdk.Datasets.GetUserSubmissionsRequest,
      Kaggle.Sdk.Datasets.GetUserSubmissionsResponse
    >("DatasetService/GetUserSubmissions"),
    // Sometime the databundle zipper would fail, this give moderator/host to recreate the databundle zip file
    recreateDatasetArchive: createRequestClient<
      Kaggle.Sdk.Datasets.RecreateDatasetArchiveRequest,
      Kaggle.Sdk.Datasets.RecreateDatasetArchiveResponse
    >("DatasetService/RecreateDatasetArchive"),
    refreshRemoteDataset: createRequestClient<
      Kaggle.Sdk.Datasets.RefreshRemoteDatasetRequest,
      Kaggle.Sdk.Datasets.DatasetCreationResponse
    >("DatasetService/RefreshRemoteDataset"),
    searchDatasets: createRequestClient<
      Kaggle.Sdk.Datasets.SearchDatasetsRequest,
      Kaggle.Sdk.Datasets.SearchDatasetsResponse
    >("DatasetService/SearchDatasets"),
    searchTasks: createRequestClient<
      Kaggle.Sdk.Datasets.SearchTasksRequest,
      Kaggle.Sdk.Datasets.SearchTasksResponse
    >("DatasetService/SearchTasks"),
    setDatabundleVersionNotes: createRequestClient<
      Kaggle.Sdk.Datasets.SetDatabundleVersionNotesRequest,
      google.protobuf.Empty
    >("DatasetService/SetDatabundleVersionNotes"),
    setDatasetChecklistVisibility: createRequestClient<
      Kaggle.Sdk.Datasets.SetDatasetChecklistVisibilityRequest,
      google.protobuf.Empty
    >("DatasetService/SetDatasetChecklistVisibility"),
    setDatasetCollaboratorList: createRequestClient<
      Kaggle.Sdk.Datasets.SetDatasetCollaboratorListRequest,
      google.protobuf.Empty
    >("DatasetService/SetDatasetCollaboratorList"),
    softDeleteDatasetsForOrg: createRequestClient<
      Kaggle.Sdk.Datasets.SoftDeleteDatasetsForOrgRequest,
      google.protobuf.Empty
    >("DatasetService/SoftDeleteDatasetsForOrg"),
    softDeleteDatasetsForUser: createRequestClient<
      Kaggle.Sdk.Datasets.SoftDeleteDatasetsForUserRequest,
      google.protobuf.Empty
    >("DatasetService/SoftDeleteDatasetsForUser"),
    taskVote: createRequestClient<
      Kaggle.Sdk.Datasets.TaskVoteRequest,
      google.protobuf.Empty
    >("DatasetService/TaskVote"),
    unacceptTaskSubmissions: createRequestClient<
      Kaggle.Sdk.Datasets.UnacceptTaskSubmissionsRequest,
      google.protobuf.Empty
    >("DatasetService/UnacceptTaskSubmissions"),
    undeleteDatasetsForUser: createRequestClient<
      Kaggle.Sdk.Datasets.UndeleteDatasetsForUserRequest,
      google.protobuf.Empty
    >("DatasetService/UndeleteDatasetsForUser"),
    updateDataset: createRequestClient<
      Kaggle.Sdk.Datasets.UpdateDatasetRequest,
      Kaggle.Sdk.Datasets.UpdateDatasetResponse
    >("DatasetService/UpdateDataset"),
    updateDatasetCollaborators: createRequestClient<
      Kaggle.Sdk.Datasets.UpdateDatasetCollaboratorsRequest,
      google.protobuf.Empty
    >("DatasetService/UpdateDatasetCollaborators"),
    updateDatasetGeneral: createRequestClient<
      Kaggle.Sdk.Datasets.UpdateDatasetGeneralRequest,
      Kaggle.Sdk.Datasets.UpdateDatasetGeneralSettingsResponse
    >("DatasetService/UpdateDatasetGeneral"),
    updateDatasetMetadata: createRequestClient<
      Kaggle.Sdk.Datasets.UpdateDatasetMetadataRequest,
      Kaggle.Sdk.Datasets.DatasetUsabilityRating
    >("DatasetService/UpdateDatasetMetadata"),
    updateDatasetPrivacy: createRequestClient<
      Kaggle.Sdk.Datasets.UpdateDatasetPrivacyRequest,
      google.protobuf.Empty
    >("DatasetService/UpdateDatasetPrivacy"),
    voteOnDataset: createRequestClient<
      Kaggle.Sdk.Datasets.VoteOnDatasetRequest,
      google.protobuf.Empty
    >("DatasetService/VoteOnDataset"),
  },
};
export const diagnosticsClient = {
  metricsService: {
    // Frontend calls this method after page load to keep track of page load latency.
    recordPageLoadMetrics: createRequestClient<
      Kaggle.Sdk.Diagnostics.RecordPageLoadMetricsRequest,
      google.protobuf.Empty
    >("MetricsService/RecordPageLoadMetrics"),
  },
};
export const discussionsClient = {
  discussionsService: {
    // Creates a token & URL for use to upload a discussions attachment to blob storage.
    createAttachment: createRequestClient<
      Kaggle.Sdk.Discussions.CreateAttachmentRequest,
      Kaggle.Sdk.Discussions.CreateAttachmentResponse
    >("DiscussionsService/CreateAttachment"),
    // Creates a comment on a kernel and returns the newly created message ID.
    createKernelMessage: createRequestClient<
      Kaggle.Sdk.Discussions.CreateKernelMessageRequest,
      Kaggle.Sdk.Discussions.CreateKernelMessageResponse
    >("DiscussionsService/CreateKernelMessage"),
    // Creates a reply to a message and returns the newly created message ID.
    createReply: createRequestClient<
      Kaggle.Sdk.Discussions.CreateReplyRequest,
      Kaggle.Sdk.Discussions.CreateReplyResponse
    >("DiscussionsService/CreateReply"),
    // Creates a topic on a forum and returns the newly created topic ID and message ID.
    createTopic: createRequestClient<
      Kaggle.Sdk.Discussions.CreateTopicRequest,
      Kaggle.Sdk.Discussions.CreateTopicResponse
    >("DiscussionsService/CreateTopic"),
    // Deletes an attachment from a discussion post and blob storage.
    deleteAttachment: createRequestClient<
      Kaggle.Sdk.Discussions.DeleteAttachmentRequest,
      google.protobuf.Empty
    >("DiscussionsService/DeleteAttachment"),
    deleteMessage: createRequestClient<
      Kaggle.Sdk.Discussions.DeleteMessageRequest,
      google.protobuf.Empty
    >("DiscussionsService/DeleteMessage"),
    deleteTopic: createRequestClient<
      Kaggle.Sdk.Discussions.DeleteTopicRequest,
      google.protobuf.Empty
    >("DiscussionsService/DeleteTopic"),
    getForum: createRequestClient<
      Kaggle.Sdk.Discussions.GetForumRequest,
      Kaggle.Sdk.Discussions.GetForumResponse
    >("DiscussionsService/GetForum"),
    getForumMessagesInTopic: createRequestClient<
      Kaggle.Sdk.Discussions.GetForumMessagesInTopicRequest,
      Kaggle.Sdk.Discussions.GetForumMessagesInTopicResponse
    >("DiscussionsService/GetForumMessagesInTopic"),
    getForumTopicById: createRequestClient<
      Kaggle.Sdk.Discussions.GetForumTopicByIdRequest,
      Kaggle.Sdk.Discussions.GetForumTopicByIdResponse
    >("DiscussionsService/GetForumTopicById"),
    getSiteForums: createRequestClient<
      Kaggle.Sdk.Discussions.GetSiteForumsRequest,
      Kaggle.Sdk.Discussions.GetSiteForumsResponse
    >("DiscussionsService/GetSiteForums"),
    getTopicListByForumId: createRequestClient<
      Kaggle.Sdk.Discussions.GetTopicListByForumIdRequest,
      Kaggle.Sdk.Discussions.GetTopicListResponse
    >("DiscussionsService/GetTopicListByForumId"),
    pinForumMessage: createRequestClient<
      Kaggle.Sdk.Discussions.PinForumMessageRequest,
      google.protobuf.Empty
    >("DiscussionsService/PinForumMessage"),
    toggleFlagMessage: createRequestClient<
      Kaggle.Sdk.Discussions.ToggleFlagMessageRequest,
      google.protobuf.Empty
    >("DiscussionsService/ToggleFlagMessage"),
    toggleSpamMessage: createRequestClient<
      Kaggle.Sdk.Discussions.ToggleSpamMessageRequest,
      Kaggle.Sdk.Discussions.ToggleSpamMessageResponse
    >("DiscussionsService/ToggleSpamMessage"),
    unsubscribeWatches: createRequestClient<
      Kaggle.Sdk.Discussions.UnsubscribeWatchesRequest,
      google.protobuf.Empty
    >("DiscussionsService/UnsubscribeWatches"),
    updateFeedbackTrackingData: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateFeedbackTrackingDataRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateFeedbackTrackingData"),
    updateForumMessageSettings: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateForumMessageSettingsRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateForumMessageSettings"),
    updateForumSettings: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateForumSettingsRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateForumSettings"),
    updateForumTopicSettings: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateForumTopicSettingsRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateForumTopicSettings"),
    updateManyFeedbackTrackingData: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateManyFeedbackTrackingDataRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateManyFeedbackTrackingData"),
    // Updates a message's content.
    updateMessage: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateMessageRequest,
      Kaggle.Sdk.Discussions.UpdateMessageResponse
    >("DiscussionsService/UpdateMessage"),
    // Updates a topic's name and message content.
    updateTopic: createRequestClient<
      Kaggle.Sdk.Discussions.UpdateTopicRequest,
      Kaggle.Sdk.Discussions.UpdateTopicResponse
    >("DiscussionsService/UpdateTopic"),
    voteOnForumMessage: createRequestClient<
      Kaggle.Sdk.Discussions.VoteOnForumMessageRequest,
      Kaggle.Sdk.Discussions.VoteOnForumMessageResponse
    >("DiscussionsService/VoteOnForumMessage"),
  },
  issuesService: {
    // Add to a previously created custom forum topic group
    addToAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.AddToAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.AddToAdminForumTopicGroupingResponse
    >("IssuesService/AddToAdminForumTopicGrouping"),
    // Star a forum topic on the product feedback forum
    adminStarForumTopic: createRequestClient<
      Kaggle.Sdk.Discussions.AdminStarForumTopicRequest,
      Kaggle.Sdk.Discussions.AdminStarForumTopicResponse
    >("IssuesService/AdminStarForumTopic"),
    // Star many forum topics on the product feedback forum
    adminStarForumTopics: createRequestClient<
      Kaggle.Sdk.Discussions.AdminStarForumTopicsRequest,
      Kaggle.Sdk.Discussions.AdminStarForumTopicsResponse
    >("IssuesService/AdminStarForumTopics"),
    // Unstar a forum topic on the product feedback forum
    adminUnstarForumTopic: createRequestClient<
      Kaggle.Sdk.Discussions.AdminUnstarForumTopicRequest,
      Kaggle.Sdk.Discussions.AdminUnstarForumTopicResponse
    >("IssuesService/AdminUnstarForumTopic"),
    // Unstar many forum topics on the product feedback forum
    adminUnstarForumTopics: createRequestClient<
      Kaggle.Sdk.Discussions.AdminUnstarForumTopicsRequest,
      Kaggle.Sdk.Discussions.AdminUnstarForumTopicsResponse
    >("IssuesService/AdminUnstarForumTopics"),
    // Create a custom group of forum topics on the product feedback forum
    createAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.CreateAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.CreateAdminForumTopicGroupingResponse
    >("IssuesService/CreateAdminForumTopicGrouping"),
    // Delete a previously created custom forum topic group
    deleteAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.DeleteAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.DeleteAdminForumTopicGroupingResponse
    >("IssuesService/DeleteAdminForumTopicGrouping"),
    // Return all forum topic groupings owned by the current user
    getAdminForumTopicGroupingsForCurrentUser: createRequestClient<
      Kaggle.Sdk.Discussions.GetAdminForumTopicGroupingsForCurrentUserRequest,
      Kaggle.Sdk.Discussions.GetAdminForumTopicGroupingsForCurrentUserResponse
    >("IssuesService/GetAdminForumTopicGroupingsForCurrentUser"),
    // Remove from a previously created custom forum topic group
    removeFromAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.RemoveFromAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.RemoveFromAdminForumTopicGroupingResponse
    >("IssuesService/RemoveFromAdminForumTopicGrouping"),
  },
};
export const educationClient = {
  educationService: {
    addLessonsToTrack: createRequestClient<
      Kaggle.Sdk.Education.AddLessonsToTrackRequest,
      Kaggle.Sdk.Education.LearnTrack
    >("EducationService/AddLessonsToTrack"),
    editLesson: createRequestClient<
      Kaggle.Sdk.Education.EditLessonRequest,
      Kaggle.Sdk.Education.LearnLesson
    >("EducationService/EditLesson"),
    getCertificateUploadUrl: createRequestClient<
      Kaggle.Sdk.Education.GetCertificateUploadUrlRequest,
      Kaggle.Sdk.Education.GetCertificateUploadUrlResponse
    >("EducationService/GetCertificateUploadUrl"),
    getExerciseVersions: createRequestClient<
      Kaggle.Sdk.Education.GetExerciseVersionsRequest,
      Kaggle.Sdk.Education.GetExerciseVersionsResponse
    >("EducationService/GetExerciseVersions"),
    getTrack: createRequestClient<
      Kaggle.Sdk.Education.GetTrackRequest,
      Kaggle.Sdk.Education.LearnTrack
    >("EducationService/GetTrack"),
    getTracks: createRequestClient<
      Kaggle.Sdk.Education.GetTracksRequest,
      Kaggle.Sdk.Education.GetTracksResponse
    >("EducationService/GetTracks"),
    reorderTracks: createRequestClient<
      Kaggle.Sdk.Education.ReorderTracksRequest,
      Kaggle.Sdk.Education.ReorderTracksResponse
    >("EducationService/ReorderTracks"),
    rescoreExerciseVersion: createRequestClient<
      Kaggle.Sdk.Education.RescoreExerciseVersionRequest,
      Kaggle.Sdk.Education.RescoreResponse
    >("EducationService/RescoreExerciseVersion"),
    trackEducation: createRequestClient<
      Kaggle.Sdk.Education.TrackEducationRequest,
      google.protobuf.Empty
    >("EducationService/TrackEducation"),
    trackExerciseInteraction: createRequestClient<
      Kaggle.Sdk.Education.TrackExerciseInteractionRequest,
      Kaggle.Sdk.Education.TrackExerciseInteractionResponse
    >("EducationService/TrackExerciseInteraction"),
  },
};
export const emailsClient = {
  emailService: {
    sendPrivateDatasetSummaryEmail: createRequestClient<
      Kaggle.Sdk.Emails.SendPrivateDatasetSummaryEmailRequest,
      Kaggle.Sdk.Emails.SendEmailResponse
    >("EmailService/SendPrivateDatasetSummaryEmail"),
  },
};
export const kernelsClient = {
  kernelsService: {
    acceptKernelCompetitionRules: createRequestClient<
      Kaggle.Sdk.Kernels.AcceptKernelCompetitionRulesRequest,
      google.protobuf.Empty
    >("KernelsService/AcceptKernelCompetitionRules"),
    addKernelCategory: createRequestClient<
      Kaggle.Sdk.Kernels.AddKernelCategoryRequest,
      google.protobuf.Empty
    >("KernelsService/AddKernelCategory"),
    batchAutoTagKernels: createRequestClient<
      Kaggle.Sdk.Kernels.BatchAutoTagKernelsRequest,
      Kaggle.Sdk.Kernels.BatchAutoTagKernelsResponse
    >("KernelsService/BatchAutoTagKernels"),
    cancelKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.CancelKernelSessionRequest,
      google.protobuf.Empty
    >("KernelsService/CancelKernelSession"),
    clearPinnedKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.ClearPinnedKernelSessionRequest,
      google.protobuf.Empty
    >("KernelsService/ClearPinnedKernelSession"),
    commitAndRun: createRequestClient<
      Kaggle.Sdk.Kernels.CommitAndRunRequest,
      Kaggle.Sdk.Kernels.CommitAndRunResponse
    >("KernelsService/CommitAndRun"),
    completeQuickSession: createRequestClient<
      Kaggle.Sdk.Kernels.CompleteQuickSessionRequest,
      Kaggle.Sdk.Kernels.CompleteQuickSessionResponse
    >("KernelsService/CompleteQuickSession"),
    computeKernelDiff: createRequestClient<
      Kaggle.Sdk.Kernels.ComputeKernelDiffRequest,
      Kaggle.Sdk.Kernels.ComputeKernelDiffResponse
    >("KernelsService/ComputeKernelDiff"),
    createKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.CreateKernelSessionRequest,
      Kaggle.Sdk.Kernels.CreateKernelSessionResponse
    >("KernelsService/CreateKernelSession"),
    createKernelUpvote: createRequestClient<
      Kaggle.Sdk.Kernels.CreateKernelUpvoteRequest,
      Kaggle.Sdk.Kernels.CreateKernelUpvoteResponse
    >("KernelsService/CreateKernelUpvote"),
    createKernelWithSettings: createRequestClient<
      Kaggle.Sdk.Kernels.CreateKernelWithSettingsRequest,
      Kaggle.Sdk.Kernels.CreateKernelWithSettingsResponse
    >("KernelsService/CreateKernelWithSettings"),
    createSnippet: createRequestClient<
      Kaggle.Sdk.Kernels.CreateSnippetRequest,
      Kaggle.Sdk.Kernels.CreateSnippetResponse
    >("KernelsService/CreateSnippet"),
    deleteKernel: createRequestClient<
      Kaggle.Sdk.Kernels.DeleteKernelRequest,
      google.protobuf.Empty
    >("KernelsService/DeleteKernel"),
    deleteKernelUpvote: createRequestClient<
      Kaggle.Sdk.Kernels.DeleteKernelUpvoteRequest,
      google.protobuf.Empty
    >("KernelsService/DeleteKernelUpvote"),
    deleteScheduledKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.DeleteScheduledKernelSessionRequest,
      Kaggle.Sdk.Kernels.DeleteScheduledKernelSessionResponse
    >("KernelsService/DeleteScheduledKernelSession"),
    deleteSnippet: createRequestClient<
      Kaggle.Sdk.Kernels.DeleteSnippetRequest,
      google.protobuf.Empty
    >("KernelsService/DeleteSnippet"),
    exportKernelRunForCaip: createRequestClient<
      Kaggle.Sdk.Kernels.ExportKernelRunForCaipRequest,
      Kaggle.Sdk.Kernels.ExportKernelRunForCaipResponse
    >("KernelsService/ExportKernelRunForCaip"),
    fetchExternalKernelContent: createRequestClient<
      Kaggle.Sdk.Kernels.FetchExternalKernelContentRequest,
      Kaggle.Sdk.Kernels.FetchExternalKernelContentResponse
    >("KernelsService/FetchExternalKernelContent"),
    fetchGitHubContent: createRequestClient<
      Kaggle.Sdk.Kernels.FetchGitHubContentRequest,
      Kaggle.Sdk.Kernels.FetchGitHubContentResponse
    >("KernelsService/FetchGitHubContent"),
    getAcceleratorQuotaStatistics: createRequestClient<
      Kaggle.Sdk.Kernels.GetAcceleratorQuotaStatisticsRequest,
      Kaggle.Sdk.Kernels.GetAcceleratorQuotaStatisticsResponse
    >("KernelsService/GetAcceleratorQuotaStatistics"),
    getCompetitionsPaneInfo: createRequestClient<
      Kaggle.Sdk.Kernels.GetCompetitionsPaneInfoRequest,
      Kaggle.Sdk.Kernels.GetCompetitionsPaneInfoResponse
    >("KernelsService/GetCompetitionsPaneInfo"),
    getDefaultSessionSettings: createRequestClient<
      Kaggle.Sdk.Kernels.GetDefaultSessionSettingsRequest,
      Kaggle.Sdk.Kernels.DefaultSessionSettings
    >("KernelsService/GetDefaultSessionSettings"),
    getDeletedKernel: createRequestClient<
      Kaggle.Sdk.Kernels.GetDeletedKernelRequest,
      Kaggle.Sdk.Kernels.GetDeletedKernelResponse
    >("KernelsService/GetDeletedKernel"),
    getFirebaseAuthToken: createRequestClient<
      Kaggle.Sdk.Kernels.GetFirebaseAuthTokenRequest,
      Kaggle.Sdk.Kernels.GetFirebaseAuthTokenResponse
    >("KernelsService/GetFirebaseAuthToken"),
    getFirebaseConfig: createRequestClient<
      Kaggle.Sdk.Kernels.GetFirebaseConfigRequest,
      Kaggle.Sdk.Kernels.GetFirebaseConfigResponse
    >("KernelsService/GetFirebaseConfig"),
    getKernel: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelRequest,
      Kaggle.Sdk.Kernels.Kernel
    >("KernelsService/GetKernel"),
    getKernelCategoryIds: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelCategoryIdsRequest,
      Kaggle.Sdk.Kernels.KernelCategoryIdList
    >("KernelsService/GetKernelCategoryIds"),
    getKernelCollaboratorList: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelCollaboratorListRequest,
      Kaggle.Sdk.Kernels.GetKernelCollaboratorListResponse
    >("KernelsService/GetKernelCollaboratorList"),
    getKernelLandingPage: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelLandingPageRequest,
      Kaggle.Sdk.Kernels.GetKernelLandingPageResponse
    >("KernelsService/GetKernelLandingPage"),
    getKernelListDetails: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelListDetailsRequest,
      Kaggle.Sdk.Kernels.KernelList
    >("KernelsService/GetKernelListDetails"),
    getKernelRunSource: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelRunSourceRequest,
      Kaggle.Sdk.Kernels.GetKernelRunSourceResponse
    >("KernelsService/GetKernelRunSource"),
    getKernelSessionDataSources: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelSessionDataSourcesRequest,
      Kaggle.Sdk.Kernels.GetKernelSessionDataSourcesResponse
    >("KernelsService/GetKernelSessionDataSources"),
    getKernelStatus: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelStatusRequest,
      Kaggle.Sdk.Kernels.GetKernelStatusResponse
    >("KernelsService/GetKernelStatus"),
    getKernelVersion: createRequestClient<
      Kaggle.Sdk.Kernels.GetKernelVersionRequest,
      Kaggle.Sdk.Kernels.GetKernelVersionResponse
    >("KernelsService/GetKernelVersion"),
    getOrCreateKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.GetOrCreateKernelSessionRequest,
      Kaggle.Sdk.Kernels.GetOrCreateKernelSessionResponse
    >("KernelsService/GetOrCreateKernelSession"),
    getScheduledKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.GetScheduledKernelSessionRequest,
      Kaggle.Sdk.Kernels.ScheduledKernelSession
    >("KernelsService/GetScheduledKernelSession"),
    getSourceIndexData: createRequestClient<
      Kaggle.Sdk.Kernels.GetSourceIndexDataRequest,
      Kaggle.Sdk.Kernels.GetSourceIndexDataResponse
    >("KernelsService/GetSourceIndexData"),
    getUserKernelAchievements: createRequestClient<
      Kaggle.Sdk.Kernels.GetUserKernelAchievementsRequest,
      Kaggle.Sdk.Kernels.GetUserKernelAchievementsResponse
    >("KernelsService/GetUserKernelAchievements"),
    hasAcceptedKernelCompetitionRules: createRequestClient<
      Kaggle.Sdk.Kernels.HasAcceptedKernelCompetitionRulesRequest,
      Kaggle.Sdk.Kernels.HasAcceptedKernelCompetitionRulesResponse
    >("KernelsService/HasAcceptedKernelCompetitionRules"),
    indexAllSnippets: createRequestClient<
      Kaggle.Sdk.Kernels.IndexAllSnippetsRequest,
      Kaggle.Sdk.Kernels.IndexAllSnippetsResponse
    >("KernelsService/IndexAllSnippets"),
    listDockerImages: createRequestClient<
      Kaggle.Sdk.Kernels.ListDockerImagesRequest,
      Kaggle.Sdk.Kernels.DockerImageVersionDetailsList
    >("KernelsService/ListDockerImages"),
    listGithubRepositories: createRequestClient<
      Kaggle.Sdk.Kernels.ListGithubRepositoriesRequest,
      Kaggle.Sdk.Kernels.ListGithubRepositoriesResponse
    >("KernelsService/ListGithubRepositories"),
    listGithubRepositoryBranches: createRequestClient<
      Kaggle.Sdk.Kernels.ListGithubRepositoryBranchesRequest,
      Kaggle.Sdk.Kernels.ListGithubRepositoryBranchesResponse
    >("KernelsService/ListGithubRepositoryBranches"),
    listGithubRepositoryFiles: createRequestClient<
      Kaggle.Sdk.Kernels.ListGithubRepositoryFilesRequest,
      Kaggle.Sdk.Kernels.ListGithubRepositoryFilesResponse
    >("KernelsService/ListGithubRepositoryFiles"),
    listKernelIds: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelIdsRequest,
      Kaggle.Sdk.Kernels.ListKernelIdsResponse
    >("KernelsService/ListKernelIds"),
    listKernelRunLogs: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelRunLogsRequest,
      Kaggle.Sdk.Kernels.ListKernelRunLogsResponse
    >("KernelsService/ListKernelRunLogs"),
    listKernels: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelsRequest,
      Kaggle.Sdk.Kernels.KernelList
    >("KernelsService/ListKernels"),
    listKernelSessionOutput: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelSessionOutputRequest,
      Kaggle.Sdk.Kernels.ListKernelSessionOutputResponse
    >("KernelsService/ListKernelSessionOutput"),
    listKernelSessionOutputFilesHierarchical: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelSessionOutputFilesHierarchicalRequest,
      Kaggle.Sdk.Kernels.ListKernelSessionOutputFilesHierarchicalResponse
    >("KernelsService/ListKernelSessionOutputFilesHierarchical"),
    listKernelSessions: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelSessionsRequest,
      Kaggle.Sdk.Kernels.KernelSessionList
    >("KernelsService/ListKernelSessions"),
    listKernelVersions: createRequestClient<
      Kaggle.Sdk.Kernels.ListKernelVersionsRequest,
      Kaggle.Sdk.Kernels.KernelVersionList
    >("KernelsService/ListKernelVersions"),
    listSnippets: createRequestClient<
      Kaggle.Sdk.Kernels.ListSnippetsRequest,
      Kaggle.Sdk.Kernels.ListSnippetsResponse
    >("KernelsService/ListSnippets"),
    promoteKernelDraft: createRequestClient<
      Kaggle.Sdk.Kernels.PromoteKernelDraftRequest,
      Kaggle.Sdk.Kernels.PromoteKernelDraftResponse
    >("KernelsService/PromoteKernelDraft"),
    removeKernelCategory: createRequestClient<
      Kaggle.Sdk.Kernels.RemoveKernelCategoryRequest,
      google.protobuf.Empty
    >("KernelsService/RemoveKernelCategory"),
    runEpisode: createRequestClient<
      Kaggle.Sdk.Kernels.RunEpisodeRequest,
      Kaggle.Sdk.Kernels.RunEpisodeResponse
    >("KernelsService/RunEpisode"),
    scheduleKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.ScheduleKernelSessionRequest,
      Kaggle.Sdk.Kernels.ScheduledKernelSession
    >("KernelsService/ScheduleKernelSession"),
    searchKernelIds: createRequestClient<
      Kaggle.Sdk.Kernels.SearchKernelIdsRequest,
      Kaggle.Sdk.Kernels.SearchKernelIdsResponse
    >("KernelsService/SearchKernelIds"),
    updateDefaultSessionSettings: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateDefaultSessionSettingsRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateDefaultSessionSettings"),
    updateDockerImageVersion: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateDockerImageVersionRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateDockerImageVersion"),
    updateDockerPinningType: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateDockerPinningTypeRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateDockerPinningType"),
    updateKernelCollaborators: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelCollaboratorsRequest,
      Kaggle.Sdk.Kernels.UpdateKernelCollaboratorsResponse
    >("KernelsService/UpdateKernelCollaborators"),
    updateKernelDraft: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelDraftRequest,
      Kaggle.Sdk.Kernels.UpdateKernelDraftResponse
    >("KernelsService/UpdateKernelDraft"),
    updateKernelOutputToDataset: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelOutputToDatasetRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateKernelOutputToDataset"),
    updateKernelPrivacy: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelPrivacyRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateKernelPrivacy"),
    updateKernelRun: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelRunRequest,
      Kaggle.Sdk.Kernels.UpdateKernelRunResponse
    >("KernelsService/UpdateKernelRun"),
    updateKernelRunDataSources: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelRunDataSourcesRequest,
      Kaggle.Sdk.Kernels.UpdateKernelRunDataSourcesResponse
    >("KernelsService/UpdateKernelRunDataSources"),
    updateKernelSessionKeepalive: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelSessionKeepaliveRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateKernelSessionKeepalive"),
    updateKernelTitle: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelTitleRequest,
      Kaggle.Sdk.Kernels.UpdateKernelTitleResponse
    >("KernelsService/UpdateKernelTitle"),
    updateKernelVersionName: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateKernelVersionNameRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateKernelVersionName"),
    updatePinnedKernelSession: createRequestClient<
      Kaggle.Sdk.Kernels.UpdatePinnedKernelSessionRequest,
      google.protobuf.Empty
    >("KernelsService/UpdatePinnedKernelSession"),
    updateSnippet: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateSnippetRequest,
      google.protobuf.Empty
    >("KernelsService/UpdateSnippet"),
    updateUserKernelFirestoreAuth: createRequestClient<
      Kaggle.Sdk.Kernels.UpdateUserKernelFirestoreAuthRequest,
      Kaggle.Sdk.Kernels.UpdateUserKernelFirestoreAuthResponse
    >("KernelsService/UpdateUserKernelFirestoreAuth"),
    uploadKernelSessionOutput: createRequestClient<
      Kaggle.Sdk.Kernels.UploadKernelSessionOutputRequest,
      google.protobuf.Empty
    >("KernelsService/UploadKernelSessionOutput"),
  },
};
export const newsfeedClient = {
  newsfeedWebService: {
    getDsSurveyBannerState: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.GetDsSurveyBannerStateRequest,
      Kaggle.Sdk.Newsfeed.Protos.GetDsSurveyBannerStateResponse
    >("NewsfeedWebService/GetDsSurveyBannerState"),
    getNewsfeedSidebarContent: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.GetNewsfeedSidebarContentRequest,
      Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarContent
    >("NewsfeedWebService/GetNewsfeedSidebarContent"),
    getStories: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.GetStoriesRequest,
      Kaggle.Sdk.Newsfeed.Protos.GetStoriesResponse
    >("NewsfeedWebService/GetStories"),
    setDsSurveyBannerState: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.SetDsSurveyBannerStateRequest,
      google.protobuf.Empty
    >("NewsfeedWebService/SetDsSurveyBannerState"),
  },
};
export const notificationsClient = {
  notificationsService: {
    // directly creates a new notification in the notification table and sends email.
    addTestNotification: createRequestClient<
      Kaggle.Sdk.Notifications.AddTestNotificationRequest,
      Kaggle.Sdk.Notifications.AddTestNotificationResponse
    >("NotificationsService/AddTestNotification"),
    // Get the list of notifications for the current user.
    getUserNotifications: createRequestClient<
      Kaggle.Sdk.Notifications.GetUserNotificationsRequest,
      Kaggle.Sdk.Notifications.GetUserNotificationsResponse
    >("NotificationsService/GetUserNotifications"),
    // Retrieves the current user's notification settings, providing defaults if user hasn't set a value
    getUserNotificationSettings: createRequestClient<
      Kaggle.Sdk.Notifications.GetUserNotificationSettingsRequest,
      Kaggle.Sdk.Notifications.GetUserNotificationSettingsResponse
    >("NotificationsService/GetUserNotificationSettings"),
    // Mark all notification as (read|viewed) for a user.
    markAllNotifications: createRequestClient<
      Kaggle.Sdk.Notifications.MarkAllNotificationsRequest,
      google.protobuf.Empty
    >("NotificationsService/MarkAllNotifications"),
    // Set the read or viewed status on a single notification or many notifications.
    markNotifications: createRequestClient<
      Kaggle.Sdk.Notifications.MarkNotificationsRequest,
      google.protobuf.Empty
    >("NotificationsService/MarkNotifications"),
    // Set the notification settings to the given settings, only updating any values that are actually set
    setUserNotificationSettings: createRequestClient<
      Kaggle.Sdk.Notifications.SetUserNotificationSettingsRequest,
      google.protobuf.Empty
    >("NotificationsService/SetUserNotificationSettings"),
  },
  subscriptionService: {
    getMySubscribeState: createRequestClient<
      Kaggle.Sdk.Notifications.GetMySubscribeStateRequest,
      Kaggle.Sdk.Notifications.GetSubscribeStateResponse
    >("SubscriptionService/GetMySubscribeState"),
    subscribeTo: createRequestClient<
      Kaggle.Sdk.Notifications.SubscribeToRequest,
      google.protobuf.Empty
    >("SubscriptionService/SubscribeTo"),
  },
};
export const searchClient = {
  searchWebService: {
    fullSearchWeb: createRequestClient<
      Kaggle.Sdk.Search.Protos.FullSearchWebRequest,
      Kaggle.Sdk.Search.Protos.FullSearchResponse
    >("SearchWebService/FullSearchWeb"),
    getAutoCompleteSuggestions: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetAutoCompleteSuggestionsRequest,
      Kaggle.Sdk.Search.Protos.GetAutoCompleteSuggestionsResponse
    >("SearchWebService/GetAutoCompleteSuggestions"),
    getPopularTags: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetPopularTagsRequest,
      Kaggle.Sdk.Search.Protos.GetPopularTagsResponse
    >("SearchWebService/GetPopularTags"),
    getRecentSearches: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetRecentSearchesRequest,
      Kaggle.Sdk.Search.Protos.GetRecentSearchesResponse
    >("SearchWebService/GetRecentSearches"),
    getTrendingSearches: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetTrendingSearchesRequest,
      Kaggle.Sdk.Search.Protos.GetTrendingSearchesResponse
    >("SearchWebService/GetTrendingSearches"),
    logSearch: createRequestClient<
      Kaggle.Sdk.Search.Protos.LogSearchRequest,
      google.protobuf.Empty
    >("SearchWebService/LogSearch"),
    suggestedSearchWeb: createRequestClient<
      Kaggle.Sdk.Search.Protos.SuggestedSearchWebRequest,
      Kaggle.Sdk.Search.Protos.SuggestedSearchResponse
    >("SearchWebService/SuggestedSearchWeb"),
    timeSpentOnClickedResult: createRequestClient<
      Kaggle.Sdk.Search.Protos.TimeSpentOnClickedResultRequest,
      google.protobuf.Empty
    >("SearchWebService/TimeSpentOnClickedResult"),
  },
};
export const tagsClient = {
  tagService: {
    // Tag a given competition with one or many tags
    createCompetitionTags: createRequestClient<
      Kaggle.Sdk.Tags.CreateCompetitionTagsRequest,
      Kaggle.Sdk.Tags.CreateCompetitionTagsResponse
    >("TagService/CreateCompetitionTags"),
    // Tag a given learn track with one or many tags
    createLearnTrackTags: createRequestClient<
      Kaggle.Sdk.Tags.CreateLearnTrackTagsRequest,
      Kaggle.Sdk.Tags.CreateLearnTrackTagsResponse
    >("TagService/CreateLearnTrackTags"),
    createTag: createRequestClient<
      Kaggle.Sdk.Tags.CreateTagRequest,
      google.protobuf.Empty
    >("TagService/CreateTag"),
    // Untag a given competition, removing one or many tags
    deleteCompetitionTags: createRequestClient<
      Kaggle.Sdk.Tags.DeleteCompetitionTagsRequest,
      Kaggle.Sdk.Tags.DeleteCompetitionTagsResponse
    >("TagService/DeleteCompetitionTags"),
    // Untag a given learn track, removing one or many tags
    deleteLearnTrackTags: createRequestClient<
      Kaggle.Sdk.Tags.DeleteLearnTrackTagsRequest,
      Kaggle.Sdk.Tags.DeleteLearnTrackTagsResponse
    >("TagService/DeleteLearnTrackTags"),
    // Fetch the hierarchical structure of all tags
    getTagHierarchy: createRequestClient<
      Kaggle.Sdk.Tags.GetTagHierarchyRequest,
      Kaggle.Sdk.Tags.GetTagHierarchyResponse
    >("TagService/GetTagHierarchy"),
    getTagsById: createRequestClient<
      Kaggle.Sdk.Tags.GetTagsByIdRequest,
      Kaggle.Sdk.Tags.TagList
    >("TagService/GetTagsById"),
    searchTags: createRequestClient<
      Kaggle.Sdk.Tags.SearchTagsRequest,
      Kaggle.Sdk.Tags.TagList
    >("TagService/SearchTags"),
    searchTagsLegacy: createRequestClient<
      Kaggle.Sdk.Tags.SearchTagsLegacyRequest,
      Kaggle.Sdk.Tags.SearchTagsLegacyResponse
    >("TagService/SearchTagsLegacy"),
    tagDatasetTask: createRequestClient<
      Kaggle.Sdk.Tags.TagDatasetTaskRequest,
      google.protobuf.Empty
    >("TagService/TagDatasetTask"),
    untagDatasetTask: createRequestClient<
      Kaggle.Sdk.Tags.UntagDatasetTaskRequest,
      google.protobuf.Empty
    >("TagService/UntagDatasetTask"),
    // Tag a given forum topic with one or many tags, removing any tags not specified in the request
    updateForumTopicTags: createRequestClient<
      Kaggle.Sdk.Tags.UpdateForumTopicTagsRequest,
      Kaggle.Sdk.Tags.UpdateForumTopicTagsResponse
    >("TagService/UpdateForumTopicTags"),
  },
};
export const usersClient = {
  accountService: {
    contactSupport: createRequestClient<
      Kaggle.Sdk.Users.ContactSupportRequest,
      google.protobuf.Empty
    >("AccountService/ContactSupport"),
    // Delete the current user's account (put into soft-delete, for later hard delete).
    deleteCurrentAccount: createRequestClient<
      Kaggle.Sdk.Users.DeleteCurrentAccountRequest,
      Kaggle.Sdk.Users.SoftDeleteAccountResponse
    >("AccountService/DeleteCurrentAccount"),
    expireApiTokens: createRequestClient<
      Kaggle.Sdk.Users.ExpireApiTokensRequest,
      google.protobuf.Empty
    >("AccountService/ExpireApiTokens"),
    generateAnalyticsToken: createRequestClient<
      Kaggle.Sdk.Users.GenerateAnalyticsTokenRequest,
      Kaggle.Sdk.Users.GenerateAnalyticsTokenResponse
    >("AccountService/GenerateAnalyticsToken"),
    generateApiToken: createRequestClient<
      Kaggle.Sdk.Users.GenerateApiTokenRequest,
      Kaggle.Sdk.Users.GenerateApiTokenResponse
    >("AccountService/GenerateApiToken"),
    // Registers the user via email.
    newEmailRegistrationUser: createRequestClient<
      Kaggle.Sdk.Users.NewEmailRegistrationUserRequest,
      Kaggle.Sdk.Users.NewEmailRegistrationUserResponse
    >("AccountService/NewEmailRegistrationUser"),
    // Validates registration values and returns any applicable errors.
    registrationValidation: createRequestClient<
      Kaggle.Sdk.Users.RegistrationValidationRequest,
      Kaggle.Sdk.Users.RegistrationValidationResponse
    >("AccountService/RegistrationValidation"),
    resendVerificationEmail: createRequestClient<
      Kaggle.Sdk.Users.ResendVerificationEmailRequest,
      google.protobuf.Empty
    >("AccountService/ResendVerificationEmail"),
    // Given a valid password reset code, reset the password of the user to the given password and log them in.
    resetPassword: createRequestClient<
      Kaggle.Sdk.Users.ResetPasswordRequest,
      Kaggle.Sdk.Users.ResetPasswordResponse
    >("AccountService/ResetPassword"),
    // Sign the current user out.
    signOut: createRequestClient<
      Kaggle.Sdk.Users.SignOutRequest,
      google.protobuf.Empty
    >("AccountService/SignOut"),
    // Delete the requested user's account (put into soft-delete, for late hard delete).
    softDeleteAccount: createRequestClient<
      Kaggle.Sdk.Users.SoftDeleteAccountRequest,
      Kaggle.Sdk.Users.SoftDeleteAccountResponse
    >("AccountService/SoftDeleteAccount"),
    startMigrateSso: createRequestClient<
      Kaggle.Sdk.Users.StartMigrateSsoRequest,
      Kaggle.Sdk.Users.StartMigrateSsoResponse
    >("AccountService/StartMigrateSso"),
    // Creates and starts the phone verification process.
    // It uses the same request/response that for CreatePhoneVerificationCode which is a subset of the process.
    // TODO: After the FE migrates from calling CreatePhoneVerificationCode, rename these request/response.
    startPhoneVerification: createRequestClient<
      Kaggle.Sdk.Users.StartPhoneVerificationRequest,
      Kaggle.Sdk.Users.StartPhoneVerificationResponse
    >("AccountService/StartPhoneVerification"),
    // Request a reset password code be sent to the given email. No direct response to prevent leaking email existence.
    startResetPassword: createRequestClient<
      Kaggle.Sdk.Users.StartResetPasswordRequest,
      google.protobuf.Empty
    >("AccountService/StartResetPassword"),
    // Validate a given password code, and get the user Id for it if valid.
    validateResetPasswordCode: createRequestClient<
      Kaggle.Sdk.Users.ValidateResetPasswordCodeRequest,
      Kaggle.Sdk.Users.ValidateResetPasswordCodeResponse
    >("AccountService/ValidateResetPasswordCode"),
    // Attempt to verify an account from an emailed verification code.
    verifyAccountEmail: createRequestClient<
      Kaggle.Sdk.Users.VerifyAccountEmailRequest,
      Kaggle.Sdk.Users.VerifyAccountEmailResponse
    >("AccountService/VerifyAccountEmail"),
    verifyPhone: createRequestClient<
      Kaggle.Sdk.Users.VerifyPhoneRequest,
      google.protobuf.Empty
    >("AccountService/VerifyPhone"),
    // Verifies that the provided code matches the code for the current user.
    verifyPhoneVerificationCode: createRequestClient<
      Kaggle.Sdk.Users.VerifyPhoneVerificationCodeRequest,
      Kaggle.Sdk.Users.VerifyPhoneVerificationCodeResponse
    >("AccountService/VerifyPhoneVerificationCode"),
  },
  bookmarkService: {
    // Create bookmark entities of a given type from the current user's historical Favorites
    convertLegacyFavorites: createRequestClient<
      Kaggle.Sdk.Users.ConvertLegacyFavoritesRequest,
      Kaggle.Sdk.Users.ConvertLegacyFavoritesResponse
    >("BookmarkService/ConvertLegacyFavorites"),
    // Create bookmark of a given type from an entity ID for the current user
    createBookmark: createRequestClient<
      Kaggle.Sdk.Users.CreateBookmarkRequest,
      Kaggle.Sdk.Users.CreateBookmarkResponse
    >("BookmarkService/CreateBookmark"),
    // Delete bookmark using bookmark_id, referring to the Bookmark entity for current user
    deleteBookmark: createRequestClient<
      Kaggle.Sdk.Users.DeleteBookmarkRequest,
      Kaggle.Sdk.Users.DeleteBookmarkResponse
    >("BookmarkService/DeleteBookmark"),
    // Create bookmark entities of a given type from the current user's historical Favorites
    getBookmarkMigrationStatus: createRequestClient<
      Kaggle.Sdk.Users.GetBookmarkMigrationStatusRequest,
      Kaggle.Sdk.Users.GetBookmarkMigrationStatusResponse
    >("BookmarkService/GetBookmarkMigrationStatus"),
    // List all bookmarks for the current user, publically visible
    listAllBookmarks: createRequestClient<
      Kaggle.Sdk.Users.ListAllBookmarksRequest,
      Kaggle.Sdk.Users.ListAllBookmarksResponse
    >("BookmarkService/ListAllBookmarks"),
  },
  captchaService: {
    getCaptchaConfig: createRequestClient<
      Kaggle.Sdk.Users.GetCaptchaConfigRequest,
      Kaggle.Sdk.Users.GetCaptchaConfigResponse
    >("CaptchaService/GetCaptchaConfig"),
    verifyCaptcha: createRequestClient<
      Kaggle.Sdk.Users.VerifyCaptchaRequest,
      Kaggle.Sdk.Users.VerifyCaptchaResponse
    >("CaptchaService/VerifyCaptcha"),
  },
  genieService: {
    // Verify a group of phone numbers.
    bulkVerifyPhone: createRequestClient<
      Kaggle.Sdk.Users.BulkVerifyPhoneRequest,
      google.protobuf.Empty
    >("GenieService/BulkVerifyPhone"),
    // Block an account for cheating.
    cheatBlockAccount: createRequestClient<
      Kaggle.Sdk.Users.CheatBlockAccountRequest,
      google.protobuf.Empty
    >("GenieService/CheatBlockAccount"),
    // Force-create a Kaggle login (username+password login).
    createKaggleAccount: createRequestClient<
      Kaggle.Sdk.Users.CreateKaggleAccountRequest,
      google.protobuf.Empty
    >("GenieService/CreateKaggleAccount"),
    // Force a user to fail their pending Nerdchas.
    failNerdcha: createRequestClient<
      Kaggle.Sdk.Users.FailNerdchaRequest,
      google.protobuf.Empty
    >("GenieService/FailNerdcha"),
    // Get a list of userids that are likely duplicates of the given user.
    getDuplicateUsers: createRequestClient<
      Kaggle.Sdk.Users.GetDuplicateUsersRequest,
      Kaggle.Sdk.Users.GetDuplicateUsersResponse
    >("GenieService/GetDuplicateUsers"),
    // Get a new randomly generated password.
    getNewPassword: createRequestClient<
      Kaggle.Sdk.Users.GetNewPasswordRequest,
      Kaggle.Sdk.Users.GetNewPasswordResponse
    >("GenieService/GetNewPassword"),
    // Get the user status logs for a user.
    getUserStatusLogs: createRequestClient<
      Kaggle.Sdk.Users.GetUserStatusLogsRequest,
      Kaggle.Sdk.Users.GetUserStatusLogsResponse
    >("GenieService/GetUserStatusLogs"),
    // Grant the selected user admin privileges on kaggle.
    grantSiteAdmin: createRequestClient<
      Kaggle.Sdk.Users.GrantSiteAdminRequest,
      google.protobuf.Empty
    >("GenieService/GrantSiteAdmin"),
    // Block an account for kernel abuse.
    kernelAbuseBlockAccount: createRequestClient<
      Kaggle.Sdk.Users.KernelAbuseBlockAccountRequest,
      google.protobuf.Empty
    >("GenieService/KernelAbuseBlockAccount"),
    // Block a group of accounts for kernel abuse.
    kernelAbuseMassBlockAccounts: createRequestClient<
      Kaggle.Sdk.Users.KernelAbuseMassBlockAccountsRequest,
      Kaggle.Sdk.Users.KernelAbuseMassBlockAccountsResponse
    >("GenieService/KernelAbuseMassBlockAccounts"),
    // Remove the admin privileges for a user.
    revokeSiteAdmin: createRequestClient<
      Kaggle.Sdk.Users.RevokeSiteAdminRequest,
      google.protobuf.Empty
    >("GenieService/RevokeSiteAdmin"),
    // Block an account for spam.
    spamBlockAccount: createRequestClient<
      Kaggle.Sdk.Users.SpamBlockAccountRequest,
      google.protobuf.Empty
    >("GenieService/SpamBlockAccount"),
    // Block a group of accounts for spam.
    spamBlockMultipleAccount: createRequestClient<
      Kaggle.Sdk.Users.SpamBlockMultipleAccountRequest,
      Kaggle.Sdk.Users.SpamBlockMultipleAccountResponse
    >("GenieService/SpamBlockMultipleAccount"),
    // Unverify a user's phone number, forcing them to reverify.
    unverifyPhone: createRequestClient<
      Kaggle.Sdk.Users.UnverifyPhoneRequest,
      google.protobuf.Empty
    >("GenieService/UnverifyPhone"),
  },
  hatsService: {
    dismissHats: createRequestClient<
      Kaggle.Sdk.Users.DismissHatsRequest,
      Kaggle.Sdk.Users.DismissHatsResponse
    >("HatsService/DismissHats"),
    dismissSurvey: createRequestClient<
      Kaggle.Sdk.Users.DismissSurveyRequest,
      Kaggle.Sdk.Users.DismissSurveyResponse
    >("HatsService/DismissSurvey"),
    getUserHatsStatus: createRequestClient<
      Kaggle.Sdk.Users.GetUserHatsStatusRequest,
      Kaggle.Sdk.Users.GetUserHatsStatusResponse
    >("HatsService/GetUserHatsStatus"),
  },
  legacyOrganizationsService: {
    // Fetches organizations for the current user
    getOrganizations: createRequestClient<
      Kaggle.Sdk.Users.GetOrganizationsRequest,
      Kaggle.Sdk.Users.GetOrganizationsResponse
    >("LegacyOrganizationsService/GetOrganizations"),
  },
  legacyUsersService: {
    legacyChangePassword: createRequestClient<
      Kaggle.Sdk.Users.LegacyChangePasswordRequest,
      google.protobuf.Empty
    >("LegacyUsersService/LegacyChangePassword"),
    legacyDeleteUserLogin: createRequestClient<
      Kaggle.Sdk.Users.LegacyDeleteUserLoginRequest,
      google.protobuf.Empty
    >("LegacyUsersService/LegacyDeleteUserLogin"),
    legacyGetAccount: createRequestClient<
      Kaggle.Sdk.Users.LegacyGetAccountRequest,
      Kaggle.Sdk.Users.AccountDto
    >("LegacyUsersService/LegacyGetAccount"),
    legacyUpdateAccountEmailAddress: createRequestClient<
      Kaggle.Sdk.Users.LegacyUpdateAccountEmailAddressRequest,
      google.protobuf.Empty
    >("LegacyUsersService/LegacyUpdateAccountEmailAddress"),
  },
  nerdchaService: {
    getNerdChallenge: createRequestClient<
      Kaggle.Sdk.Users.GetNerdChallengeRequest,
      Kaggle.Sdk.Users.GetNerdChallengeResponse
    >("NerdchaService/GetNerdChallenge"),
    verifyNerdChallengeAnswer: createRequestClient<
      Kaggle.Sdk.Users.VerifyNerdChallengeAnswerRequest,
      Kaggle.Sdk.Users.VerifyNerdChallengeAnswerResponse
    >("NerdchaService/VerifyNerdChallengeAnswer"),
  },
  nudgeService: {
    // Check if a user has any available nudges to show
    checkForNudge: createRequestClient<
      Kaggle.Sdk.Users.CheckForNudgeRequest,
      Kaggle.Sdk.Users.CheckForNudgeResponse
    >("NudgeService/CheckForNudge"),
    // Log what a user did with the nudge (ie did they ignore? accept?)
    reactToNudge: createRequestClient<
      Kaggle.Sdk.Users.ReactToNudgeRequest,
      Kaggle.Sdk.Users.ReactToNudgeResponse
    >("NudgeService/ReactToNudge"),
    // Report that a user is seeing a particular nudge
    // This should only be called once by the frontend for a particular user/nudge pair
    showingNudge: createRequestClient<
      Kaggle.Sdk.Users.ShowingNudgeRequest,
      Kaggle.Sdk.Users.ShowingNudgeResponse
    >("NudgeService/ShowingNudge"),
  },
  planService: {
    // Activate an account for Cloud Marketplace (user confirms link).
    activateMarketplaceUser: createRequestClient<
      Kaggle.Sdk.Users.ActivateMarketplaceUserRequest,
      Kaggle.Sdk.Users.ActivateMarketplaceUserResponse
    >("PlanService/ActivateMarketplaceUser"),
    // Cancel an account activation for Cloud Marketplace (user cancels linking in progress).
    cancelMarketplaceActivation: createRequestClient<
      Kaggle.Sdk.Users.CancelMarketplaceActivationRequest,
      Kaggle.Sdk.Users.CancelMarketplaceActivationResponse
    >("PlanService/CancelMarketplaceActivation"),
    // Get the current billing plan of a user (free / Kaggle Pro)
    getUserPlan: createRequestClient<
      Kaggle.Sdk.Users.GetUserPlanRequest,
      Kaggle.Sdk.Users.GetUserPlanResponse
    >("PlanService/GetUserPlan"),
    // Get the history of user plans for a given user Id (or admins only).
    getUserPlanLog: createRequestClient<
      Kaggle.Sdk.Users.GetUserPlanLogRequest,
      Kaggle.Sdk.Users.GetUserPlanLogResponse
    >("PlanService/GetUserPlanLog"),
    // Before users are about to quit (on marketplace), allow them to give a reason why
    setCancelPlanReason: createRequestClient<
      Kaggle.Sdk.Users.SetCancelPlanReasonRequest,
      Kaggle.Sdk.Users.SetCancelPlanReasonResponse
    >("PlanService/SetCancelPlanReason"),
    // Update the current billing plan of a user (free / Kaggle Pro)
    updateUserPlan: createRequestClient<
      Kaggle.Sdk.Users.UpdateUserPlanRequest,
      Kaggle.Sdk.Users.UpdateUserPlanResponse
    >("PlanService/UpdateUserPlan"),
  },
  profileService: {
    // Fetches information used for populating the profile preview feature.
    getProfilePreview: createRequestClient<
      Kaggle.Sdk.Users.GetProfilePreviewRequest,
      Kaggle.Sdk.Users.GetProfilePreviewResponse
    >("ProfileService/GetProfilePreview"),
    // Returns activity information for each day to populate a user's activity graph
    getUserActivity: createRequestClient<
      Kaggle.Sdk.Users.GetUserActivityRequest,
      Kaggle.Sdk.Users.GetUserActivityResponse
    >("ProfileService/GetUserActivity"),
    // Returns total counts of different user discussions engagement, e.g. created topics, replies, etc.
    getUserDiscussionCounts: createRequestClient<
      Kaggle.Sdk.Users.GetUserDiscussionCountsRequest,
      Kaggle.Sdk.Users.DiscussionCounts
    >("ProfileService/GetUserDiscussionCounts"),
    // Fetch discussion messages to display on a user's profile on the discussions tab
    getUserDiscussionMessages: createRequestClient<
      Kaggle.Sdk.Users.GetUserDiscussionMessagesRequest,
      Kaggle.Sdk.Users.GetUserDiscussionMessagesResponse
    >("ProfileService/GetUserDiscussionMessages"),
    // Updates a user bio, which is a short message about the user.
    updateBio: createRequestClient<
      Kaggle.Sdk.Users.UpdateBioRequest,
      Kaggle.Sdk.Users.UpdateBioResponse
    >("ProfileService/UpdateBio"),
    // Updates various personal information/links about a user
    updateProfile: createRequestClient<
      Kaggle.Sdk.Users.UpdateProfileRequest,
      Kaggle.Sdk.Users.UpdateProfileResponse
    >("ProfileService/UpdateProfile"),
    // Updates the user's main profile image.
    updateProfileImage: createRequestClient<
      Kaggle.Sdk.Users.UpdateProfileImageRequest,
      Kaggle.Sdk.Users.UpdateProfileImageResponse
    >("ProfileService/UpdateProfileImage"),
  },
  progressionService: {
    // Gets the progression tiers and current rankings for the current user
    getCurrentUserProgression: createRequestClient<
      Kaggle.Sdk.Users.GetCurrentUserProgressionRequest,
      Kaggle.Sdk.Users.GetCurrentUserProgressionResponse
    >("ProgressionService/GetCurrentUserProgression"),
    getUserRankings: createRequestClient<
      Kaggle.Sdk.Users.GetUserRankingsRequest,
      Kaggle.Sdk.Users.UserRankings
    >("ProgressionService/GetUserRankings"),
  },
  recentlyViewedService: {
    deleteRecentlyViewedItems: createRequestClient<
      Kaggle.Sdk.Users.DeleteRecentlyViewedItemsRequest,
      Kaggle.Sdk.Users.DeleteRecentlyViewedItemsResponse
    >("RecentlyViewedService/DeleteRecentlyViewedItems"),
    getRecentlyViewedItems: createRequestClient<
      Kaggle.Sdk.Users.GetRecentlyViewedItemsRequest,
      Kaggle.Sdk.Users.GetRecentlyViewedItemsResponse
    >("RecentlyViewedService/GetRecentlyViewedItems"),
  },
  usersService: {
    acceptCookies: createRequestClient<
      Kaggle.Sdk.Users.AcceptCookiesRequest,
      google.protobuf.Empty
    >("UsersService/AcceptCookies"),
    activateAccount: createRequestClient<
      Kaggle.Sdk.Users.ActivateAccountRequest,
      google.protobuf.Empty
    >("UsersService/ActivateAccount"),
    // Send a message to the given user.
    createUserMessage: createRequestClient<
      Kaggle.Sdk.Users.CreateUserMessageRequest,
      Kaggle.Sdk.Users.CreateUserMessageResponse
    >("UsersService/CreateUserMessage"),
    deletePhoneVerifications: createRequestClient<
      Kaggle.Sdk.Users.DeletePhoneVerificationsRequest,
      google.protobuf.Empty
    >("UsersService/DeletePhoneVerifications"),
    // Current user follows the requested user by username
    followUser: createRequestClient<
      Kaggle.Sdk.Users.FollowUserRequest,
      Kaggle.Sdk.Users.FollowUserResponse
    >("UsersService/FollowUser"),
    // Get information about whether the current user can use the contact user feature.
    getContactUserInfo: createRequestClient<
      Kaggle.Sdk.Users.GetContactUserInfoRequest,
      Kaggle.Sdk.Users.GetContactUserInfoResponse
    >("UsersService/GetContactUserInfo"),
    // Get the current user, or null if no user is logged in. Note please avoid using if you just need the Id.
    getCurrentUser: createRequestClient<
      Kaggle.Sdk.Users.GetCurrentUserRequest,
      Kaggle.Sdk.Users.User
    >("UsersService/GetCurrentUser"),
    // Get the id of the current user, or null if no user is logged in. No DB access required.
    getCurrentUserId: createRequestClient<
      Kaggle.Sdk.Users.GetCurrentUserIdRequest,
      Kaggle.Sdk.Users.GetCurrentUserIdResponse
    >("UsersService/GetCurrentUserId"),
    getMyAttributes: createRequestClient<
      Kaggle.Sdk.Users.GetMyAttributesRequest,
      Kaggle.Sdk.Users.GetMyAttributesResponse
    >("UsersService/GetMyAttributes"),
    // Fetch information about a given user. Note if this is a different user, some fields won't be returned.
    getUser: createRequestClient<
      Kaggle.Sdk.Users.GetUserRequest,
      Kaggle.Sdk.Users.User
    >("UsersService/GetUser"),
    getUserCount: createRequestClient<
      Kaggle.Sdk.Users.GetUserCountRequest,
      Kaggle.Sdk.Users.GetUserCountResponse
    >("UsersService/GetUserCount"),
    migrateTermsAcceptances: createRequestClient<
      Kaggle.Sdk.Users.MigrateTermsAcceptancesRequest,
      Kaggle.Sdk.Users.MigrateTermsAcceptancesResponse
    >("UsersService/MigrateTermsAcceptances"),
    searchPlaces: createRequestClient<
      Kaggle.Sdk.Users.SearchPlacesRequest,
      Kaggle.Sdk.Users.SearchPlacesResponse
    >("UsersService/SearchPlaces"),
    searchUsersSuggestions: createRequestClient<
      Kaggle.Sdk.Users.SearchUsersSuggestionsRequest,
      Kaggle.Sdk.Users.SearchUsersSuggestionsResponse
    >("UsersService/SearchUsersSuggestions"),
    setMyAttributes: createRequestClient<
      Kaggle.Sdk.Users.SetMyAttributesRequest,
      google.protobuf.Empty
    >("UsersService/SetMyAttributes"),
    // For an admin to set a user's phone reputable.
    setPhoneReputable: createRequestClient<
      Kaggle.Sdk.Users.SetPhoneReputableRequest,
      google.protobuf.Empty
    >("UsersService/SetPhoneReputable"),
    // Current user unfollows the requested user by username
    unfollowUser: createRequestClient<
      Kaggle.Sdk.Users.UnfollowUserRequest,
      Kaggle.Sdk.Users.UnfollowUserResponse
    >("UsersService/UnfollowUser"),
    unsubscribeNewsletter: createRequestClient<
      Kaggle.Sdk.Users.UnsubscribeNewsletterRequest,
      google.protobuf.Empty
    >("UsersService/UnsubscribeNewsletter"),
  },
};
export const userSecretsClient = {
  userSecretsService: {
    addSecretKernelAttachment: createRequestClient<
      Kaggle.Sdk.UserSecrets.AddSecretKernelAttachmentRequest,
      Kaggle.Sdk.UserSecrets.UserSecretKernelAttachmentMetadata
    >("UserSecretsService/AddSecretKernelAttachment"),
    deleteSecretKernelAttachment: createRequestClient<
      Kaggle.Sdk.UserSecrets.DeleteSecretKernelAttachmentRequest,
      google.protobuf.Empty
    >("UserSecretsService/DeleteSecretKernelAttachment"),
    deleteUserSecret: createRequestClient<
      Kaggle.Sdk.UserSecrets.DeleteUserSecretRequest,
      Kaggle.Sdk.UserSecrets.DeleteUserSecretResponse
    >("UserSecretsService/DeleteUserSecret"),
    exchangeGcloudAuthorizationCode: createRequestClient<
      Kaggle.Sdk.UserSecrets.ExchangeGcloudAuthorizationCodeRequest,
      Kaggle.Sdk.UserSecrets.UserSecretMetadata
    >("UserSecretsService/ExchangeGcloudAuthorizationCode"),
    getGitHubAccessInfo: createRequestClient<
      Kaggle.Sdk.UserSecrets.GetGitHubAccessInfoRequest,
      Kaggle.Sdk.UserSecrets.GetGitHubAccessInfoResponse
    >("UserSecretsService/GetGitHubAccessInfo"),
    getUserSecretByLabel: createRequestClient<
      Kaggle.Sdk.UserSecrets.GetUserSecretByLabelRequest,
      Kaggle.Sdk.UserSecrets.GetUserSecretResponse
    >("UserSecretsService/GetUserSecretByLabel"),
    listKernelSecretsMetadata: createRequestClient<
      Kaggle.Sdk.UserSecrets.ListKernelSecretsMetadataRequest,
      Kaggle.Sdk.UserSecrets.ListKernelSecretsMetadataResponse
    >("UserSecretsService/ListKernelSecretsMetadata"),
    listKernelsWithSecret: createRequestClient<
      Kaggle.Sdk.UserSecrets.ListKernelsWithSecretRequest,
      Kaggle.Sdk.UserSecrets.ListKernelsWithSecretResponse
    >("UserSecretsService/ListKernelsWithSecret"),
    listUserSecretsMetadata: createRequestClient<
      Kaggle.Sdk.UserSecrets.ListUserSecretsMetadataRequest,
      Kaggle.Sdk.UserSecrets.ListUserSecretsMetadataResponse
    >("UserSecretsService/ListUserSecretsMetadata"),
    upsertCustomUserSecret: createRequestClient<
      Kaggle.Sdk.UserSecrets.UpsertCustomUserSecretRequest,
      Kaggle.Sdk.UserSecrets.UserSecretMetadata
    >("UserSecretsService/UpsertCustomUserSecret"),
  },
};
